import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zM4 17a1.001 1.001 0 1 0-1 1c.551 0 1-.448 1-1zm13-3c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3c0-.353.072-.686.184-1H5.816c.112.314.184.647.184 1 0 1.654-1.346 3-3 3s-3-1.346-3-3c0-1.302.838-2.401 2-2.815V2H1a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1v9h12.279l1.772-5.316a.998.998 0 0 1 1.265-.632c.524.174.808.74.633 1.264l-2 6A1 1 0 0 1 17 12H4v2h13zM7.793 6.707a.999.999 0 0 1 0-1.414L9.586 3.5 7.793 1.707A.999.999 0 1 1 9.207.293L11 2.086 12.793.293a.999.999 0 1 1 1.414 1.414L12.414 3.5l1.793 1.793a.999.999 0 1 1-1.414 1.414L11 4.914 9.207 6.707a.997.997 0 0 1-1.414 0z"
});

var SvgAbandonedCartMajorMonotone = function SvgAbandonedCartMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

var _ref$1 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zM4 17a1.001 1.001 0 0 0-2 0 1.001 1.001 0 0 0 2 0zm13-3c1.653 0 3 1.346 3 3s-1.347 3-3 3c-1.655 0-3-1.346-3-3 0-.353.072-.686.184-1H5.816c.112.314.184.647.184 1 0 1.654-1.346 3-3 3s-3-1.346-3-3c0-1.302.838-2.4 2-2.815V2H1a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1v9h12.278l1.772-5.316a.998.998 0 0 1 1.265-.632c.524.174.808.74.633 1.264l-2 6A1 1 0 0 1 17 12H4v2h13zM7.792 6.707a.999.999 0 0 1 0-1.414L9.586 3.5 7.793 1.707A.999.999 0 1 1 9.207.293L11 2.086 12.793.293a.999.999 0 1 1 1.414 1.414L12.414 3.5l1.793 1.793a.999.999 0 1 1-1.414 1.414L11 4.914 9.207 6.707a.997.997 0 0 1-1.414 0z"
});

var SvgAbandonedCartMajorTwotone = function SvgAbandonedCartMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1);
};

var _ref$2 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 18C2.334 18 .061 10.352.038 10.274a1 1 0 0 1 0-.548C.061 9.648 2.334 2 10 2c7.633 0 9.927 6.617 9.948 6.684a.998.998 0 0 1-1.895.635A8.348 8.348 0 0 0 10 4c-5.467 0-7.513 4.772-7.948 6 .434 1.225 2.479 6 7.948 6a1 1 0 1 1 0 2zm0-4c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4a1 1 0 1 1-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2a1 1 0 1 1 0 2zm5 4a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414L15 15.586l3.293-3.293a.999.999 0 1 1 1.414 1.414l-4 4A.997.997 0 0 1 15 18z"
});

var SvgAccessibilityMajorMonotone = function SvgAccessibilityMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2);
};

var _ref$3 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 18C2.334 18 .061 10.352.038 10.274a1 1 0 0 1 0-.548C.061 9.648 2.334 2 10 2c7.633 0 9.927 6.617 9.948 6.684a.998.998 0 0 1-1.895.635A8.348 8.348 0 0 0 10 4c-5.467 0-7.513 4.772-7.948 6 .434 1.225 2.479 6 7.948 6a1 1 0 1 1 0 2zm0-4c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4a1 1 0 1 1-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2a1 1 0 1 1 0 2zm5 4a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414L15 15.586l3.293-3.293a.999.999 0 1 1 1.414 1.414l-4 4A.997.997 0 0 1 15 18z"
});

var SvgAccessibilityMajorTwotone = function SvgAccessibilityMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3);
};

var _ref$4 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.112.88a3.041 3.041 0 0 0-2.18-.88C4.22.247.225 2.615 0 16.938a2.988 2.988 0 0 0 .888 2.182c.572.57 1.323.88 2.12.88h.06C15.78 19.753 19.776 17.385 20 3.061a2.992 2.992 0 0 0-.89-2.18M6.902 17.825c-.484-3.09-2.855-4.354-4.741-4.709C2.751 5.17 5.128 2.793 13.1 2.173c.486 3.09 2.857 4.353 4.742 4.71-.59 7.945-2.966 10.322-10.94 10.942M3.032 18a.957.957 0 0 1-.73-.296 1.01 1.01 0 0 1-.3-.734c.009-.637.027-1.24.048-1.826 1.013.248 2.438.937 2.836 2.8-.593.024-1.207.043-1.854.056M16.97 2h.02a1 1 0 0 1 .71.296c.198.198.306.46.3.734a89.62 89.62 0 0 1-.048 1.825c-1.013-.248-2.438-.936-2.836-2.799A91.014 91.014 0 0 1 16.97 2m-4.277 3.274a.999.999 0 1 0-1.414 1.414l.293.293-1.586 1.586-.293-.293a.999.999 0 1 0-1.414 1.414l.293.293-1.586 1.586-.293-.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.293-.293 1.586-1.586.293.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.293-.293 1.586-1.586.293.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-2-2z"
});

var SvgActivitiesMajorMonotone = function SvgActivitiesMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4);
};

var _ref$5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 16.954C1.198 4.33 3.518 1.261 16.951 1A2.02 2.02 0 0 1 19 3.046C18.802 15.671 16.482 18.74 3.049 19A2.02 2.02 0 0 1 1 16.954"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.112.88a3.041 3.041 0 0 0-2.18-.88C4.22.247.225 2.615 0 16.938a2.988 2.988 0 0 0 .888 2.182c.572.57 1.323.88 2.12.88h.06C15.78 19.753 19.776 17.385 20 3.061a2.992 2.992 0 0 0-.89-2.18M6.902 17.825c-.484-3.09-2.855-4.354-4.741-4.709C2.751 5.17 5.128 2.793 13.1 2.173c.486 3.09 2.857 4.353 4.742 4.71-.59 7.945-2.966 10.322-10.94 10.942M3.032 18a.957.957 0 0 1-.73-.296 1.01 1.01 0 0 1-.3-.734c.009-.637.027-1.24.048-1.826 1.013.248 2.438.937 2.836 2.8-.593.024-1.207.043-1.854.056M16.97 2h.02a1 1 0 0 1 .71.296c.198.198.306.46.3.734a89.62 89.62 0 0 1-.048 1.825c-1.013-.248-2.438-.936-2.836-2.799A91.014 91.014 0 0 1 16.97 2m-4.277 3.274a.999.999 0 1 0-1.414 1.414l.293.293-1.586 1.586-.293-.293a.999.999 0 1 0-1.414 1.414l.293.293-1.586 1.586-.293-.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.293-.293 1.586-1.586.293.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.293-.293 1.586-1.586.293.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-2-2z"
});

var SvgActivitiesMajorTwotone = function SvgActivitiesMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5, _ref2);
};

var _ref$6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 0H1a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0 1 1 0 0 0 0-2zm4 2h2a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2zm8-2h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM8 18H6a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zm6 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zm5-18h-1a1 1 0 0 0 0 2 1 1 0 0 0 2 0V1a1 1 0 0 0-1-1zm0 17a1 1 0 0 0-1 1 1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM2 18a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2zm-1-3a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zm0-6a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zm18 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm0-6a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1zm-5 4h-3V6a1 1 0 0 0-2 0v3H6a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2z",
  fill: undefined
});

var SvgAddMajorMonotone = function SvgAddMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6);
};

var _ref$7 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 0H1a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0 1 1 0 0 0 0-2m4 2h2a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2m8-2h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2M8 18H6a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m6 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m5-18h-1a1 1 0 0 0 0 2 1 1 0 0 0 2 0V1a1 1 0 0 0-1-1m0 17a1 1 0 0 0-1 1 1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1M2 18a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2m-1-3a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m0-6a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m18 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m0-6a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1m-5 4h-3V6a1 1 0 0 0-2 0v3H6a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2"
});

var SvgAddMajorTwotone = function SvgAddMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7);
};

var _ref$8 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3 9c0 .266-.105.52-.293.707L2.414 10l.293.293A.996.996 0 0 1 3 11v4a1 1 0 0 0 1 1 1 1 0 1 1 0 2c-1.654 0-3-1.346-3-3v-3.586l-.707-.707a.999.999 0 0 1 0-1.414L1 8.586V5c0-1.654 1.346-3 3-3a1 1 0 1 1 0 2 1 1 0 0 0-1 1v4zm16.707.293a.999.999 0 0 1 0 1.414l-.707.707V15c0 1.654-1.346 3-3 3a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-4c0-.266.105-.52.293-.707l.293-.293-.293-.293A.996.996 0 0 1 17 9V5a1 1 0 0 0-1-1 1 1 0 1 1 0-2c1.654 0 3 1.346 3 3v3.586l.707.707zM13 9a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H7a1 1 0 1 1 0-2h2V7a1 1 0 1 1 2 0v2h2z"
});

var SvgAddCodeMajorMonotone = function SvgAddCodeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8);
};

var _ref$9 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3 9c0 .266-.105.52-.293.707L2.414 10l.293.293A.996.996 0 0 1 3 11v4a1 1 0 0 0 1 1 1 1 0 1 1 0 2c-1.654 0-3-1.346-3-3v-3.586l-.707-.707a.999.999 0 0 1 0-1.414L1 8.586V5c0-1.654 1.346-3 3-3a1 1 0 1 1 0 2 1 1 0 0 0-1 1v4zm16.707.293a.999.999 0 0 1 0 1.414l-.707.707V15c0 1.654-1.346 3-3 3a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-4c0-.266.105-.52.293-.707l.293-.293-.293-.293A.996.996 0 0 1 17 9V5a1 1 0 0 0-1-1 1 1 0 1 1 0-2c1.654 0 3 1.346 3 3v3.586l.707.707zM13 9a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H7a1 1 0 1 1 0-2h2V7a1 1 0 1 1 2 0v2h2z"
});

var SvgAddCodeMajorTwotone = function SvgAddCodeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9);
};

var _ref$a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 10a1 1 0 0 0-1 1v.522l-3.629-1.451a.994.994 0 0 0-.886.072l-4.457 2.674-2.473-1.649a.996.996 0 0 0-1.07-.025L2 13.233V2h7a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm-6-5h2v2a1 1 0 1 0 2 0V5h2a1 1 0 1 0 0-2h-2V1a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2M9 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 7c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3M2 18v-2.434l3.972-2.383 2.473 1.649c.322.213.737.225 1.07.025l4.574-2.745L18 13.677V18H2z"
});

var SvgAddImageMajorMonotone = function SvgAddImageMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$a);
};

var _ref$b =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M14 11l-4.999 3-3-2L1 15.001V19h18v-6z"
});

var _ref2$1 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 10a1 1 0 0 0-1 1v.522l-3.629-1.451a.994.994 0 0 0-.886.072l-4.457 2.674-2.473-1.649a.996.996 0 0 0-1.07-.025L2 13.233V2h7a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm-6-5h2v2a1 1 0 1 0 2 0V5h2a1 1 0 1 0 0-2h-2V1a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2M9 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 7c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3M2 18v-2.434l3.972-2.383 2.473 1.649c.322.213.737.225 1.07.025l4.574-2.745L18 13.677V18H2z"
});

var SvgAddImageMajorTwotone = function SvgAddImageMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$b, _ref2$1);
};

var _ref$c =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9 9a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h4zm0 4a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h4zm10-2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1 0-2h2V9a1 1 0 0 1 2 0v2h2zm-4 7a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h10c.265 0 .52.105.707.293l4 4a.999.999 0 1 1-1.414 1.414L10.586 2H2v16h13zM5 7a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2H5z"
});

var SvgAddNoteMajorMonotone = function SvgAddNoteMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$c);
};

var _ref$d =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9 9a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h4zm0 4a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h4zm10-2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1 0-2h2V9a1 1 0 0 1 2 0v2h2zm-4 7a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h10c.265 0 .52.105.707.293l4 4a.999.999 0 1 1-1.414 1.414L10.586 2H2v16h13zM5 7a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2H5z"
});

var SvgAddNoteMajorTwotone = function SvgAddNoteMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$d);
};

var _ref$e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h10v-2H2v2zm11-5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6c0-.297.132-.578.359-.769l6-5a1.005 1.005 0 0 1 1.282 0l6 5c.423.354.481.985.128 1.41-.354.423-.983.48-1.41.128L7 2.302 2 6.469V14h10a1 1 0 0 1 1-1zM6 6a1 1 0 1 1 2 0 1 1 0 1 1-2 0zm13 3a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V7a1 1 0 1 1 2 0v2h2z"
});

var SvgAddProductMajorMonotone = function SvgAddProductMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$e);
};

var _ref$f =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 15h12v4H1z"
});

var _ref2$2 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h10v-2H2v2zm11-5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6c0-.297.132-.578.359-.769l6-5a1.005 1.005 0 0 1 1.282 0l6 5c.423.354.481.985.128 1.41-.354.423-.983.48-1.41.128L7 2.302 2 6.469V14h10a1 1 0 0 1 1-1zM6 6a1 1 0 1 1 2 0 1 1 0 1 1-2 0zm13 3a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V7a1 1 0 1 1 2 0v2h2z"
});

var SvgAddProductMajorTwotone = function SvgAddProductMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$f, _ref2$2);
};

var _ref$g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M7 16c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3M2 3a1.001 1.001 0 0 1 2 0 1.001 1.001 0 0 1-2 0m15-1a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2m0 12c-.807 0-1.537.324-2.077.844l-2.96-1.481c.009-.122.037-.238.037-.363a4.964 4.964 0 0 0-.833-2.753l4.54-4.54.006-.009A2.96 2.96 0 0 0 17 6c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .463.114.896.302 1.287-.003.003-.007.003-.009.006l-4.54 4.54A4.966 4.966 0 0 0 7 8c-.125 0-.241.027-.363.037L5.156 5.076C5.676 4.537 6 3.807 6 3c0-1.654-1.346-3-3-3S0 1.346 0 3s1.346 3 3 3c.125 0 .243-.021.363-.037l1.318 2.635C3.095 9.437 2 11.085 2 13c0 2.757 2.243 5 5 5 1.916 0 3.563-1.095 4.402-2.681l2.635 1.318c-.015.12-.037.238-.037.363 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3"
});

var SvgAffiliateMajorMonotone = function SvgAffiliateMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$g);
};

var _ref$h =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M7 16c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3M2 3a1.001 1.001 0 0 1 2 0 1.001 1.001 0 0 1-2 0m15-1a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2m0 12c-.807 0-1.537.324-2.077.844l-2.96-1.481c.009-.122.037-.238.037-.363a4.964 4.964 0 0 0-.833-2.753l4.54-4.54.006-.009A2.96 2.96 0 0 0 17 6c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .463.114.896.302 1.287-.003.003-.007.003-.009.006l-4.54 4.54A4.966 4.966 0 0 0 7 8c-.125 0-.241.027-.363.037L5.156 5.076C5.676 4.537 6 3.807 6 3c0-1.654-1.346-3-3-3S0 1.346 0 3s1.346 3 3 3c.125 0 .243-.021.363-.037l1.318 2.635C3.095 9.437 2 11.085 2 13c0 2.757 2.243 5 5 5 1.916 0 3.563-1.095 4.402-2.681l2.635 1.318c-.015.12-.037.238-.037.363 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3"
});

var SvgAffiliateMajorTwotone = function SvgAffiliateMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$h);
};

var _ref$i =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-8h2V6H9v4zm0 4h2v-2H9v2z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgAlertMinor = function SvgAlertMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$i);
};

var _ref$j =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h18zm0-18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h5V5a1 1 0 0 1 1-1h5V1a1 1 0 0 1 1-1h6zm-5 14h4V2h-4v12zm-6 0h4V6H8v8zm-6 0h4v-4H2v4z"
});

var SvgAnalyticsMajorMonotone = function SvgAnalyticsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$j);
};

var _ref$k =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 5h6v10H7z"
});

var _ref2$3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h18zm0-18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h5V5a1 1 0 0 1 1-1h5V1a1 1 0 0 1 1-1h6zm-5 14h4V2h-4v12zm-6 0h4V6H8v8zm-6 0h4v-4H2v4z",
  fill: undefined
});

var SvgAnalyticsMajorTwotone = function SvgAnalyticsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$k, _ref2$3);
};

var _ref$l =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9 12v4c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm8 0v4c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zM9 4v4c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm10-2v5c0 .55-.45 1-1 1s-1-.45-1-1V4.42l-4.29 4.29c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29-.39-.39-.39-1.03 0-1.42L15.58 3H13c-.55 0-1-.45-1-1s.45-1 1-1h5c.08 0 .17.01.25.04.05 0 .09.02.14.04.12.05.23.12.32.21s.16.2.21.32c.02.05.04.09.04.14.03.08.04.17.04.25z"
});

var SvgAppExtensionMinor = function SvgAppExtensionMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$l);
};

var _ref$m =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 11H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zm-1 7H2v-5h5v5zM8 0H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM7 7H2V2h5v5zm12 4h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zm-1 7h-5v-5h5v5zM12 6h2v2a1 1 0 1 0 2 0V6h2a1 1 0 1 0 0-2h-2V2a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2z",
  fill: undefined
});

var SvgAppsMajorMonotone = function SvgAppsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$m);
};

var _ref$n =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 1h7v7H1V1zm0 11h7v7H1v-7zm11 0h7v7h-7v-7z",
  fill: "currentColor"
});

var _ref2$4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 11H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zm-1 7H2v-5h5v5zM8 0H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM7 7H2V2h5v5zm12 4h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zm-1 7h-5v-5h5v5zM12 6h2v2a1 1 0 1 0 2 0V6h2a1 1 0 1 0 0-2h-2V2a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2z",
  fill: undefined
});

var SvgAppsMajorTwotone = function SvgAppsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$n, _ref2$4);
};

var _ref$o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19 0H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM3 18h14V7H3v11zM2 5h16V2H2v3zm6 6h4a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2"
});

var SvgArchiveMajorMonotone = function SvgArchiveMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$o);
};

var _ref$p =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v5H1z"
});

var _ref2$5 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19 0H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM3 18h14V7H3v11zM2 5h16V2H2v3zm6 6h4a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2"
});

var SvgArchiveMajorTwotone = function SvgArchiveMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$p, _ref2$5);
};

var _ref$q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M17 2H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM5 16h10V8H5v8zM4 6h12V4H4v2zm5 6h2a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2"
});

var SvgArchiveMinor = function SvgArchiveMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$q);
};

var _ref$r =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.707 17.707l5-5a.999.999 0 1 0-1.414-1.414L11 14.586V3a1 1 0 1 0-2 0v11.586l-3.293-3.293a.999.999 0 1 0-1.414 1.414l5 5a.999.999 0 0 0 1.414 0",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgArrowDownMinor = function SvgArrowDownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$r);
};

var _ref$s =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgArrowLeftMinor = function SvgArrowLeftMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$s);
};

var _ref$t =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.707 9.293l-5-5a.999.999 0 1 0-1.414 1.414L14.586 9H3a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgArrowRightMinor = function SvgArrowRightMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$t);
};

var _ref$u =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 17V5.414l3.293 3.293a.999.999 0 1 0 1.414-1.414l-5-5a.999.999 0 0 0-1.414 0l-5 5a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0L9 5.414V17a1 1 0 1 0 2 0",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgArrowUpMinor = function SvgArrowUpMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$u);
};

var _ref$v =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M5.243 20a5.229 5.229 0 0 1-3.707-1.533A5.212 5.212 0 0 1 0 14.759c0-1.402.546-2.719 1.536-3.708l9.515-9.519a5.25 5.25 0 0 1 7.414 0A5.21 5.21 0 0 1 20 5.24a5.207 5.207 0 0 1-1.535 3.708l-4.258 4.26a3.124 3.124 0 0 1-4.414 0A3.098 3.098 0 0 1 8.879 11c0-.835.324-1.619.914-2.208l4.5-4.501a1 1 0 1 1 1.414 1.414l-4.5 4.501a1.113 1.113 0 0 0-.328.794c0 .3.116.58.328.793a1.127 1.127 0 0 0 1.586 0l4.258-4.26A3.224 3.224 0 0 0 18 5.24c0-.866-.337-1.681-.949-2.293a3.248 3.248 0 0 0-4.586 0L2.95 12.465A3.224 3.224 0 0 0 2 14.76c0 .866.338 1.68.95 2.293a3.248 3.248 0 0 0 4.586 0l1.757-1.758a1 1 0 1 1 1.414 1.414L8.95 18.467A5.235 5.235 0 0 1 5.243 20"
});

var SvgAttachmentMajorMonotone = function SvgAttachmentMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$v);
};

var _ref$w =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M5.243 20a5.229 5.229 0 0 1-3.707-1.533A5.212 5.212 0 0 1 0 14.759c0-1.402.546-2.719 1.536-3.708l9.515-9.519a5.25 5.25 0 0 1 7.414 0A5.21 5.21 0 0 1 20 5.24a5.207 5.207 0 0 1-1.535 3.708l-4.258 4.26a3.124 3.124 0 0 1-4.414 0A3.098 3.098 0 0 1 8.879 11c0-.835.324-1.619.914-2.208l4.5-4.501a1 1 0 1 1 1.414 1.414l-4.5 4.501a1.113 1.113 0 0 0-.328.794c0 .3.116.58.328.793a1.127 1.127 0 0 0 1.586 0l4.258-4.26A3.224 3.224 0 0 0 18 5.24c0-.866-.337-1.681-.949-2.293a3.248 3.248 0 0 0-4.586 0L2.95 12.465A3.224 3.224 0 0 0 2 14.76c0 .866.338 1.68.95 2.293a3.248 3.248 0 0 0 4.586 0l1.757-1.758a1 1 0 1 1 1.414 1.414L8.95 18.467A5.235 5.235 0 0 1 5.243 20"
});

var SvgAttachmentMajorTwotone = function SvgAttachmentMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$w);
};

var _ref$x =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 3H7a.997.997 0 0 0-.707.293l-6 6a.999.999 0 0 0 0 1.414l6 6A.997.997 0 0 0 7 17h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 12H7.414l-5-5 5-5H18v10zm-8.707-2.293a.997.997 0 0 0 1.414 0L12 11.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L13.414 10l1.293-1.293a.999.999 0 1 0-1.414-1.414L12 8.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414L10.586 10l-1.293 1.293a.999.999 0 0 0 0 1.414"
});

var SvgBackspaceMajorMonotone = function SvgBackspaceMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$x);
};

var _ref$y =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 10l6-6h12v12H7z"
});

var _ref2$6 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 3H7a.997.997 0 0 0-.707.293l-6 6a.999.999 0 0 0 0 1.414l6 6A.997.997 0 0 0 7 17h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 12H7.414l-5-5 5-5H18v10zm-8.707-2.293a.997.997 0 0 0 1.414 0L12 11.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L13.414 10l1.293-1.293a.999.999 0 1 0-1.414-1.414L12 8.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414L10.586 10l-1.293 1.293a.999.999 0 0 0 0 1.414"
});

var SvgBackspaceMajorTwotone = function SvgBackspaceMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$y, _ref2$6);
};

var _ref$z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3 17c-.551 0-1-.448-1-1V6.802c.346.128.72.198 1.107.198H18v2h-2c-1.206 0-3 .799-3 3s1.794 3 3 3h2v2H3zM2.238 3.353A.998.998 0 0 1 3 3h13v2H3.107c-.537 0-1.017-.362-1.093-.824a1 1 0 0 1 .224-.823zM18 13h-1.988C15.55 12.988 15 12.806 15 12s.55-.988 1-1h2v2zm1-8h-1V2a1 1 0 0 0-1-1H3A2.997 2.997 0 0 0 .001 3.956L0 4v12c0 1.654 1.346 3 3 3h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
});

var SvgBalanceMajorMonotone = function SvgBalanceMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$z);
};

var _ref$A =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3 17c-.551 0-1-.448-1-1V6.802c.346.128.72.198 1.107.198H18v2h-2c-1.206 0-3 .799-3 3s1.794 3 3 3h2v2H3zM2.238 3.353A.998.998 0 0 1 3 3h13v2H3.107c-.537 0-1.017-.362-1.093-.824a1 1 0 0 1 .224-.823zM18 13h-1.988C15.55 12.988 15 12.806 15 12s.55-.988 1-1h2v2zm1-8h-1V2a1 1 0 0 0-1-1H3A2.997 2.997 0 0 0 .001 3.956L0 4v12c0 1.654 1.346 3 3 3h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
});

var SvgBalanceMajorTwotone = function SvgBalanceMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$A);
};

var _ref$B =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19 18V9a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2v9a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zM3.394 4.918a1 1 0 0 1-.788-1.838l7-3c.252-.107.536-.107.788 0l7 3a1 1 0 0 1-.788 1.838L10 2.088l-6.606 2.83zM3 18h14V9H3v9zm7-7a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1m-8 0a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1"
});

var SvgBankMajorMonotone = function SvgBankMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$B);
};

var _ref$C =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2 8h16v11H2z"
});

var _ref2$7 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19 18V9a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2v9a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zM3.394 4.918a1 1 0 0 1-.788-1.838l7-3c.252-.107.536-.107.788 0l7 3a1 1 0 0 1-.788 1.838L10 2.088l-6.606 2.83zM3 18h14V9H3v9zm7-7a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1m-8 0a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1"
});

var SvgBankMajorTwotone = function SvgBankMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$C, _ref2$7);
};

var _ref$D =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M1 4a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v1a1 1 0 0 1-1 1zm2 14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h1zM19 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2h-1a1 1 0 1 1 0-2h2zm0 16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1zM8 6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1zm11 7a1 1 0 1 1-2 0V7a1 1 0 1 1 2 0v6zM4 6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2zm10 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2z"
});

var SvgBarcodeMajorMonotone = function SvgBarcodeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$D);
};

var _ref$E =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M1 4a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v1a1 1 0 0 1-1 1zm2 14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h1zM19 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2h-1a1 1 0 1 1 0-2h2zm0 16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1zM8 6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1zm11 7a1 1 0 1 1-2 0V7a1 1 0 1 1 2 0v6zM4 6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2zm10 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2z"
});

var SvgBarcodeMajorTwotone = function SvgBarcodeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$E);
};

var _ref$F =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.37 12.07l-10-4a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 .89.63H13a1 1 0 0 0 .9-.55l1.85-3.7 3.7-1.86a1 1 0 0 0-.08-1.82zm-4.82 2.03a1 1 0 0 0-.44.45l-1 2.01-2.31-5.77 5.76 2.31-2 1zM9 5a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1zM5 9a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1zm-.95-6.36a1 1 0 1 0-1.41 1.41l2.12 2.12a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41L4.05 2.64zm8.48 3.82a1 1 0 0 0 .71-.29l2.12-2.12a1 1 0 1 0-1.41-1.41l-2.12 2.12a1 1 0 0 0 .7 1.7zm-7.77 5.37l-2.12 2.12a1 1 0 1 0 1.41 1.41l2.12-2.12a1 1 0 1 0-1.41-1.41z"
});

var SvgBehaviorMajorMonotone = function SvgBehaviorMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$F);
};

var _ref$G =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M15.54 14.85a1.56 1.56 0 0 0-.7.7l-1.56 3.13-3.6-9 9 3.6-3.14 1.56z"
});

var _ref2$8 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.37 12.07l-10-4a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 .89.63H13a1 1 0 0 0 .9-.55l1.85-3.7 3.7-1.86a1 1 0 0 0-.08-1.82zm-4.82 2.03a1 1 0 0 0-.44.45l-1 2.01-2.31-5.77 5.76 2.31-2 1zM9 5a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1zM5 9a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1zm-.95-6.36a1 1 0 1 0-1.41 1.41l2.12 2.12a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41L4.05 2.64zm8.48 3.82a1 1 0 0 0 .71-.29l2.12-2.12a1 1 0 1 0-1.41-1.41l-2.12 2.12a1 1 0 0 0 .7 1.7zm-7.77 5.37l-2.12 2.12a1 1 0 1 0 1.41 1.41l2.12-2.12a1 1 0 1 0-1.41-1.41z"
});

var SvgBehaviorMajorTwotone = function SvgBehaviorMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$G, _ref2$8);
};

var _ref$H =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0a1 1 0 1 0 0 2h1v15.132l-1.445-.964a.997.997 0 0 0-1.11 0L13 17.798l-2.445-1.63a.997.997 0 0 0-1.11 0L7 17.798l-2.445-1.63a.997.997 0 0 0-1.11 0L2 17.132V2h1a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1.555.832L4 18.202l2.445 1.63a.997.997 0 0 0 1.11 0L10 18.202l2.445 1.63a.997.997 0 0 0 1.11 0L16 18.202l2.445 1.63a1.006 1.006 0 0 0 1.027.05A1 1 0 0 0 20 19V1a1 1 0 0 0-1-1h-2zm-6.977 9c-.026-.001-.649-.04-1.316-.707a.999.999 0 1 0-1.414 1.414A4.491 4.491 0 0 0 9 10.8v.2a1 1 0 1 0 2 0v-.185A2.995 2.995 0 0 0 13 8c0-2.281-1.727-2.712-2.758-2.97C9.127 4.751 9 4.646 9 4c0-.552.448-1 .976-1 .026.001.65.04 1.317.707a.999.999 0 1 0 1.414-1.414A4.506 4.506 0 0 0 11 1.2V1a1 1 0 1 0-2 0v.185A2.993 2.993 0 0 0 7 4c0 2.281 1.726 2.712 2.757 2.97C10.872 7.249 11 7.354 11 8c0 .552-.449 1-.977 1"
});

var SvgBillingStatementDollarMajorMonotone = function SvgBillingStatementDollarMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$H);
};

var _ref$I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0a1 1 0 1 0 0 2h1v15.132l-1.445-.964a.997.997 0 0 0-1.11 0L13 17.798l-2.445-1.63a.997.997 0 0 0-1.11 0L7 17.798l-2.445-1.63a.997.997 0 0 0-1.11 0L2 17.132V2h1a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1.555.832L4 18.202l2.445 1.63a.997.997 0 0 0 1.11 0L10 18.202l2.445 1.63a.997.997 0 0 0 1.11 0L16 18.202l2.445 1.63a1.006 1.006 0 0 0 1.027.05A1 1 0 0 0 20 19V1a1 1 0 0 0-1-1h-2zm-6.977 9c-.026-.001-.649-.04-1.316-.707a.999.999 0 1 0-1.414 1.414A4.491 4.491 0 0 0 9 10.8v.2a1 1 0 1 0 2 0v-.185A2.995 2.995 0 0 0 13 8c0-2.281-1.727-2.712-2.758-2.97C9.127 4.751 9 4.646 9 4c0-.552.448-1 .976-1 .026.001.65.04 1.317.707a.999.999 0 1 0 1.414-1.414A4.506 4.506 0 0 0 11 1.2V1a1 1 0 1 0-2 0v.185A2.993 2.993 0 0 0 7 4c0 2.281 1.726 2.712 2.757 2.97C10.872 7.249 11 7.354 11 8c0 .552-.449 1-.977 1"
});

var SvgBillingStatementDollarMajorTwotone = function SvgBillingStatementDollarMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$I);
};

var _ref$J =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zM7.014 5.992a10.617 10.617 0 0 1 .014-1H6.75a.75.75 0 0 1 0-1.5h.49C7.696 1.468 8.807 0 10.326 0c1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5H9.018a8.248 8.248 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5H9.208c.272 1.102.749 1.812 1.119 1.812h.053c.514 0 .507.003.626-.213a.992.992 0 1 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796H6.75a.75.75 0 0 1 0-1.5h.264z"
});

var SvgBillingStatementEuroMajorMonotone = function SvgBillingStatementEuroMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$J);
};

var _ref$K =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zM7.014 5.992a10.617 10.617 0 0 1 .014-1H6.75a.75.75 0 0 1 0-1.5h.49C7.696 1.468 8.807 0 10.326 0c1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5H9.018a8.248 8.248 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5H9.208c.272 1.102.749 1.812 1.119 1.812h.053c.514 0 .507.003.626-.213a.992.992 0 1 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796H6.75a.75.75 0 0 1 0-1.5h.264z"
});

var SvgBillingStatementEuroMajorTwotone = function SvgBillingStatementEuroMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$K);
};

var _ref$L =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zM7.744 6.6H7.5a1 1 0 1 1 0-2h.472C7.99 4.26 8 3.918 8 3.573 8 1.68 9.057.327 10.555.09c1.504-.239 2.867.785 2.867 2.4a1 1 0 0 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027H11.5a1 1 0 0 1 0 2H9.77a18.695 18.695 0 0 1-.422 2H12a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1 .998.998 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
});

var SvgBillingStatementPoundMajorMonotone = function SvgBillingStatementPoundMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$L);
};

var _ref$M =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zM7.744 6.6H7.5a1 1 0 1 1 0-2h.472C7.99 4.26 8 3.918 8 3.573 8 1.68 9.057.327 10.555.09c1.504-.239 2.867.785 2.867 2.4a1 1 0 0 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027H11.5a1 1 0 0 1 0 2H9.77a18.695 18.695 0 0 1-.422 2H12a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1 .998.998 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
});

var SvgBillingStatementPoundMajorTwotone = function SvgBillingStatementPoundMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$M);
};

var _ref$N =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zM9.326 7.762l2.08 2.761a1 1 0 1 1-1.597 1.204L6.8 7.734a1 1 0 0 1 1.258-1.49c.234.037.492.056.777.056.702 0 1.241-.478 1.493-1.235h-3.1a.75.75 0 0 1 0-1.5h3.229c-.09-.72-.395-1.283-.844-1.58H7.478a1 1 0 0 1 0-2h5a1 1 0 1 1 0 2h-.945c.233.467.38 1.004.432 1.58h.763a.75.75 0 1 1 0 1.5h-.85c-.298 1.407-1.21 2.486-2.552 2.697z"
});

var SvgBillingStatementRupeeMajorMonotone = function SvgBillingStatementRupeeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$N);
};

var _ref$O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zM9.326 7.762l2.08 2.761a1 1 0 1 1-1.597 1.204L6.8 7.734a1 1 0 0 1 1.258-1.49c.234.037.492.056.777.056.702 0 1.241-.478 1.493-1.235h-3.1a.75.75 0 0 1 0-1.5h3.229c-.09-.72-.395-1.283-.844-1.58H7.478a1 1 0 0 1 0-2h5a1 1 0 1 1 0 2h-.945c.233.467.38 1.004.432 1.58h.763a.75.75 0 1 1 0 1.5h-.85c-.298 1.407-1.21 2.486-2.552 2.697z"
});

var SvgBillingStatementRupeeMajorTwotone = function SvgBillingStatementRupeeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$O);
};

var _ref$P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zm-6.125 6.954h1.25a.75.75 0 0 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859L6.634 1.5a1 1 0 0 1 1.732-1l1.515 2.624L11.396.5a1 1 0 0 1 1.732 1l-1.85 3.204h.847a.75.75 0 0 1 0 1.5h-1.25v.75z"
});

var SvgBillingStatementYenMajorMonotone = function SvgBillingStatementYenMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$P);
};

var _ref$Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0h2a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L10 18.202l-2.445 1.63a.997.997 0 0 1-1.11 0L4 18.202l-2.445 1.63A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2v15.132l1.445-.964a.997.997 0 0 1 1.11 0L7 17.798l2.445-1.63a.997.997 0 0 1 1.11 0L13 17.798l2.445-1.63a.997.997 0 0 1 1.11 0l1.445.964V2h-1a1 1 0 1 1 0-2zm-6.125 6.954h1.25a.75.75 0 0 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859L6.634 1.5a1 1 0 0 1 1.732-1l1.515 2.624L11.396.5a1 1 0 0 1 1.732 1l-1.85 3.204h.847a.75.75 0 0 1 0 1.5h-1.25v.75z"
});

var SvgBillingStatementYenMajorTwotone = function SvgBillingStatementYenMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$Q);
};

var _ref$R =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 4H6a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1a1 1 0 1 1 0 2zM2 4H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1a1 1 0 1 1 0 2zm12 16a1 1 0 0 1-1-1v-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm5 0a1 1 0 0 1-1-1v-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0-6H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zM9 20H1a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zM19 2h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm0 6H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2z",
  fill: undefined
});

var SvgBlockquoteMajorMonotone = function SvgBlockquoteMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$R);
};

var _ref$S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 4H6a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1a1 1 0 1 1 0 2zM2 4H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1a1 1 0 1 1 0 2zm12 16a1 1 0 0 1-1-1v-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm5 0a1 1 0 0 1-1-1v-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0-6H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zM9 20H1a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zM19 2h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm0 6H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2z"
});

var SvgBlockquoteMajorTwotone = function SvgBlockquoteMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$S);
};

var _ref$T =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18.878 1.122c-1.445-1.446-3.967-1.446-5.414 0L13 1.586 11.707.293A1.003 1.003 0 0 0 11 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.414l2.878-2.878A3.805 3.805 0 0 0 20 3.829a3.803 3.803 0 0 0-1.122-2.707zm-1.414 4L17 5.586 14.414 3l.464-.464c.691-.691 1.895-.691 2.586 0 .346.346.536.805.536 1.293 0 .488-.19.947-.536 1.293zM14 18H2V2h8.586l1 1-5.293 5.293a.976.976 0 0 0-.227.367c-.003.009-.012.015-.015.024l-2 6a.999.999 0 0 0 1.265 1.265l6-2c.01-.003.015-.012.024-.015a.976.976 0 0 0 .367-.227L14 11.414V18zm-6.563-7.15l1.712 1.713-2.568.856.856-2.568zm6.856-2.557L11 11.587 8.414 9 13 4.414 15.586 7l-1.293 1.293z"
});

var SvgBlogMajorMonotone = function SvgBlogMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$T);
};

var _ref$U =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11 13l6-6-4-4-6 6z"
});

var _ref2$9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.878 1.122c-1.445-1.446-3.967-1.446-5.414 0L13 1.586 11.707.293A1.002 1.002 0 0 0 11 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.414l2.878-2.878A3.81 3.81 0 0 0 20 3.83c0-1.024-.4-1.985-1.122-2.708zm-1.414 4L17 5.586 14.414 3l.464-.464c.69-.69 1.895-.69 2.586 0 .346.346.536.805.536 1.293s-.19.944-.536 1.29zM14 18H2V2h8.586l1 1-5.293 5.293a.964.964 0 0 0-.227.367c-.003.01-.012.015-.015.024l-2 6A1.001 1.001 0 0 0 5.32 15.95l6-2c.01-.004.014-.013.023-.016a.98.98 0 0 0 .368-.227L14 11.414V18zm-6.563-7.15l1.712 1.713-2.57.856.855-2.57zm6.856-2.557L11 11.586 8.414 9 13 4.414 15.586 7l-1.293 1.293z",
  fill: undefined
});

var SvgBlogMajorTwotone = function SvgBlogMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$U, _ref2$9);
};

var _ref$V =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 17.703V7.919a8.214 8.214 0 0 0 2.71-.817c.182.884.29 1.853.29 2.898 0 3.89-1.436 6.8-3 7.703M6 10c0-1.045.108-2.014.29-2.898A8.214 8.214 0 0 0 9 7.919v9.784C7.435 16.802 6 13.89 6 10m4-8c1.131 0 2.335 1.18 3.124 3.13a6.292 6.292 0 0 1-6.248 0C7.666 3.18 8.87 2 10 2m9.32 4.057a.999.999 0 0 0-1.267.622c-.028.079-.604 1.643-2.095 2.15a16.035 16.035 0 0 0-.136-1.251C17.97 5.284 18 1.177 18 1a1 1 0 1 0-2 0c0 .733-.17 2.487-.813 3.923C14.157 1.959 12.243 0 10 0 7.755 0 5.84 1.963 4.81 4.93 4.021 3.18 4 1.028 4 1a1 1 0 0 0-2 0c0 .177.03 4.284 2.178 6.578-.059.408-.107.824-.136 1.252-1.49-.508-2.068-2.072-2.095-2.151a1 1 0 0 0-1.896.638c.046.136 1.057 3.036 3.975 3.586.047.914.168 1.786.35 2.608C3.022 15.82 3 18.849 3 19a1 1 0 1 0 2 0c0-.514.09-1.53.363-2.587C6.455 18.617 8.113 20 10 20c1.891 0 3.551-1.387 4.644-3.598.34 1.35.356 2.579.356 2.6.002.55.45.998 1 .998h.001a1 1 0 0 0 1-1c0-.151-.028-3.173-1.377-5.482a15.99 15.99 0 0 0 .35-2.615c2.92-.55 3.93-3.45 3.974-3.586a.995.995 0 0 0-.628-1.26"
});

var SvgBugMajorMonotone = function SvgBugMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$V);
};

var _ref$W =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M14.343 6c-1.251.883-2.74 1.4-4.343 1.4-1.602 0-3.092-.517-4.343-1.4C5.241 7.27 5 8.735 5 10.3c0 4.805 2.239 8.7 5 8.7 2.762 0 5-3.895 5-8.7 0-1.565-.241-3.03-.657-4.3"
});

var _ref2$a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 17.703V7.919a8.214 8.214 0 0 0 2.71-.817c.182.884.29 1.853.29 2.898 0 3.89-1.436 6.8-3 7.703M6 10c0-1.045.108-2.014.29-2.898A8.214 8.214 0 0 0 9 7.919v9.784C7.435 16.802 6 13.89 6 10m4-8c1.131 0 2.335 1.18 3.124 3.13a6.292 6.292 0 0 1-6.248 0C7.666 3.18 8.87 2 10 2m9.32 4.057a.999.999 0 0 0-1.267.622c-.028.079-.604 1.643-2.095 2.15a16.035 16.035 0 0 0-.136-1.251C17.97 5.284 18 1.177 18 1a1 1 0 1 0-2 0c0 .733-.17 2.487-.813 3.923C14.157 1.959 12.243 0 10 0 7.755 0 5.84 1.963 4.81 4.93 4.021 3.18 4 1.028 4 1a1 1 0 0 0-2 0c0 .177.03 4.284 2.178 6.578-.059.408-.107.824-.136 1.252-1.49-.508-2.068-2.072-2.095-2.151a1 1 0 0 0-1.896.638c.046.136 1.057 3.036 3.975 3.586.047.914.168 1.786.35 2.608C3.022 15.82 3 18.849 3 19a1 1 0 1 0 2 0c0-.514.09-1.53.363-2.587C6.455 18.617 8.113 20 10 20c1.891 0 3.551-1.387 4.644-3.598.34 1.35.356 2.579.356 2.6.002.55.45.998 1 .998h.001a1 1 0 0 0 1-1c0-.151-.028-3.173-1.377-5.482a15.99 15.99 0 0 0 .35-2.615c2.92-.55 3.93-3.45 3.974-3.586a.995.995 0 0 0-.628-1.26"
});

var SvgBugMajorTwotone = function SvgBugMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$W, _ref2$a);
};

var _ref$X =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15.873 13.679l-.72 4.32H4.677l-1.431-3.576c.59-.177 1.628-.134 3.047 1.284A.999.999 0 1 0 8 15V7a1.001 1.001 0 0 1 2 0v4a1 1 0 0 0 .684.949l5.189 1.73zM5 7.999A3 3 0 0 1 2 5c0-1.653 1.346-3 3-3h10c1.654 0 3 1.347 3 3 0 1.656-1.346 3-3 3h-3V7c0-1.653-1.346-3-3-3S6 5.347 6 7v1H5zm10 2c2.757 0 5-2.242 5-5 0-2.756-2.243-5-5-5H5A5.008 5.008 0 0 0 0 5c0 2.758 2.243 5 5 5h1v2.972c-2.184-1.214-3.959-.426-4.707.322-.283.283-.37.707-.222 1.079l2 5c.153.379.52.628.929.628h12a.999.999 0 0 0 .986-.835l1-6a.999.999 0 0 0-.67-1.113L12 10.28V10h3z"
});

var SvgBuyButtonMajorMonotone = function SvgBuyButtonMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$X);
};

var _ref$Y =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M15 1H5a4 4 0 0 0 0 8h2V7a2 2 0 0 1 4 0v2h4a4 4 0 0 0 0-8"
});

var _ref2$b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15.873 13.679l-.72 4.32H4.677l-1.431-3.576c.59-.177 1.628-.134 3.047 1.284A.999.999 0 1 0 8 15V7a1.001 1.001 0 0 1 2 0v4a1 1 0 0 0 .684.949l5.189 1.73zM5 7.999A3 3 0 0 1 2 5c0-1.653 1.346-3 3-3h10c1.654 0 3 1.347 3 3 0 1.656-1.346 3-3 3h-3V7c0-1.653-1.346-3-3-3S6 5.347 6 7v1H5zm10 2c2.757 0 5-2.242 5-5 0-2.756-2.243-5-5-5H5A5.008 5.008 0 0 0 0 5c0 2.758 2.243 5 5 5h1v2.972c-2.184-1.214-3.959-.426-4.707.322-.283.283-.37.707-.222 1.079l2 5c.153.379.52.628.929.628h12a.999.999 0 0 0 .986-.835l1-6a.999.999 0 0 0-.67-1.113L12 10.28V10h3z"
});

var SvgBuyButtonMajorTwotone = function SvgBuyButtonMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$Y, _ref2$b);
};

var _ref$Z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 6H4c-2.206 0-4 1.794-4 4s1.794 4 4 4h12c2.206 0 4-1.794 4-4s-1.794-4-4-4M2 18a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m17-1a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M1 3a1 1 0 0 0 1-1 1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m5-1h2a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m6 0h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2M8 18H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m2-6H4c-1.103 0-2-.897-2-2s.897-2 2-2h12c1.103 0 2 .897 2 2s-.897 2-2 2"
});

var SvgBuyButtonButtonLayoutMajorMonotone = function SvgBuyButtonButtonLayoutMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$Z);
};

var _ref$_ =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4 13a3 3 0 1 1 0-6h12a3 3 0 1 1 0 6H4z"
});

var _ref2$c =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 6H4c-2.206 0-4 1.794-4 4s1.794 4 4 4h12c2.206 0 4-1.794 4-4s-1.794-4-4-4M2 18a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m17-1a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M1 3a1 1 0 0 0 1-1 1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m5-1h2a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m6 0h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2M8 18H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m2-6H4c-1.103 0-2-.897-2-2s.897-2 2-2h12c1.103 0 2 .897 2 2s-.897 2-2 2"
});

var SvgBuyButtonButtonLayoutMajorTwotone = function SvgBuyButtonButtonLayoutMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$_, _ref2$c);
};

var _ref$$ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M1 15h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm1 3a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0zm0-5h4V7H2v6zm17 4a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M1 3a1 1 0 0 0 1-1 1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m7-3H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m4 2h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2M8 18H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m5-13h-8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m0 4h-8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m-3 4h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2"
});

var SvgBuyButtonHorizontalLayoutMajorMonotone = function SvgBuyButtonHorizontalLayoutMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$$);
};

var _ref$10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 6h6v8H1z"
});

var _ref2$d =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M1 15h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm1 3a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0zm0-5h4V7H2v6zm17 4a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M1 3a1 1 0 0 0 1-1 1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m7-3H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m4 2h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2M8 18H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m5-13h-8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m0 4h-8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m-3 4h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2"
});

var SvgBuyButtonHorizontalLayoutMajorTwotone = function SvgBuyButtonHorizontalLayoutMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$10, _ref2$d);
};

var _ref$11 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M14 0H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 18a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0zM7 6h6V2H7v4zm12 11a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M2 0H1a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0 1 1 0 1 0 0-2m17 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1m0 6a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1M1 9a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m0 6a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m13-5H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m0 4H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m-3 4H6a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2"
});

var SvgBuyButtonVerticalLayoutMajorMonotone = function SvgBuyButtonVerticalLayoutMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$11);
};

var _ref$12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M6 1h8v6H6z"
});

var _ref2$e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M14 0H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 18a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0zM7 6h6V2H7v4zm12 11a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M2 0H1a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0 1 1 0 1 0 0-2m17 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1m0 6a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1M1 9a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m0 6a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m13-5H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m0 4H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m-3 4H6a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2"
});

var SvgBuyButtonVerticalLayoutMajorTwotone = function SvgBuyButtonVerticalLayoutMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$12, _ref2$e);
};

var _ref$13 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19 2h-3V1a1 1 0 1 0-2 0v1H6V1a1 1 0 1 0-2 0v1H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM2 18h16V8H2v10zM2 6h16V4H2v2zm4 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
});

var SvgCalendarMajorMonotone = function SvgCalendarMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$13);
};

var _ref$14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 7h18v12H1z"
});

var _ref2$f =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 2h-3V1a1 1 0 1 0-2 0v1H6V1a1 1 0 1 0-2 0v1H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM2 18h16V8H2v10zM2 6h16V4H2v2zm4 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCalendarMajorTwotone = function SvgCalendarMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$14, _ref2$f);
};

var _ref$15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 8h12V6H4v2zm9 4h2v-2h-2v2zm-4 0h2v-2H9v2zm0 4h2v-2H9v2zm-4-4h2v-2H5v2zm0 4h2v-2H5v2zM17 4h-2V3a1 1 0 1 0-2 0v1H7V3a1 1 0 1 0-2 0v1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCalendarMinor = function SvgCalendarMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$15);
};

var _ref$16 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19 2h-3V1a1 1 0 1 0-2 0v1H6V1a1 1 0 1 0-2 0v1H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8a1 1 0 1 0 0-2H2V8h16v3a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1zM2 6h16V4H2v2zm4 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m5 1a1 1 0 1 0-2 0 1 1 0 1 0 2 0m3.293 3.293L15 17.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414"
});

var SvgCalendarTickMajorMonotone = function SvgCalendarTickMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$16);
};

var _ref$17 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19 2h-3V1a1 1 0 1 0-2 0v1H6V1a1 1 0 1 0-2 0v1H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8a1 1 0 1 0 0-2H2V8h16v3a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1zM2 6h16V4H2v2zm4 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m5 1a1 1 0 1 0-2 0 1 1 0 1 0 2 0m3.293 3.293L15 17.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414"
});

var SvgCalendarTickMajorTwotone = function SvgCalendarTickMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$17);
};

var _ref$18 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 4h-3.382l-.723-1.447A1.001 1.001 0 0 0 14 2H6c-.379 0-.725.214-.895.553L4.382 4H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 12H2V6h3c.379 0 .725-.214.895-.553L6.618 4h6.764l.723 1.447c.17.339.516.553.895.553h3v10zm-8-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4"
});

var SvgCameraMajorMonotone = function SvgCameraMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$18);
};

var _ref$19 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 3,
  fill: "currentColor"
});

var _ref2$g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 4h-3.382l-.723-1.447A1.001 1.001 0 0 0 14 2H6c-.379 0-.725.214-.895.553L4.382 4H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 12H2V6h3c.379 0 .725-.214.895-.553L6.618 4h6.764l.723 1.447c.17.339.516.553.895.553h3v10zm-8-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4"
});

var SvgCameraMajorTwotone = function SvgCameraMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$19, _ref2$g);
};

var _ref$1a =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCancelSmallMinor = function SvgCancelSmallMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1a);
};

var _ref$1b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 9a2 2 0 1 1-.001 4.001A2 2 0 0 1 15 9zm-5 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 10 9zm6-7a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 2zm-3 14a1 1 0 1 1 0 2H7a.998.998 0 0 1-.243-.03l-4-1A1 1 0 0 1 2 16v-3c0-.431.275-.813.684-.948l3-1a.947.947 0 0 1 .294-.047C5.985 11.004 5.992 11 6 11h3a1 1 0 1 1 0 2H7.166c.599 1.807 2.828 3 5.834 3z"
});

var SvgCapturePaymentMinor = function SvgCapturePaymentMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1b);
};

var _ref$1c =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 0a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2v3a1 1 0 0 1-1 1h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 0 1-1-1v-3H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zm-2.424 10H16V6H4v4h1.424A5.002 5.002 0 0 1 10 7a5.002 5.002 0 0 1 4.576 3zM13 14v-2c0-1.654-1.346-3-3-3s-3 1.346-3 3v2h6zM4 4h12V2H4v2z",
  fill: undefined
});

var SvgCardReaderMajorMonotone = function SvgCardReaderMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1c);
};

var _ref$1d =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 5h14V1H3z"
});

var _ref2$h =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 0a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2v3a1 1 0 0 1-1 1h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 0 1-1-1v-3H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zm-2.424 10H16V6H4v4h1.424A5.002 5.002 0 0 1 10 7a5.002 5.002 0 0 1 4.576 3zM13 14v-2c0-1.654-1.346-3-3-3s-3 1.346-3 3v2h6zM4 4h12V2H4v2z",
  fill: undefined
});

var SvgCardReaderMajorTwotone = function SvgCardReaderMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1d, _ref2$h);
};

var _ref$1e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1v-3a3 3 0 0 1 2-2.82V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.18A3 3 0 0 1 18 11v3h1zM2 18h16v-2H2v2zm2-7v3h12v-3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm2-3h4V2H6v6zm6 0h2V2h-2v6z"
});

var SvgCardReaderChipMajorMonotone = function SvgCardReaderChipMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1e);
};

var _ref$1f =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11 1h4v8h-4z"
});

var _ref2$i =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1v-3a3 3 0 0 1 2-2.82V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.18A3 3 0 0 1 18 11v3h1zM2 18h16v-2H2v2zm2-7v3h12v-3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm2-3h4V2H6v6zm6 0h2V2h-2v6z"
});

var SvgCardReaderChipMajorTwotone = function SvgCardReaderChipMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1f, _ref2$i);
};

var _ref$1g =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 4h8a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v9h4V6h-3a1 1 0 0 1 0-2zm5 14h2V6h-2v12zM8 1a1 1 0 0 1-1 1C4.243 2 2 4.243 2 7a1 1 0 0 1-2 0c0-3.86 3.14-7 7-7a1 1 0 0 1 1 1zM7 4a1 1 0 0 1 0 2c-.551 0-1 .449-1 1a1 1 0 0 1-2 0c0-1.654 1.346-3 3-3z",
  fill: undefined
});

var SvgCardReaderTapMajorMonotone = function SvgCardReaderTapMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1g);
};

var _ref$1h =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M15 19h4V5h-4z"
});

var _ref2$j =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 4h8a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v9h4V6h-3a1 1 0 0 1 0-2zm5 14h2V6h-2v12zM8 1a1 1 0 0 1-1 1C4.243 2 2 4.243 2 7a1 1 0 0 1-2 0c0-3.86 3.14-7 7-7a1 1 0 0 1 1 1zM7 4a1 1 0 0 1 0 2c-.551 0-1 .449-1 1a1 1 0 0 1-2 0c0-1.654 1.346-3 3-3z",
  fill: undefined
});

var SvgCardReaderTapMajorTwotone = function SvgCardReaderTapMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1h, _ref2$j);
};

var _ref$1i =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 8l5 5 5-5z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCaretDownMinor = function SvgCaretDownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1i);
};

var _ref$1j =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 12l-5-5-5 5z",
  fill: undefined
});

var SvgCaretUpMinor = function SvgCaretUpMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1j);
};

var _ref$1k =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zM4 17c0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1zM17.666 5.841L16.279 10H4V4.133l13.666 1.708zM17 14H4v-2h13a1 1 0 0 0 .949-.684l2-6a1 1 0 0 0-.825-1.308L4 2.117V1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1v12.184A2.996 2.996 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.184-1h8.368A2.962 2.962 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z"
});

var SvgCartMajorMonotone = function SvgCartMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1k);
};

var _ref$1l =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 11h14l2-6L3 3z"
});

var _ref2$k =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 18c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zM4 17c0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1zM17.666 5.841L16.279 10H4V4.133l13.666 1.708zM17 14H4v-2h13a1 1 0 0 0 .949-.684l2-6a1 1 0 0 0-.825-1.308L4 2.117V1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1v12.184A2.996 2.996 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.184-1h8.368A2.962 2.962 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z",
  fill: undefined
});

var SvgCartMajorTwotone = function SvgCartMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1l, _ref2$k);
};

var _ref$1m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14H4v-2h13a.998.998 0 0 0 .948-.684l2-6a1 1 0 1 0-1.896-.632L16.279 10H4V1a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h1v12.184A2.997 2.997 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h8.37A2.938 2.938 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m-6.707-6.293a.997.997 0 0 0 1.414 0l3-3a.999.999 0 1 0-1.414-1.414L12 4.586V1a1 1 0 1 0-2 0v3.586L8.707 3.293a.999.999 0 1 0-1.414 1.414l3 3zM17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M4 17a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0"
});

var SvgCartDownMajorMonotone = function SvgCartDownMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1m);
};

var _ref$1n =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14H4v-2h13a.998.998 0 0 0 .948-.684l2-6a1 1 0 1 0-1.896-.632L16.279 10H4V1a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h1v12.184A2.997 2.997 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h8.37A2.938 2.938 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m-6.707-6.293a.997.997 0 0 0 1.414 0l3-3a.999.999 0 1 0-1.414-1.414L12 4.586V1a1 1 0 1 0-2 0v3.586L8.707 3.293a.999.999 0 1 0-1.414 1.414l3 3zM17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M4 17a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0"
});

var SvgCartDownMajorTwotone = function SvgCartDownMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1n);
};

var _ref$1o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14H4v-2h13a.998.998 0 0 0 .948-.684l2-6a1 1 0 1 0-1.896-.632L16.279 10H4V1a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h1v12.184A2.997 2.997 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h8.37A2.938 2.938 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3M8.707 4.707L10 3.414V7a1 1 0 1 0 2 0V3.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 1 0 1.414 1.414M17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M4 17a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0"
});

var SvgCartUpMajorMonotone = function SvgCartUpMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1o);
};

var _ref$1p =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14H4v-2h13a.998.998 0 0 0 .948-.684l2-6a1 1 0 1 0-1.896-.632L16.279 10H4V1a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h1v12.184A2.997 2.997 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h8.37A2.938 2.938 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3M8.707 4.707L10 3.414V7a1 1 0 1 0 2 0V3.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 1 0 1.414 1.414M17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M4 17a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0"
});

var SvgCartUpMajorTwotone = function SvgCartUpMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1p);
};

var _ref$1q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M9.977 7c.026 0 .649.04 1.316.707a1 1 0 0 0 1.414-1.414A4.487 4.487 0 0 0 11 5.2V5a1 1 0 1 0-2 0v.184A2.996 2.996 0 0 0 7 8c0 2.28 1.727 2.713 2.758 2.97C10.873 11.25 11 11.354 11 12c0 .552-.448 1-.976 1-.026 0-.65-.04-1.317-.707a1 1 0 0 0-1.414 1.415A4.502 4.502 0 0 0 9 14.798v.2a1 1 0 1 0 2 0v-.184A2.995 2.995 0 0 0 13 12c0-2.28-1.726-2.712-2.757-2.97C9.128 8.752 9 8.646 9 8c0-.55.449-1 .977-1"
});

var SvgCashDollarMajorMonotone = function SvgCashDollarMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1q);
};

var _ref$1r =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$l =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M9.977 7c.026 0 .649.04 1.316.707a1 1 0 0 0 1.414-1.414A4.487 4.487 0 0 0 11 5.2V5a1 1 0 1 0-2 0v.184A2.996 2.996 0 0 0 7 8c0 2.28 1.727 2.713 2.758 2.97C10.873 11.25 11 11.354 11 12c0 .552-.448 1-.976 1-.026 0-.65-.04-1.317-.707a1 1 0 0 0-1.414 1.415A4.502 4.502 0 0 0 9 14.798v.2a1 1 0 1 0 2 0v-.184A2.995 2.995 0 0 0 13 12c0-2.28-1.726-2.712-2.757-2.97C9.128 8.752 9 8.646 9 8c0-.55.449-1 .977-1"
});

var SvgCashDollarMajorTwotone = function SvgCashDollarMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1r, _ref2$l);
};

var _ref$1s =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm-2.986-7.608a10.617 10.617 0 0 1 .014-1H6.75a.75.75 0 0 1 0-1.5h.49C7.696 5.868 8.807 4.4 10.326 4.4c1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5H9.018a8.248 8.248 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5H9.208c.272 1.102.749 1.812 1.119 1.812h.053c.514 0 .507.003.626-.213a.992.992 0 1 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796H6.75a.75.75 0 1 1 0-1.5h.264z"
});

var SvgCashEuroMajorMonotone = function SvgCashEuroMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1s);
};

var _ref$1t =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm-2.986-7.608a10.617 10.617 0 0 1 .014-1H6.75a.75.75 0 0 1 0-1.5h.49C7.696 5.868 8.807 4.4 10.326 4.4c1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5H9.018a8.248 8.248 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5H9.208c.272 1.102.749 1.812 1.119 1.812h.053c.514 0 .507.003.626-.213a.992.992 0 1 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796H6.75a.75.75 0 1 1 0-1.5h.264z"
});

var SvgCashEuroMajorTwotone = function SvgCashEuroMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1t, _ref2$m);
};

var _ref$1u =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm-2.256-7H7.5a1 1 0 0 1 0-2h.472C7.99 8.66 8 8.318 8 7.973 8 6.08 9.057 4.727 10.555 4.49c1.504-.239 2.867.785 2.867 2.4a1 1 0 0 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027H11.5a1 1 0 0 1 0 2H9.77a18.695 18.695 0 0 1-.422 2H12a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1 .998.998 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
});

var SvgCashPoundMajorMonotone = function SvgCashPoundMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1u);
};

var _ref$1v =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$n =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm-2.256-7H7.5a1 1 0 0 1 0-2h.472C7.99 8.66 8 8.318 8 7.973 8 6.08 9.057 4.727 10.555 4.49c1.504-.239 2.867.785 2.867 2.4a1 1 0 0 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027H11.5a1 1 0 0 1 0 2H9.77a18.695 18.695 0 0 1-.422 2H12a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1 .998.998 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
});

var SvgCashPoundMajorTwotone = function SvgCashPoundMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1v, _ref2$n);
};

var _ref$1w =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm-.474-5.938l2.08 2.761a1 1 0 1 1-1.597 1.204L7 12.034a1 1 0 0 1 1.258-1.49c.234.037.492.056.777.056.702 0 1.241-.478 1.493-1.235h-3.1a.75.75 0 0 1 0-1.5h3.229c-.09-.72-.395-1.283-.844-1.58H7.678a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2h-.945c.233.467.38 1.004.432 1.58h.763a.75.75 0 1 1 0 1.5h-.85c-.298 1.407-1.21 2.486-2.552 2.697z"
});

var SvgCashRupeeMajorMonotone = function SvgCashRupeeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1w);
};

var _ref$1x =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm-.474-5.938l2.08 2.761a1 1 0 1 1-1.597 1.204L7 12.034a1 1 0 0 1 1.258-1.49c.234.037.492.056.777.056.702 0 1.241-.478 1.493-1.235h-3.1a.75.75 0 0 1 0-1.5h3.229c-.09-.72-.395-1.283-.844-1.58H7.678a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2h-.945c.233.467.38 1.004.432 1.58h.763a.75.75 0 1 1 0 1.5h-.85c-.298 1.407-1.21 2.486-2.552 2.697z"
});

var SvgCashRupeeMajorTwotone = function SvgCashRupeeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1x, _ref2$o);
};

var _ref$1y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm.975-6.246h1.25a.75.75 0 0 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859L6.734 6.3a1 1 0 0 1 1.732-1l1.515 2.624L11.496 5.3a1 1 0 0 1 1.732 1l-1.85 3.204h.847a.75.75 0 0 1 0 1.5h-1.25v.75z"
});

var SvgCashYenMajorMonotone = function SvgCashYenMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1y);
};

var _ref$1z =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$p =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm.975-6.246h1.25a.75.75 0 0 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859L6.734 6.3a1 1 0 0 1 1.732-1l1.515 2.624L11.496 5.3a1 1 0 0 1 1.732 1l-1.85 3.204h.847a.75.75 0 0 1 0 1.5h-1.25v.75z"
});

var SvgCashYenMajorTwotone = function SvgCashYenMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1z, _ref2$p);
};

var _ref$1A =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h16v-8H2v8zm17 2H1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM17 6H3a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2zm-2-4H5a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z"
});

var SvgCategoriesMajorMonotone = function SvgCategoriesMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1A);
};

var _ref$1B =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 9h18v10H1z"
});

var _ref2$q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h16v-8H2v8zm17 2H1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM17 6H3a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2zm-2-4H5a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z"
});

var SvgCategoriesMajorTwotone = function SvgCategoriesMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1B, _ref2$q);
};

var _ref$1C =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14c-.639 0-1.229.204-1.716.546l-1.56-1.114A3.97 3.97 0 0 0 14 12c0-1.858-1.28-3.411-3-3.858V5.816A2.996 2.996 0 0 0 13 3c0-1.654-1.346-3-3-3S7 1.346 7 3c0 1.302.838 2.401 2 2.815v2.327c-1.72.447-3 2-3 3.858 0 .506.104.985.276 1.432l-1.56 1.114A2.975 2.975 0 0 0 3 14c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.287-.053-.56-.129-.822l1.575-1.125A3.964 3.964 0 0 0 10 16c.976 0 1.859-.365 2.554-.947l1.575 1.125A2.937 2.937 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m0 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m-7-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-7 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m7-16c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1"
});

var SvgChannelsMajorMonotone = function SvgChannelsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1C);
};

var _ref$1D =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 12,
  r: 3,
  fill: "currentColor"
});

var _ref2$r =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14c-.639 0-1.229.204-1.716.546l-1.56-1.114A3.97 3.97 0 0 0 14 12c0-1.858-1.28-3.411-3-3.858V5.816A2.996 2.996 0 0 0 13 3c0-1.654-1.346-3-3-3S7 1.346 7 3c0 1.302.838 2.401 2 2.815v2.327c-1.72.447-3 2-3 3.858 0 .506.104.985.276 1.432l-1.56 1.114A2.975 2.975 0 0 0 3 14c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.287-.053-.56-.129-.822l1.575-1.125A3.964 3.964 0 0 0 10 16c.976 0 1.859-.365 2.554-.947l1.575 1.125A2.937 2.937 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m0 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m-7-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-7 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m7-16c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1"
});

var SvgChannelsMajorTwotone = function SvgChannelsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1D, _ref2$r);
};

var _ref$1E =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10c0 1.728.45 3.42 1.304 4.924l-1.253 3.76a1.001 1.001 0 0 0 1.265 1.264l3.76-1.253A9.947 9.947 0 0 0 10 20c5.514 0 10-4.486 10-10S15.514 0 10 0m0 18a7.973 7.973 0 0 1-4.269-1.243.996.996 0 0 0-.852-.104l-2.298.766.766-2.299a.998.998 0 0 0-.104-.851A7.973 7.973 0 0 1 2 10c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8m0-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
});

var SvgChatMajorMonotone = function SvgChatMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1E);
};

var _ref$1F =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 1a9 9 0 0 0-9 9c0 1.769.518 3.413 1.398 4.804L1 19l4.196-1.398A8.954 8.954 0 0 0 10 19a9 9 0 0 0 9-9 9 9 0 0 0-9-9"
});

var _ref2$s =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10c0 1.728.45 3.42 1.304 4.924l-1.253 3.76a1.001 1.001 0 0 0 1.265 1.264l3.76-1.253A9.947 9.947 0 0 0 10 20c5.514 0 10-4.486 10-10S15.514 0 10 0m0 18a7.973 7.973 0 0 1-4.269-1.243.996.996 0 0 0-.852-.104l-2.298.766.766-2.299a.998.998 0 0 0-.104-.851A7.973 7.973 0 0 1 2 10c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8m0-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
});

var SvgChatMajorTwotone = function SvgChatMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1F, _ref2$s);
};

var _ref$1G =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 2h-2.586L12.707.293A.997.997 0 0 0 12 0H8a.997.997 0 0 0-.707.293L5.586 2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 16H4V4h1.586l1.707 1.707A.997.997 0 0 0 8 6h4c.265 0 .52-.105.707-.293L14.414 4H16v14zM8.414 2h3.172l1 1-1 1H8.414l-1-1 1-1zm3.879 7.293L9 12.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414"
});

var SvgChecklistMajorMonotone = function SvgChecklistMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1G);
};

var _ref$1H =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M14 3l-2 2H8.001L6 3H3v16h14.001V3z"
});

var _ref2$t =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 2h-2.586L12.707.293A.997.997 0 0 0 12 0H8a.997.997 0 0 0-.707.293L5.586 2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 16H4V4h1.586l1.707 1.707A.997.997 0 0 0 8 6h4c.265 0 .52-.105.707-.293L14.414 4H16v14zM8.414 2h3.172l1 1-1 1H8.414l-1-1 1-1zm3.879 7.293L9 12.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414"
});

var SvgChecklistMajorTwotone = function SvgChecklistMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1H, _ref2$t);
};

var _ref$1I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 2h-2.586L12.707.293A.996.996 0 0 0 12 0H8a.996.996 0 0 0-.707.293L5.586 2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 16H4V4h1.586l1.707 1.707A.996.996 0 0 0 8 6h4c.266 0 .52-.105.707-.293L14.414 4H16v14zM8.414 2h3.172l1 1-1 1H8.414l-1-1 1-1zM7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
});

var SvgChecklistAlternateMajorMonotone = function SvgChecklistAlternateMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1I);
};

var _ref$1J =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M14 3l-2 2H8.001L6 3H3v16h14.001V3z"
});

var _ref2$u =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 2h-2.586L12.707.293A.996.996 0 0 0 12 0H8a.996.996 0 0 0-.707.293L5.586 2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 16H4V4h1.586l1.707 1.707A.996.996 0 0 0 8 6h4c.266 0 .52-.105.707-.293L14.414 4H16v14zM8.414 2h3.172l1 1-1 1H8.414l-1-1 1-1zM7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
});

var SvgChecklistAlternateMajorTwotone = function SvgChecklistAlternateMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1J, _ref2$u);
};

var _ref$1K =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 17c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zM17.666 5.84L16.28 10H4V4.133L17.666 5.84zM17 14H4v-2h13c.43 0 .812-.275.95-.684l2-6a1 1 0 0 0-.826-1.308L4 2.118V1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1v12.184A2.997 2.997 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.184-1h8.368A2.962 2.962 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z",
  fill: undefined
});

var SvgCheckoutMajorMonotone = function SvgCheckoutMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1K);
};

var _ref$1L =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 11h14l2-6L3 3z"
});

var _ref2$v =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 17c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zM17.666 5.84L16.28 10H4V4.133L17.666 5.84zM17 14H4v-2h13c.43 0 .812-.275.95-.684l2-6a1 1 0 0 0-.826-1.308L4 2.118V1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1v12.184A2.997 2.997 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.184-1h8.368A2.962 2.962 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z",
  fill: undefined
});

var SvgCheckoutMajorTwotone = function SvgCheckoutMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1L, _ref2$v);
};

var _ref$1M =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 14a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 1 1 1.414-1.414L10 11.586l4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5A.997.997 0 0 1 10 14",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgChevronDownMinor = function SvgChevronDownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1M);
};

var _ref$1N =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgChevronLeftMinor = function SvgChevronLeftMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1N);
};

var _ref$1O =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgChevronRightMinor = function SvgChevronRightMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1O);
};

var _ref$1P =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 13a.997.997 0 0 1-.707-.293L10 8.414l-4.293 4.293a.999.999 0 1 1-1.414-1.414l5-5a.999.999 0 0 1 1.414 0l5 5A.999.999 0 0 1 15 13",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgChevronUpMinor = function SvgChevronUpMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1P);
};

var _ref$1Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-7a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1m0 1.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2"
});

var SvgCircleAlertMajorMonotone = function SvgCircleAlertMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1Q);
};

var _ref$1R =
/*#__PURE__*/
React.createElement("circle", {
  fill: "currentColor",
  cx: 10,
  cy: 10,
  r: 9
});

var _ref2$w =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-13a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1m0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
  fill: undefined
});

var SvgCircleAlertMajorTwotone = function SvgCircleAlertMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1R, _ref2$w);
};

var _ref$1S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m3.707-11.707a.999.999 0 0 0-1.414 0L10 8.586 7.707 6.293a.999.999 0 1 0-1.414 1.414L8.586 10l-2.293 2.293a.999.999 0 1 0 1.414 1.414L10 11.414l2.293 2.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10l2.293-2.293a.999.999 0 0 0 0-1.414"
});

var SvgCircleCancelMajorMonotone = function SvgCircleCancelMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1S);
};

var _ref$1T =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$x =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m3.707-11.707a.999.999 0 0 0-1.414 0L10 8.586 7.707 6.293a.999.999 0 1 0-1.414 1.414L8.586 10l-2.293 2.293a.999.999 0 1 0 1.414 1.414L10 11.414l2.293 2.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10l2.293-2.293a.999.999 0 0 0 0-1.414"
});

var SvgCircleCancelMajorTwotone = function SvgCircleCancelMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1T, _ref2$x);
};

var _ref$1U =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.242 12.829l-1.414 1.414L10 11.413l-2.828 2.83-1.414-1.414 2.828-2.83-2.828-2.827 1.414-1.414L10 8.586l2.828-2.828 1.414 1.414L11.414 10l2.828 2.829zM10 1.999A8 8 0 1 0 10 18a8 8 0 0 0 0-16z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCircleCancelMinor = function SvgCircleCancelMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1U);
};

var _ref$1V =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 13.414L5.293 8.707l1.414-1.414L10 10.586l3.293-3.293 1.414 1.414L10 13.414zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCircleChevronDownMinor = function SvgCircleChevronDownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1V);
};

var _ref$1W =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.293 5.293l1.414 1.414L9.414 10l3.293 3.293-1.414 1.414L6.586 10l4.707-4.707zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCircleChevronLeftMinor = function SvgCircleChevronLeftMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1W);
};

var _ref$1X =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.707 14.707l-1.414-1.414L10.586 10 7.293 6.707l1.414-1.414L13.414 10l-4.707 4.707zM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCircleChevronRightMinor = function SvgCircleChevronRightMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1X);
};

var _ref$1Y =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.707 11.293l-1.414 1.414L10 9.414l-3.293 3.293-1.414-1.414L10 6.586l4.707 4.707zM18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCircleChevronUpMinor = function SvgCircleChevronUpMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1Y);
};

var _ref$1Z =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 16a5.961 5.961 0 0 1-3.471-1.115l8.356-8.356A5.961 5.961 0 0 1 16 10c0 3.309-2.691 6-6 6m0-12c1.294 0 2.49.416 3.471 1.115l-8.356 8.356A5.961 5.961 0 0 1 4 10c0-3.309 2.691-6 6-6m0-2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCircleDisableMinor = function SvgCircleDisableMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1Z);
};

var _ref$1_ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 10c0-1.846.635-3.543 1.688-4.897l11.209 11.209A7.954 7.954 0 0 1 10 18c-4.411 0-8-3.589-8-8m14.312 4.897L5.103 3.688A7.954 7.954 0 0 1 10 2c4.411 0 8 3.589 8 8a7.952 7.952 0 0 1-1.688 4.897M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10"
});

var SvgCircleDisabledMajorMonotone = function SvgCircleDisabledMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1_);
};

var _ref$1$ =
/*#__PURE__*/
React.createElement("circle", {
  fill: "currentColor",
  cx: 10,
  cy: 10,
  r: 9
});

var _ref2$y =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 10c0-1.846.635-3.543 1.688-4.897l11.209 11.209A7.954 7.954 0 0 1 10 18c-4.411 0-8-3.589-8-8m14.312 4.897L5.103 3.688A7.954 7.954 0 0 1 10 2c4.411 0 8 3.589 8 8a7.952 7.952 0 0 1-1.688 4.897M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10",
  fill: undefined
});

var SvgCircleDisabledMajorTwotone = function SvgCircleDisabledMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$1$, _ref2$y);
};

var _ref$20 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
});

var SvgCircleDotsMajorMonotone = function SvgCircleDotsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$20);
};

var _ref$21 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
});

var SvgCircleDotsMajorTwotone = function SvgCircleDotsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$21, _ref2$z);
};

var _ref$22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 20c5.514 0 10-4.486 10-10S15.514 0 10 0 0 4.486 0 10s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm-.707 12.707a.997.997 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V6a1 1 0 0 0-2 0v5.586l-1.293-1.293a.994.994 0 0 0-1.414 0 .997.997 0 0 0 0 1.414l3 3z",
  fill: undefined
});

var SvgCircleDownMajorMonotone = function SvgCircleDownMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$22);
};

var _ref$23 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$A =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 20c5.514 0 10-4.486 10-10S15.514 0 10 0 0 4.486 0 10s4.486 10 10 10m0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8m-.707 12.707a.999.999 0 0 0 1.414 0l3-3a.999.999 0 1 0-1.414-1.414L11 11.586V6a1 1 0 1 0-2 0v5.586l-1.293-1.293a.997.997 0 0 0-1.414 0 .999.999 0 0 0 0 1.414l3 3z"
});

var SvgCircleDownMajorTwotone = function SvgCircleDownMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$23, _ref2$A);
};

var _ref$24 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m1-5v-3a1 1 0 0 0-1-1H9a1 1 0 1 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m-1-5.9a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2"
});

var SvgCircleInformationMajorMonotone = function SvgCircleInformationMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$24);
};

var _ref$25 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$B =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m1-5v-3a1 1 0 0 0-1-1H9a1 1 0 1 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m-1-5.9a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2"
});

var SvgCircleInformationMajorTwotone = function SvgCircleInformationMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$25, _ref2$B);
};

var _ref$26 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10m18 0c0 4.411-3.589 8-8 8s-8-3.589-8-8 3.589-8 8-8 8 3.589 8 8M5.293 9.293a.999.999 0 0 0 0 1.414l3 3a.999.999 0 1 0 1.414-1.414L8.414 11H14a1 1 0 1 0 0-2H8.414l1.293-1.293a.997.997 0 0 0 0-1.414.999.999 0 0 0-1.414 0l-3 3z"
});

var SvgCircleLeftMajorMonotone = function SvgCircleLeftMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$26);
};

var _ref$27 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$C =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10m18 0c0 4.411-3.589 8-8 8s-8-3.589-8-8 3.589-8 8-8 8 3.589 8 8M5.293 9.293a.999.999 0 0 0 0 1.414l3 3a.999.999 0 1 0 1.414-1.414L8.414 11H14a1 1 0 1 0 0-2H8.414l1.293-1.293a.997.997 0 0 0 0-1.414.999.999 0 0 0-1.414 0l-3 3z"
});

var SvgCircleLeftMajorTwotone = function SvgCircleLeftMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$27, _ref2$C);
};

var _ref$28 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m4-9H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2"
});

var SvgCircleMinusMajorMonotone = function SvgCircleMinusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$28);
};

var _ref$29 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$D =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m4-9H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2"
});

var SvgCircleMinusMajorTwotone = function SvgCircleMinusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$29, _ref2$D);
};

var _ref$2a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 11H5V9h10v2zm-5-9a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
});

var SvgCircleMinusMinor = function SvgCircleMinusMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2a);
};

var _ref$2b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6M7 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7z"
});

var SvgCircleMinusOutlineMinor = function SvgCircleMinusOutlineMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2b);
};

var _ref$2c =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
  fill: undefined
});

var _ref2$E =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.996 8.996V7.008c.001-.043 0-.054.004-.097.044-.449.423-.845.879-.9.094-.011.115-.007.145-.007.043.002.054.002.097.007.448.054.834.442.879.9.004.043.003.054.004.097v1.988h1.992l.048.001c.49.035.918.441.954.93.039.545-.424 1.063-1.002 1.077h-1.992V13a1.04 1.04 0 0 1-.648.939c-.584.221-1.327-.217-1.359-.891L8.996 13v-1.996H7.004c-.511-.012-.966-.435-1.002-.931-.038-.53.396-1.049.954-1.076l.048-.001h1.992z",
  fill: undefined
});

var SvgCirclePlusMajorMonotone = function SvgCirclePlusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2c, _ref2$E);
};

var _ref$2d =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$F =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m4-9h-3V6a1 1 0 1 0-2 0v3H6a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2"
});

var SvgCirclePlusMajorTwotone = function SvgCirclePlusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2d, _ref2$F);
};

var _ref$2e =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 11h-4v4H9v-4H5V9h4V5h2v4h4v2zm-5-9a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgCirclePlusMinor = function SvgCirclePlusMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2e);
};

var _ref$2f =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm3-7h-2V7a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2z",
  fill: undefined
});

var SvgCirclePlusOutlineMinor = function SvgCirclePlusOutlineMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2f);
};

var _ref$2g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M20 10c0-5.514-4.486-10-10-10S0 4.486 0 10s4.486 10 10 10 10-4.486 10-10M2 10c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8m12.707.707a.999.999 0 0 0 0-1.414l-3-3a.999.999 0 1 0-1.414 1.414L11.586 9H6a1 1 0 1 0 0 2h5.586l-1.293 1.293a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0l3-3z"
});

var SvgCircleRightMajorMonotone = function SvgCircleRightMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2g);
};

var _ref$2h =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$G =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M20 10c0-5.514-4.486-10-10-10S0 4.486 0 10s4.486 10 10 10 10-4.486 10-10M2 10c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8m12.707.707a.999.999 0 0 0 0-1.414l-3-3a.999.999 0 1 0-1.414 1.414L11.586 9H6a1 1 0 1 0 0 2h5.586l-1.293 1.293a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0l3-3z"
});

var SvgCircleRightMajorTwotone = function SvgCircleRightMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2h, _ref2$G);
};

var _ref$2i =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m2.293-10.707L9 10.586 7.707 9.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414",
  fill: undefined
});

var SvgCircleTickMajorMonotone = function SvgCircleTickMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2i);
};

var _ref$2j =
/*#__PURE__*/
React.createElement("circle", {
  fill: "currentColor",
  cx: 10,
  cy: 10,
  r: 9
});

var _ref2$H =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m2.293-10.707L9 10.586 7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414",
  fill: undefined
});

var SvgCircleTickMajorTwotone = function SvgCircleTickMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2j, _ref2$H);
};

var _ref$2k =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-14c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m-1 9a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414L9 10.586l3.293-3.293a.999.999 0 1 1 1.414 1.414l-4 4A.997.997 0 0 1 9 13"
});

var SvgCircleTickOutlineMinor = function SvgCircleTickOutlineMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2k);
};

var _ref$2l =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m.707-12.707a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 1 0 1.414 1.414L9 8.414V14a1 1 0 1 0 2 0V8.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3z"
});

var SvgCircleUpMajorMonotone = function SvgCircleUpMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2l);
};

var _ref$2m =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m.707-12.707a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 1 0 1.414 1.414L9 8.414V14a1 1 0 1 0 2 0V8.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3z"
});

var SvgCircleUpMajorTwotone = function SvgCircleUpMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2m, _ref2$I);
};

var _ref$2n =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 1 1 2 0v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V3a1 1 0 0 1 1-1m-4 2H9a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2"
});

var SvgClipboardMinor = function SvgClipboardMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2n);
};

var _ref$2o =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm1-8.414V5a1 1 0 0 0-2 0v5c0 .266.105.52.293.707l3 3a.994.994 0 0 0 1.414 0 .997.997 0 0 0 0-1.414L11 9.586z",
  fill: undefined
});

var SvgClockMajorMonotone = function SvgClockMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2o);
};

var _ref$2p =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$J =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m1-8.414V5a1 1 0 1 0-2 0v5c0 .266.105.52.293.707l3 3a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11 9.586z"
});

var SvgClockMajorTwotone = function SvgClockMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2p, _ref2$J);
};

var _ref$2q =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm2 9a.997.997 0 0 1-.707-.293l-2-2A.997.997 0 0 1 9 10V7a1 1 0 1 1 2 0v2.586l1.707 1.707A1 1 0 0 1 12 13z",
  fill: undefined
});

var SvgClockMinor = function SvgClockMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2q);
};

var _ref$2r =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 9a.99.99 0 0 1-.3.7l-.29.3.3.3A1 1 0 0 1 3 11v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2 3 3 0 0 1-3-3v-3.59l-.7-.7a1 1 0 0 1 0-1.42l.7-.7V5a3 3 0 0 1 3-3 1 1 0 1 1 0 2 1 1 0 0 0-1 1v4zm16.7.3a1 1 0 0 1 0 1.4l-.7.71V15a3 3 0 0 1-3 3 1 1 0 0 1 0-2 1 1 0 0 0 1-1v-4a.99.99 0 0 1 .3-.7l.29-.3-.3-.3A1 1 0 0 1 17 9V5a1 1 0 0 0-1-1 1 1 0 0 1 0-2 3 3 0 0 1 3 3v3.59l.7.7zm-7.33-5.23a1 1 0 0 1 .56 1.3l-4 10A1 1 0 0 1 8 16a1 1 0 0 1-.93-1.37l4-10a1 1 0 0 1 1.3-.56z",
  fill: undefined
});

var SvgCodeMajorMonotone = function SvgCodeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2r);
};

var _ref$2s =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3 9c0 .266-.105.52-.293.707L2.414 10l.293.293A.996.996 0 0 1 3 11v4a1 1 0 0 0 1 1 1 1 0 1 1 0 2c-1.654 0-3-1.346-3-3v-3.586l-.707-.707a.999.999 0 0 1 0-1.414L1 8.586V5c0-1.654 1.346-3 3-3a1 1 0 1 1 0 2 1 1 0 0 0-1 1v4zm16.707.293a.999.999 0 0 1 0 1.414l-.707.707V15c0 1.654-1.346 3-3 3a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-4c0-.266.105-.52.293-.707l.293-.293-.293-.293A.996.996 0 0 1 17 9V5a1 1 0 0 0-1-1 1 1 0 1 1 0-2c1.654 0 3 1.346 3 3v3.586l.707.707zm-7.336-5.222a1 1 0 0 1 .558 1.3l-4 10a1.002 1.002 0 0 1-1.3.557 1 1 0 0 1-.558-1.299l4-10a.999.999 0 0 1 1.3-.558z"
});

var SvgCodeMajorTwotone = function SvgCodeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2s);
};

var _ref$2t =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 20a1 1 0 0 0 1-1V6c0-.297-.132-.578-.36-.77l-6-5a1.005 1.005 0 0 0-1.28 0L10 2.198 7.64.23a1.005 1.005 0 0 0-1.28 0l-6 5C.13 5.423 0 5.704 0 6v13a1 1 0 0 0 1 1h18zM8 18v-2h10v2H8zm-6 0v-2h4v2H2zM7 2.302L8.438 3.5l-2.08 1.73A1.018 1.018 0 0 0 6 6v8H2V6.47L7 2.3zm6 0l5 4.167V14H8V6.47l5-4.17zM13 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2z",
  fill: undefined
});

var SvgCollectionsMajorMonotone = function SvgCollectionsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2t);
};

var _ref$2u =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 15h12v4H7v-4z"
});

var _ref2$K =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 20a1 1 0 0 0 1-1V6c0-.297-.132-.578-.36-.77l-6-5a1.005 1.005 0 0 0-1.28 0L10 2.198 7.64.23a1.005 1.005 0 0 0-1.28 0l-6 5C.13 5.423 0 5.704 0 6v13a1 1 0 0 0 1 1h18zM8 18v-2h10v2H8zm-6 0v-2h4v2H2zM7 2.302L8.438 3.5l-2.08 1.73A1.018 1.018 0 0 0 6 6v8H2V6.47L7 2.3zm6 0l5 4.167V14H8V6.47l5-4.17zM13 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2z",
  fill: undefined
});

var SvgCollectionsMajorTwotone = function SvgCollectionsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2u, _ref2$K);
};

var _ref$2v =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.76 4.35a1 1 0 0 0-1.41-.108S2.312 16.274 2.293 16.292a1.002 1.002 0 0 0 0 1.415.992.992 0 0 0 1.35.043l.008.01 1.964-1.683A5.968 5.968 0 0 0 10 18a6 6 0 0 0 6-6c0-1.157-.51-2.48-1.223-3.777L17.65 5.76c.42-.36.47-.99.11-1.41zM4.01 12.184C4.006 12.122 4 12.064 4 12c0-4 6-10 6-10s1.2 1.203 2.525 2.885l-8.516 7.3z",
  fill: undefined
});

var SvgColorNoneMinor = function SvgColorNoneMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2v);
};

var _ref$2w =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 10h-2.586l3.293-3.293a.999.999 0 0 0 0-1.414l-5-5a.999.999 0 0 0-1.414 0L10 3.586V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v14c0 2.757 2.243 5 5 5h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM5 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm11 2h2v-6h-2v6zm-2 0H8.975c.288-.381.522-.799.693-1.254L14 12.414V18zM2 4h6V2H2v2zm6 11c0 1.654-1.346 3-3 3s-3-1.346-3-3V6h6v9zm2-8.586l1-1L14.586 9 10 13.586V6.414zm4-4L17.586 6 16 7.586 12.414 4 14 2.414z"
});

var SvgColorsMajorMonotone = function SvgColorsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2w);
};

var _ref$2x =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 15a4 4 0 0 0 8 0V1H1v14z"
});

var _ref2$L =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 10h-2.586l3.293-3.293a.999.999 0 0 0 0-1.414l-5-5a.999.999 0 0 0-1.414 0L10 3.586V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v14c0 2.757 2.243 5 5 5h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM5 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm11 2h2v-6h-2v6zm-2 0H8.975c.288-.381.522-.799.693-1.254L14 12.414V18zM2 4h6V2H2v2zm6 11c0 1.654-1.346 3-3 3s-3-1.346-3-3V6h6v9zm2-8.586l1-1L14.586 9 10 13.586V6.414zm4-4L17.586 6 16 7.586 12.414 4 14 2.414z"
});

var SvgColorsMajorTwotone = function SvgColorsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2x, _ref2$L);
};

var _ref$2y =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7zM8 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7zm5 6h5V2h-5v4zM2 6h5V2H2v4zm6 4H1a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm0 4H1a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-5 4H1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm16-8h-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm0 4h-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-5 4h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
  fill: undefined
});

var SvgColumnWithTextMajorMonotone = function SvgColumnWithTextMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2y);
};

var _ref$2z =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h7v6H1V1zm11 0h7v6h-7V1z"
});

var _ref2$M =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7zM8 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7zm5 6h5V2h-5v4zM2 6h5V2H2v4zm6 4H1a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm0 4H1a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-5 4H1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm16-8h-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm0 4h-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-5 4h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
  fill: undefined
});

var SvgColumnWithTextMajorTwotone = function SvgColumnWithTextMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2z, _ref2$M);
};

var _ref$2A =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6.707 6.293a1.003 1.003 0 0 0-1.587.232l-4.866 9a.986.986 0 0 0-.06.133 3.23 3.23 0 0 0 .75 3.378 3.23 3.23 0 0 0 3.377.75c.045-.017.09-.037.132-.059l9.021-4.846a.998.998 0 0 0 .233-1.588l-7-7zM3.58 17.926a1.222 1.222 0 0 1-1.525-1.524l4.187-7.746 5.101 5.1-7.763 4.17zM15 4a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1 1 1 0 1 0 0-2 1 1 0 0 1-1-1 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 1 0 0 2M1 4a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1 1 1 0 1 0 0-2 1 1 0 0 1-1-1 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 1 0 0 2m18 12a1 1 0 0 1-1-1 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1 1 1 0 1 0 0-2m-7-7a.997.997 0 0 0 .707-.293l1-1a.999.999 0 1 0-1.414-1.414l-1 1A.999.999 0 0 0 12 9m6.684.052l-3 1a1 1 0 1 0 .633 1.896l3-1a1 1 0 1 0-.633-1.896m-10-4.103a1.001 1.001 0 0 0 1.265-.632l1-3A1 1 0 0 0 9.052.683l-1 3a1 1 0 0 0 .632 1.264"
});

var SvgConfettiMajorMonotone = function SvgConfettiMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2A);
};

var _ref$2B =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1.65 18.33a2.22 2.22 0 0 0 2.33.516L13 14 6 7l-4.867 9a2.22 2.22 0 0 0 .517 2.33"
});

var _ref2$N =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6.707 6.293a1.003 1.003 0 0 0-1.587.232l-4.866 9a.986.986 0 0 0-.06.133 3.23 3.23 0 0 0 .75 3.378 3.23 3.23 0 0 0 3.377.75c.045-.017.09-.037.132-.059l9.021-4.846a.998.998 0 0 0 .233-1.588l-7-7zM3.58 17.926a1.222 1.222 0 0 1-1.525-1.524l4.187-7.746 5.101 5.1-7.763 4.17zM15 4a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1 1 1 0 1 0 0-2 1 1 0 0 1-1-1 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 1 0 0 2M1 4a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1 1 1 0 1 0 0-2 1 1 0 0 1-1-1 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 1 0 0 2m18 12a1 1 0 0 1-1-1 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1 1 1 0 1 0 0-2m-7-7a.997.997 0 0 0 .707-.293l1-1a.999.999 0 1 0-1.414-1.414l-1 1A.999.999 0 0 0 12 9m6.684.052l-3 1a1 1 0 1 0 .633 1.896l3-1a1 1 0 1 0-.633-1.896m-10-4.103a1.001 1.001 0 0 0 1.265-.632l1-3A1 1 0 0 0 9.052.683l-1 3a1 1 0 0 0 .632 1.264"
});

var SvgConfettiMajorTwotone = function SvgConfettiMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2B, _ref2$N);
};

var _ref$2C =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14 8c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-6 6c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2m6-12c-1.858 0-3.411 1.28-3.857 3H10c-2.757 0-5 2.243-5 5v.142c-1.721.447-3 2-3 3.858 0 2.206 1.794 4 4 4s4-1.794 4-4c0-1.858-1.279-3.411-3-3.858V10c0-1.654 1.346-3 3-3h.143c.446 1.72 1.999 3 3.857 3 2.206 0 4-1.794 4-4s-1.794-4-4-4"
});

var SvgConnectMinor = function SvgConnectMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2C);
};

var _ref$2D =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 11h2V9h-2v2zm-4 0h2V9H9v2zm-4 0h2V9H5v2zm5-9c-4.411 0-8 3.589-8 8 0 1.504.425 2.908 1.15 4.111l-1.069 2.495a1 1 0 0 0 1.314 1.313l2.494-1.069A7.939 7.939 0 0 0 10 18c4.411 0 8-3.589 8-8s-3.589-8-8-8z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgConversationMinor = function SvgConversationMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2D);
};

var _ref$2E =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M2 16h16v-6H2v6zM2 6h16V4H2v2zM1 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H1zm4 10a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H5z"
});

var SvgCreditCardMajorMonotone = function SvgCreditCardMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2E);
};

var _ref$2F =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 3h18v5H1z"
});

var _ref2$O =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M2 16h16v-6H2v6zM2 6h16V4H2v2zM1 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H1zm4 10a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H5z"
});

var SvgCreditCardMajorTwotone = function SvgCreditCardMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2F, _ref2$O);
};

var _ref$2G =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M1 0h18a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8H2v6h7a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm16 18.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm-4.707-.207l6-6a.999.999 0 1 1 1.414 1.414l-6 6a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414zM15 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM5 10h3a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zM2 4h16V2H2v2z"
});

var SvgCreditCardPercentMajorMonotone = function SvgCreditCardPercentMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2G);
};

var _ref$2H =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v5H1z"
});

var _ref2$P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M1 0h18a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8H2v6h7a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm16 18.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm-4.707-.207l6-6a.999.999 0 1 1 1.414 1.414l-6 6a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414zM15 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM5 10h3a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zM2 4h16V2H2v2z"
});

var SvgCreditCardPercentMajorTwotone = function SvgCreditCardPercentMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2H, _ref2$P);
};

var _ref$2I =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 1 0 0-2H2V8h16v1a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1zm0 14v-1c0-1.654-1.346-3-3-3s-3 1.346-3 3v1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zM5 10a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H5zM2 4h16V2H2v2zm12 14h4v-2h-4v2zm1-5a1 1 0 0 1 2 0v1h-2v-1z"
});

var SvgCreditCardSecureMajorMonotone = function SvgCreditCardSecureMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2I);
};

var _ref$2J =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v5H1z"
});

var _ref2$Q =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 1 0 0-2H2V8h16v1a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1zm0 14v-1c0-1.654-1.346-3-3-3s-3 1.346-3 3v1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zM5 10a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H5zM2 4h16V2H2v2zm12 14h4v-2h-4v2zm1-5a1 1 0 0 1 2 0v1h-2v-1z"
});

var SvgCreditCardSecureMajorTwotone = function SvgCreditCardSecureMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2J, _ref2$Q);
};

var _ref$2K =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 6a1 1 0 0 1 1-1h3.59l-.29-.29a1 1 0 0 1 1.41-1.41l2 2a1 1 0 0 1 0 1.42l-2 2a1 1 0 0 1-1.41-1.41l.29-.31H11a1 1 0 0 1-1-1zm7 7h-3.59l.29-.29a1 1 0 0 0-1.41-1.41l-2 2a1 1 0 0 0 0 1.42l2 2a1 1 0 0 0 1.41-1.41l-.29-.31H17a1 1 0 0 0 0-2zM5 7a2.19 2.19 0 0 1 1.32.71 1 1 0 0 0 1.39-1.42A4.51 4.51 0 0 0 6 5.2V5a1 1 0 0 0-2 0v.18A3 3 0 0 0 2 8c0 2.28 1.73 2.71 2.76 3S6 11.35 6 12a1 1 0 0 1-1 1 2.19 2.19 0 0 1-1.32-.71 1 1 0 0 0-1.41 1.41A4.51 4.51 0 0 0 4 14.8v.2a1 1 0 0 0 2 0v-.18A3 3 0 0 0 8 12c0-2.28-1.73-2.71-2.76-3S4 8.65 4 8a1 1 0 0 1 1-1z",
  fill: undefined
});

var SvgCurrencyConvertMinor = function SvgCurrencyConvertMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2K);
};

var _ref$2L =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 12C2.516 12 .26 15.305.168 15.445a1.003 1.003 0 0 0-.117.871l1 3A1 1 0 0 0 2 20h10c.43 0 .812-.275.948-.684l1-3a1 1 0 0 0-.116-.871C13.738 15.305 11.482 12 7 12zM7 2c1.654 0 3 1.346 3 3S8.654 8 7 8 4 6.654 4 5s1.346-3 3-3m0 8c2.757 0 5-2.243 5-5S9.757 0 7 0 2 2.243 2 5s2.243 5 5 5m4.279 8h-8.56l-.6-1.804C2.74 15.492 4.369 14 6.999 14c2.638 0 4.26 1.489 4.882 2.194L11.279 18zm7.72-9h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"
});

var SvgCustomerMinusMajorMonotone = function SvgCustomerMinusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2L);
};

var _ref$2M =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 13c4 0 6 3 6 3l-1 3H2l-1-3s2-3 6-3"
});

var _ref2$R =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 12C2.516 12 .26 15.305.168 15.445a1.003 1.003 0 0 0-.117.871l1 3A1 1 0 0 0 2 20h10c.43 0 .812-.275.948-.684l1-3a1 1 0 0 0-.116-.871C13.738 15.305 11.482 12 7 12zM7 2c1.654 0 3 1.346 3 3S8.654 8 7 8 4 6.654 4 5s1.346-3 3-3m0 8c2.757 0 5-2.243 5-5S9.757 0 7 0 2 2.243 2 5s2.243 5 5 5m4.279 8h-8.56l-.6-1.804C2.74 15.492 4.369 14 6.999 14c2.638 0 4.26 1.489 4.882 2.194L11.279 18zm7.72-9h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"
});

var SvgCustomerMinusMajorTwotone = function SvgCustomerMinusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2M, _ref2$R);
};

var _ref$2N =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 12C2.516 12 .26 15.305.168 15.445a1.003 1.003 0 0 0-.117.871l1 3A1 1 0 0 0 2 20h10c.43 0 .812-.275.948-.684l1-3a1 1 0 0 0-.116-.871C13.738 15.305 11.482 12 7 12zM7 2c1.654 0 3 1.346 3 3S8.654 8 7 8 4 6.654 4 5s1.346-3 3-3m0 8c2.757 0 5-2.243 5-5S9.757 0 7 0 2 2.243 2 5s2.243 5 5 5m4.279 8h-8.56l-.6-1.804C2.74 15.492 4.369 14 6.999 14c2.638 0 4.26 1.489 4.882 2.194L11.279 18zm7.72-9h-2V7a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2"
});

var SvgCustomerPlusMajorMonotone = function SvgCustomerPlusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2N);
};

var _ref$2O =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 13c4 0 6 3 6 3l-1 3H2l-1-3s2-3 6-3"
});

var _ref2$S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 12C2.516 12 .26 15.305.168 15.445a1.003 1.003 0 0 0-.117.871l1 3A1 1 0 0 0 2 20h10c.43 0 .812-.275.948-.684l1-3a1 1 0 0 0-.116-.871C13.738 15.305 11.482 12 7 12zM7 2c1.654 0 3 1.346 3 3S8.654 8 7 8 4 6.654 4 5s1.346-3 3-3m0 8c2.757 0 5-2.243 5-5S9.757 0 7 0 2 2.243 2 5s2.243 5 5 5m4.279 8h-8.56l-.6-1.804C2.74 15.492 4.369 14 6.999 14c2.638 0 4.26 1.489 4.882 2.194L11.279 18zm7.72-9h-2V7a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2"
});

var SvgCustomerPlusMajorTwotone = function SvgCustomerPlusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2O, _ref2$S);
};

var _ref$2P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 15.293a.999.999 0 0 1 .241 1.023l-1 3A.999.999 0 0 1 16 20H4a1 1 0 0 1-.949-.684l-1-3a.999.999 0 0 1 .242-1.023C2.427 15.158 5.635 12 10 12c4.364 0 7.572 3.158 7.707 3.293zM15.28 18l.562-1.687c-.92-.752-3.155-2.313-5.84-2.313-2.704 0-4.928 1.558-5.844 2.31L4.72 18h10.56zM10 2C8.346 2 7 3.346 7 5s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
});

var SvgCustomersMajorMonotone = function SvgCustomersMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2P);
};

var _ref$2Q =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 13c-4 0-7 3-7 3l1 3h12l1-3s-3-3-7-3",
  fill: "currentColor"
});

var _ref2$T =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.707 15.293a.999.999 0 0 1 .241 1.023l-1 3A.999.999 0 0 1 16 20H4a1 1 0 0 1-.949-.684l-1-3a.999.999 0 0 1 .242-1.023C2.427 15.158 5.635 12 10 12c4.364 0 7.572 3.158 7.707 3.293zM15.28 18l.562-1.687c-.92-.752-3.155-2.313-5.84-2.313-2.704 0-4.928 1.558-5.844 2.31L4.72 18h10.56zM10 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 8c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5",
  fill: undefined
});

var SvgCustomersMajorTwotone = function SvgCustomersMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2Q, _ref2$T);
};

var _ref$2R =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 1 0 0 2v13a1 1 0 0 0 1 1h4.72l-.69 2.758a1 1 0 0 0 1.94.484L8.78 16h2.44l.81 3.242a1 1 0 1 0 1.94-.484L13.28 16H18a1 1 0 0 0 1-1V2a1 1 0 1 0 0-2zM3 14h14V2H3v12zm3-2a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m4 0a1 1 0 0 0 1-1V7a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1m4 0a1 1 0 0 0 1-1V5a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1"
});

var SvgDataVisualizationMajorMonotone = function SvgDataVisualizationMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2R);
};

var _ref$2S =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2 1h16v14H2z"
});

var _ref2$U =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 1 0 0 2v13a1 1 0 0 0 1 1h4.72l-.69 2.758a1 1 0 0 0 1.94.484L8.78 16h2.44l.81 3.242a1 1 0 1 0 1.94-.484L13.28 16H18a1 1 0 0 0 1-1V2a1 1 0 1 0 0-2zM3 14h14V2H3v12zm3-2a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m4 0a1 1 0 0 0 1-1V7a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1m4 0a1 1 0 0 0 1-1V5a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1"
});

var SvgDataVisualizationMajorTwotone = function SvgDataVisualizationMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2S, _ref2$U);
};

var _ref$2T =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 4h-3V2c0-1.103-.897-2-2-2H8C6.897 0 6 .897 6 2v2H3a1 1 0 1 0 0 2v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 1 0 0-2zM5 18h10V6H5v12zM8 4h4V2H8v2zm0 12a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1m4 0a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1"
});

var SvgDeleteMajorMonotone = function SvgDeleteMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2T);
};

var _ref$2U =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4 5h12v14H4z"
});

var _ref2$V =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 4h-3V2c0-1.103-.897-2-2-2H8C6.897 0 6 .897 6 2v2H3a1 1 0 1 0 0 2v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 1 0 0-2zM5 18h10V6H5v12zM8 4h4V2H8v2zm0 12a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1m4 0a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1"
});

var SvgDeleteMajorTwotone = function SvgDeleteMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2U, _ref2$V);
};

var _ref$2V =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 6H4a1 1 0 1 0 0 2h1v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8h1a1 1 0 1 0 0-2zM9 4a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2H9zm2 12h2V8h-2v8zm-4 0h2V8H7v8z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgDeleteMinor = function SvgDeleteMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2V);
};

var _ref$2W =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M13 14H2v-2h16v2h-5zm-.606 4H7.606a9.139 9.139 0 0 0 .357-2h4.074c.062.818.196 1.478.357 2zM2 10h16V2H2v8zM19 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4.951c-.157 1.657-.661 2.293-.659 2.293h.001A1 1 0 0 0 6 20h8a.996.996 0 0 0 .897-.598c.163-.356.09-.788-.166-1.084-.006-.007-.523-.641-.682-2.318H19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"
});

var SvgDesktopMajorMonotone = function SvgDesktopMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2W);
};

var _ref$2X =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v10H1z"
});

var _ref2$W =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4.951c-.157 1.657-.661 2.293-.659 2.293h.001A1 1 0 0 0 6 20h8a.996.996 0 0 0 .897-.598c.163-.356.09-.788-.166-1.084-.006-.007-.523-.641-.682-2.318H19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM7.606 18a9.139 9.139 0 0 0 .357-2h4.074c.062.818.196 1.478.357 2H7.606zM18 14H2v-2h16v2zm0-4H2V2h16v8z",
  fill: undefined
});

var SvgDesktopMajorTwotone = function SvgDesktopMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2X, _ref2$W);
};

var _ref$2Y =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 14h-8v-4a1 1 0 1 0-2 0v4H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zM10 4a1 1 0 1 1 0 2c-2.206 0-4 1.794-4 4a1 1 0 1 1-2 0c0-3.309 2.691-6 6-6zm-9 7a1 1 0 0 0 1-1c0-4.411 3.589-8 8-8a1 1 0 1 0 0-2C4.486 0 0 4.486 0 10a1 1 0 0 0 1 1m1 7h16v-2H2v2z"
});

var SvgDigitalMediaReceiverMajorMonotone = function SvgDigitalMediaReceiverMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2Y);
};

var _ref$2Z =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 15h18v4H1z"
});

var _ref2$X =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 14h-8v-4a1 1 0 1 0-2 0v4H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zM10 4a1 1 0 1 1 0 2c-2.206 0-4 1.794-4 4a1 1 0 1 1-2 0c0-3.309 2.691-6 6-6zm-9 7a1 1 0 0 0 1-1c0-4.411 3.589-8 8-8a1 1 0 1 0 0-2C4.486 0 0 4.486 0 10a1 1 0 0 0 1 1m1 7h16v-2H2v2z"
});

var SvgDigitalMediaReceiverMajorTwotone = function SvgDigitalMediaReceiverMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2Z, _ref2$X);
};

var _ref$2_ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-5-5a1.5 1.5 0 1 1-2.999.001A1.5 1.5 0 0 1 10 1.5M8 8a.999.999 0 0 1-.707-1.707l6-6a.999.999 0 1 1 1.414 1.414l-6 6A.997.997 0 0 1 8 8m9 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m11-4H6.81l-.43-2H17c.43 0 .81-.28.95-.68l2-6c.17-.53-.11-1.09-.63-1.27-.53-.17-1.09.11-1.27.63L16.28 10H5.95L3.98.79C3.88.33 3.47 0 3 0H1C.45 0 0 .45 0 1s.45 1 1 1h1.19l2.62 12.25A3.005 3.005 0 0 0 3 17c0 1.65 1.35 3 3 3s3-1.35 3-3c0-.35-.06-.69-.18-1h5.36c-.12.31-.18.65-.18 1 0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3"
});

var SvgDiscountAutomaticMajorMonotone = function SvgDiscountAutomaticMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2_);
};

var _ref$2$ =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm11 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
});

var _ref2$Y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-5-5a1.5 1.5 0 1 1-2.999.001A1.5 1.5 0 0 1 10 1.5M8 8a.999.999 0 0 1-.707-1.707l6-6a.999.999 0 1 1 1.414 1.414l-6 6A.997.997 0 0 1 8 8m9 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m11-4H6.81l-.43-2H17c.43 0 .81-.28.95-.68l2-6c.17-.53-.11-1.09-.63-1.27-.53-.17-1.09.11-1.27.63L16.28 10H5.95L3.98.79C3.88.33 3.47 0 3 0H1C.45 0 0 .45 0 1s.45 1 1 1h1.19l2.62 12.25A3.005 3.005 0 0 0 3 17c0 1.65 1.35 3 3 3s3-1.35 3-3c0-.35-.06-.69-.18-1h5.36c-.12.31-.18.65-.18 1 0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3"
});

var SvgDiscountAutomaticMajorTwotone = function SvgDiscountAutomaticMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$2$, _ref2$Y);
};

var _ref$30 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M20 19v-1a1 1 0 1 0-2 0 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1m-7.5-8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12.5 11m-5-5a1.5 1.5 0 1 0-.001 2.999A1.5 1.5 0 0 0 7.5 6m.207 7.707l6-6a.999.999 0 1 0-1.414-1.414l-6 6a.999.999 0 1 0 1.414 1.414M20 8V6a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0m0 6v-2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0M2 8V6a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0m0 6v-2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0m1 5a1 1 0 0 0-1-1 1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1M20 2V1a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0m-5 17a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1m-6 0a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1m6-18a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1M9 1a1 1 0 0 0-1-1H6a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1M1 3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2 1 1 0 0 1-1 1"
});

var SvgDiscountCodeMajorMonotone = function SvgDiscountCodeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$30);
};

var _ref$31 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M20 19v-1a1 1 0 1 0-2 0 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1m-7.5-8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12.5 11m-5-5a1.5 1.5 0 1 0-.001 2.999A1.5 1.5 0 0 0 7.5 6m.207 7.707l6-6a.999.999 0 1 0-1.414-1.414l-6 6a.999.999 0 1 0 1.414 1.414M20 8V6a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0m0 6v-2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0M2 8V6a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0m0 6v-2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0m1 5a1 1 0 0 0-1-1 1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1M20 2V1a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0m-5 17a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1m-6 0a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1m6-18a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1M9 1a1 1 0 0 0-1-1H6a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1M1 3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2 1 1 0 0 1-1 1"
});

var SvgDiscountCodeMajorTwotone = function SvgDiscountCodeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$31);
};

var _ref$32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.06 7.73l-.7-.7a1.22 1.22 0 0 1-.35-.85V5.2A3.2 3.2 0 0 0 14.8 2h-1a1.2 1.2 0 0 1-.85-.35l-.7-.7a3.2 3.2 0 0 0-4.53 0l-.7.7a1.2 1.2 0 0 1-.85.35H5.2A3.2 3.2 0 0 0 2 5.19v1c0 .3-.13.62-.35.84l-.7.7a3.2 3.2 0 0 0 0 4.53l.7.7c.22.23.35.54.35.85v1a3.2 3.2 0 0 0 3.2 3.2h1c.31 0 .62.12.84.35l.7.7A3.2 3.2 0 0 0 10 20a3.2 3.2 0 0 0 2.26-.94l.7-.7c.23-.23.53-.35.85-.35h1a3.2 3.2 0 0 0 3.2-3.2v-1c0-.31.13-.62.35-.85l.7-.7a3.2 3.2 0 0 0 0-4.53M12.3 6.3l-6 6a1 1 0 1 0 1.4 1.4l6-6a1 1 0 1 0-1.4-1.4M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5.16-.14l-.7.7A3.18 3.18 0 0 0 16 13.8v1c0 .66-.54 1.2-1.2 1.2h-1a3.18 3.18 0 0 0-2.26.94l-.7.7a1.2 1.2 0 0 1-1.7 0l-.7-.7A3.18 3.18 0 0 0 6.18 16H5.2A1.2 1.2 0 0 1 4 14.8v-1c0-.85-.33-1.66-.94-2.26l-.7-.7a1.2 1.2 0 0 1 0-1.7l.7-.7c.6-.6.94-1.41.94-2.27V5.2C4 4.54 4.54 4 5.2 4h1c.85 0 1.65-.33 2.26-.94l.7-.7a1.2 1.2 0 0 1 1.7 0l.7.7a3.18 3.18 0 0 0 2.26.94h1c.66 0 1.2.54 1.2 1.2v1c0 .85.33 1.65.93 2.26l.7.7a1.2 1.2 0 0 1 0 1.7",
  fill: undefined
});

var SvgDiscountsMajorMonotone = function SvgDiscountsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$32);
};

var _ref$33 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7.74 17.66A2.2 2.2 0 0 0 6.18 17H5.2A2.2 2.2 0 0 1 3 14.8v-1a2.2 2.2 0 0 0-.64-1.55l-.7-.7a2.2 2.2 0 0 1 0-3.12l.7-.7c.4-.41.64-.97.64-1.55v-1C3 3.98 3.98 3 5.2 3h1a2.2 2.2 0 0 0 1.55-.64l.7-.7a2.2 2.2 0 0 1 3.12 0l.7.7c.41.4.97.64 1.55.64h1c1.21 0 2.2.99 2.2 2.2v1c0 .58.23 1.14.64 1.55l.7.7a2.2 2.2 0 0 1 0 3.12l-.7.7a2.2 2.2 0 0 0-.64 1.56v.99a2.2 2.2 0 0 1-2.2 2.2h-1a2.2 2.2 0 0 0-1.55.64l-.7.7a2.2 2.2 0 0 1-3.12 0l-.7-.7z"
});

var _ref2$Z =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.06 7.73l-.7-.7a1.22 1.22 0 0 1-.35-.85V5.2A3.2 3.2 0 0 0 14.8 2h-1a1.2 1.2 0 0 1-.85-.35l-.7-.7a3.2 3.2 0 0 0-4.53 0l-.7.7a1.2 1.2 0 0 1-.85.35H5.2A3.2 3.2 0 0 0 2 5.19v1c0 .3-.13.62-.35.84l-.7.7a3.2 3.2 0 0 0 0 4.53l.7.7c.22.23.35.54.35.85v1a3.2 3.2 0 0 0 3.2 3.2h1c.31 0 .62.12.84.35l.7.7A3.2 3.2 0 0 0 10 20a3.2 3.2 0 0 0 2.26-.94l.7-.7c.23-.23.53-.35.85-.35h1a3.2 3.2 0 0 0 3.2-3.2v-1c0-.31.13-.62.35-.85l.7-.7a3.2 3.2 0 0 0 0-4.53M12.3 6.3l-6 6a1 1 0 1 0 1.4 1.4l6-6a1 1 0 1 0-1.4-1.4M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5.16-.14l-.7.7A3.18 3.18 0 0 0 16 13.8v1c0 .66-.54 1.2-1.2 1.2h-1a3.18 3.18 0 0 0-2.26.94l-.7.7a1.2 1.2 0 0 1-1.7 0l-.7-.7A3.18 3.18 0 0 0 6.18 16H5.2A1.2 1.2 0 0 1 4 14.8v-1c0-.85-.33-1.66-.94-2.26l-.7-.7a1.2 1.2 0 0 1 0-1.7l.7-.7c.6-.6.94-1.41.94-2.27V5.2C4 4.54 4.54 4 5.2 4h1c.85 0 1.65-.33 2.26-.94l.7-.7a1.2 1.2 0 0 1 1.7 0l.7.7a3.18 3.18 0 0 0 2.26.94h1c.66 0 1.2.54 1.2 1.2v1c0 .85.33 1.65.93 2.26l.7.7a1.2 1.2 0 0 1 0 1.7",
  fill: undefined
});

var SvgDiscountsMajorTwotone = function SvgDiscountsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$33, _ref2$Z);
};

var _ref$34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 10h2V6H9v4zm0 4h2v-2H9v2zm-7-4c0 4.411 3.589 8 8 8a7.939 7.939 0 0 0 4.111-1.15l2.494 1.069a1 1 0 0 0 1.314-1.313l-1.069-2.495A7.939 7.939 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgDisputeMinor = function SvgDisputeMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$34);
};

var _ref$35 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15.5 8.663c-.824 0-1.494.67-1.494 1.494s.67 1.494 1.494 1.494 1.494-.67 1.494-1.494-.67-1.494-1.494-1.494zM3.002 12H8a1 1 0 1 1 0 2H3.002C2.45 14 2 14.45 2 15.002v1.996C2 17.55 2.45 18 3.002 18h12.996c.553 0 1.002-.45 1.002-1.002a1 1 0 1 1 2 0A3.006 3.006 0 0 1 15.998 20H3.002A3.006 3.006 0 0 1 0 16.998v-1.996c0-.768.29-1.47.767-2.002A2.99 2.99 0 0 1 0 10.998V9.002C0 8.234.29 7.532.767 7A2.99 2.99 0 0 1 0 4.998V3.002A3.006 3.006 0 0 1 3.002 0h12.996A3.006 3.006 0 0 1 19 3.002a1 1 0 1 1-2 0C17 2.45 16.551 2 15.998 2H3.002C2.45 2 2 2.45 2 3.002v1.996C2 5.55 2.45 6 3.002 6H8a1 1 0 1 1 0 2H3.002C2.45 8 2 8.45 2 9.002v1.996C2 11.55 2.45 12 3.002 12zm9.141-2.814l-.685-.442a1 1 0 1 1 1.084-1.68l.685.441a3.491 3.491 0 0 1 1.273-.697V6a1 1 0 1 1 2 0v.808c.474.142.907.382 1.273.697l.685-.442a1.001 1.001 0 0 1 1.084 1.681l-.685.442a3.486 3.486 0 0 1 0 1.941l.685.443a1 1 0 1 1-1.084 1.68l-.685-.442a3.491 3.491 0 0 1-1.273.697v.808a1 1 0 1 1-2 0v-.808a3.491 3.491 0 0 1-1.273-.697l-.685.442a1.003 1.003 0 0 1-1.383-.298 1 1 0 0 1 .3-1.382l.684-.443a3.486 3.486 0 0 1 0-1.941zM6 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm0 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm0 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
});

var SvgDnsSettingsMajorMonotone = function SvgDnsSettingsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$35);
};

var _ref$36 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15.5 8.663c-.824 0-1.494.67-1.494 1.494s.67 1.494 1.494 1.494 1.494-.67 1.494-1.494-.67-1.494-1.494-1.494zM3.002 12H8a1 1 0 1 1 0 2H3.002C2.45 14 2 14.45 2 15.002v1.996C2 17.55 2.45 18 3.002 18h12.996c.553 0 1.002-.45 1.002-1.002a1 1 0 1 1 2 0A3.006 3.006 0 0 1 15.998 20H3.002A3.006 3.006 0 0 1 0 16.998v-1.996c0-.768.29-1.47.767-2.002A2.99 2.99 0 0 1 0 10.998V9.002C0 8.234.29 7.532.767 7A2.99 2.99 0 0 1 0 4.998V3.002A3.006 3.006 0 0 1 3.002 0h12.996A3.006 3.006 0 0 1 19 3.002a1 1 0 1 1-2 0C17 2.45 16.551 2 15.998 2H3.002C2.45 2 2 2.45 2 3.002v1.996C2 5.55 2.45 6 3.002 6H8a1 1 0 1 1 0 2H3.002C2.45 8 2 8.45 2 9.002v1.996C2 11.55 2.45 12 3.002 12zm9.141-2.814l-.685-.442a1 1 0 1 1 1.084-1.68l.685.441a3.491 3.491 0 0 1 1.273-.697V6a1 1 0 1 1 2 0v.808c.474.142.907.382 1.273.697l.685-.442a1.001 1.001 0 0 1 1.084 1.681l-.685.442a3.486 3.486 0 0 1 0 1.941l.685.443a1 1 0 1 1-1.084 1.68l-.685-.442a3.491 3.491 0 0 1-1.273.697v.808a1 1 0 1 1-2 0v-.808a3.491 3.491 0 0 1-1.273-.697l-.685.442a1.003 1.003 0 0 1-1.383-.298 1 1 0 0 1 .3-1.382l.684-.443a3.486 3.486 0 0 1 0-1.941zM6 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm0 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm0 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
});

var SvgDnsSettingsMajorTwotone = function SvgDnsSettingsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$36);
};

var _ref$37 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 11h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1H8a1 1 0 0 1 0-2h1v-1a1 1 0 1 1 2 0v1zM4 2H2v2h2V2zm2 0v2h12V2H6zm14 2.975a1.02 1.02 0 0 1 0 .05V19a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3.975zM2 6v12h16V6H2z"
});

var SvgDomainNewMajorMonotone = function SvgDomainNewMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$37);
};

var _ref$38 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M18 6v12.087H2V6z"
});

var _ref2$_ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 11h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1H8a1 1 0 0 1 0-2h1v-1a1 1 0 1 1 2 0v1zM4 2H2v2h2V2zm2 0v2h12V2H6zm14 2.975a1.02 1.02 0 0 1 0 .05V19a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3.975zM2 6v12h16V6H2z"
});

var SvgDomainNewMajorTwotone = function SvgDomainNewMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$38, _ref2$_);
};

var _ref$39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.993 16.19c-.054.444-.396.8-.839.869l-2.168.338-.715 1.947a.999.999 0 0 1-.938.656l-.046-.001a1 1 0 0 1-.92-.742l-1.333-5a.999.999 0 1 1 1.349-1.181l5 2.071c.414.172.663.598.61 1.043zM8.424 6c.464-2.033 1.178-3.358 1.564-3.964.388.606 1.107 1.931 1.573 3.964H8.424zm-2.342 6H2.263A7.959 7.959 0 0 1 2 10c0-.692.097-1.36.263-2h3.82a21.39 21.39 0 0 0-.096 2.004c0 .706.037 1.367.095 1.996zm1.437 5.601A8.031 8.031 0 0 1 3.082 14h3.289a16.294 16.294 0 0 0 1.148 3.601zm.004-15.204c-.415.9-.849 2.102-1.15 3.603H3.082a8.03 8.03 0 0 1 4.441-3.603zM16.917 6h-3.305a16.127 16.127 0 0 0-1.16-3.612A8.029 8.029 0 0 1 16.917 6zM14 10c0-.708-.037-1.371-.097-2h3.834c.165.64.263 1.308.263 2 0 .3-.031.592-.066.883a1.001 1.001 0 0 0 1.987.233c.043-.367.079-.737.079-1.116 0-5.515-4.486-10-10-10S0 4.485 0 10c0 5.514 4.486 10 10 10 0 0 .979.004 1.073-.003a1 1 0 0 0 .924-1.07 1.008 1.008 0 0 0-1.07-.925c-.137.011-.926-.002-.926-.002-.383-.59-1.116-1.92-1.585-4H10a1 1 0 0 0 0-2H8.088a19.424 19.424 0 0 1 .004-4h3.803c.066.622.105 1.287.105 2a1 1 0 0 0 2 0z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgDomainsMajorMonotone = function SvgDomainsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$39);
};

var _ref$3a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.993 16.19c-.054.444-.396.8-.839.869l-2.168.338-.715 1.947a.999.999 0 0 1-.938.656l-.046-.001a1 1 0 0 1-.92-.742l-1.333-5a.999.999 0 1 1 1.349-1.181l5 2.071c.414.172.663.598.61 1.043zM8.424 6c.464-2.033 1.178-3.358 1.564-3.964.388.606 1.107 1.931 1.573 3.964H8.424zm-2.342 6H2.263A7.959 7.959 0 0 1 2 10c0-.692.097-1.36.263-2h3.82a21.39 21.39 0 0 0-.096 2.004c0 .706.037 1.367.095 1.996zm1.437 5.601A8.031 8.031 0 0 1 3.082 14h3.289a16.294 16.294 0 0 0 1.148 3.601zm.004-15.204c-.415.9-.849 2.102-1.15 3.603H3.082a8.03 8.03 0 0 1 4.441-3.603zM16.917 6h-3.305a16.127 16.127 0 0 0-1.16-3.612A8.029 8.029 0 0 1 16.917 6zM14 10c0-.708-.037-1.371-.097-2h3.834c.165.64.263 1.308.263 2 0 .3-.031.592-.066.883a1.001 1.001 0 0 0 1.987.233c.043-.367.079-.737.079-1.116 0-5.515-4.486-10-10-10S0 4.485 0 10c0 5.514 4.486 10 10 10 0 0 .979.004 1.073-.003a1 1 0 0 0 .924-1.07 1.008 1.008 0 0 0-1.07-.925c-.137.011-.926-.002-.926-.002-.383-.59-1.116-1.92-1.585-4H10a1 1 0 0 0 0-2H8.088a19.424 19.424 0 0 1 .004-4h3.803c.066.622.105 1.287.105 2a1 1 0 0 0 2 0z"
});

var SvgDomainsMajorTwotone = function SvgDomainsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3a);
};

var _ref$3b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1.01a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H9a1 1 0 1 1 0 2H2.01v9H6a.988.988 0 0 1 .89.55L7.62 14h4.76l.73-1.45A.977.977 0 0 1 14 12h4v-2a1 1 0 0 1 1-1zm-1 9v-4h-3.38l-.72 1.45a1.022 1.022 0 0 1-.9.55H7a1.006 1.006 0 0 1-.89-.55L5.38 14H2.01v4H18zM19.11.93c.56.536.878 1.276.88 2.05a3.955 3.955 0 0 1-1.29 2.73l-2.97 2.98-1.02 1.02a1.038 1.038 0 0 1-.47.26l-4 1a1.007 1.007 0 0 1-.95-.26.985.985 0 0 1-.26-.95l1-4a.953.953 0 0 1 .26-.47l3.99-4a4.505 4.505 0 0 1 2-1.2 2.9 2.9 0 0 1 2.83.84zM13.49 8.1l.09-.09-1.61-1.57-.07.07-.53 2.12 2.12-.53zm3.79-3.81c.36-.35 1.11-1.25.42-1.95A.964.964 0 0 0 17 2a.877.877 0 0 0-.24.03c-.405.133-.77.367-1.06.68l-2.32 2.32 1.61 1.56 2.29-2.3zM18 14l-.01 3.96V18H18v-4zM.01 13v5.06a.34.34 0 0 1-.01-.1L.01 13z"
});

var SvgDraftOrdersMajorMonotone = function SvgDraftOrdersMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3b);
};

var _ref$3c =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M17.28 4.29l-2.29 2.3-1.61-1.56 2.32-2.32c.29-.313.655-.547 1.06-.68A.877.877 0 0 1 17 2c.271.01.525.133.7.34.69.7-.06 1.6-.42 1.95zM18 18H2.01v-4h3.37l.73 1.45c.17.335.514.547.89.55h6a1.02 1.02 0 0 0 .9-.55l.72-1.45H18v4z"
});

var _ref2$$ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1.01a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H9a1 1 0 1 1 0 2H2.01v9H6a.988.988 0 0 1 .89.55L7.62 14h4.76l.73-1.45A.977.977 0 0 1 14 12h4v-2a1 1 0 0 1 1-1zm-1 9v-4h-3.38l-.72 1.45a1.022 1.022 0 0 1-.9.55H7a1.006 1.006 0 0 1-.89-.55L5.38 14H2.01v4H18zM19.11.93c.56.536.878 1.276.88 2.05a3.955 3.955 0 0 1-1.29 2.73l-2.97 2.98-1.02 1.02a1.038 1.038 0 0 1-.47.26l-4 1a1.007 1.007 0 0 1-.95-.26.985.985 0 0 1-.26-.95l1-4a.953.953 0 0 1 .26-.47l3.99-4a4.505 4.505 0 0 1 2-1.2 2.9 2.9 0 0 1 2.83.84zM13.49 8.1l.09-.09-1.61-1.57-.07.07-.53 2.12 2.12-.53zm3.79-3.81c.36-.35 1.11-1.25.42-1.95A.964.964 0 0 0 17 2a.877.877 0 0 0-.24.03c-.405.133-.77.367-1.06.68l-2.32 2.32 1.61 1.56 2.29-2.3zM18 14l-.01 3.96V18H18v-4zM.01 13v5.06a.34.34 0 0 1-.01-.1L.01 13z"
});

var SvgDraftOrdersMajorTwotone = function SvgDraftOrdersMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3c, _ref2$$);
};

var _ref$3d =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M19.317 12.052L14 10.28V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.28l1.772 5.317a.998.998 0 0 0 1.843.13l1.85-3.701 3.703-1.851a1 1 0 0 0-.131-1.843zM2 16a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2M16 2a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2M6 2h1a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m5 0h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2M2 0H1a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0 1 1 0 1 0 0-2M1 8a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m0 5a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m13.553 1.105a1.002 1.002 0 0 0-.447.447l-.921 1.841-1.604-4.812 4.813 1.604-1.841.92zM6 12.002V6h6v3.612l-1.683-.561a.998.998 0 1 0-1.265 1.265L9.612 12H6zM7 16H6a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M17 5a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1"
});

var SvgDragDropMajorMonotone = function SvgDragDropMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3d);
};

var _ref$3e =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 5v8h6l-1-3 3 1V5z"
});

var _ref2$10 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.317 12.052L14 10.28V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.28l1.772 5.317a.998.998 0 0 0 1.843.13l1.85-3.701 3.703-1.851a1 1 0 0 0-.131-1.843zM2 16a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2M16 2a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2M6 2h1a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m5 0h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2M2 0H1a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0 1 1 0 1 0 0-2M1 8a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m0 5a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m13.553 1.105a1.002 1.002 0 0 0-.447.447l-.921 1.841-1.604-4.812 4.813 1.604-1.841.92zM6 12.002V6h6v3.612l-1.683-.561a.998.998 0 1 0-1.265 1.265L9.612 12H6zM7 16H6a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M17 5a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1"
});

var SvgDragDropMajorTwotone = function SvgDragDropMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3e, _ref2$10);
};

var _ref$3f =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2m0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8m0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14m6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6m0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8m0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14"
});

var SvgDragHandleMinor = function SvgDragHandleMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3f);
};

var _ref$3g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M5 8l5 5 5-5z"
});

var SvgDropdownMinor = function SvgDropdownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3g);
};

var _ref$3h =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 12h8V4H8v8zm4 4H4V8h2v5a1 1 0 0 0 1 1h5v2zm5-14H7a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgDuplicateMinor = function SvgDuplicateMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3h);
};

var _ref$3i =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18.878 1.085c-1.445-1.446-3.967-1.446-5.414 0l-11.17 11.17a.976.976 0 0 0-.228.368c-.003.009-.012.015-.015.024l-2 6a.999.999 0 0 0 1.265 1.265l6-2c.01-.003.015-.012.024-.015a.976.976 0 0 0 .367-.227L18.878 6.499A3.805 3.805 0 0 0 20 3.792a3.803 3.803 0 0 0-1.122-2.707zm-1.414 4L17 5.549l-2.586-2.586.464-.464c.691-.691 1.895-.691 2.586 0 .346.346.536.805.536 1.293 0 .488-.19.947-.536 1.293zM3.437 14.814l1.712 1.712-2.568.856.856-2.568zM7 15.549l-2.586-2.586L13 4.377l2.586 2.586L7 15.549z"
});

var SvgEditMajorMonotone = function SvgEditMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3i);
};

var _ref$3j =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 17L17 7l-4-4L3 13z"
});

var _ref2$11 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18.878 1.085c-1.445-1.446-3.967-1.446-5.414 0l-11.17 11.17a.976.976 0 0 0-.228.368c-.003.009-.012.015-.015.024l-2 6a.999.999 0 0 0 1.265 1.265l6-2c.01-.003.015-.012.024-.015a.976.976 0 0 0 .367-.227L18.878 6.499A3.805 3.805 0 0 0 20 3.792a3.803 3.803 0 0 0-1.122-2.707zm-1.414 4L17 5.549l-2.586-2.586.464-.464c.691-.691 1.895-.691 2.586 0 .346.346.536.805.536 1.293 0 .488-.19.947-.536 1.293zM3.437 14.814l1.712 1.712-2.568.856.856-2.568zM7 15.549l-2.586-2.586L13 4.377l2.586 2.586L7 15.549z"
});

var SvgEditMajorTwotone = function SvgEditMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3j, _ref2$11);
};

var _ref$3k =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.086 2.912a3.126 3.126 0 0 0-4.414 0l-9.379 9.379a.998.998 0 0 0-.263.464l-1 4a1 1 0 0 0 1.212 1.213l4-1c.176-.044.337-.135.465-.263l9.38-9.379a3.125 3.125 0 0 0 0-4.414zm-1.414 3L15 6.584l-1.586-1.586.672-.672a1.125 1.125 0 0 1 1.586 0 1.123 1.123 0 0 1 0 1.586zM5.414 12.998L12 6.412l1.586 1.586L7 14.584l-1.586-1.586z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgEditMinor = function SvgEditMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3k);
};

var _ref$3l =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 16V5.414l7.293 7.293a.997.997 0 0 0 1.414 0L18 5.414V16H2zM16.586 4L10 10.586 3.414 4h13.172zM19 2H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
});

var SvgEmailMajorMonotone = function SvgEmailMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3l);
};

var _ref$3m =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 3l9 9 9-9z"
});

var _ref2$12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 16V5.414l7.293 7.293a.996.996 0 0 0 1.414 0L18 5.414V16H2zM16.586 4L10 10.586 3.414 4h13.172zM19 2H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z",
  fill: undefined
});

var SvgEmailMajorTwotone = function SvgEmailMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3m, _ref2$12);
};

var _ref$3n =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2H7zm5 2a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h4zm6 10v-6h-.795l-6.811 2.919a1 1 0 0 1-.788 0L2.795 12H2v6h16zM16 2H4v8.341l6 2.571 6-2.571V2zm3 8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v9h1z"
});

var SvgEmailNewsletterMajorMonotone = function SvgEmailNewsletterMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3n);
};

var _ref$3o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2H7zm5 2a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h4zm6 10v-6h-.795l-6.811 2.919a1 1 0 0 1-.788 0L2.795 12H2v6h16zM16 2H4v8.341l6 2.571 6-2.571V2zm3 8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v9h1z"
});

var SvgEmailNewsletterMajorTwotone = function SvgEmailNewsletterMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3o);
};

var _ref$3p =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 13a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h12v-2a1 1 0 0 1 1-1zm0-11a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V4H4v2a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1h14zm.555 7.168a1.001 1.001 0 0 1 0 1.664l-3 2a1 1 0 0 1-1.109-1.664L15.198 10l-1.752-1.168a1 1 0 1 1 1.109-1.664l3 2zM6.832 7.445a1 1 0 0 1-.277 1.387L4.803 10l1.752 1.168a1 1 0 1 1-1.11 1.664l-3-2a1.001 1.001 0 0 1 0-1.664l3-2a1 1 0 0 1 1.387.277zM9 14.001a1 1 0 0 1-.948-1.317l2-6a1 1 0 0 1 1.896.633l-2 6A.999.999 0 0 1 9 14z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgEmbedMinor = function SvgEmbedMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3p);
};

var _ref$3q =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 14.41l-3.71-3.7 1.42-1.42L9 11.59l5.29-5.3 1.42 1.42L9 14.41zM17 2H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z",
  fill: undefined
});

var SvgEnableSelectionMinor = function SvgEnableSelectionMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3q);
};

var _ref$3r =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9 12H5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2m-4-2h2a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2M2 4h14.001L14.4 5.2a1 1 0 0 0-.4.8v8a1 1 0 0 0 .4.8l1.601 1.2H2V4zm14 9.5v-7L18 5v10l-2-1.5z"
});

var SvgEnvelopeMajorMonotone = function SvgEnvelopeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3r);
};

var _ref$3s =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 3v14h18l-4-3V6l4-3z"
});

var _ref2$13 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9 12H5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2m-4-2h2a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2M2 4h14.001L14.4 5.2a1 1 0 0 0-.4.8v8a1 1 0 0 0 .4.8l1.601 1.2H2V4zm14 9.5v-7L18 5v10l-2-1.5z"
});

var SvgEnvelopeMajorTwotone = function SvgEnvelopeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3s, _ref2$13);
};

var _ref$3t =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.986 13.166a3 3 0 1 1-1.973 0A1.007 1.007 0 0 1 16 13V8.999A3.999 3.999 0 0 0 12.001 5h-.587l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L11.414 3h.587A5.999 5.999 0 0 1 18 8.999V13c0 .057-.005.112-.014.166zm-14-6.332c.01.054.014.11.014.166v4.001A3.999 3.999 0 0 0 7.999 15h.587l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414L8.586 17h-.587A5.999 5.999 0 0 1 2 11.001V7c0-.057.005-.112.014-.166a3 3 0 1 1 1.973 0zM4 4a1 1 0 1 0-2.001.001A1 1 0 0 0 4 4zm14 12a1 1 0 1 0-2.001.001A1 1 0 0 0 18 16z"
});

var SvgExchangeMajorMonotone = function SvgExchangeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3t);
};

var _ref$3u =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4 3a2 2 0 1 1-4.001-.001A2 2 0 0 1 4 3zm14 12a2 2 0 1 1-4.001-.001A2 2 0 0 1 18 15z"
});

var _ref2$14 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.986 13.166a3 3 0 1 1-1.973 0A1.007 1.007 0 0 1 16 13V8.999A3.999 3.999 0 0 0 12.001 5h-.587l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L11.414 3h.587A5.999 5.999 0 0 1 18 8.999V13c0 .057-.005.112-.014.166zm-14-6.332c.01.054.014.11.014.166v4.001A3.999 3.999 0 0 0 7.999 15h.587l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414L8.586 17h-.587A5.999 5.999 0 0 1 2 11.001V7c0-.057.005-.112.014-.166a3 3 0 1 1 1.973 0zM4 4a1 1 0 1 0-2.001.001A1 1 0 0 0 4 4zm14 12a1 1 0 1 0-2.001.001A1 1 0 0 0 18 16z"
});

var SvgExchangeMajorTwotone = function SvgExchangeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3u, _ref2$14);
};

var _ref$3v =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M20 9c0 .55-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2V6c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1zM4 8h3V3H4v5zm-2 9h5v-7H2v7zm14-2c-.55 0-1 .45-1 1v1H9V6h3c.55 0 1-.45 1-1s-.45-1-1-1H9V2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v6H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"
});

var SvgExistingInventoryMajorMonotone = function SvgExistingInventoryMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3v);
};

var _ref$3w =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4 8V3h3v5H4zm-2 9v-7h5v7H2z"
});

var _ref2$15 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M20 9c0 .55-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2V6c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1zM4 8h3V3H4v5zm-2 9h5v-7H2v7zm14-2c-.55 0-1 .45-1 1v1H9V6h3c.55 0 1-.45 1-1s-.45-1-1-1H9V2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v6H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"
});

var SvgExistingInventoryMajorTwotone = function SvgExistingInventoryMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3w, _ref2$15);
};

var _ref$3x =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.707 6.707a.997.997 0 0 1-1.414 0L11 5.414V13a1 1 0 1 1-2 0V5.414L7.707 6.707a.999.999 0 1 1-1.414-1.414l3-3a.999.999 0 0 1 1.414 0l3 3a.999.999 0 0 1 0 1.414zM17 18H3a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z",
  fill: undefined
});

var SvgExportMinor = function SvgExportMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3x);
};

var _ref$3y =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V5.414l-7.293 7.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 4H13a1 1 0 1 1 0-2h4zm-4 9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H4v8h8v-4a1 1 0 0 1 1-1z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgExternalMinor = function SvgExternalMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3y);
};

var _ref$3z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13 12a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6c-.575 0-1-.484-1-1V7a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2v5h5a1 1 0 0 1 1-1zm-2-7h4v4a1 1 0 1 1-2 0v-.586l-2.293 2.293a.999.999 0 1 1-1.414-1.414L11.586 7H11a1 1 0 0 1 0-2z"
});

var SvgExternalSmallMinor = function SvgExternalSmallMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3z);
};

var _ref$3A =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 0H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM7 16a1 1 0 1 0 0-2c-1.654 0-3 1.346-3 3s1.346 3 3 3a1 1 0 1 0 0-2c-.55 0-1-.448-1-1s.45-1 1-1zm6 2c-.55 0-1-.448-1-1s.45-1 1-1 1 .448 1 1-.45 1-1 1zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM1 14a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1zm1-4V7.535l2-1.333 2.445 1.63c.274.184.62.22.927.097l4.66-1.866L14 6.72V10H2zm12-8v2.613l-1.684-.56a.987.987 0 0 0-.688.018l-4.51 1.806-2.563-1.708a.997.997 0 0 0-1.11 0L2 5.132V2h12z",
  fill: undefined
});

var SvgFaviconMajorMonotone = function SvgFaviconMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3A);
};

var _ref$3B =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 11V7l3-2 3 2 5-2 3 1v5z"
});

var _ref2$16 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM9 16a1 1 0 1 0 0-2c-1.654 0-3 1.346-3 3s1.346 3 3 3a1 1 0 1 0 0-2 1.001 1.001 0 0 1 0-2m6 2a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3M3 14a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1m1-4V7.535l2-1.333 2.445 1.63a.998.998 0 0 0 .927.097l4.659-1.865L16 6.721V10H4zm12-8v2.613l-1.684-.561a.993.993 0 0 0-.688.019L9.117 5.876 6.555 4.168a.997.997 0 0 0-1.11 0L4 5.132V2h12z"
});

var SvgFaviconMajorTwotone = function SvgFaviconMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3B, _ref2$16);
};

var _ref$3C =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3.08 8.668l2.627 2.626a.998.998 0 0 1 .283.849l-.732 5.12 4.375-2.16a1 1 0 0 1 .894.005l4.21 2.133-.727-5.098a.998.998 0 0 1 .283-.85l2.644-2.643-4.235-.754a.999.999 0 0 1-.724-.547L9.988 3.26 7.894 7.448a.998.998 0 0 1-.73.539l-4.083.68zM4 20a1 1 0 0 1-.99-1.142l.929-6.504L.293 8.708a1 1 0 0 1 .542-1.693l5.498-.917L9.105.554a1 1 0 1 1 1.794.01l2.654 5.452 5.622 1a1 1 0 0 1 .532 1.692l-3.647 3.647.93 6.504a1 1 0 0 1-1.442 1.034l-5.478-2.774-5.627 2.778A.99.99 0 0 1 4 20z"
});

var SvgFavouriteMajorMonotone = function SvgFavouriteMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3C);
};

var _ref$3D =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 1L7 7 1 8l4 4-1 7 6-3 6 3-1-7 4-4-6-1z"
});

var _ref2$17 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3.08 8.668l2.627 2.626a.998.998 0 0 1 .283.849l-.732 5.12 4.375-2.16a1 1 0 0 1 .894.005l4.21 2.133-.727-5.098a.998.998 0 0 1 .283-.85l2.644-2.643-4.235-.754a.999.999 0 0 1-.724-.547L9.988 3.26 7.894 7.448a.998.998 0 0 1-.73.539l-4.083.68zM4 20a1 1 0 0 1-.99-1.142l.929-6.504L.293 8.708a1 1 0 0 1 .542-1.693l5.498-.917L9.105.554a1 1 0 1 1 1.794.01l2.654 5.452 5.622 1a1 1 0 0 1 .532 1.692l-3.647 3.647.93 6.504a1 1 0 0 1-1.442 1.034l-5.478-2.774-5.627 2.778A.99.99 0 0 1 4 20z"
});

var SvgFavouriteMajorTwotone = function SvgFavouriteMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3D, _ref2$17);
};

var _ref$3E =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 5c-.203 0-.403.01-.6.03L7.64.23a1.005 1.005 0 0 0-1.28 0l-6 5A1.01 1.01 0 0 0 0 6v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2c3.31 0 6-2.69 6-6s-2.69-6-6-6zM7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm-2 3H2v-2h8.69c.405.27.845.484 1.31.65V18zM2 6.47L7 2.3l4.123 3.435A6.007 6.007 0 0 0 8 11c0 1.094.3 2.116.812 3H2V6.47zM15 9a1 1 0 0 0-1 1 1 1 0 1 0-2 0c0 2 2 3 2 3s2-1 2-3a1 1 0 0 0-1-1z",
  fill: undefined
});

var SvgFeaturedCollectionMajorMonotone = function SvgFeaturedCollectionMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3E);
};

var _ref$3F =
/*#__PURE__*/
React.createElement("circle", {
  cx: 14,
  cy: 11,
  r: 5,
  fill: "currentColor"
});

var _ref2$18 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14 5c-.203 0-.403.011-.601.03L7.64.231a1.002 1.002 0 0 0-1.28 0l-6 5C.132 5.422 0 5.703 0 6v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2c3.309 0 6-2.691 6-6s-2.691-6-6-6zM7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm-2 3H2v-2h8.69c.405.269.845.484 1.31.65V18zM2 6.469l5-4.167 4.123 3.435A6.003 6.003 0 0 0 8 11c0 1.094.299 2.116.812 3H2V6.469zM15 9a1 1 0 0 0-1 1 1 1 0 1 0-2 0c0 2 2 3 2 3s2-1 2-3a1 1 0 0 0-1-1"
});

var SvgFeaturedCollectionMajorTwotone = function SvgFeaturedCollectionMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3F, _ref2$18);
};

var _ref$3G =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 11c0-2.606-1.674-4.823-4-5.65V5a.996.996 0 0 0-.293-.707l-4-4A.994.994 0 0 0 11 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2.35c2.326-.827 4-3.044 4-5.65zM5 7h1a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2zm9 8c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0 3H2V2h8.586l3.02 3.02A6 6 0 0 0 8.35 9H5a1 1 0 1 0 0 2h3c0 .702.128 1.373.35 2H5a1 1 0 1 0 0 2h4.54c1.1 1.225 2.69 2 4.46 2v1zm1-9a1 1 0 0 0-1 1 1 1 0 1 0-2 0c0 2 2 3 2 3s2-1 2-3a1 1 0 0 0-1-1z",
  fill: undefined
});

var SvgFeaturedContentMajorMonotone = function SvgFeaturedContentMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3G);
};

var _ref$3H =
/*#__PURE__*/
React.createElement("circle", {
  cx: 14,
  cy: 11,
  r: 5,
  fill: "currentColor"
});

var _ref2$19 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M20 11c0-2.606-1.674-4.823-4-5.65V5a.996.996 0 0 0-.293-.707l-4-4A.996.996 0 0 0 11 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2.35c2.326-.827 4-3.044 4-5.65zM5 7h1a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2m9 8c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0 3H2V2h8.586l3.019 3.02A6.004 6.004 0 0 0 8.35 9H5a1 1 0 1 0 0 2h3c0 .702.128 1.373.35 2H5a1 1 0 1 0 0 2h4.54A5.98 5.98 0 0 0 14 17v1zm1-9a1 1 0 0 0-1 1 1 1 0 1 0-2 0c0 2 2 3 2 3s2-1 2-3a1 1 0 0 0-1-1"
});

var SvgFeaturedContentMajorTwotone = function SvgFeaturedContentMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3H, _ref2$19);
};

var _ref$3I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M1 4h3.185A2.995 2.995 0 0 0 7 6a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2H9.815A2.995 2.995 0 0 0 7 0a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2m18 12H9.815A2.995 2.995 0 0 0 7 14a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2h3.185A2.995 2.995 0 0 0 7 20a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2m0-7h-3.185A2.995 2.995 0 0 0 13 7a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2h9.185A2.995 2.995 0 0 0 13 13a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2M7 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2m6-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
});

var SvgFilterMajorMonotone = function SvgFilterMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3I);
};

var _ref$3J =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-6 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
});

var _ref2$1a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M1 4h3.185A2.995 2.995 0 0 0 7 6a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2H9.815A2.995 2.995 0 0 0 7 0a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2m18 12H9.815A2.995 2.995 0 0 0 7 14a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2h3.185A2.995 2.995 0 0 0 7 20a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2m0-7h-3.185A2.995 2.995 0 0 0 13 7a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2h9.185A2.995 2.995 0 0 0 13 13a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2M7 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2m6-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
});

var SvgFilterMajorTwotone = function SvgFilterMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3J, _ref2$1a);
};

var _ref$3K =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 9a1 1 0 0 0-1 1v2h-4c-.379 0-.725.214-.895.553L12.382 14H7.618l-.723-1.447A1.001 1.001 0 0 0 6 12H2v-2a1 1 0 1 0-2 0v9a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1zM2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM9.447 3.895l.243-.123-.677 4.063A1.002 1.002 0 0 0 10.001 9a1 1 0 0 0 .985-.835l1-6a.998.998 0 0 0-1.434-1.059l-2 1a1 1 0 0 0 .895 1.79M4.293 2.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-1-1a.999.999 0 1 0-1.414 1.414l1 1zM15 3a.997.997 0 0 0 .707-.293l1-1A.999.999 0 1 0 15.293.293l-1 1A.999.999 0 0 0 15 3m0 3a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1M2 7h2a1 1 0 1 0 0-2H2a1 1 0 1 0 0 2"
});

var SvgFirstOrderMajorMonotone = function SvgFirstOrderMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3K);
};

var _ref$3L =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13h5l1 2h6l1-2h5v6H1v-6z"
});

var _ref2$1b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 9a1 1 0 0 0-1 1v2h-4c-.379 0-.725.214-.895.553L12.382 14H7.618l-.723-1.447A1.001 1.001 0 0 0 6 12H2v-2a1 1 0 1 0-2 0v9a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1zM2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM9.447 3.895l.243-.123-.677 4.063A1.002 1.002 0 0 0 10.001 9a1 1 0 0 0 .985-.835l1-6a.998.998 0 0 0-1.434-1.059l-2 1a1 1 0 0 0 .895 1.79M4.293 2.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-1-1a.999.999 0 1 0-1.414 1.414l1 1zM15 3a.997.997 0 0 0 .707-.293l1-1A.999.999 0 1 0 15.293.293l-1 1A.999.999 0 0 0 15 3m0 3a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1M2 7h2a1 1 0 1 0 0-2H2a1 1 0 1 0 0 2"
});

var SvgFirstOrderMajorTwotone = function SvgFirstOrderMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3L, _ref2$1b);
};

var _ref$3M =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.962 9.726C19.939 9.648 17.666 2 10 2S.061 9.648.038 9.726a1 1 0 0 0 0 .548C.061 10.352 2.334 18 10 18s9.939-7.648 9.962-7.726a1 1 0 0 0 0-.548M10 16c-5.467 0-7.512-4.771-7.948-6C2.488 8.771 4.533 4 10 4c5.469 0 7.514 4.775 7.948 6-.435 1.228-2.481 6-7.948 6m1.594-9.805a1 1 0 0 0-1.041-.09l-2 1a1 1 0 0 0 .895 1.79l.243-.123-.677 4.064a1 1 0 1 0 1.973.328l1-6a1.002 1.002 0 0 0-.393-.969"
});

var SvgFirstVisitMajorMonotone = function SvgFirstVisitMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3M);
};

var _ref$3N =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 10s2 7 9 7 9-7 9-7-2-7-9-7-9 7-9 7"
});

var _ref2$1c =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.962 9.726C19.939 9.648 17.666 2 10 2S.061 9.648.038 9.726a1 1 0 0 0 0 .548C.061 10.352 2.334 18 10 18s9.939-7.648 9.962-7.726a1 1 0 0 0 0-.548M10 16c-5.467 0-7.512-4.771-7.948-6C2.488 8.771 4.533 4 10 4c5.469 0 7.514 4.775 7.948 6-.435 1.228-2.481 6-7.948 6m1.594-9.805a1 1 0 0 0-1.041-.09l-2 1a1 1 0 0 0 .895 1.79l.243-.123-.677 4.064a1 1 0 1 0 1.973.328l1-6a1.002 1.002 0 0 0-.393-.969"
});

var SvgFirstVisitMajorTwotone = function SvgFirstVisitMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3N, _ref2$1c);
};

var _ref$3O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16.105 11.447L17.381 14h-8.38v-2h4a1 1 0 0 0 1-1V8h3.38l-1.276 2.552a1 1 0 0 0 0 .895zM2.691 4h9.31v6H4.026L2.692 4zm15.428 7l1.776-3.553A.998.998 0 0 0 19 6h-5V3a1 1 0 0 0-1-1H2.248L1.976.782A1.005 1.005 0 0 0 .783.022c-.539.12-.879.654-.76 1.194l4 18a1.002 1.002 0 0 0 1.194.76c.538-.12.879-.654.76-1.194L4.468 12H7v3a1 1 0 0 0 1 1h11a1 1 0 0 0 .895-1.447L18.119 11z"
});

var SvgFlagMajorMonotone = function SvgFlagMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3O);
};

var _ref$3P =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2 3h11v4h6l-2 4 2 4H8v-4H3"
});

var _ref2$1d =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.105 11.447L17.381 14H9v-2h4a1 1 0 0 0 1-1V8h3.38l-1.274 2.552a.993.993 0 0 0 0 .895zM2.69 4H12v6H4.027L2.692 4zm15.43 7l1.774-3.553A1 1 0 0 0 19 6h-5V3c0-.554-.447-1-1-1H2.248L1.976.782a1 1 0 1 0-1.953.434l4 18a1.006 1.006 0 0 0 1.193.76 1 1 0 0 0 .76-1.194L4.47 12H7v3a1 1 0 0 0 1 1h11c.346 0 .67-.18.85-.476a.993.993 0 0 0 .044-.972l-1.775-3.553z",
  fill: undefined
});

var SvgFlagMajorTwotone = function SvgFlagMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3P, _ref2$1d);
};

var _ref$3Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 4h-3.382l-.723-1.447A1.001 1.001 0 0 0 14 2H6c-.379 0-.725.214-.895.553L4.382 4H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10.5c2.481 0 4.5-2.019 4.5-4.5S13.981 9 11.5 9H9.414l1.293-1.293a.999.999 0 1 0-1.414-1.414l-3 3a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9.414 11H11.5c1.379 0 2.5 1.121 2.5 2.5S12.879 16 11.5 16H2V6h3c.379 0 .725-.214.895-.553L6.618 4h6.764l.723 1.447c.17.339.516.553.895.553h3v10a1 1 0 1 0 0 2h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1"
});

var SvgFlipCameraMajorMonotone = function SvgFlipCameraMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3Q);
};

var _ref$3R =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 4h-3.382l-.723-1.447A1.001 1.001 0 0 0 14 2H6c-.379 0-.725.214-.895.553L4.382 4H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10.5c2.481 0 4.5-2.019 4.5-4.5S13.981 9 11.5 9H9.414l1.293-1.293a.999.999 0 1 0-1.414-1.414l-3 3a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9.414 11H11.5c1.379 0 2.5 1.121 2.5 2.5S12.879 16 11.5 16H2V6h3c.379 0 .725-.214.895-.553L6.618 4h6.764l.723 1.447c.17.339.516.553.895.553h3v10a1 1 0 1 0 0 2h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1"
});

var SvgFlipCameraMajorTwotone = function SvgFlipCameraMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3R);
};

var _ref$3S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h16V4H9a.996.996 0 0 1-.707-.293L6.586 2H2v16zm17 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6c.266 0 .52.105.707.293L9.414 2H19a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1z"
});

var SvgFolderMajorMonotone = function SvgFolderMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3S);
};

var _ref$3T =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 19h18V3H9L7 1H1z"
});

var _ref2$1e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h16V4H9a.996.996 0 0 1-.707-.293L6.586 2H2v16zm17 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6c.266 0 .52.105.707.293L9.414 2H19a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1z"
});

var SvgFolderMajorTwotone = function SvgFolderMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3T, _ref2$1e);
};

var _ref$3U =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9 11.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l3 3a.997.997 0 0 0 1.414 0l3-3a.999.999 0 1 0-1.414-1.414L11 11.586V8a1 1 0 1 0-2 0v3.586zM18 18H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderDownMajorMonotone = function SvgFolderDownMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3U);
};

var _ref$3V =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 19h18V3H9L7 1H1z"
});

var _ref2$1f =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9 11.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l3 3a.997.997 0 0 0 1.414 0l3-3a.999.999 0 1 0-1.414-1.414L11 11.586V8a1 1 0 1 0-2 0v3.586zM18 18H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderDownMajorTwotone = function SvgFolderDownMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3V, _ref2$1f);
};

var _ref$3W =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM6 11a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1m12 7H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderMinusMajorMonotone = function SvgFolderMinusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3W);
};

var _ref$3X =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 19h18V3H9L7 1H1z"
});

var _ref2$1g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM6 11a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1m12 7H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderMinusMajorTwotone = function SvgFolderMinusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3X, _ref2$1g);
};

var _ref$3Y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9 10H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V8a1 1 0 1 0-2 0v2zm9 8H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderPlusMajorMonotone = function SvgFolderPlusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3Y);
};

var _ref$3Z =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 19h18V3H9L7 1H1z"
});

var _ref2$1h =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9 10H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V8a1 1 0 1 0-2 0v2zm9 8H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderPlusMajorTwotone = function SvgFolderPlusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3Z, _ref2$1h);
};

var _ref$3_ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM6.293 11.707a.999.999 0 0 0 1.414 0L9 10.414V14a1 1 0 1 0 2 0v-3.586l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 0 0 0 1.414M18 18H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderUpMajorMonotone = function SvgFolderUpMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3_);
};

var _ref$3$ =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 19h18V3H9L7 1H1z"
});

var _ref2$1i =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 2H9.414L7.707.293A.996.996 0 0 0 7 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM6.293 11.707a.999.999 0 0 0 1.414 0L9 10.414V14a1 1 0 1 0 2 0v-3.586l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 0 0 0 1.414M18 18H2V2h4.586l1.707 1.707A.996.996 0 0 0 9 4h9v14z"
});

var SvgFolderUpMajorTwotone = function SvgFolderUpMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$3$, _ref2$1i);
};

var _ref$40 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M10 8.586L16.586 2H3.414L10 8.586zM19.382.077A1.006 1.006 0 0 1 20 1v8a1 1 0 1 1-2 0V3.414l-7.293 7.293a.997.997 0 0 1-1.414 0L2 3.414V15h7a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1.006 1.006 0 0 1 1-1h18c.13 0 .26.026.382.077zm-2.675 12.216l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 17H13a1 1 0 1 1 0-2h3.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414z"
});

var SvgFollowUpEmailMajorMonotone = function SvgFollowUpEmailMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$40);
};

var _ref$41 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M10 8.586L16.586 2H3.414L10 8.586zM19.382.077A1.006 1.006 0 0 1 20 1v8a1 1 0 1 1-2 0V3.414l-7.293 7.293a.997.997 0 0 1-1.414 0L2 3.414V15h7a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1.006 1.006 0 0 1 1-1h18c.13 0 .26.026.382.077zm-2.675 12.216l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 17H13a1 1 0 1 1 0-2h3.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414z"
});

var SvgFollowUpEmailMajorTwotone = function SvgFollowUpEmailMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$41);
};

var _ref$42 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 4h-.22L15.97.758A.999.999 0 0 0 15 0H5a.998.998 0 0 0-.97.758L3.22 4H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.095l.91 9.1A1 1 0 0 0 5 20h10c.514 0 .945-.39.996-.9l.91-9.1H17a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-2.4 8.946C13.498 12.447 11.968 12 10 12c-1.967 0-3.498.447-4.6.947L5.106 10h9.789l-.294 2.946zM5.907 18l-.293-2.926C6.463 14.586 7.912 14 10 14c2.09 0 3.543.584 4.389 1.066L14.095 18h-8.19zM5.782 2h8.437l.5 2H5.282l.5-2zM4 8h12V6H4v2z"
});

var SvgFoodMajorMonotone = function SvgFoodMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$42);
};

var _ref$43 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 9V5h1l1-4h10l1 4h1v4z"
});

var _ref2$1j =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 4h-.22L15.97.758A.999.999 0 0 0 15 0H5a.998.998 0 0 0-.97.758L3.22 4H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.095l.91 9.1A1 1 0 0 0 5 20h10c.514 0 .945-.39.996-.9l.91-9.1H17a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-2.4 8.946C13.498 12.447 11.968 12 10 12c-1.967 0-3.498.447-4.6.947L5.106 10h9.789l-.294 2.946zM5.907 18l-.293-2.926C6.463 14.586 7.912 14 10 14c2.09 0 3.543.584 4.389 1.066L14.095 18h-8.19zM5.782 2h8.437l.5 2H5.282l.5-2zM4 8h12V6H4v2z"
});

var SvgFoodMajorTwotone = function SvgFoodMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$43, _ref2$1j);
};

var _ref$44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h18zM2 18h16v-5H2v5zM6 2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2H6zm6 0h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2zm7-2h-1a1 1 0 0 0 0 2 1 1 0 0 0 2 0V1a1 1 0 0 0-1-1zM1 3a1 1 0 0 0 1-1 1 1 0 0 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1zm0 6a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zm18-4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1z",
  fill: undefined
});

var SvgFooterMajorMonotone = function SvgFooterMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$44);
};

var _ref$45 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 12h18v7H1z"
});

var _ref2$1k =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 11H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zM2 18h16v-5H2v5zM6 2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2H6zm6 0h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2m7-2h-1a1 1 0 0 0 0 2 1 1 0 0 0 2 0V1a1 1 0 0 0-1-1M1 3a1 1 0 0 0 1-1 1 1 0 0 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m0 6a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m18-4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"
});

var SvgFooterMajorTwotone = function SvgFooterMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$45, _ref2$1k);
};

var _ref$46 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18a1 1 0 1 1 0 2h-2c-.768 0-1.469-.29-2-.766A2.987 2.987 0 0 1 11 20H9a1 1 0 1 1 0-2h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9a1 1 0 1 1 0-2h2c.768 0 1.469.29 2 .766A2.987 2.987 0 0 1 15 0h2a1 1 0 1 1 0 2h-2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2zm-7-3a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2v8h7a1 1 0 0 1 1 1zm9-11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h1V6h-1a1 1 0 1 1 0-2h2zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-5 1a1 1 0 1 1 2 0 1 1 0 1 1-2 0z"
});

var SvgFormsMajorMonotone = function SvgFormsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$46);
};

var _ref$47 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18a1 1 0 1 1 0 2h-2c-.768 0-1.469-.29-2-.766A2.987 2.987 0 0 1 11 20H9a1 1 0 1 1 0-2h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9a1 1 0 1 1 0-2h2c.768 0 1.469.29 2 .766A2.987 2.987 0 0 1 15 0h2a1 1 0 1 1 0 2h-2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2zm-7-3a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2v8h7a1 1 0 0 1 1 1zm9-11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h1V6h-1a1 1 0 1 1 0-2h2zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-5 1a1 1 0 1 1 2 0 1 1 0 1 1-2 0z"
});

var SvgFormsMajorTwotone = function SvgFormsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$47);
};

var _ref$48 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14.01 6a3.92 3.92 0 0 0-1.753.409 6.015 6.015 0 0 1-1.255.466V3c0-.551.45-1 1.029-1 .552 0 1.002.449 1.002 1a1 1 0 0 0 1.003 1 1 1 0 0 0 1.002-1c0-1.654-1.349-3-3.033-3a3.007 3.007 0 0 0-3.007 3v3.875a6.123 6.123 0 0 1-1.252-.465A3.926 3.926 0 0 0 5.99 6C.32 6 .08 14.515.002 17.314a2.622 2.622 0 0 0 3.595 2.498.988.988 0 0 0 .197-.106C3.818 19.69 6.309 18 8.974 18h2.004c2.652 0 5.213 1.696 5.238 1.712a1.1 1.1 0 0 0 .189.1 2.631 2.631 0 0 0 2.477-.283 2.61 2.61 0 0 0 1.117-2.215C19.921 14.515 19.684 6 14.01 6m3.724 11.888a.61.61 0 0 1-.511.091C16.629 17.603 13.934 16 10.978 16H8.973c-2.95 0-5.6 1.596-6.197 1.98a.613.613 0 0 1-.508-.092.602.602 0 0 1-.262-.519C2.18 11.153 3.52 8 5.99 8c.305 0 .596.068.867.202 2.152 1.059 4.135 1.059 6.289-.001.27-.133.56-.201.864-.201 2.47 0 3.811 3.153 3.985 9.369a.602.602 0 0 1-.262.519M5.99 11a1.001 1.001 0 1 0 0 2 1 1 0 1 0 0-2m8.02 0a1.001 1.001 0 1 0 0 2 1 1 0 1 0 0-2"
});

var SvgGamesConsoleMajorMonotone = function SvgGamesConsoleMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$48);
};

var _ref$49 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10.95 17c3 0 5.784 1.883 5.784 1.883a1.615 1.615 0 0 0 2.216-1.542C18.827 12.948 18.115 7 13.975 7c-.47 0-.914.11-1.307.306-.845.417-1.75.694-2.693.694-.942 0-1.848-.277-2.693-.694A2.924 2.924 0 0 0 5.975 7c-4.139 0-4.852 5.948-4.974 10.341a1.614 1.614 0 0 0 2.215 1.542S5.95 17 8.95 17h2z"
});

var _ref2$1l =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14.01 6a3.92 3.92 0 0 0-1.753.409 6.015 6.015 0 0 1-1.255.466V3c0-.551.45-1 1.029-1 .552 0 1.002.449 1.002 1a1 1 0 0 0 1.003 1 1 1 0 0 0 1.002-1c0-1.654-1.349-3-3.033-3a3.007 3.007 0 0 0-3.007 3v3.875a6.123 6.123 0 0 1-1.252-.465A3.926 3.926 0 0 0 5.99 6C.32 6 .08 14.515.002 17.314a2.622 2.622 0 0 0 3.595 2.498.988.988 0 0 0 .197-.106C3.818 19.69 6.309 18 8.974 18h2.004c2.652 0 5.213 1.696 5.238 1.712a1.1 1.1 0 0 0 .189.1 2.631 2.631 0 0 0 2.477-.283 2.61 2.61 0 0 0 1.117-2.215C19.921 14.515 19.684 6 14.01 6m3.724 11.888a.61.61 0 0 1-.511.091C16.629 17.603 13.934 16 10.978 16H8.973c-2.95 0-5.6 1.596-6.197 1.98a.613.613 0 0 1-.508-.092.602.602 0 0 1-.262-.519C2.18 11.153 3.52 8 5.99 8c.305 0 .596.068.867.202 2.152 1.059 4.135 1.059 6.289-.001.27-.133.56-.201.864-.201 2.47 0 3.811 3.153 3.985 9.369a.602.602 0 0 1-.262.519M5.99 11a1.001 1.001 0 1 0 0 2 1 1 0 1 0 0-2m8.02 0a1.001 1.001 0 1 0 0 2 1 1 0 1 0 0-2"
});

var SvgGamesConsoleMajorTwotone = function SvgGamesConsoleMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$49, _ref2$1l);
};

var _ref$4a =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M11 9h7V7h-7v2zm0 9h5v-7h-5v7zm-7 0h5v-7H4v7zM2 9h7V7H2v2zm2.75-5.5c0-.827.673-1.5 1.5-1.5 1.562 0 2.411 1.42 2.662 3H6.25c-.827 0-1.5-.673-1.5-1.5zM13 3a1.001 1.001 0 0 1 0 2h-1.887c.207-.964.738-2 1.887-2zm6 2h-3.185c.113-.314.185-.647.185-1 0-1.654-1.346-3-3-3-1.243 0-2.202.567-2.871 1.425C9.347 1.005 8.047 0 6.25 0c-1.93 0-3.5 1.57-3.5 3.5 0 .539.133 1.043.352 1.5H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
});

var SvgGiftCardMajorMonotone = function SvgGiftCardMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4a);
};

var _ref$4b =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 6h18v4H1z"
});

var _ref2$1m =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 9h7V7h-7v2zm0 9h5v-7h-5v7zm-7 0h5v-7H4v7zM2 9h7V7H2v2zm2.75-5.5c0-.827.673-1.5 1.5-1.5 1.562 0 2.411 1.42 2.662 3H6.25c-.827 0-1.5-.673-1.5-1.5zM13 3a1.001 1.001 0 0 1 0 2h-1.887c.207-.964.738-2 1.887-2zm6 2h-3.185c.113-.314.185-.647.185-1 0-1.654-1.346-3-3-3-1.243 0-2.202.567-2.871 1.425C9.347 1.005 8.047 0 6.25 0c-1.93 0-3.5 1.57-3.5 3.5 0 .539.133 1.043.352 1.5H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgGiftCardMajorTwotone = function SvgGiftCardMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4b, _ref2$1m);
};

var _ref$4c =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M17 7h-2.185c.113-.314.185-.647.185-1 0-1.654-1.346-3-3-3-.605 0-1.168.184-1.641.494A3.49 3.49 0 0 0 7.5 2C5.57 2 4 3.57 4 5.5c0 .539.133 1.043.352 1.5H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm-6 4h5V9h-5v2zm0 5h3v-3h-3v3zm-5 0h3v-3H6v3zm-2-5h5V9H4v2zm2-5.5C6 4.673 6.673 4 7.5 4S9 4.673 9 5.5 8.327 7 7.5 7 6 6.327 6 5.5zm6-.5a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2z"
});

var SvgGiftCardMinor = function SvgGiftCardMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4c);
};

var _ref$4d =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14.96 11h2.97a8.012 8.012 0 0 1-5.252 6.53c1.025-1.465 2.078-3.635 2.282-6.53zm-9.92 0c.204 2.895 1.258 5.065 2.283 6.53A8.01 8.01 0 0 1 2.07 11h2.97zm0-2H2.07a8.01 8.01 0 0 1 5.253-6.53C6.298 3.934 5.243 6.104 5.04 9zm2.002 0C7.328 5.506 9.059 3.302 10 2.346c.94.956 2.672 3.161 2.959 6.654H7.042zm0 2h5.917c-.286 3.494-2.02 5.7-2.96 6.653-.94-.956-2.671-3.16-2.957-6.653zm7.899-2c-.206-2.895-1.243-5.073-2.267-6.53A8.011 8.011 0 0 1 17.93 9h-2.99zM0 10c0 5.513 4.486 10 10 10s10-4.487 10-10c0-5.514-4.486-10-10-10S0 4.486 0 10z"
});

var SvgGlobeMajorMonotone = function SvgGlobeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4d);
};

var _ref$4e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14.96 11h2.97a8.012 8.012 0 0 1-5.252 6.53c1.025-1.465 2.078-3.635 2.282-6.53zm-9.92 0c.204 2.895 1.258 5.065 2.283 6.53A8.01 8.01 0 0 1 2.07 11h2.97zm0-2H2.07a8.01 8.01 0 0 1 5.253-6.53C6.298 3.934 5.243 6.104 5.04 9zm2.002 0C7.328 5.506 9.059 3.302 10 2.346c.94.956 2.672 3.161 2.959 6.654H7.042zm0 2h5.917c-.286 3.494-2.02 5.7-2.96 6.653-.94-.956-2.671-3.16-2.957-6.653zm7.899-2c-.206-2.895-1.243-5.073-2.267-6.53A8.011 8.011 0 0 1 17.93 9h-2.99zM0 10c0 5.513 4.486 10 10 10s10-4.487 10-10c0-5.514-4.486-10-10-10S0 4.486 0 10z"
});

var SvgGlobeMajorTwotone = function SvgGlobeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4e);
};

var _ref$4f =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12.347 15.521c.699-1.16 1.39-2.712 1.589-4.521h1.974a6.013 6.013 0 0 1-3.563 4.521zM4.09 11h1.975c.198 1.809.889 3.361 1.589 4.521A6.017 6.017 0 0 1 4.09 11zm3.564-6.521c-.7 1.16-1.391 2.712-1.59 4.521H4.09a6.017 6.017 0 0 1 3.564-4.521zM8.077 9c.269-1.916 1.239-3.52 1.925-4.443.687.92 1.655 2.519 1.922 4.443H8.077zm1.92 6.443c-.685-.919-1.653-2.519-1.921-4.443h3.847c-.27 1.916-1.24 3.521-1.925 4.443zM15.91 9h-1.974c-.198-1.809-.89-3.361-1.59-4.521A6.013 6.013 0 0 1 15.91 9zM10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8c4.41 0 8-3.589 8-8s-3.59-8-8-8z"
});

var SvgGlobeMinor = function SvgGlobeMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4f);
};

var _ref$4g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h8a1 1 0 1 0 0-2H2V2h16v9a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1m-.707 14.293L15 17.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414M6 11h8a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m0 4h3a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m0-8h8a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2"
});

var SvgGrammarMajorMonotone = function SvgGrammarMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4g);
};

var _ref$4h =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h8a1 1 0 1 0 0-2H2V2h16v9a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1m-.707 14.293L15 17.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a.999.999 0 1 0-1.414-1.414M6 11h8a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m0 4h3a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2m0-8h8a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2"
});

var SvgGrammarMajorTwotone = function SvgGrammarMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4h);
};

var _ref$4i =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6.673 12.999l.667-6h5.987l-.666 6H6.673zm12.327 0h-4.327l.667-6H19a1 1 0 1 0 0-2h-3.438l.432-3.89a1 1 0 0 0-.883-1.104 1.01 1.01 0 0 0-1.105.884l-.456 4.11H7.562l.432-3.89A1 1 0 0 0 7.11.005a1.009 1.009 0 0 0-1.104.884l-.456 4.11H1a1 1 0 1 0 0 2h4.327l-.666 6H1a1 1 0 1 0 0 2h3.439l-.433 3.89a1 1 0 0 0 1.988.22l.456-4.11h5.989l-.433 3.89a1 1 0 0 0 1.988.22l.456-4.11H19a1 1 0 1 0 0-2z"
});

var SvgHashtagMajorMonotone = function SvgHashtagMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4i);
};

var _ref$4j =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6.673 12.999l.667-6h5.987l-.666 6H6.673zm12.327 0h-4.327l.667-6H19a1 1 0 1 0 0-2h-3.438l.432-3.89a1 1 0 0 0-.883-1.104 1.01 1.01 0 0 0-1.105.884l-.456 4.11H7.562l.432-3.89A1 1 0 0 0 7.11.005a1.009 1.009 0 0 0-1.104.884l-.456 4.11H1a1 1 0 1 0 0 2h4.327l-.666 6H1a1 1 0 1 0 0 2h3.439l-.433 3.89a1 1 0 0 0 1.988.22l.456-4.11h5.989l-.433 3.89a1 1 0 0 0 1.988.22l.456-4.11H19a1 1 0 1 0 0-2z"
});

var SvgHashtagMajorTwotone = function SvgHashtagMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4j);
};

var _ref$4k =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18zM2 7h16V2H2v5zm6 11a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2h2zm6 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zm5-1a1 1 0 0 0-1 1 1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM2 18a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2zm-1-3a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zm18-4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1z",
  fill: undefined
});

var SvgHeaderMajorMonotone = function SvgHeaderMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4k);
};

var _ref$4l =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v7H1z"
});

var _ref2$1n =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 7h16V2H2v5zm6 11a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2h2zm6 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m5-1a1 1 0 0 0-1 1 1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1M2 18a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2m-1-3a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m18-4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgHeaderMajorTwotone = function SvgHeaderMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4l, _ref2$1n);
};

var _ref$4m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9.999 17.877C8.291 16.959 2 13.161 2 7c0-1.867.52-5 4-5 1.65 0 2.255.891 3.056 2.357l.067.124c.351.64 1.403.64 1.754 0l.067-.124C11.745 2.891 12.35 2 14 2c3.48 0 4 3.133 4 5 0 6.144-6.295 9.956-8.001 10.877M14 0c-2.064 0-3.232.998-4 2.061C9.232.998 8.065 0 6 0 2.299 0 0 2.682 0 7c0 8.355 9.187 12.725 9.578 12.906a.99.99 0 0 0 .844 0C10.813 19.725 20 15.355 20 7c0-4.318-2.299-7-6-7"
});

var SvgHeartMajorMonotone = function SvgHeartMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4m);
};

var _ref$4n =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 4c.719-1.312 1.562-3 4-3 3.594 0 5 2.781 5 6 0 7.813-9 12-9 12S1 14.813 1 7c0-3.219 1.406-6 5-6 2.438 0 3.281 1.688 4 3"
});

var _ref2$1o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9.999 17.877C8.291 16.959 2 13.161 2 7c0-1.867.52-5 4-5 1.65 0 2.255.891 3.056 2.357l.067.124c.351.64 1.403.64 1.754 0l.067-.124C11.745 2.891 12.35 2 14 2c3.48 0 4 3.133 4 5 0 6.144-6.295 9.956-8.001 10.877M14 0c-2.064 0-3.232.998-4 2.061C9.232.998 8.065 0 6 0 2.299 0 0 2.682 0 7c0 8.355 9.187 12.725 9.578 12.906a.99.99 0 0 0 .844 0C10.813 19.725 20 15.355 20 7c0-4.318-2.299-7-6-7"
});

var SvgHeartMajorTwotone = function SvgHeartMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4n, _ref2$1o);
};

var _ref$4o =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 12a2 2 0 0 0 2-2c0-.178-.03-.348-.074-.512l5.78-5.78a1 1 0 1 0-1.413-1.415l-2.61 2.61A7.757 7.757 0 0 0 10 4C4.388 4 2.163 9.4 2.07 9.628a1.017 1.017 0 0 0 0 .744c.055.133.836 2.01 2.583 3.56l-2.36 2.36a1 1 0 1 0 1.414 1.415l5.78-5.78c.165.042.335.073.513.073zm-4-2a4 4 0 0 1 4-4c.742 0 1.432.208 2.025.56l-1.513 1.514A2.004 2.004 0 0 0 10 8a2 2 0 0 0-2 2c0 .178.03.347.074.51L6.56 12.026A3.96 3.96 0 0 1 6 10zm10.144-3.144l-2.252 2.252c.065.288.107.585.107.893a4 4 0 0 1-4 4c-.308 0-.604-.04-.892-.107l-1.682 1.68a7.903 7.903 0 0 0 2.573.428c5.612 0 7.836-5.398 7.928-5.628a1.004 1.004 0 0 0 0-.743c-.044-.112-.596-1.438-1.784-2.774z",
  fill: undefined
});

var SvgHideMinor = function SvgHideMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4o);
};

var _ref$4p =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 12h16V2H2v10zm9.293 4.293L10 17.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l2-2a.999.999 0 1 0-1.414-1.414M9 10h2a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m5-1a1 1 0 1 0 2 0 1 1 0 1 0-2 0m-9 1a1 1 0 1 0 0-2 1 1 0 1 0 0 2m1-4a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2"
});

var SvgHideKeyboardMajorMonotone = function SvgHideKeyboardMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4p);
};

var _ref$4q =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v12H1z"
});

var _ref2$1p =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 12h16V2H2v10zm9.293 4.293L10 17.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l2-2a.999.999 0 1 0-1.414-1.414M9 10h2a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m5-1a1 1 0 1 0 2 0 1 1 0 1 0-2 0m-9 1a1 1 0 1 0 0-2 1 1 0 1 0 0 2m1-4a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2"
});

var SvgHideKeyboardMajorTwotone = function SvgHideKeyboardMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4q, _ref2$1p);
};

var _ref$4r =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 9H1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm8-6a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1zm-6.293-.707a.999.999 0 1 0-1.414 1.414l1 1a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-1-1zm9.4 3.789c-1.203-.956-2.766-1.3-4.293-.945a4.96 4.96 0 0 0-3.663 3.621c-.358 1.465-.082 2.932.779 4.13.7.974 1.07 2.094 1.07 3.239V17c0 1.654 1.346 3 3 3s3-1.346 3-3v-.869c0-1.099.388-2.23 1.153-3.362A4.932 4.932 0 0 0 15 10c0-1.535-.69-2.962-1.893-3.918zM11 16.131V17a1.001 1.001 0 0 1-2 0v-.873c0-.043-.01-.084-.01-.127h2.021c-.001.044-.011.087-.011.131zm1.496-4.482A9.047 9.047 0 0 0 11.345 14H8.673a7.73 7.73 0 0 0-1.118-2.279c-.515-.716-.678-1.599-.46-2.488a2.982 2.982 0 0 1 2.172-2.148c.25-.058.497-.086.74-.086.676 0 1.317.221 1.856.649A2.987 2.987 0 0 1 13 10c0 .59-.175 1.161-.504 1.649zM19 9h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm-1.293-6.707a.999.999 0 0 0-1.414 0l-1 1a.999.999 0 1 0 1.414 1.414l1-1a.999.999 0 0 0 0-1.414z",
  fill: undefined
});

var SvgHintMajorMonotone = function SvgHintMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4r);
};

var _ref$4s =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7.89 15h4.229c.196-.995.627-1.935 1.206-2.79A3.94 3.94 0 0 0 14 10a4.007 4.007 0 0 0-4.96-3.889 3.967 3.967 0 0 0-2.917 2.885c-.304 1.245-.023 2.414.62 3.309A6.68 6.68 0 0 1 7.89 15"
});

var _ref2$1q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13.107 6.082c-1.203-.956-2.766-1.3-4.293-.945a4.96 4.96 0 0 0-3.663 3.621c-.358 1.465-.082 2.932.78 4.13.7.974 1.07 2.094 1.07 3.24V17c0 1.654 1.345 3 3 3 1.653 0 3-1.346 3-3v-.869c0-1.099.387-2.23 1.152-3.362A4.932 4.932 0 0 0 15 10c0-1.535-.69-2.962-1.893-3.918zM19 9h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M2 9H1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m8-6a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m7.707-.707a.999.999 0 0 0-1.414 0l-1 1a.999.999 0 1 0 1.414 1.414l1-1a.999.999 0 0 0 0-1.414m-14 0a.999.999 0 1 0-1.414 1.414l1 1a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-1-1zm8.79 9.356A9.047 9.047 0 0 0 11.344 14H8.673a7.73 7.73 0 0 0-1.118-2.279c-.515-.716-.678-1.599-.46-2.488a2.982 2.982 0 0 1 2.172-2.148c.25-.058.497-.086.74-.086.676 0 1.317.221 1.856.65A2.987 2.987 0 0 1 13 10c0 .59-.175 1.161-.504 1.65zM11 17a1.001 1.001 0 0 1-2 0v-.873c0-.043-.01-.084-.01-.127h2.021c0 .044-.01.087-.01.131v.87z"
});

var SvgHintMajorTwotone = function SvgHintMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4s, _ref2$1q);
};

var _ref$4t =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.664 8.252l-9-8a1 1 0 0 0-1.328 0L8 1.44V1a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5.773L.336 8.252a1.001 1.001 0 0 0 1.328 1.496L2 9.449V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.449l.336.299a.997.997 0 0 0 1.411-.083 1.001 1.001 0 0 0-.083-1.413zM16 18h-2v-5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5H4V7.671l6-5.333 6 5.333V18zm-8 0v-4h4v4H8zM4 2h2v1.218L4 4.996V2z",
  fillRule: "evenodd",
  fill: undefined
});

var SvgHomeMajorMonotone = function SvgHomeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4t);
};

var _ref$4u =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 13h6v6H7z"
});

var _ref2$1r =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.664 8.252l-9-8a1 1 0 0 0-1.328 0L8 1.44V1a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5.773L.336 8.252a1.001 1.001 0 0 0 1.328 1.496L2 9.449V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.449l.336.299a.997.997 0 0 0 1.411-.083 1.001 1.001 0 0 0-.083-1.413zM16 18h-2v-5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5H4V7.671l6-5.333 6 5.333V18zm-8 0v-4h4v4H8zM4 2h2v1.218L4 4.996V2z",
  fillRule: "evenodd",
  fill: undefined
});

var SvgHomeMajorTwotone = function SvgHomeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4u, _ref2$1r);
};

var _ref$4v =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 10a2 2 0 1 1-4.001-.001A2 2 0 0 1 6 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 12 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 18 10z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgHorizontalDotsMinor = function SvgHorizontalDotsMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4v);
};

var _ref$4w =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.618 18L14 11.236 17.382 18h-6.764zM4 16V9.899A5.006 5.006 0 0 0 9.898 4H16v6.764l-1.106-2.211c-.339-.678-1.449-.678-1.789 0L9.382 16H4zM5 2c1.654 0 3 1.346 3 3S6.654 8 5 8 2 6.654 2 5s1.346-3 3-3zm14.894 16.553L18 14.764V3a1 1 0 0 0-1-1H8.974C8.06.793 6.627 0 5 0 2.243 0 0 2.243 0 5c0 1.627.793 3.061 2 3.975V17a1 1 0 0 0 1 1h5.382l-.277.553A.999.999 0 0 0 9 20h10a.998.998 0 0 0 .894-1.447z"
});

var SvgIconsMajorMonotone = function SvgIconsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4w);
};

var _ref$4x =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4 10l5-10 5 10H9z"
});

var _ref2$1s =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.618 18L14 11.236 17.382 18h-6.764zM4 16V9.899A5.006 5.006 0 0 0 9.898 4H16v6.764l-1.106-2.211c-.339-.678-1.449-.678-1.789 0L9.382 16H4zM5 2c1.654 0 3 1.346 3 3S6.654 8 5 8 2 6.654 2 5s1.346-3 3-3zm14.894 16.553L18 14.764V3a1 1 0 0 0-1-1H8.974C8.06.793 6.627 0 5 0 2.243 0 0 2.243 0 5c0 1.627.793 3.061 2 3.975V17a1 1 0 0 0 1 1h5.382l-.277.553A.999.999 0 0 0 9 20h10a.998.998 0 0 0 .894-1.447z"
});

var SvgIconsMajorTwotone = function SvgIconsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4x, _ref2$1s);
};

var _ref$4y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12.474 10.595c-.854-1.585-2.166-2.54-3.091-3.051C11.247 4.863 14 2.42 17.952 2.049c-.371 3.934-2.803 6.68-5.478 8.546M9.26 12.42a5.008 5.008 0 0 0-1.686-1.683c.226-.488.47-.985.754-1.495.697.37 1.789 1.125 2.442 2.415-.516.287-1.018.535-1.51.763M5 18H2v-3c0-1.654 1.346-3 3-3 1.655 0 3 1.346 3 3 0 1.655-1.345 3-3 3M20 1a1 1 0 0 0-1-1C11.688 0 7.678 5.74 5.69 10.07 5.464 10.038 5.238 10 5 10c-2.756 0-5 2.243-5 5v4a1 1 0 0 0 1 1h4c2.757 0 5-2.243 5-5 0-.236-.038-.463-.07-.69C14.26 12.323 20 8.313 20 1"
});

var SvgIllustrationMajorMonotone = function SvgIllustrationMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4y);
};

var _ref$4z =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 15a4 4 0 1 1 4 4H1v-4z"
});

var _ref2$1t =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12.474 10.595c-.854-1.585-2.166-2.54-3.091-3.051C11.247 4.863 14 2.42 17.952 2.049c-.371 3.934-2.803 6.68-5.478 8.546M9.26 12.42a5.008 5.008 0 0 0-1.686-1.683c.226-.488.47-.985.754-1.495.697.37 1.789 1.125 2.442 2.415-.516.287-1.018.535-1.51.763M5 18H2v-3c0-1.654 1.346-3 3-3 1.655 0 3 1.346 3 3 0 1.655-1.345 3-3 3M20 1a1 1 0 0 0-1-1C11.688 0 7.678 5.74 5.69 10.07 5.464 10.038 5.238 10 5 10c-2.756 0-5 2.243-5 5v4a1 1 0 0 0 1 1h4c2.757 0 5-2.243 5-5 0-.236-.038-.463-.07-.69C14.26 12.323 20 8.313 20 1"
});

var SvgIllustrationMajorTwotone = function SvgIllustrationMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4z, _ref2$1t);
};

var _ref$4A =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM8 6c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1m0 4c1.654 0 3-1.346 3-3S9.654 4 8 4 5 5.346 5 7s1.346 3 3 3m-6 8v-2.434l3.972-2.383 2.473 1.649a1 1 0 0 0 1.262-.125l4.367-4.367L18 13.48V18H2zM18 2v8.919l-3.375-2.7a1 1 0 0 0-1.332.074l-4.42 4.42-2.318-1.545a1 1 0 0 0-1.07-.025L2 13.234V2h16z"
});

var SvgImageMajorMonotone = function SvgImageMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4A);
};

var _ref$4B =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M14 9l-5 5-3-2-5 3v4h18v-6z"
});

var _ref2$1u =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM8 6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.654 0 3-1.346 3-3S9.654 4 8 4 5 5.346 5 7s1.346 3 3 3zm-6 8v-2.434l3.972-2.383 2.473 1.65c.398.264.925.21 1.262-.126l4.367-4.367L18 13.48V18H2zM18 2v8.92l-3.375-2.7a.999.999 0 0 0-1.332.073l-4.42 4.42-2.318-1.545a1 1 0 0 0-1.07-.025L2 13.233V2h16z",
  fill: undefined
});

var SvgImageMajorTwotone = function SvgImageMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4B, _ref2$1u);
};

var _ref$4C =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.894 6.553c-.339-.678-1.45-.678-1.789 0l-3 6a1 1 0 1 0 1.789.894L2.618 12h2.764l.723 1.447a1 1 0 0 0 1.789-.894l-3-6zM13 12h-2V7a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2zm6-6h-4a1 1 0 1 0 0 2h1v5a1 1 0 1 0 2 0V8h1a1 1 0 1 0 0-2zM3.618 10L4 9.236l.382.764h-.764z",
  fill: undefined
});

var SvgImageAltMajorMonotone = function SvgImageAltMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4C);
};

var _ref$4D =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4.895 6.553c-.34-.678-1.45-.678-1.79 0l-3 6a1 1 0 1 0 1.79.894L2.619 12h2.764l.723 1.447a1 1 0 0 0 1.789-.894l-3-6zM13 12h-2V7a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2m6-6h-4a1 1 0 1 0 0 2h1v5a1 1 0 1 0 2 0V8h1a1 1 0 1 0 0-2M3.619 10L4 9.236l.382.764h-.764z"
});

var SvgImageAltMajorTwotone = function SvgImageAltMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4D);
};

var _ref$4E =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12 11a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v3h1zm5-4a1 1 0 1 1 0 2h-1v3a1 1 0 1 1-2 0V9h-1a1 1 0 1 1 0-2h4zm-11.105.553l2 4a1 1 0 0 1-1.79.895L5.883 12H4.119l-.224.448a1 1 0 0 1-1.79-.895l2-4c.34-.678 1.45-.678 1.79 0z"
});

var SvgImageAltMinor = function SvgImageAltMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4E);
};

var _ref$4F =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 8H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zM2 6h6V2H2v4zm7 14H1a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm10-4H1a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zm0-4H1a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2zm0-4h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm0-4h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z",
  fill: undefined
});

var SvgImageWithTextMajorMonotone = function SvgImageWithTextMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4F);
};

var _ref$4G =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h8v6H1z"
});

var _ref2$1v =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9 8H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zM2 6h6V2H2v4zm7 14H1a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2zm10-4H1a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m0-4H1a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m0-4h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2m0-4h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2"
});

var SvgImageWithTextMajorTwotone = function SvgImageWithTextMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4G, _ref2$1v);
};

var _ref$4H =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 4h-6a1 1 0 1 0 0 2h5v4.586l-1.293-1.293a1 1 0 0 0-1.414 0l-4.42 4.42-2.318-1.545a.997.997 0 0 0-1.11 0L6 13.132V13a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM6 18v-2.465l2-1.333 2.445 1.63a.997.997 0 0 0 1.262-.125L16 11.414l2 2V18H6zm3-8.5a1.5 1.5 0 1 0 2.999.001A1.5 1.5 0 0 0 9 9.5zM1 2h8a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2zm0 4h8a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2zm6 3a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1z",
  fill: undefined
});

var SvgImageWithTextOverlayMajorMonotone = function SvgImageWithTextOverlayMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4H);
};

var _ref$4I =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16 10l-4.999 5L8 13l-3 2v4h14.001v-6z"
});

var _ref2$1w =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 4h-6a1 1 0 1 0 0 2h5v4.586l-1.293-1.293a.999.999 0 0 0-1.414 0l-4.42 4.42-2.318-1.545a.997.997 0 0 0-1.11 0L6 13.132V13a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM6 18v-2.465l2-1.333 2.445 1.63a.997.997 0 0 0 1.262-.125L16 11.414l2 2V18H6zm3-8.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M1 2h8a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2m0 4h8a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2m6 3a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1"
});

var SvgImageWithTextOverlayMajorTwotone = function SvgImageWithTextOverlayMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4I, _ref2$1w);
};

var _ref$4J =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0H5a1 1 0 0 0-1 1v3H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM6 14v-2.465l2-1.333 2.445 1.63a.998.998 0 0 0 1.262-.125L16 7.414l2 2V14H6zm8 4H2V6h2v9a1 1 0 0 0 1 1h9v2zM6 2h12v4.586l-1.293-1.293a.999.999 0 0 0-1.414 0l-4.42 4.42-2.318-1.545a.997.997 0 0 0-1.11 0L6 9.132V2zm4.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
});

var SvgImagesMajorMonotone = function SvgImagesMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4J);
};

var _ref$4K =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16 6l-4.999 5L8 9l-3 2v4h14.001V9z"
});

var _ref2$1x =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0H5a1 1 0 0 0-1 1v3H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM6 14v-2.465l2-1.333 2.445 1.63a.998.998 0 0 0 1.262-.125L16 7.414l2 2V14H6zm8 4H2V6h2v9a1 1 0 0 0 1 1h9v2zM6 2h12v4.586l-1.293-1.293a.999.999 0 0 0-1.414 0l-4.42 4.42-2.318-1.545a.997.997 0 0 0-1.11 0L6 9.132V2zm4.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
});

var SvgImagesMajorTwotone = function SvgImagesMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4K, _ref2$1x);
};

var _ref$4L =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.293 13.707l-3-3a.999.999 0 1 1 1.414-1.414L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.999.999 0 0 1-1.414 0zM17 16a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h14z",
  fill: undefined
});

var SvgImportMinor = function SvgImportMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4L);
};

var _ref$4M =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.97 4.77c.02.07.03.15.03.23v1c0 1.48-.8 2.77-2 3.46V19c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-5h-2c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1v5h2v-8a3.97 3.97 0 0 1-2.93-1.28C12.36 9.53 11.3 10 10 10a4 4 0 0 1-3-1.36A4 4 0 0 1 4 10c-2.21 0-4-1.79-4-4V5c0-.08.01-.16.03-.23.02-.07.04-.14.08-.21.01-.04.04-.08.06-.12L2.11.55C2.27.21 2.62 0 3 0h14a.988.988 0 0 1 .89.55l1.94 3.89c.02.04.05.08.06.12a.904.904 0 0 1 .08.21zM4 8c1.1 0 2-.9 2-2H2c0 1.1.9 2 2 2zm6 0c.6 0 2-.19 2-2H8c0 1.1.9 2 2 2zM2.62 4h14.76l-1-2H3.62l-1 2zM16 8c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z",
  fill: undefined
});

var _ref2$1y =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.71 16.71l-3 3c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29-.39-.39-.39-1.03 0-1.42L4.59 17H1c-.55 0-1-.45-1-1s.45-1 1-1h3.59l-1.3-1.29c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l3 3c.39.39.39 1.03 0 1.42z",
  fill: undefined
});

var SvgImportStoreMajorMonotone = function SvgImportStoreMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4M, _ref2$1y);
};

var _ref$4N =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.97 4.77a.904.904 0 0 0-.08-.21c-.01-.04-.04-.08-.06-.12L17.89.55A.988.988 0 0 0 17 0H3c-.38 0-.73.21-.89.55L.17 4.44c-.02.04-.05.08-.06.12-.04.07-.06.14-.08.21C.01 4.84 0 4.92 0 5v1c0 2.21 1.79 4 4 4a4 4 0 0 0 3-1.36A4 4 0 0 0 10 10c1.3 0 2.36-.47 3.07-1.28A3.97 3.97 0 0 0 16 10v8h-2v-5c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h2v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9.46c1.2-.69 2-1.98 2-3.46V5c0-.08-.01-.16-.03-.23z",
  fill: undefined
});

var _ref2$1z =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4 8c-1.1 0-2-.9-2-2h4c0 1.1-.9 2-2 2zm6 0c-1.1 0-2-.9-2-2h4c0 1.81-1.4 2-2 2zM2.62 4l1-2h12.76l1 2H2.62zM16 8c-1.1 0-2-.9-2-2h4c0 1.1-.9 2-2 2z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.71 16.71l-3 3c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29-.39-.39-.39-1.03 0-1.42L4.59 17H1c-.55 0-1-.45-1-1s.45-1 1-1h3.59l-1.3-1.29c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l3 3c.39.39.39 1.03 0 1.42z",
  fill: undefined
});

var SvgImportStoreMajorTwotone = function SvgImportStoreMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4N, _ref2$1z, _ref3);
};

var _ref$4O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 7a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H2v9h16V9h-4a1 1 0 1 1 0-2h5zM1 2a1 1 0 1 1 0-2h5c2.757 0 5 2.243 5 5v7.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a.999.999 0 1 1 1.414-1.414L9 12.586V5c0-1.654-1.346-3-3-3H1z"
});

var SvgIncomingMajorMonotone = function SvgIncomingMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4O);
};

var _ref$4P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 7a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H2v9h16V9h-4a1 1 0 1 1 0-2h5zM1 2a1 1 0 1 1 0-2h5c2.757 0 5 2.243 5 5v7.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a.999.999 0 1 1 1.414-1.414L9 12.586V5c0-1.654-1.346-3-3-3H1z"
});

var SvgIncomingMajorTwotone = function SvgIncomingMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4P);
};

var _ref$4Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-9 4h2v-4H9v4zm0-6h2V6H9v2z"
});

var SvgInfoMinor = function SvgInfoMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4Q);
};

var _ref$4R =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M4 16h12v-2H4v2zM6.707 5.293L10 8.586l3.293-3.293 1.414 1.414L10 11.414 5.293 6.707l1.414-1.414zM17 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
});

var SvgInstallMinor = function SvgInstallMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4R);
};

var _ref$4S =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M12 18h2v-6h-2v6zm-2-8H8v2h2v-2zm-4 8h4v-4H6v4zm9-8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1V9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3zm4.406-5.914A1 1 0 0 1 20 5v14a1 1 0 0 1-2 0V5.65l-8-3.556L2 5.65V19a1 1 0 0 1-2 0V5a1 1 0 0 1 .594-.914l9-4a.999.999 0 0 1 .812 0l9 4z"
});

var SvgInventoryMajorMonotone = function SvgInventoryMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4S);
};

var _ref$4T =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 19v-6h2V9h4v2h4v8z"
});

var _ref2$1A =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M12 18h2v-6h-2v6zm-2-8H8v2h2v-2zm-4 8h4v-4H6v4zm9-8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1V9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3zm4.406-5.914A1 1 0 0 1 20 5v14a1 1 0 0 1-2 0V5.65l-8-3.556L2 5.65V19a1 1 0 0 1-2 0V5a1 1 0 0 1 .594-.914l9-4a.999.999 0 0 1 .812 0l9 4z"
});

var SvgInventoryMajorTwotone = function SvgInventoryMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4T, _ref2$1A);
};

var _ref$4U =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4 14V6.943l5.419 3.871a.999.999 0 0 0 1.162 0L16 6.943V14H4zm9.879-8L10 8.771 6.121 6h7.758zM17 4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
});

var SvgInviteMinor = function SvgInviteMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4U);
};

var _ref$4V =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8.936-7.89a9.953 9.953 0 0 1-5.491 7.839 1.002 1.002 0 0 1-1.341-.449 1 1 0 0 1 .451-1.341 7.961 7.961 0 0 0 4.392-6.269 1 1 0 0 1 1.989.22m-13.04 7.389a1.002 1.002 0 0 1-1.341.449A9.952 9.952 0 0 1 .064 11.11a1 1 0 0 1 .884-1.104.991.991 0 0 1 1.105.884 7.96 7.96 0 0 0 4.392 6.268 1 1 0 0 1 .451 1.341M.134 6.5A.998.998 0 0 1 1.5 6.134.998.998 0 0 1 .999 8a1 1 0 0 1-.865-1.5m18 1a1 1 0 1 1 1.73-1 1 1 0 0 1-1.73 1M3.572 3.629a1 1 0 0 1 .149-1.407A10.02 10.02 0 0 1 10 0c2.277 0 4.508.789 6.28 2.222a1 1 0 1 1-1.258 1.556A7.903 7.903 0 0 0 10 2a7.902 7.902 0 0 0-5.021 1.778c-.431.347-1.06.28-1.407-.149M13 10c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3m-8 0c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5-5 2.243-5 5"
});

var SvgIqMajorMonotone = function SvgIqMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4V);
};

var _ref$4W =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 4,
  fill: "currentColor"
});

var _ref2$1B =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8.936-7.89a9.953 9.953 0 0 1-5.491 7.839 1.002 1.002 0 0 1-1.341-.449 1 1 0 0 1 .451-1.341 7.961 7.961 0 0 0 4.392-6.269 1 1 0 0 1 1.989.22m-13.04 7.389a1.002 1.002 0 0 1-1.341.449A9.952 9.952 0 0 1 .064 11.11a1 1 0 0 1 .884-1.104.991.991 0 0 1 1.105.884 7.96 7.96 0 0 0 4.392 6.268 1 1 0 0 1 .451 1.341M.134 6.5A.998.998 0 0 1 1.5 6.134.998.998 0 0 1 .999 8a1 1 0 0 1-.865-1.5m18 1a1 1 0 1 1 1.73-1 1 1 0 0 1-1.73 1M3.572 3.629a1 1 0 0 1 .149-1.407A10.02 10.02 0 0 1 10 0c2.277 0 4.508.789 6.28 2.222a1 1 0 1 1-1.258 1.556A7.903 7.903 0 0 0 10 2a7.902 7.902 0 0 0-5.021 1.778c-.431.347-1.06.28-1.407-.149M13 10c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3m-8 0c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5-5 2.243-5 5"
});

var SvgIqMajorTwotone = function SvgIqMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4W, _ref2$1B);
};

var _ref$4X =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 4.001a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h1.68L3.78.682a1 1 0 0 1 .94-.68h10.51a1 1 0 0 1 1 .68l1.09 3.32H19zm-16.64 2l2.58 6h10.14l2.54-6H2.36zm3.08-4l-.65 2h10.43l-.66-2H5.44zm-3.44 16h16v-7.77l-1.25 3.121a1.06 1.06 0 0 1-.95.69H4.33a1.07 1.07 0 0 1-1-.69L2 10.262v7.74zm8-9a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
});

var SvgJobsMajorMonotone = function SvgJobsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4X);
};

var _ref$4Y =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 7.001h7.62l-2.54 6H4.94l-2.58-6z"
});

var _ref2$1C =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 4.001a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h1.68L3.78.682a1 1 0 0 1 .94-.68h10.51a1 1 0 0 1 1 .68l1.09 3.32H19zm-16.64 2l2.58 6h10.14l2.54-6H2.36zm3.08-4l-.65 2h10.43l-.66-2H5.44zm-3.44 16h16v-7.77l-1.25 3.121a1.06 1.06 0 0 1-.95.69H4.33a1.07 1.07 0 0 1-1-.69L2 10.262v7.74zm8-9a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
});

var SvgJobsMajorTwotone = function SvgJobsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4Y, _ref2$1C);
};

var _ref$4Z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6 20c-3.309 0-6-2.691-6-6s2.691-6 6-6c.467 0 .931.06 1.405.181L15.293.293A.996.996 0 0 1 16 0h3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2v3a1 1 0 0 1-1 1h-3.586l-.595.595c.121.474.181.938.181 1.405 0 3.309-2.691 6-6 6m1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4c0-.434-.083-.875-.254-1.349a1 1 0 0 1 .234-1.046l1.313-1.312A.996.996 0 0 1 12 10h3V7a1 1 0 0 1 1-1h2V2h-1.586l-8.019 8.02a1.005 1.005 0 0 1-1.046.234A3.934 3.934 0 0 0 6 10"
});

var SvgKeyMajorMonotone = function SvgKeyMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4Z);
};

var _ref$4_ =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16 1L7.687 9.313A4.947 4.947 0 0 0 6 9a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 4.97 4.97 0 0 0-.312-1.687L12 11h4V7h3V1h-3z"
});

var _ref2$1D =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6 20c-3.309 0-6-2.691-6-6s2.691-6 6-6c.467 0 .931.06 1.405.181L15.293.293A.996.996 0 0 1 16 0h3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2v3a1 1 0 0 1-1 1h-3.586l-.595.595c.121.474.181.938.181 1.405 0 3.309-2.691 6-6 6m1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4c0-.434-.083-.875-.254-1.349a1 1 0 0 1 .234-1.046l1.313-1.312A.996.996 0 0 1 12 10h3V7a1 1 0 0 1 1-1h2V2h-1.586l-8.019 8.02a1.005 1.005 0 0 1-1.046.234A3.934 3.934 0 0 0 6 10"
});

var SvgKeyMajorTwotone = function SvgKeyMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4_, _ref2$1D);
};

var _ref$4$ =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 6h-3V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM7 14H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 4H2V8h2v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8h2v10zM6 10h8V2H6v8z"
});

var SvgLabelPrinterMajorMonotone = function SvgLabelPrinterMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$4$);
};

var _ref$50 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 1h10v10H5z"
});

var _ref2$1E =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 6h-3V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM7 14H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 4H2V8h2v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8h2v10zM6 10h8V2H6v8z"
});

var SvgLabelPrinterMajorTwotone = function SvgLabelPrinterMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$50, _ref2$1E);
};

var _ref$51 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 7c0-.552-.449-1-1-1H1a1 1 0 1 1 0-2h9c1.654 0 3 1.346 3 3v5.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a.999.999 0 1 1 1.414-1.414L11 12.586V7zm8.707-2.707A1 1 0 0 1 20 5v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v9h12V5.414L14.586 2H5a1 1 0 1 1 0-2h10c.265 0 .52.106.707.293l4 4z"
});

var SvgLandingPageMajorMonotone = function SvgLandingPageMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$51);
};

var _ref$52 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 7c0-.552-.449-1-1-1H1a1 1 0 1 1 0-2h9c1.654 0 3 1.346 3 3v5.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a.999.999 0 1 1 1.414-1.414L11 12.586V7zm8.707-2.707A1 1 0 0 1 20 5v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v9h12V5.414L14.586 2H5a1 1 0 1 1 0-2h10c.265 0 .52.106.707.293l4 4z"
});

var SvgLandingPageMajorTwotone = function SvgLandingPageMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$52);
};

var _ref$53 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11.428 13.999L13 10.46l1.573 3.538h-3.145zm6.486 2.594l-4-9a1 1 0 0 0-1.828 0l-1.958 4.406H10c-1.276 0-2.24-.3-2.965-.716l.012-.012c1.292-1.443 1.777-3.536 1.94-5.272H10a1 1 0 1 0 0-2h-.942c-.015-.63-.058-1.051-.064-1.11a.998.998 0 0 0-1.103-.884 1.002 1.002 0 0 0-.885 1.103c0 .013.035.359.05.89H3a1 1 0 0 0 0 2h3.98c-.143 1.37-.515 2.922-1.42 3.935a4.165 4.165 0 0 1-.59-1.183.999.999 0 1 0-1.938.492c.118.474.373 1.07.778 1.679a4.17 4.17 0 0 1-.81.078 1 1 0 0 0 0 2c.857 0 1.629-.16 2.322-.467.962.734 2.253 1.303 3.932 1.435l-1.167 2.626a1.001 1.001 0 0 0 1.828.812l.625-1.406h4.922l.625 1.406a1 1 0 0 0 1.828-.812z"
});

var SvgLanguageMinor = function SvgLanguageMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$53);
};

var _ref$54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 0H6a4 4 0 0 0-4 4v10H1a1 1 0 0 0-1 1v1a4 4 0 0 0 4 4h9a3 3 0 0 0 3-3V6h1a3 3 0 0 0 0-6zM4 18a2 2 0 0 1-2-2h8v1a3 3 0 0 0 .17 1H4zm10-1a1 1 0 0 1-2 0v-2a1 1 0 0 0-1-1H4V4a2 2 0 0 1 2-2h8.18A2.92 2.92 0 0 0 14 3v14zm3-13h-1V3a1 1 0 1 1 1 1zm-5 1a1 1 0 0 1-1 1H7a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1zm0 4a1 1 0 0 1-1 1H7a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1z",
  fill: undefined
});

var SvgLegalMajorMonotone = function SvgLegalMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$54);
};

var _ref$55 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11 17zM6 1C4.346 1 3 2.346 3 4v11H1v1c0 1.654 1.346 3 3 3h7.586l-.472-1.334c-.019-.055-.029-.112-.044-.168.223.861 1 1.502 1.93 1.502 1.103 0 2-.897 2-2V3c0-.212.041-.428.125-.66L15.609 1H6z"
});

var _ref2$1F =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12 9a1 1 0 0 1-1 1H7a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0-4a1 1 0 0 1-1 1H7a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm5-1h-1V3c0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm-3 13c0 .551-.449 1-1 1-.551 0-1-.449-1-1v-2a1 1 0 0 0-1-1H4V4c0-1.103.897-2 2-2h8.184A2.933 2.933 0 0 0 14 3v14zM4 18c-1.103 0-2-.897-2-2h8v1c0 .351.061.687.171 1H4zM17 0H6C3.794 0 2 1.794 2 4v10H1a1 1 0 0 0-1 1v1c0 2.206 1.794 4 4 4h9.001A3.003 3.003 0 0 0 16 17V6h1c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
});

var SvgLegalMajorTwotone = function SvgLegalMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$55, _ref2$1F);
};

var _ref$56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.534 18a4.507 4.507 0 0 1-3.208-1.329 4.54 4.54 0 0 1 0-6.414l1.966-1.964a.999.999 0 1 1 1.414 1.414L4.74 11.671a2.54 2.54 0 0 0 0 3.586c.961.959 2.631.958 3.587 0l1.966-1.964a1 1 0 1 1 1.415 1.414l-1.966 1.964A4.503 4.503 0 0 1 6.534 18zm7.467-6a.999.999 0 0 1-.707-1.707l1.966-1.964a2.54 2.54 0 0 0 0-3.586c-.961-.959-2.631-.957-3.587 0L9.707 6.707a1 1 0 1 1-1.415-1.414l1.966-1.964A4.503 4.503 0 0 1 13.466 2c1.211 0 2.351.472 3.208 1.329a4.541 4.541 0 0 1 0 6.414l-1.966 1.964a.997.997 0 0 1-.707.293zm-6.002 1a.999.999 0 0 1-.707-1.707l4.001-4a1 1 0 1 1 1.415 1.414l-4.001 4a1 1 0 0 1-.708.293z",
  fill: undefined
});

var SvgLinkMinor = function SvgLinkMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$56);
};

var _ref$57 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 18h16V2H2v16zM9 7h6a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 4h6a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m-4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 4h6a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m-4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2"
});

var SvgListMajorMonotone = function SvgListMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$57);
};

var _ref$58 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v18H1z"
});

var _ref2$1G =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 18h16V2H2v16zM9 7h6a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 4h6a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m-4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2m4 4h6a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m-4 0a1 1 0 1 0 0-2 1 1 0 1 0 0 2"
});

var SvgListMajorTwotone = function SvgListMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$58, _ref2$1G);
};

var _ref$59 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 13.424C15.248 12.756 12.901 11 9 11c-3.898 0-6.245 1.753-7 2.424V18h14v-4.576zM2 10.946C3.45 10.03 5.795 9 9 9s5.55 1.031 7 1.946V9a1 1 0 1 1 2 0v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H2v6.946zM17 4a.999.999 0 0 1-.707-1.707l1-1a.999.999 0 1 1 1.414 1.414l-1 1A.997.997 0 0 1 17 4zm2 3h-1a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zm-5-4a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1zm1 3a1 1 0 1 1-2 0 1 1 0 1 1 2 0z"
});

var SvgLiveViewMajorMonotone = function SvgLiveViewMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$59);
};

var _ref$5a =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16 13.43V18H2v-4.57C2.75 12.76 5.1 11 9 11s6.25 1.76 7 2.43"
});

var _ref2$1H =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 13.424C15.248 12.756 12.901 11 9 11c-3.898 0-6.245 1.753-7 2.424V18h14v-4.576zM2 10.946C3.45 10.03 5.795 9 9 9s5.55 1.031 7 1.946V9a1 1 0 1 1 2 0v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H2v6.946zM17 4a.999.999 0 0 1-.707-1.707l1-1a.999.999 0 1 1 1.414 1.414l-1 1A.997.997 0 0 1 17 4zm2 3h-1a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zm-5-4a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1zm1 3a1 1 0 1 1-2 0 1 1 0 1 1 2 0z"
});

var SvgLiveViewMajorTwotone = function SvgLiveViewMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5a, _ref2$1H);
};

var _ref$5b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C5.589 0 2 3.589 2 8c0 7.495 7.197 11.694 7.504 11.869a.996.996 0 0 0 .992 0C10.803 19.694 18 15.495 18 8c0-4.412-3.589-8-8-8m-.001 17.813C8.478 16.782 4 13.296 4 8c0-3.31 2.691-6 6-6s6 2.69 6 6c0 5.276-4.482 8.778-6.001 9.813M10 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m0-6C7.794 4 6 5.794 6 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4"
});

var SvgLocationMajorMonotone = function SvgLocationMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5b);
};

var _ref$5c =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M13 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
});

var _ref2$1I =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C5.59 0 2 3.59 2 8c0 7.495 7.197 11.694 7.504 11.87a1.004 1.004 0 0 0 .992 0C10.803 19.693 18 15.494 18 8c0-4.41-3.59-8-8-8zm0 17.813C8.477 16.783 4 13.295 4 8c0-3.31 2.69-6 6-6s6 2.69 6 6c0 5.276-4.482 8.778-6 9.813zM10 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-6C7.794 4 6 5.794 6 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
  fill: undefined
});

var SvgLocationMajorTwotone = function SvgLocationMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5c, _ref2$1I);
};

var _ref$5d =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m0-8C6.69 2 4 4.87 4 8.4c0 6 5.4 9.35 5.63 9.49.11.07.24.11.37.11s.26-.04.37-.11C10.6 17.75 16 14.4 16 8.4 16 4.87 13.31 2 10 2",
  fill: undefined
});

var SvgLocationsMinor = function SvgLocationsMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5d);
};

var _ref$5e =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 8h-1V6c0-3.309-2.691-6-6-6S4 2.691 4 6v2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM4 18h12v-8H4v8zM6 6c0-2.206 1.794-4 4-4s4 1.794 4 4v2H6V6zm4 10a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1"
});

var SvgLockMajorMonotone = function SvgLockMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5e);
};

var _ref$5f =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 9h14v10H3z"
});

var _ref2$1J =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 8h-1V6c0-3.309-2.691-6-6-6S4 2.691 4 6v2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM4 18h12v-8H4v8zM6 6c0-2.206 1.794-4 4-4s4 1.794 4 4v2H6V6zm4 10a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1"
});

var SvgLockMajorTwotone = function SvgLockMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5f, _ref2$1J);
};

var _ref$5g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M15 8V7c0-2.757-2.243-5-5-5S5 4.243 5 7v1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-6 7h2v-4H9v4zm4-7H7V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1z"
});

var SvgLockMinor = function SvgLockMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5g);
};

var _ref$5h =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 16a1 1 0 1 1 0 2c-4.411 0-8-3.589-8-8s3.589-8 8-8a1 1 0 1 1 0 2c-3.309 0-6 2.691-6 6s2.691 6 6 6zm7.707-6.707a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 11H10a1 1 0 1 1 0-2h4.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l3 3z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgLogOutMinor = function SvgLogOutMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5h);
};

var _ref$5i =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 6c-1.2 0-2.267.542-3 1.382C12.267 6.542 11.2 6 10 6s-2.266.542-3 1.382A3.975 3.975 0 0 0 4 6c-2.206 0-4 1.794-4 4s1.794 4 4 4c1.2 0 2.266-.542 3-1.382.734.84 1.8 1.382 3 1.382s2.267-.542 3-1.382c.733.84 1.8 1.382 3 1.382 2.206 0 4-1.794 4-4s-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm-6 0c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm-6 0c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm-2 6a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2zm17-1a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1zM1 3a1 1 0 0 0 1-1 1 1 0 0 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1zm5-1h2a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2zm6 0h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zM8 18H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
  fill: undefined
});

var SvgLogoBlockMajorMonotone = function SvgLogoBlockMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5i);
};

var _ref$5j =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm6 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm6 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
});

var _ref2$1K =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 6c-1.2 0-2.267.542-3 1.382A3.974 3.974 0 0 0 10 6a3.974 3.974 0 0 0-3 1.382A3.974 3.974 0 0 0 4 6c-2.206 0-4 1.794-4 4s1.794 4 4 4a3.974 3.974 0 0 0 3-1.382A3.974 3.974 0 0 0 10 14c1.2 0 2.267-.542 3-1.382.733.84 1.8 1.382 3 1.382 2.206 0 4-1.794 4-4s-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-6 0c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-6 0c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-2 6a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m17-1a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m0-17h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M1 3a1 1 0 0 0 1-1 1 1 0 0 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m5-1h2a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2m6 0h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2M8 18H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
});

var SvgLogoBlockMajorTwotone = function SvgLogoBlockMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5j, _ref2$1K);
};

var _ref$5k =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M16 8c1.103 0 2-.897 2-2h-4c0 1.103.897 2 2 2zm-6 0c1.103 0 2-.897 2-2H8c0 1.103.897 2 2 2zM4 8c1.103 0 2-.897 2-2H2c0 1.103.897 2 2 2zm-.382-6l-1 2h14.764l-1-2H3.618zm16.277 2.553c.069.138.105.292.105.447v1c0 1.475-.811 2.75-2 3.443V11a1 1 0 1 1-2 0v-1a3.99 3.99 0 0 1-3-1.357A3.99 3.99 0 0 1 10 10a3.99 3.99 0 0 1-3-1.357A3.99 3.99 0 0 1 4 10v8h2v-5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9.443C.811 8.75 0 7.475 0 6V5c0-.155.036-.309.105-.447l2-4C2.275.214 2.621 0 3 0h14c.379 0 .725.214.895.553l2 4zm-1.602 9.74a.999.999 0 1 1 1.414 1.414l-4 4a.997.997 0 0 1-1.414 0l-2-2a.999.999 0 1 1 1.414-1.414L15 17.586l3.293-3.293z"
});

var SvgManagedStoreMajorMonotone = function SvgManagedStoreMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5k);
};

var _ref$5l =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M16 8c1.103 0 2-.897 2-2h-4c0 1.103.897 2 2 2zm-6 0c1.103 0 2-.897 2-2H8c0 1.103.897 2 2 2zM4 8c1.103 0 2-.897 2-2H2c0 1.103.897 2 2 2zm-.382-6l-1 2h14.764l-1-2H3.618zm16.277 2.553c.069.138.105.292.105.447v1c0 1.475-.811 2.75-2 3.443V11a1 1 0 1 1-2 0v-1a3.99 3.99 0 0 1-3-1.357A3.99 3.99 0 0 1 10 10a3.99 3.99 0 0 1-3-1.357A3.99 3.99 0 0 1 4 10v8h2v-5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9.443C.811 8.75 0 7.475 0 6V5c0-.155.036-.309.105-.447l2-4C2.275.214 2.621 0 3 0h14c.379 0 .725.214.895.553l2 4zm-1.602 9.74a.999.999 0 1 1 1.414 1.414l-4 4a.997.997 0 0 1-1.414 0l-2-2a.999.999 0 1 1 1.414-1.414L15 17.586l3.293-3.293z"
});

var SvgManagedStoreMajorTwotone = function SvgManagedStoreMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5l);
};

var _ref$5m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v3h2.382c.379 0 .725.214.894.553L8 15h4l.724-1.447a.998.998 0 0 1 .894-.553H16v-3a1 1 0 0 1 1-1zm-8.707-.293l-3-3a.999.999 0 1 1 1.414-1.414L9 6.586l4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5a.997.997 0 0 1-1.414 0z"
});

var SvgMarkFulfilledMinor = function SvgMarkFulfilledMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5m);
};

var _ref$5n =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9 12.414L5.293 8.707l1.414-1.414L9 9.586l4.293-4.293 1.414 1.414L9 12.414zM17 2H3a1 1 0 0 0-1 1v14a1.002 1.002 0 0 0 1.555.832l2.305-1.537 1.349 1.399c.184.191.437.301.702.306a.96.96 0 0 0 .713-.281l1.364-1.317 1.305 1.305a.997.997 0 0 0 1.414 0l1.42-1.42 2.318 1.545A1 1 0 0 0 18 17V3a1 1 0 0 0-1-1z"
});

var SvgMarkPaidMinor = function SvgMarkPaidMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5n);
};

var _ref$5o =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 14.6c-2-1.5-4.9-2.3-7-2.6V6.901c2.1-.2 5-1.101 7-2.601v10.3zM9 18H7.651L5.6 14H9v4zm0-6H4.5C3.1 12 2 10.901 2 9.5 2 8.1 3.1 7 4.5 7H9v5zM19 0c-.5 0-1 .5-1 1 0 2-5.1 4-8 4H4.5C2 5 0 7 0 9.5c0 2.1 1.4 3.8 3.3 4.3l2.5 5c.3.7 1 1.2 1.8 1.2H9c1.1 0 2-.9 2-2v-3.9c3 .301 7 2.101 7 3.9 0 .5.5 1 1 1s1-.5 1-1V1c0-.5-.5-1-1-1z",
  fill: undefined
});

var SvgMarketingMajorMonotone = function SvgMarketingMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5o);
};

var _ref$5p =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M9 12H4.5C3.1 12 2 10.901 2 9.5 2 8.1 3.1 7 4.5 7H9v5z"
});

var _ref2$1L =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 14.6c-2-1.5-4.9-2.3-7-2.6V6.901c2.1-.2 5-1.101 7-2.601v10.3zM9 18H7.651L5.6 14H9v4zm0-6H4.5C3.1 12 2 10.901 2 9.5 2 8.1 3.1 7 4.5 7H9v5zM19 0c-.5 0-1 .5-1 1 0 2-5.1 4-8 4H4.5C2 5 0 7 0 9.5c0 2.1 1.4 3.8 3.3 4.3l2.5 5c.3.7 1 1.2 1.8 1.2H9c1.1 0 2-.9 2-2v-3.9c3 .301 7 2.101 7 3.9 0 .5.5 1 1 1s1-.5 1-1V1c0-.5-.5-1-1-1z"
});

var SvgMarketingMajorTwotone = function SvgMarketingMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5p, _ref2$1L);
};

var _ref$5q =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0V2h16v16h-7a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1M2 18h4v-4H2v4zm5-6H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm3.707-1.293L14 7.414V10a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1h-5a1 1 0 1 0 0 2h2.586L9.293 9.293a.999.999 0 1 0 1.414 1.414"
});

var SvgMaximizeMajorMonotone = function SvgMaximizeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5q);
};

var _ref$5r =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13h6v6H1z"
});

var _ref2$1M =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0V2h16v16h-7a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1M2 18h4v-4H2v4zm5-6H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm3.707-1.293L14 7.414V10a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1h-5a1 1 0 1 0 0 2h2.586L9.293 9.293a.999.999 0 1 0 1.414 1.414"
});

var SvgMaximizeMajorTwotone = function SvgMaximizeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5r, _ref2$1M);
};

var _ref$5s =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M3 11a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3zm14-9a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414l-4.293 4.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 4H12a1 1 0 1 1 0-2h5zm-1 12v2h-2a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 1 0-2 0zM4 16h3v-3H4v3zM4 6V4h2a1 1 0 1 0 0-2H3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0z"
});

var SvgMaximizeMinor = function SvgMaximizeMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5s);
};

var _ref$5t =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m0-13C4.486 0 0 4.486 0 10s4.486 10 10 10a1 1 0 1 0 0-2c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8v1c0 .827-.673 1.5-1.5 1.5S15 11.827 15 11v-1c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5c1.531 0 2.887-.707 3.805-1.795A3.477 3.477 0 0 0 16.5 14.5c1.93 0 3.5-1.57 3.5-3.5v-1c0-5.514-4.486-10-10-10"
});

var SvgMentionMajorMonotone = function SvgMentionMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5t);
};

var _ref$5u =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m0-13C4.486 0 0 4.486 0 10s4.486 10 10 10a1 1 0 1 0 0-2c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8v1c0 .827-.673 1.5-1.5 1.5S15 11.827 15 11v-1c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5c1.531 0 2.887-.707 3.805-1.795A3.477 3.477 0 0 0 16.5 14.5c1.93 0 3.5-1.57 3.5-3.5v-1c0-5.514-4.486-10-10-10"
});

var SvgMentionMajorTwotone = function SvgMentionMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5u);
};

var _ref$5v =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 8a1 1 0 1 0-2 0c0 3.309-2.691 6-6 6s-6-2.691-6-6a1 1 0 1 0-2 0c0 4.072 3.061 7.436 7 7.931V18H8a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-2.069c3.939-.495 7-3.859 7-7.931m-8 4c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4S6 1.794 6 4v4c0 2.206 1.794 4 4 4zM8 4c0-1.103.897-2 2-2s2 .897 2 2v4c0 1.103-.897 2-2 2s-2-.897-2-2V4z"
});

var SvgMicrophoneMajorMonotone = function SvgMicrophoneMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5v);
};

var _ref$5w =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 4a3 3 0 1 1 6 0v4a3 3 0 1 1-6 0V4z"
});

var _ref2$1N =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 8a1 1 0 1 0-2 0c0 3.309-2.691 6-6 6s-6-2.691-6-6a1 1 0 1 0-2 0c0 4.072 3.061 7.436 7 7.931V18H8a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-2.069c3.939-.495 7-3.859 7-7.931m-8 4c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4S6 1.794 6 4v4c0 2.206 1.794 4 4 4zM8 4c0-1.103.897-2 2-2s2 .897 2 2v4c0 1.103-.897 2-2 2s-2-.897-2-2V4z"
});

var SvgMicrophoneMajorTwotone = function SvgMicrophoneMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5w, _ref2$1N);
};

var _ref$5x =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0V2h16v16h-7a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1M2 18h4v-4H2v4zm5-6H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm8-1a1 1 0 1 0 0-2h-2.586l3.293-3.293a.999.999 0 1 0-1.414-1.414L11 7.586V5a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5z"
});

var SvgMinimizeMajorMonotone = function SvgMinimizeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5x);
};

var _ref$5y =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13h6v6H1z"
});

var _ref2$1O =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0V2h16v16h-7a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1M2 18h4v-4H2v4zm5-6H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm8-1a1 1 0 1 0 0-2h-2.586l3.293-3.293a.999.999 0 1 0-1.414-1.414L11 7.586V5a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5z"
});

var SvgMinimizeMajorTwotone = function SvgMinimizeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5y, _ref2$1O);
};

var _ref$5z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M8 11H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm9-2a1 1 0 0 0-1-1h-2.586l4.293-4.293a.999.999 0 1 0-1.414-1.414L12 6.586V4a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1m0 4a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1M4 16h3v-3H4v3zM3 7a1 1 0 0 0 1-1V4h2a1 1 0 1 0 0-2H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1"
});

var SvgMinimizeMinor = function SvgMinimizeMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5z);
};

var _ref$5A =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 9H5a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgMinusMinor = function SvgMinusMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5A);
};

var _ref$5B =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM4 18h12V2H4v16zM9 6h2a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m1 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
});

var SvgMobileMajorMonotone = function SvgMobileMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5B);
};

var _ref$5C =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 1h14v18H3z"
});

var _ref2$1P =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM4 18h12V2H4v16zM9 6h2a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2m1 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
  fillRule: "evenodd",
  fill: undefined
});

var SvgMobileMajorTwotone = function SvgMobileMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5C, _ref2$1P);
};

var _ref$5D =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 18a.997.997 0 0 1-.707-.293l-6-6a.999.999 0 1 1 1.414-1.414l5.236 5.236 11.298-13.18a.999.999 0 1 1 1.518 1.3l-12 14a1 1 0 0 1-.721.35H7"
});

var SvgMobileAcceptMajorMonotone = function SvgMobileAcceptMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5D);
};

var _ref$5E =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 18a.997.997 0 0 1-.707-.293l-6-6a.999.999 0 1 1 1.414-1.414l5.236 5.236 11.298-13.18a.999.999 0 1 1 1.518 1.3l-12 14a1 1 0 0 1-.721.35H7"
});

var SvgMobileAcceptMajorTwotone = function SvgMobileAcceptMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5E);
};

var _ref$5F =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 9H3.661l5.997-5.246a1 1 0 0 0-1.316-1.506l-8 7c-.008.007-.011.018-.019.025a.975.975 0 0 0-.177.24c-.018.03-.045.054-.059.087a.975.975 0 0 0 0 .802c.014.033.041.057.059.088.05.087.104.17.177.239.008.007.011.018.019.025l8 7a.996.996 0 0 0 1.411-.095 1 1 0 0 0-.095-1.411L3.661 11H19a1 1 0 1 0 0-2"
});

var SvgMobileBackArrowMajorMonotone = function SvgMobileBackArrowMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5F);
};

var _ref$5G =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 9H3.661l5.997-5.246a1 1 0 0 0-1.316-1.506l-8 7c-.008.007-.011.018-.019.025a.975.975 0 0 0-.177.24c-.018.03-.045.054-.059.087a.975.975 0 0 0 0 .802c.014.033.041.057.059.088.05.087.104.17.177.239.008.007.011.018.019.025l8 7a.996.996 0 0 0 1.411-.095 1 1 0 0 0-.095-1.411L3.661 11H19a1 1 0 1 0 0-2"
});

var SvgMobileBackArrowMajorTwotone = function SvgMobileBackArrowMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5G);
};

var _ref$5H =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgMobileCancelMajorMonotone = function SvgMobileCancelMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5H);
};

var _ref$5I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"
});

var SvgMobileCancelMajorTwotone = function SvgMobileCancelMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5I);
};

var _ref$5J =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14 20.001a.994.994 0 0 1-.747-.336l-8-9a.999.999 0 0 1 0-1.328l8-9a.999.999 0 1 1 1.494 1.328l-7.41 8.336 7.41 8.336A.999.999 0 0 1 14 20.001"
});

var SvgMobileChevronMajorMonotone = function SvgMobileChevronMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5J);
};

var _ref$5K =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14 20.001a.994.994 0 0 1-.747-.336l-8-9a.999.999 0 0 1 0-1.328l8-9a.999.999 0 1 1 1.494 1.328l-7.41 8.336 7.41 8.336A.999.999 0 0 1 14 20.001"
});

var SvgMobileChevronMajorTwotone = function SvgMobileChevronMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5K);
};

var _ref$5L =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 11H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0-7H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2zm0 14H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2z",
  fill: undefined
});

var SvgMobileHamburgerMajorMonotone = function SvgMobileHamburgerMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5L);
};

var _ref$5M =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 11H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0-7H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0 14H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2z"
});

var SvgMobileHamburgerMajorTwotone = function SvgMobileHamburgerMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5M);
};

var _ref$5N =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 8c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm-6 0c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM4 8c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
});

var SvgMobileHorizontalDotsMajorMonotone = function SvgMobileHorizontalDotsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5N);
};

var _ref$5O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 8c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm-6 0c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM4 8c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
});

var SvgMobileHorizontalDotsMajorTwotone = function SvgMobileHorizontalDotsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5O);
};

var _ref$5P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 9h-6V3a1 1 0 0 0-2 0v6H3a1 1 0 0 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2"
});

var SvgMobilePlusMajorMonotone = function SvgMobilePlusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5P);
};

var _ref$5Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 9h-6V3a1 1 0 0 0-2 0v6H3a1 1 0 0 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2"
});

var SvgMobilePlusMajorTwotone = function SvgMobilePlusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5Q);
};

var _ref$5R =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0 2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
});

var SvgMobileVerticalDotsMajorMonotone = function SvgMobileVerticalDotsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5R);
};

var _ref$5S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0 2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
});

var SvgMobileVerticalDotsMajorTwotone = function SvgMobileVerticalDotsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5S);
};

var _ref$5T =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.447 1.105C17.357 1.061 15.177 0 10 0S2.643 1.061 2.552 1.105C2.214 1.275 2 1.621 2 2c0 .456.023 11.232 2.051 17.316a1 1 0 0 0 .95.684h10c.43 0 .811-.275.947-.684C17.976 13.232 18 2.456 18 2c0-.379-.214-.725-.553-.895zM5.737 18a26.274 26.274 0 0 1-.49-2H6a1 1 0 1 0 0-2H4.886a55.95 55.95 0 0 1-.274-2H6a1 1 0 1 0 0-2H4.4a92.069 92.069 0 0 1-.206-2.649C5.506 7.648 7.567 8 10 8c2.432 0 4.495-.353 5.805-.649A85.3 85.3 0 0 1 15.6 10H14a1 1 0 1 0 0 2h1.388a58.67 58.67 0 0 1-.274 2H14a1 1 0 1 0 0 2h.755c-.147.701-.31 1.374-.492 2H5.736zM10 2c3.215 0 5.123.431 5.992.695-.009.574-.03 1.474-.077 2.573C14.816 5.548 12.633 6 10 6c-2.623 0-4.813-.453-5.915-.733a98.017 98.017 0 0 1-.078-2.574C4.87 2.43 6.772 2 10 2zm0 8a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
});

var SvgMonerisMajorMonotone = function SvgMonerisMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5T);
};

var _ref$5U =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 2s3-1 7-1 7 1 7 1v4s-3 1-7 1-7-1-7-1V2z"
});

var _ref2$1Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.447 1.105C17.357 1.061 15.177 0 10 0S2.643 1.061 2.552 1.105C2.214 1.275 2 1.621 2 2c0 .456.023 11.232 2.051 17.316a1 1 0 0 0 .95.684h10c.43 0 .811-.275.947-.684C17.976 13.232 18 2.456 18 2c0-.379-.214-.725-.553-.895zM5.737 18a26.274 26.274 0 0 1-.49-2H6a1 1 0 1 0 0-2H4.886a55.95 55.95 0 0 1-.274-2H6a1 1 0 1 0 0-2H4.4a92.069 92.069 0 0 1-.206-2.649C5.506 7.648 7.567 8 10 8c2.432 0 4.495-.353 5.805-.649A85.3 85.3 0 0 1 15.6 10H14a1 1 0 1 0 0 2h1.388a58.67 58.67 0 0 1-.274 2H14a1 1 0 1 0 0 2h.755c-.147.701-.31 1.374-.492 2H5.736zM10 2c3.215 0 5.123.431 5.992.695-.009.574-.03 1.474-.077 2.573C14.816 5.548 12.633 6 10 6c-2.623 0-4.813-.453-5.915-.733a98.017 98.017 0 0 1-.078-2.574C4.87 2.43 6.772 2 10 2zm0 8a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
});

var SvgMonerisMajorTwotone = function SvgMonerisMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5U, _ref2$1Q);
};

var _ref$5V =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16.12 13.093c-2.38 2.17-5.77 3.25-10.11 3.25-1.09 0-2.24-.061-3.46-.21-.35.93-.55 1.91-.55 2.93 0 .55-.45 1-1 1s-1-.45-1-1c0-7.52 8.45-12.89 12.76-13.97a.991.991 0 0 1 1.21.729.99.99 0 0 1-.73 1.21c-2.89.72-7.42 3.44-9.75 7.19 5.06.48 8.86-.4 11.29-2.61 2.62-2.37 3.2-5.83 3.18-8.5-1.79-.9-6.94-2.1-10.83.31C4.21 5.243 2 8.533 2 11.063c0 .55-.45 1-1 1s-1-.45-1-1c0-3.22 2.56-7.15 6.08-9.34 5.06-3.14 11.67-1.27 13.45 0 .25.18.41.47.42.78.09 2.58-.28 7.38-3.83 10.59"
});

var SvgNatureMajorMonotone = function SvgNatureMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5V);
};

var _ref$5W =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16.12 13.093c-2.38 2.17-5.77 3.25-10.11 3.25-1.09 0-2.24-.061-3.46-.21-.35.93-.55 1.91-.55 2.93 0 .55-.45 1-1 1s-1-.45-1-1c0-7.52 8.45-12.89 12.76-13.97a.991.991 0 0 1 1.21.729.99.99 0 0 1-.73 1.21c-2.89.72-7.42 3.44-9.75 7.19 5.06.48 8.86-.4 11.29-2.61 2.62-2.37 3.2-5.83 3.18-8.5-1.79-.9-6.94-2.1-10.83.31C4.21 5.243 2 8.533 2 11.063c0 .55-.45 1-1 1s-1-.45-1-1c0-3.22 2.56-7.15 6.08-9.34 5.06-3.14 11.67-1.27 13.45 0 .25.18.41.47.42.78.09 2.58-.28 7.38-3.83 10.59"
});

var SvgNatureMajorTwotone = function SvgNatureMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5W);
};

var _ref$5X =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.487 0 10c0 5.514 4.486 10 10 10s10-4.486 10-10c0-5.513-4.486-10-10-10m1 17.93V17a1 1 0 1 0-2 0v.93A8.007 8.007 0 0 1 2.069 11H3a1 1 0 1 0 0-2h-.931A8.007 8.007 0 0 1 9 2.07V3a1 1 0 1 0 2 0v-.93A8.007 8.007 0 0 1 17.931 9H17a1 1 0 1 0 0 2h.931A8.007 8.007 0 0 1 11 17.93m-.293-7.223c-.258.248-1.355.729-2.617 1.203.473-1.263.956-2.36 1.203-2.616.257-.248 1.354-.731 2.617-1.204-.474 1.262-.955 2.359-1.203 2.617m2.522-5.194c-1.032.332-4.466 1.482-5.35 2.366-.884.884-2.034 4.318-2.366 5.35a.997.997 0 0 0 .245 1.013.997.997 0 0 0 1.012.245c1.033-.332 4.467-1.482 5.351-2.366.884-.884 2.034-4.318 2.366-5.351a1 1 0 0 0-1.258-1.257"
});

var SvgNavigationMajorMonotone = function SvgNavigationMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5X);
};

var _ref$5Y =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.2 11.2C10.536 11.863 7 13 7 13s1.137-3.537 1.8-4.2C9.462 8.139 13 7 13 7s-1.138 3.538-1.8 4.2",
  fill: "currentColor"
});

var _ref2$1R =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.487 0 10c0 5.514 4.486 10 10 10s10-4.486 10-10c0-5.513-4.486-10-10-10m1 17.93V17a1 1 0 1 0-2 0v.93A8.007 8.007 0 0 1 2.069 11H3a1 1 0 1 0 0-2h-.931A8.007 8.007 0 0 1 9 2.07V3a1 1 0 1 0 2 0v-.93A8.007 8.007 0 0 1 17.931 9H17a1 1 0 1 0 0 2h.931A8.007 8.007 0 0 1 11 17.93m-.293-7.223c-.258.248-1.355.729-2.617 1.203.473-1.263.956-2.36 1.203-2.616.257-.248 1.354-.731 2.617-1.204-.474 1.262-.955 2.359-1.203 2.617m2.522-5.194c-1.032.332-4.466 1.482-5.35 2.366-.884.884-2.034 4.318-2.366 5.35a.997.997 0 0 0 .245 1.013.997.997 0 0 0 1.012.245c1.033-.332 4.467-1.482 5.351-2.366.884-.884 2.034-4.318 2.366-5.351a1 1 0 0 0-1.258-1.257",
  fill: undefined
});

var SvgNavigationMajorTwotone = function SvgNavigationMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5Y, _ref2$1R);
};

var _ref$5Z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.997.997 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.997.997 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zm-3-5H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-7-3a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2H7a1 1 0 0 0-1 1m1-3h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2"
});

var SvgNoteMajorMonotone = function SvgNoteMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5Z);
};

var _ref$5_ =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 19h14V5l-4-4H3z"
});

var _ref2$1S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.997.997 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.997.997 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zm-3-5H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-7-3a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2H7a1 1 0 0 0-1 1m1-3h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2"
});

var SvgNoteMajorTwotone = function SvgNoteMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5_, _ref2$1S);
};

var _ref$5$ =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 11h8V9H6v2zm0 4h8v-2H6v2zm0-8h4V5H6v2zm9.707-1.707l-3-3A.996.996 0 0 0 12 2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a.997.997 0 0 0-.293-.707z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgNoteMinor = function SvgNoteMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$5$);
};

var _ref$60 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M6 11h8V9H6v2zm0 4h8v-2H6v2zm0-8h4V5H6v2zm9.707-1.707l-3-3A.996.996 0 0 0 12 2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a.997.997 0 0 0-.293-.707z"
});

var SvgNotesMinor = function SvgNotesMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$60);
};

var _ref$61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 8c0-2.967-2.167-5.432-5-5.91V1a1 1 0 1 0-2 0v1.09C6.167 2.568 4 5.033 4 8c0 2.957 0 4.586-1.707 6.293A1 1 0 0 0 3 16h4.183A2.909 2.909 0 0 0 7 17c0 1.654 1.345 3 3 3s3-1.346 3-3c0-.353-.07-.687-.184-1H17a1 1 0 0 0 .707-1.707C16 12.586 16 10.957 16 8zM5.011 14C6 12.208 6 10.285 6 8c0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.285 0 4.208.989 6H5.011zM11 17a1.001 1.001 0 0 1-2 0 1 1 0 0 1 2 0z",
  fill: undefined
});

var SvgNotificationMajorMonotone = function SvgNotificationMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$61);
};

var _ref$62 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 15c2-2 2-4 2-7a5 5 0 1 1 10 0c0 3 0 5 2 7H3z"
});

var _ref2$1T =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 8c0-2.967-2.167-5.432-5-5.91V1a1 1 0 1 0-2 0v1.09C6.167 2.568 4 5.033 4 8c0 2.957 0 4.586-1.707 6.293A1 1 0 0 0 3 16h4.183A2.909 2.909 0 0 0 7 17c0 1.654 1.345 3 3 3 1.654 0 3-1.346 3-3 0-.353-.07-.687-.184-1H17a1 1 0 0 0 .707-1.707C16 12.586 16 10.957 16 8zM5.011 14c.99-1.792.99-3.715.99-6 0-2.206 1.793-4 4-4 2.204 0 4 1.794 4 4 0 2.285 0 4.208.988 6H5.011zm5.99 3a1.001 1.001 0 0 1-2 0 1 1 0 0 1 2 0z"
});

var SvgNotificationMajorTwotone = function SvgNotificationMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$62, _ref2$1T);
};

var _ref$63 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm0 6H4v-4a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v4zm-3.281 4H7.281c.357-.702.536-1.434.627-2h4.184c.091.566.27 1.298.627 2zM12 6c0 1.103-.897 2-2 2s-2-.897-2-2h4zM2 6h4c0 1.103-.897 2-2 2s-2-.897-2-2zm1.618-4h12.764l1 2H2.618l1-2zm16.277 2.553l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4A1.002 1.002 0 0 0 0 5v1c0 1.474.811 2.75 2 3.444V15a1 1 0 0 0 1 1h2.871c-.157.747-.508 1.7-1.318 2.105a1.002 1.002 0 0 0-.527 1.125c.108.451.51.77.974.77h10c.464 0 .866-.319.974-.77a1.002 1.002 0 0 0-.527-1.125c-.801-.4-1.153-1.356-1.313-2.105H17a1 1 0 0 0 1-1V9.444c1.189-.694 2-1.97 2-3.444V5c0-.155-.036-.309-.105-.447z"
});

var SvgOnlineStoreMajorMonotone = function SvgOnlineStoreMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$63);
};

var _ref$64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 6a3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 1 1-6 0V5l2-4h14l2 4v1z",
  fill: "currentColor"
});

var _ref2$1U =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm0 6H4v-4a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v4zm-3.281 4H7.281c.357-.702.536-1.434.627-2h4.184c.091.566.27 1.298.627 2zM12 6c0 1.103-.897 2-2 2s-2-.897-2-2h4zM2 6h4c0 1.103-.897 2-2 2s-2-.897-2-2zm1.618-4h12.764l1 2H2.618l1-2zm16.277 2.553l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4A1.002 1.002 0 0 0 0 5v1c0 1.474.811 2.75 2 3.444V15a1 1 0 0 0 1 1h2.871c-.157.747-.508 1.7-1.318 2.105a1.002 1.002 0 0 0-.527 1.125c.108.451.51.77.974.77h10c.464 0 .866-.319.974-.77a1.002 1.002 0 0 0-.527-1.125c-.801-.4-1.153-1.356-1.313-2.105H17a1 1 0 0 0 1-1V9.444c1.189-.694 2-1.97 2-3.444V5c0-.155-.036-.309-.105-.447z",
  fill: undefined
});

var SvgOnlineStoreMajorTwotone = function SvgOnlineStoreMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$64, _ref2$1U);
};

var _ref$65 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M3 7a1 1 0 1 1 0-2h2.586l2.707-2.707a.997.997 0 0 1 1.655.391l1.49 4.465 1.855-1.856A.996.996 0 0 1 14 5h3a1 1 0 1 1 0 2h-2.586l-2.707 2.707a.998.998 0 0 1-1.655-.391l-1.49-4.465-1.855 1.856A.996.996 0 0 1 6 7H3zm14 2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v3h2.382c.379 0 .725.214.894.553L8 15h4l.724-1.447a.998.998 0 0 1 .894-.553H16v-3a1 1 0 0 1 1-1z"
});

var SvgOrderStatusMinor = function SvgOrderStatusMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$65);
};

var _ref$66 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M2 18h16v-4h-3.382l-.723 1.447c-.17.339-.516.553-.895.553H7c-.379 0-.725-.214-.895-.553L5.382 14H2v4zM19 1a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H2v9h4c.379 0 .725.214.895.553L7.618 14h4.764l.723-1.447c.17-.339.516-.553.895-.553h4V3h-3a1 1 0 0 1 0-2h4zM6.293 6.707a.999.999 0 1 1 1.414-1.414L9 6.586V1a1 1 0 0 1 2 0v5.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3z"
});

var SvgOrdersMajorMonotone = function SvgOrdersMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$66);
};

var _ref$67 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13h5l1 2h6l1-2h5v6H1z"
});

var _ref2$1V =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM19 1a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H2v9h4c.379 0 .725.214.895.553L7.618 14h4.764l.723-1.447c.17-.339.516-.553.895-.553h4V3h-3a1 1 0 0 1 0-2h4zM6.293 6.707a.999.999 0 1 1 1.414-1.414L9 6.586V1a1 1 0 0 1 2 0v5.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgOrdersMajorTwotone = function SvgOrdersMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$67, _ref2$1V);
};

var _ref$68 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H2v6h16v-6h-4a1 1 0 1 1 0-2h5zm-9 6a1 1 0 0 1-1-1V8c0-2.757 2.243-5 5-5h2.586l-1.293-1.293A.999.999 0 1 1 16.707.293l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 5H14c-1.654 0-3 1.346-3 3v7a1 1 0 0 1-1 1z"
});

var SvgOutgoingMajorMonotone = function SvgOutgoingMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$68);
};

var _ref$69 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H2v6h16v-6h-4a1 1 0 1 1 0-2h5zm-9 6a1 1 0 0 1-1-1V8c0-2.757 2.243-5 5-5h2.586l-1.293-1.293A.999.999 0 1 1 16.707.293l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 5H14c-1.654 0-3 1.346-3 3v7a1 1 0 0 1-1 1z"
});

var SvgOutgoingMajorTwotone = function SvgOutgoingMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$69);
};

var _ref$6a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.901 4.581c-.004-.009-.002-.019-.006-.028l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4c-.004.009-.002.019-.006.028A.982.982 0 0 0 0 5v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a.982.982 0 0 0-.099-.419zM2 18V6h7v1a1 1 0 0 0 2 0V6h7v12H2zM3.618 2H9v2H2.618l1-2zm13.764 2H11V2h5.382l1 2zM9 14H5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-4-2h2a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2"
});

var SvgPackageMajorMonotone = function SvgPackageMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6a);
};

var _ref$6b =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 5h18v14H1V5z"
});

var _ref2$1W =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.9 4.58c-.003-.008 0-.018-.005-.027l-2-4A.998.998 0 0 0 17 0H3a1 1 0 0 0-.895.553l-2 4c-.004.01-.002.02-.006.028-.06.13-.1.27-.1.42v14a1 1 0 0 0 1 1h18c.55 0 1-.447 1-1V5c0-.15-.04-.29-.1-.42zM2 18V6h7v1a1 1 0 0 0 2 0V6h7v12H2zM3.618 2H9v2H2.618l1-2zm13.764 2H11V2h5.382l1 2zM9 14H5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zm-4-2h2a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2z",
  fill: undefined
});

var SvgPackageMajorTwotone = function SvgPackageMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6b, _ref2$1W);
};

var _ref$6c =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4 18h12V5.414L12.586 2H4v16zm13 2H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h10c.266 0 .52.105.707.293l4 4A.996.996 0 0 1 18 5v14a1 1 0 0 1-1 1z"
});

var SvgPageMajorMonotone = function SvgPageMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6c);
};

var _ref$6d =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 19h14V5l-4-4H3z"
});

var _ref2$1X =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 18h12V5.414L12.586 2H4v16zm13 2H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h10c.266 0 .52.105.707.293l4 4A.996.996 0 0 1 18 5v14a1 1 0 0 1-1 1z",
  fill: undefined
});

var SvgPageMajorTwotone = function SvgPageMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6d, _ref2$1X);
};

var _ref$6e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zm-5-7.414V7a1 1 0 1 0-2 0v3.586L7.707 9.293a.999.999 0 1 0-1.414 1.414l3 3a.997.997 0 0 0 1.414 0l3-3a.999.999 0 1 0-1.414-1.414L11 10.586z"
});

var SvgPageDownMajorMonotone = function SvgPageDownMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6e);
};

var _ref$6f =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 19h14V5l-4-4H3z"
});

var _ref2$1Y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zm-5-7.414V7a1 1 0 1 0-2 0v3.586L7.707 9.293a.999.999 0 1 0-1.414 1.414l3 3a.997.997 0 0 0 1.414 0l3-3a.999.999 0 1 0-1.414-1.414L11 10.586z"
});

var SvgPageDownMajorTwotone = function SvgPageDownMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6f, _ref2$1Y);
};

var _ref$6g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zM6 10a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1"
});

var SvgPageMinusMajorMonotone = function SvgPageMinusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6g);
};

var _ref$6h =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 19h14V5l-4-4H3z"
});

var _ref2$1Z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zM6 10a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1"
});

var SvgPageMinusMajorTwotone = function SvgPageMinusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6h, _ref2$1Z);
};

var _ref$6i =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zM11 7a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V7z"
});

var SvgPagePlusMajorMonotone = function SvgPagePlusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6i);
};

var _ref$6j =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 19h14V5l-4-4H3z"
});

var _ref2$1_ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zM11 7a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V7z"
});

var SvgPagePlusMajorTwotone = function SvgPagePlusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6j, _ref2$1_);
};

var _ref$6k =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zM9.293 6.293l-3 3a.999.999 0 1 0 1.414 1.414L9 9.414V13a1 1 0 1 0 2 0V9.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3a.999.999 0 0 0-1.414 0"
});

var SvgPageUpMajorMonotone = function SvgPageUpMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6k);
};

var _ref$6l =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 19h14V5l-4-4H3z"
});

var _ref2$1$ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.707 4.293l-4-4A.996.996 0 0 0 13 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707zM16 18H4V2h8.586L16 5.414V18zM9.293 6.293l-3 3a.999.999 0 1 0 1.414 1.414L9 9.414V13a1 1 0 1 0 2 0V9.414l1.293 1.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3-3a.999.999 0 0 0-1.414 0"
});

var SvgPageUpMajorTwotone = function SvgPageUpMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6l, _ref2$1$);
};

var _ref$6m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14 4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1zm-7.219.376l4 5a1 1 0 0 1 0 1.249l-4 5a1 1 0 1 1-1.562-1.25l3.5-4.374-3.5-4.376a1 1 0 1 1 1.562-1.25z"
});

var SvgPaginationEndMinor = function SvgPaginationEndMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6m);
};

var _ref$6n =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6 4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1zm7.219.376a1 1 0 1 1 1.562 1.249L11.28 10l3.5 4.375a1 1 0 1 1-1.562 1.249l-4-5a1 1 0 0 1 0-1.25l4-5z"
});

var SvgPaginationStartMinor = function SvgPaginationStartMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6n);
};

var _ref$6o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.98 17a1.001 1.001 0 0 1-2 0v-6a1 1 0 1 0-2 0 1.001 1.001 0 0 1-2 0V3.414l6 6V17zm-9.587-2.071A4.627 4.627 0 0 0 5.1 16.293l-1.413 1.414a1 1 0 0 1-1.528-.134c-.274-.38-.191-.976.189-1.356l1.339-1.339a4.637 4.637 0 0 0 1.35-3.424l3.483 3.483c-.043 0-.083-.008-.127-.008zm3.095.149L4.903 8.492 9.98 3.414V11a2.994 2.994 0 0 0 2.623 2.962l-1.115 1.116zm8.198-6.785l-8-8A.99.99 0 0 0 10.98.01V0c-.013 0-.026.007-.04.008a1.014 1.014 0 0 0-.31.06c-.01.004-.02.003-.028.007l-.005.001a1.022 1.022 0 0 0-.293.196c-.01.009-.022.012-.03.021l-8 8a.999.999 0 0 0 0 1.414 2.661 2.661 0 0 1 0 3.757l-1.34 1.339c-1.07 1.072-1.242 2.765-.398 3.939A3.012 3.012 0 0 0 2.982 20c.792 0 1.554-.313 2.12-.879l1.413-1.414c1.005-1.005 2.756-1.004 3.759 0a.996.996 0 0 0 1.414 0l2.293-2.293V17c0 1.654 1.345 3 3 3 1.654 0 3-1.346 3-3V9a.997.997 0 0 0-.294-.707z"
});

var SvgPaintBrushMajorMonotone = function SvgPaintBrushMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6o);
};

var _ref$6p =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11 1l8 8v8a2 2 0 0 1-4 0v-6a2 2 0 0 1-4 0V1z"
});

var _ref2$20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.98 17c0 .55-.45 1-1 1s-1-.45-1-1v-6a1 1 0 0 0-2 0c0 .55-.45 1-1 1s-1-.45-1-1V3.414l6 6V17zm-9.587-2.07A4.626 4.626 0 0 0 5.1 16.293l-1.414 1.414a1.003 1.003 0 0 1-1.528-.134c-.274-.38-.19-.976.19-1.356l1.338-1.34a4.637 4.637 0 0 0 1.35-3.423l3.483 3.483c-.044 0-.085-.008-.128-.008zm3.094.148L4.902 8.492 9.98 3.414V11a2.994 2.994 0 0 0 2.623 2.962l-1.116 1.116zm8.2-6.785l-8-8A.993.993 0 0 0 10.98.01V0c-.014 0-.027.007-.04.008a.997.997 0 0 0-.31.06c-.01.004-.02.003-.03.007h-.003a1.045 1.045 0 0 0-.294.197c-.01.01-.02.012-.03.02l-8 8a1.002 1.002 0 0 0 0 1.415 2.661 2.661 0 0 1 0 3.757l-1.34 1.34c-1.07 1.07-1.242 2.764-.397 3.938A3.012 3.012 0 0 0 2.981 20c.795 0 1.557-.313 2.12-.88l1.416-1.413c1.004-1.005 2.755-1.004 3.758 0a.998.998 0 0 0 1.415 0l2.293-2.293V17c0 1.654 1.347 3 3 3s3-1.346 3-3V9a.996.996 0 0 0-.292-.707z",
  fill: undefined
});

var SvgPaintBrushMajorTwotone = function SvgPaintBrushMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6p, _ref2$20);
};

var _ref$6q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6 1a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1zm9.002 0a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1z"
});

var SvgPauseMajorMonotone = function SvgPauseMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6q);
};

var _ref$6r =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6 1a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1zm9.002 0a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1z"
});

var SvgPauseMajorTwotone = function SvgPauseMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6r);
};

var _ref$6s =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M11 14h2V6h-2v8zm-4 0h2V6H7v8zm3-12a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
});

var SvgPauseMinor = function SvgPauseMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6s);
};

var _ref$6t =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M8 6a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1"
});

var SvgPauseCircleMajorMonotone = function SvgPauseCircleMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6t);
};

var _ref$6u =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$21 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M8 6a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1"
});

var SvgPauseCircleMajorTwotone = function SvgPauseCircleMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6u, _ref2$21);
};

var _ref$6v =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17.815 10A2.996 2.996 0 0 0 15 8H6V6h12v4h-.185zM15 12h-4a1 1 0 0 0-.949.684l-1.74 5.222L2 17.117V6.618l2-1V9a1 1 0 0 0 1 1h10a1.001 1.001 0 0 1 0 2zM6 4h12V2H6v2zm13-4H5a1 1 0 0 0-1 1v2.382L.552 5.105A1 1 0 0 0 0 6v12a1 1 0 0 0 .876.992l8 1a.999.999 0 0 0 1.072-.676L11.72 14H15a2.996 2.996 0 0 0 2.815-2H19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"
});

var SvgPaymentsMajorMonotone = function SvgPaymentsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6v);
};

var _ref$6w =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 1h14v4H5V1z"
});

var _ref2$22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.815 10A2.996 2.996 0 0 0 15 8H6V6h12v4h-.185zM15 12h-4a1 1 0 0 0-.949.684L8.31 17.906 2 17.117V6.618l2-1V9a1 1 0 0 0 1 1h10a1.001 1.001 0 0 1 0 2zM6 4V2h12v2H6zm13-4H5a1 1 0 0 0-1 1v2.382L.552 5.105A1 1 0 0 0 0 6v12a1 1 0 0 0 .876.992l8 1a.999.999 0 0 0 1.072-.676L11.72 14H15a2.996 2.996 0 0 0 2.815-2H19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z",
  fill: undefined
});

var SvgPaymentsMajorTwotone = function SvgPaymentsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6w, _ref2$22);
};

var _ref$6x =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.011 18.034c-4.856.1-8.682-1.246-11.395-3.954C2.675 10.147 2.086 4.276 2.013 2H6.19l.683 3.446-1.318.66c-.394.197-.613.63-.539 1.064l-.001-.006c.387 2.32 2.518 6.938 7.822 7.822.428.067.86-.145 1.057-.536l.666-1.32 3.45.69v4.214h.001zm1.196-6.015l-5-1a.995.995 0 0 0-1.087.525l-.003.006-.663 1.313c-3.562-.925-4.87-3.94-5.291-5.326l1.285-.643a1 1 0 0 0 .533-1.096l.001.006-.992-5a1 1 0 0 0-.979-.805H1.01a.999.999 0 0 0-.998.944v.003c-.019.363-.403 8.953 5.181 14.538 3.025 3.025 7.189 4.553 12.394 4.553.484 0 .976-.013 1.477-.039a1 1 0 0 0 .947-.999v-6a1 1 0 0 0-.798-.979l-.006-.001z",
  fill: undefined
});

var SvgPhoneMajorMonotone = function SvgPhoneMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6x);
};

var _ref$6y =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M18.011 18.034c-4.856.1-8.682-1.246-11.395-3.954C2.675 10.147 2.086 4.276 2.013 2H6.19l.683 3.446-1.318.66c-.394.197-.613.63-.539 1.064l-.001-.006c.387 2.32 2.518 6.938 7.822 7.822.428.067.86-.145 1.057-.536l.666-1.32 3.45.69v4.214h.001z"
});

var _ref2$23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.011 18.034c-4.856.1-8.682-1.246-11.395-3.954C2.675 10.147 2.086 4.276 2.013 2H6.19l.683 3.446-1.318.66c-.394.197-.613.63-.539 1.064l-.001-.006c.387 2.32 2.518 6.938 7.822 7.822.428.067.86-.145 1.057-.536l.666-1.32 3.45.69v4.214h.001zm1.196-6.015l-5-1a.995.995 0 0 0-1.087.525l-.003.006-.663 1.313c-3.562-.925-4.87-3.94-5.291-5.326l1.285-.643a1 1 0 0 0 .533-1.096l.001.006-.992-5a1 1 0 0 0-.979-.805H1.01a.999.999 0 0 0-.998.944v.003c-.019.363-.403 8.953 5.181 14.538 3.025 3.025 7.189 4.553 12.394 4.553.484 0 .976-.013 1.477-.039a1 1 0 0 0 .947-.999v-6a1 1 0 0 0-.798-.979l-.006-.001z",
  fill: undefined
});

var SvgPhoneMajorTwotone = function SvgPhoneMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6y, _ref2$23);
};

var _ref$6z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.196 11.996l-4.997-.998a.996.996 0 0 0-1.088.53l-.663 1.31c-3.56-.923-4.867-3.932-5.288-5.315l1.284-.642a.997.997 0 0 0 .534-1.087L7.987.804A.997.997 0 0 0 7.007 0H1.01a.999.999 0 0 0-.998.945c-.019.363-.403 8.936 5.178 14.51C8.213 18.475 12.375 20 17.577 20c.484 0 .976-.013 1.476-.04a.999.999 0 0 0 .947-.996v-5.989a1 1 0 0 0-.804-.979zm-6.201-4.011h3.998a.998.998 0 1 0 0-1.997h-1.585l4.29-4.284A1 1 0 0 0 18.285.293l-4.29 4.284V2.994a.998.998 0 0 0-1-.998c-.553 0-1 .446-1 .998v3.993c0 .552.447.998 1 .998M18.001 18c-4.855.098-8.677-1.244-11.389-3.947-3.938-3.925-4.527-9.785-4.6-12.057h4.175l.682 3.44-1.317.657a.998.998 0 0 0-.539 1.057c.387 2.315 2.517 6.925 7.818 7.807a1.01 1.01 0 0 0 1.056-.535l.666-1.317 3.448.688V18z"
});

var SvgPhoneInMajorMonotone = function SvgPhoneInMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6z);
};

var _ref$6A =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M13 14l1.01-2 5 1v6c-19 1-18-18-18-18h6L8 6 6 7s1 6 7 7"
});

var _ref2$24 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.196 11.996l-4.997-.998a.996.996 0 0 0-1.088.53l-.663 1.31c-3.56-.923-4.867-3.932-5.288-5.315l1.284-.642a.997.997 0 0 0 .534-1.087L7.987.804A.997.997 0 0 0 7.007 0H1.01a.999.999 0 0 0-.998.945c-.019.363-.403 8.936 5.178 14.51C8.213 18.475 12.375 20 17.577 20c.484 0 .976-.013 1.476-.04a.999.999 0 0 0 .947-.996v-5.989a1 1 0 0 0-.804-.979zm-6.201-4.011h3.998a.998.998 0 1 0 0-1.997h-1.585l4.29-4.284A1 1 0 0 0 18.285.293l-4.29 4.284V2.994a.998.998 0 0 0-1-.998c-.553 0-1 .446-1 .998v3.993c0 .552.447.998 1 .998M18.001 18c-4.855.098-8.677-1.244-11.389-3.947-3.938-3.925-4.527-9.785-4.6-12.057h4.175l.682 3.44-1.317.657a.998.998 0 0 0-.539 1.057c.387 2.315 2.517 6.925 7.818 7.807a1.01 1.01 0 0 0 1.056-.535l.666-1.317 3.448.688V18z"
});

var SvgPhoneInMajorTwotone = function SvgPhoneInMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6A, _ref2$24);
};

var _ref$6B =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.196 11.996l-4.997-.998a1 1 0 0 0-1.089.53l-.662 1.31C8.887 11.916 7.58 8.907 7.16 7.524l1.284-.642c.403-.2.62-.646.534-1.087l-.99-4.99A.999.999 0 0 0 7.006 0H1.01a.999.999 0 0 0-.998.945c-.02.363-.403 8.936 5.178 14.51C8.213 18.476 12.375 20 17.577 20c.483 0 .975-.013 1.476-.039a1 1 0 0 0 .947-.997v-5.989a.999.999 0 0 0-.804-.979zm-6.202-4.011a.997.997 0 0 0 .707-.293l4.29-4.285V4.99a.998.998 0 0 0 2 0V.998a.998.998 0 0 0-1-.998h-3.998a.998.998 0 1 0 0 1.996h1.585l-4.29 4.285a.996.996 0 0 0 .706 1.704M18.001 18c-4.858.105-8.677-1.244-11.388-3.947-3.94-3.925-4.527-9.785-4.601-12.057h4.174l.683 3.44-1.318.658a1 1 0 0 0-.54 1.057c.388 2.314 2.519 6.924 7.819 7.807.427.068.86-.145 1.056-.535l.667-1.318 3.448.688V18z"
});

var SvgPhoneOutMajorMonotone = function SvgPhoneOutMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6B);
};

var _ref$6C =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M13 14l1.01-2 5 1v6c-19 1-18-18-18-18h6L8 6 6 7s1 6 7 7"
});

var _ref2$25 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.196 11.996l-4.997-.998a1 1 0 0 0-1.089.53l-.662 1.31C8.887 11.916 7.58 8.907 7.16 7.524l1.284-.642c.403-.2.62-.646.534-1.087l-.99-4.99A.999.999 0 0 0 7.006 0H1.01a.999.999 0 0 0-.998.945c-.02.363-.403 8.936 5.178 14.51C8.213 18.476 12.375 20 17.577 20c.483 0 .975-.013 1.476-.039a1 1 0 0 0 .947-.997v-5.989a.999.999 0 0 0-.804-.979zm-6.202-4.011a.997.997 0 0 0 .707-.293l4.29-4.285V4.99a.998.998 0 0 0 2 0V.998a.998.998 0 0 0-1-.998h-3.998a.998.998 0 1 0 0 1.996h1.585l-4.29 4.285a.996.996 0 0 0 .706 1.704M18.001 18c-4.858.105-8.677-1.244-11.388-3.947-3.94-3.925-4.527-9.785-4.601-12.057h4.174l.683 3.44-1.318.658a1 1 0 0 0-.54 1.057c.388 2.314 2.519 6.924 7.819 7.807.427.068.86-.145 1.056-.535l.667-1.318 3.448.688V18z"
});

var SvgPhoneOutMajorTwotone = function SvgPhoneOutMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6C, _ref2$25);
};

var _ref$6D =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12.36 11.233a1 1 0 0 0-.36.769c0 1.998-.537 3.085-.956 3.628L4.372 8.96c.55-.425 1.635-.958 3.628-.958a1 1 0 0 0 .768-.36l4.3-5.16 4.45 4.452-5.159 4.299zm7.347-4.938l-6-6a.966.966 0 0 0-.752-.292.998.998 0 0 0-.724.358L7.524 6.01c-4.103.155-5.293 2.292-5.419 2.544-.192.385-.117.85.188 1.155l3.293 3.293-5.293 5.293a.999.999 0 1 0 1.414 1.414L7 14.416l3.293 3.293a1 1 0 0 0 1.154.187c.252-.126 2.39-1.315 2.544-5.42l5.65-4.706a1.003 1.003 0 0 0 .066-1.475z"
});

var SvgPinMajorMonotone = function SvgPinMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6D);
};

var _ref$6E =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M8 7l5-6 6 6-6 5c0 4-2 5-2 5L3 9s1-2 5-2"
});

var _ref2$26 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12.36 11.233a1 1 0 0 0-.36.769c0 1.998-.537 3.085-.956 3.628L4.372 8.96c.55-.425 1.635-.958 3.628-.958a1 1 0 0 0 .768-.36l4.3-5.16 4.45 4.452-5.159 4.299zm7.347-4.938l-6-6a.966.966 0 0 0-.752-.292.998.998 0 0 0-.724.358L7.524 6.01c-4.103.155-5.293 2.292-5.419 2.544-.192.385-.117.85.188 1.155l3.293 3.293-5.293 5.293a.999.999 0 1 0 1.414 1.414L7 14.416l3.293 3.293a1 1 0 0 0 1.154.187c.252-.126 2.39-1.315 2.544-5.42l5.65-4.706a1.003 1.003 0 0 0 .066-1.475z"
});

var SvgPinMajorTwotone = function SvgPinMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6E, _ref2$26);
};

var _ref$6F =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.7 7L13 2.3c-.2-.2-.401-.3-.7-.3-.3 0-.6.1-.701.4L8 6.7c-3.3.1-4.2 1.9-4.3 2.1-.2.4-.2.8.2 1.1l2.4 2.4-4 4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l4-4 2.399 2.4c.201.2.401.3.701.3.2 0 .299 0 .4-.1.2-.1 1.899-1.1 2.1-4.3l4.299-3.6C17.9 8.3 18 8 18 7.7c0-.3-.1-.5-.3-.7"
});

var SvgPinMinor = function SvgPinMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6F);
};

var _ref$6G =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4.333 1C3.64 1 3 1.555 3 2.332v15.335a1.328 1.328 0 0 0 2.014 1.143l12.787-7.665a1.331 1.331 0 0 0 0-2.283L5.015 1.192A1.326 1.326 0 0 0 4.333 1M5 3.515l10.815 6.488L5 16.485V3.515"
});

var SvgPlayMajorMonotone = function SvgPlayMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6G);
};

var _ref$6H =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4.333 1C3.64 1 3 1.555 3 2.332v15.335a1.328 1.328 0 0 0 2.014 1.143l12.787-7.665a1.331 1.331 0 0 0 0-2.283L5.015 1.192A1.326 1.326 0 0 0 4.333 1M5 3.515l10.815 6.488L5 16.485V3.515"
});

var SvgPlayMajorTwotone = function SvgPlayMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6H);
};

var _ref$6I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 10a.997.997 0 0 1-.485.857l-10 6a1.004 1.004 0 0 1-1.008.013A1.001 1.001 0 0 1 4 16V4a1.001 1.001 0 0 1 1.515-.857l10 6c.301.18.485.505.485.857"
});

var SvgPlayMinor = function SvgPlayMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6I);
};

var _ref$6J =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm3.515-8.858l-5-3A1.001 1.001 0 0 0 7 7v6a1.001 1.001 0 0 0 1.515.857l5-3a1.002 1.002 0 0 0 0-1.715zM9 11.233V8.766L11.057 10 9 11.233z",
  fill: undefined
});

var SvgPlayCircleMajorMonotone = function SvgPlayCircleMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6J);
};

var _ref$6K =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M8 7v6l5-3z"
});

var _ref2$27 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m3.515-8.858l-5-3A1.001 1.001 0 0 0 7 7v6a1.001 1.001 0 0 0 1.515.857l5-3a1.002 1.002 0 0 0 0-1.715zM9 11.233V8.766L11.057 10 9 11.233z"
});

var SvgPlayCircleMajorTwotone = function SvgPlayCircleMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6K, _ref2$27);
};

var _ref$6L =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 9h-6V3a1 1 0 1 0-2 0v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgPlusMinor = function SvgPlusMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6L);
};

var _ref$6M =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 10h-3.796C14 9.554 13.456 8.693 13.211 8H17a1 1 0 0 0 .949-1.316l-2-6A1 1 0 0 0 15 0H5a1 1 0 0 0-.949.684l-2 6A1.003 1.003 0 0 0 3 8h3.789c-.245.693-.789 1.554-1.993 2H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM2 18h16v-6H2v6zM8.87 8h2.26c.141.624.426 1.331.902 2H7.968a5.626 5.626 0 0 0 .902-2zM5.721 2h8.558l1.334 4H4.387l1.334-4zM8 14H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2"
});

var SvgPointOfSaleMajorMonotone = function SvgPointOfSaleMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6M);
};

var _ref$6N =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 1h10l2 6H3z"
});

var _ref2$28 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 10h-3.796C14 9.554 13.456 8.693 13.211 8H17a1 1 0 0 0 .949-1.316l-2-6A1 1 0 0 0 15 0H5a1 1 0 0 0-.949.684l-2 6A1.003 1.003 0 0 0 3 8h3.789c-.245.693-.789 1.554-1.993 2H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM2 18h16v-6H2v6zM8.87 8h2.26c.141.624.426 1.331.902 2H7.968a5.626 5.626 0 0 0 .902-2zM5.721 2h8.558l1.334 4H4.387l1.334-4zM8 14H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2"
});

var SvgPointOfSaleMajorTwotone = function SvgPointOfSaleMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6N, _ref2$28);
};

var _ref$6O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13 18.002a.998.998 0 0 1-.94-.658L8.986 8.889l-2.048 5.465a1.001 1.001 0 0 1-1.794.163l-2.187-3.645-1.124 1.685a1.001 1.001 0 0 1-1.664-1.11l2-3a.966.966 0 0 1 .856-.445.997.997 0 0 1 .833.485l1.935 3.224 2.27-6.06A1 1 0 0 1 9 5h.005a1 1 0 0 1 .935.659l2.946 8.102 3.152-11.035c.12-.421.502-.715.94-.725.43-.026.833.268.97.684l2 6a1 1 0 1 1-1.896.632l-.98-2.933-3.11 10.89a1 1 0 0 1-.927.726H13"
});

var SvgPopularMajorMonotone = function SvgPopularMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6O);
};

var _ref$6P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13 18.002a.998.998 0 0 1-.94-.658L8.986 8.889l-2.048 5.465a1.001 1.001 0 0 1-1.794.163l-2.187-3.645-1.124 1.685a1.001 1.001 0 0 1-1.664-1.11l2-3a.966.966 0 0 1 .856-.445.997.997 0 0 1 .833.485l1.935 3.224 2.27-6.06A1 1 0 0 1 9 5h.005a1 1 0 0 1 .935.659l2.946 8.102 3.152-11.035c.12-.421.502-.715.94-.725.43-.026.833.268.97.684l2 6a1 1 0 1 1-1.896.632l-.98-2.933-3.11 10.89a1 1 0 0 1-.927.726H13"
});

var SvgPopularMajorTwotone = function SvgPopularMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6P);
};

var _ref$6Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M8.03 11c0 1.65 1.35 3 3 3s3-1.35 3-3-1.34-2.99-2.99-3h-.01c-1.65 0-3 1.35-3 3zm9.71 5.29c.39.39.39 1.03 0 1.42-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29l-2.53-2.53c-.79.51-1.74.82-2.76.82a5 5 0 0 1-4.9-4H3c-.55 0-1-.45-1-1s.45-1 1-1h3.13c.15-.72.44-1.38.87-1.95l-3.96.04h-.01a1 1 0 0 1-.01-2l8-.09h.01c2.76 0 5 2.24 5 5 0 1.02-.31 1.97-.82 2.76l2.53 2.53zM3.03 4.023a1 1 0 0 1-.003-2l8-.022h.003a1 1 0 0 1 .003 2l-8 .021H3.03z"
});

var SvgPriceLookupMinor = function SvgPriceLookupMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6Q);
};

var _ref$6R =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 4h-3V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-5 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 5h-2v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1H2V6h16v8zM6 18h8v-4H6v4zM6 4h8V2H6v2zm1 4H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
});

var SvgPrintMajorMonotone = function SvgPrintMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6R);
};

var _ref$6S =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 1h10v4H5V1zm0 12h10v6H5v-6z"
});

var _ref2$29 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 4h-3V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-5 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 5h-2v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1H2V6h16v8zM6 18h8v-4H6v4zM6 4h8V2H6v2zm1 4H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
});

var SvgPrintMajorTwotone = function SvgPrintMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6S, _ref2$29);
};

var _ref$6T =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 11h2V9h-2v2zM7 7h6V4H7v3zm0 9h6v-2H7v2zm10-9h-2V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgPrintMinor = function SvgPrintMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6T);
};

var _ref$6U =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0a1 1 0 0 1 1 1v9c0 .265-.105.52-.293.707l-9 9a.997.997 0 0 1-1.414 0l-9-9a.999.999 0 0 1 0-1.414l9-9C9.48.106 9.735 0 10 0h9zm-9 17.586L11.586 16 4 8.414 2.414 10 10 17.586zm8-8V2h-7.586l-5 5L13 14.586l5-5zM15 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
});

var SvgProductsMajorMonotone = function SvgProductsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6U);
};

var _ref$6V =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4 7l-3 3 9 9 3-3z"
});

var _ref2$2a =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0h-9c-.265 0-.52.106-.707.293l-9 9a.999.999 0 0 0 0 1.414l9 9a.997.997 0 0 0 1.414 0l9-9A.997.997 0 0 0 20 10V1a1 1 0 0 0-1-1zm-9 17.586L2.414 10 4 8.414 11.586 16 10 17.586zm8-8l-5 5L5.414 7l5-5H18v7.586zM15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  fill: undefined
});

var SvgProductsMajorTwotone = function SvgProductsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6V, _ref2$2a);
};

var _ref$6W =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0c5.514 0 10 4.486 10 10 0 5.513-4.486 10-10 10S0 15.513 0 10C0 4.486 4.486 0 10 0zm5.603 15.7A7.97 7.97 0 0 0 18 10c0-4.41-3.589-8-8-8s-8 3.59-8 8c0 2.23.919 4.248 2.396 5.7C5.801 14.842 7.744 14 10 14c2.257 0 4.199.841 5.603 1.7zm-9.454 1.31a7.965 7.965 0 0 0 7.702-.002C12.782 16.458 11.464 16 10 16c-1.463 0-2.782.457-3.851 1.01zM10 4c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 6c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2z",
  fill: undefined
});

var SvgProfileMajorMonotone = function SvgProfileMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6W);
};

var _ref$6X =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 15c-2.54 0-4.69 1.092-6 1.959A9.727 9.727 0 0 0 10 19c2.28 0 4.366-.767 6-2.041C14.687 16.092 12.537 15 10 15z"
});

var _ref2$2b =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10c0 5.512 4.486 10 10 10s10-4.488 10-10c0-5.514-4.486-10-10-10zm5.603 15.7C14.2 14.841 12.256 14 10 14s-4.199.842-5.604 1.7A7.97 7.97 0 0 1 2 10c0-4.411 3.589-8 8-8s8 3.589 8 8c0 2.145-.863 4.2-2.397 5.7zM6.15 17.01C7.218 16.456 8.536 16 10 16s2.781.459 3.851 1.01c-1.18.65-2.504.99-3.851.99a7.961 7.961 0 0 1-3.851-.99zM10 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-6C7.794 4 6 5.794 6 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
  fill: undefined
});

var SvgProfileMajorTwotone = function SvgProfileMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6X, _ref2$2b);
};

var _ref$6Y =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 3c-1.104 0-2 .897-2 2s.896 2 2 2 2-.897 2-2-.896-2-2-2zm0 10c1.631 0 3.064-.792 3.978-2-.914-1.208-2.347-2-3.978-2-1.631 0-3.064.792-3.978 2 .914 1.208 2.347 2 3.978 2z",
  fill: undefined
});

var SvgProfileMinor = function SvgProfileMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6Y);
};

var _ref$6Z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414l-5.293 5.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 4H12a1 1 0 1 1 0-2h5zm0 9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H4v12h12v-4a1 1 0 0 1 1-1z"
});

var SvgPromoteMinor = function SvgPromoteMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6Z);
};

var _ref$6_ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-4.1a1.1 1.1 0 1 0 .001 2.201A1.1 1.1 0 0 0 10 13.9M10 4C8.625 4 7.425 5.161 7.293 5.293A1.001 1.001 0 0 0 8.704 6.71C8.995 6.424 9.608 6 10 6a1.001 1.001 0 0 1 .591 1.808C9.58 8.548 9 9.616 9 10.737V11a1 1 0 1 0 2 0v-.263c0-.653.484-1.105.773-1.317A3.013 3.013 0 0 0 13 7c0-1.654-1.346-3-3-3"
});

var SvgQuestionMarkMajorMonotone = function SvgQuestionMarkMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6_);
};

var _ref$6$ =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$2c =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-10C8.346 4 7 5.346 7 7a1 1 0 1 0 2 0 1.001 1.001 0 1 1 1.591.808C9.58 8.548 9 9.616 9 10.737V11a1 1 0 1 0 2 0v-.263c0-.653.484-1.105.773-1.317A3.013 3.013 0 0 0 13 7c0-1.654-1.346-3-3-3",
  fill: undefined
});

var SvgQuestionMarkMajorTwotone = function SvgQuestionMarkMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$6$, _ref2$2c);
};

var _ref$70 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M11 11H9v-.148c0-.876.306-1.499 1-1.852.385-.195 1-.568 1-1a1.001 1.001 0 0 0-2 0H7c0-1.654 1.346-3 3-3s3 1 3 3-2 2.165-2 3zm-2 4h2v-2H9v2zm1-13a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
});

var SvgQuestionMarkMinor = function SvgQuestionMarkMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$70);
};

var _ref$71 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14H8v-2h9a.998.998 0 0 0 .948-.684l2-6a.994.994 0 0 0-.092-.832.994.994 0 0 0-.692-.47L8 2.153V1a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h1v1a1 1 0 0 0 .836.986l10.846 1.808L16.279 10H7a1 1 0 0 0-1 1v3.185A2.995 2.995 0 0 0 4 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h4.37A2.938 2.938 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5-7H1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-1 4H1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M1 4h1a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2m0 4h6a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2"
});

var SvgQuickSaleMajorMonotone = function SvgQuickSaleMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$71);
};

var _ref$72 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 14H8v-2h9a.998.998 0 0 0 .948-.684l2-6a.994.994 0 0 0-.092-.832.994.994 0 0 0-.692-.47L8 2.153V1a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h1v1a1 1 0 0 0 .836.986l10.846 1.808L16.279 10H7a1 1 0 0 0-1 1v3.185A2.995 2.995 0 0 0 4 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h4.37A2.938 2.938 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5-7H1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-1 4H1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M1 4h1a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2m0 4h6a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2"
});

var SvgQuickSaleMajorTwotone = function SvgQuickSaleMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$72);
};

var _ref$73 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 12h-2c-.55 0-1 .45-1 1v2h-2V5.79l1.36-.68c.14-.07.29-.11.44-.11H16v7zM4 15V5h3.2c.15 0 .3.04.44.11L9 5.79V15H4zM17 3h-4.2c-.46 0-.92.11-1.34.32L10 4.05l-1.46-.73C8.12 3.11 7.66 3 7.2 3H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c0 .55.45 1 1 1s1-.45 1-1h3c.26 0 .52-.1.71-.29l3-3c.19-.19.29-.45.29-.71V4c0-.55-.45-1-1-1z"
});

var SvgReadTimeMinor = function SvgReadTimeMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$73);
};

var _ref$74 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M16 17.132V2H4v15.132l1.445-.964a1 1 0 0 1 1.262.125L8 17.586l1.293-1.293a.997.997 0 0 1 1.414 0L12 17.586l1.293-1.293a.998.998 0 0 1 1.262-.125l1.445.964zM17 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832l-2.318-1.545-1.42 1.42A.993.993 0 0 1 12 20a.993.993 0 0 1-.707-.293L10 18.414l-1.293 1.293a.999.999 0 0 1-1.414 0l-1.42-1.42-2.318 1.545A1 1 0 0 1 2 19V1a1 1 0 0 1 1-1h14zM7 6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2H7zm0 8a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2H7zm0-4a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2H7z"
});

var SvgReceiptMajorMonotone = function SvgReceiptMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$74);
};

var _ref$75 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M16 17.132V2H4v15.132l1.445-.964a1 1 0 0 1 1.262.125L8 17.586l1.293-1.293a.997.997 0 0 1 1.414 0L12 17.586l1.293-1.293a.998.998 0 0 1 1.262-.125l1.445.964zM17 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832l-2.318-1.545-1.42 1.42A.993.993 0 0 1 12 20a.993.993 0 0 1-.707-.293L10 18.414l-1.293 1.293a.999.999 0 0 1-1.414 0l-1.42-1.42-2.318 1.545A1 1 0 0 1 2 19V1a1 1 0 0 1 1-1h14zM7 6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2H7zm0 8a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2H7zm0-4a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2H7z"
});

var SvgReceiptMajorTwotone = function SvgReceiptMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$75);
};

var _ref$76 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.707 18.293l-5.395-5.396A7.952 7.952 0 0 0 16 8c0-4.411-3.589-8-8-8S0 3.589 0 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l5.396 5.395a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414M8 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6m1-6.414V5a1 1 0 1 0-2 0v3c0 .266.105.52.293.707l2 2a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9 7.586z"
});

var SvgRecentSearchesMajorMonotone = function SvgRecentSearchesMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$76);
};

var _ref$77 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "currentColor"
});

var _ref2$2d =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.707 18.293l-5.395-5.396A7.952 7.952 0 0 0 16 8c0-4.411-3.589-8-8-8S0 3.589 0 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l5.396 5.395a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414M8 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6m1-6.414V5a1 1 0 1 0-2 0v3c0 .266.105.52.293.707l2 2a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9 7.586z"
});

var SvgRecentSearchesMajorTwotone = function SvgRecentSearchesMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$77, _ref2$2d);
};

var _ref$78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.293 7.707a.997.997 0 0 0 1.414 0l3-3a.999.999 0 0 0 0-1.414l-3-3a.999.999 0 1 0-1.414 1.414L16.586 3H8.5C3.813 3 0 6.813 0 11.5 0 16.187 3.813 20 8.5 20c4.687 0 8.5-3.813 8.5-8.5V11a1 1 0 1 0-2 0v.5c0 3.584-2.916 6.5-6.5 6.5A6.508 6.508 0 0 1 2 11.5C2 7.916 4.916 5 8.5 5h8.086l-1.293 1.293a.999.999 0 0 0 0 1.414",
  fill: undefined
});

var SvgRedoMajorMonotone = function SvgRedoMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$78);
};

var _ref$79 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15.293 7.707a.997.997 0 0 0 1.414 0l3-3a.999.999 0 0 0 0-1.414l-3-3a.999.999 0 1 0-1.414 1.414L16.586 3H8.5C3.813 3 0 6.813 0 11.5 0 16.187 3.813 20 8.5 20c4.687 0 8.5-3.813 8.5-8.5V11a1 1 0 1 0-2 0v.5c0 3.584-2.916 6.5-6.5 6.5A6.508 6.508 0 0 1 2 11.5C2 7.916 4.916 5 8.5 5h8.086l-1.293 1.293a.999.999 0 0 0 0 1.414"
});

var SvgRedoMajorTwotone = function SvgRedoMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$79);
};

var _ref$7a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.707 3.293a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 5H7C4.794 5 3 6.794 3 9a1 1 0 1 1-2 0c0-3.309 2.691-6 6-6h9.586l-1.293-1.293A.999.999 0 1 1 16.707.293l3 3zM17 10a1 1 0 0 1 1 1c0 3.31-2.69 6-6 6H3.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L3.414 15H12c2.206 0 4-1.794 4-4a1 1 0 0 1 1-1z"
});

var SvgRefreshMajorMonotone = function SvgRefreshMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7a);
};

var _ref$7b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.707 3.293a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 5H7C4.794 5 3 6.794 3 9a1 1 0 1 1-2 0c0-3.309 2.691-6 6-6h9.586l-1.293-1.293A.999.999 0 1 1 16.707.293l3 3zM17 10a1 1 0 0 1 1 1c0 3.31-2.69 6-6 6H3.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L3.414 15H12c2.206 0 4-1.794 4-4a1 1 0 0 1 1-1z"
});

var SvgRefreshMajorTwotone = function SvgRefreshMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7b);
};

var _ref$7c =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 11a1 1 0 0 1 1 1c0 1.654-1.346 3-3 3H5.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L5.414 13H15c.552 0 1-.449 1-1a1 1 0 0 1 1-1zM3 9a1 1 0 0 1-1-1c0-1.654 1.346-3 3-3h9.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 7H5c-.552 0-1 .449-1 1a1 1 0 0 1-1 1z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgRefreshMinor = function SvgRefreshMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7c);
};

var _ref$7d =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 2H2v15.131l1.445-.963a1.002 1.002 0 0 1 1.114.002l-.004-.002L7 17.798l2.445-1.63a1.002 1.002 0 0 1 1.114.002l-.004-.002L13 17.798l2.445-1.63a1.002 1.002 0 0 1 1.114.002l-.004-.002L18 17.13V2zM8.414 8l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a.997.997 0 0 0 0 1.414l3 3a1 1 0 1 0 1.414-1.414L8.414 10h1.587C12.071 10 13 11.116 13 13a1 1 0 0 0 2 0c0-2.916-1.736-5-4.999-5H8.414zm-6.86 11.832A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v18a1 1 0 0 1-1.559.83l.004.002L16 18.202l-2.445 1.63a1.002 1.002 0 0 1-1.114-.002l.004.002L10 18.202l-2.445 1.63a1.002 1.002 0 0 1-1.114-.002l.004.002L4 18.202l-2.445 1.63z",
  fill: undefined
});

var SvgRefundMajorMonotone = function SvgRefundMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7d);
};

var _ref$7e =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M18 2H2v15.131l1.445-.963a1 1 0 0 1 1.11 0L7 17.798l2.445-1.63a1 1 0 0 1 1.11 0L13 17.798l2.445-1.63a1 1 0 0 1 1.11 0L18 17.13V2z"
});

var _ref2$2e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 2H2v15.131l1.445-.963a1 1 0 0 1 1.11 0L7 17.798l2.445-1.63a1 1 0 0 1 1.11 0L13 17.798l2.445-1.63a1 1 0 0 1 1.11 0L18 17.13V2zM8.414 8h1.587C13.264 8 15 10.084 15 13a1 1 0 0 1-2 0c0-1.884-.93-3-2.999-3H8.414l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L8.414 8zm-6.86 11.832A1 1 0 0 1 0 19V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v18a1 1 0 0 1-1.555.832L16 18.202l-2.445 1.63a1 1 0 0 1-1.11 0L10 18.202l-2.445 1.63a1 1 0 0 1-1.11 0L4 18.202l-2.445 1.63z"
});

var SvgRefundMajorTwotone = function SvgRefundMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7e, _ref2$2e);
};

var _ref$7f =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14 12h-2v-1c0-.551-.449-1-1-1H8.414l1.293 1.293-1.414 1.414L4.586 9l3.707-3.707 1.414 1.414L8.414 8H11c1.654 0 3 1.346 3 3v1zm3-10H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1.555.832l2.305-1.537 1.349 1.399a1.002 1.002 0 0 0 1.415.026l1.364-1.318 1.305 1.305a.997.997 0 0 0 1.414 0l1.42-1.42 2.318 1.545A1 1 0 0 0 18 17V3a1 1 0 0 0-1-1z"
});

var SvgRefundMinor = function SvgRefundMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7f);
};

var _ref$7g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h10v-2H2v2zm11-5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6c0-.297.132-.578.359-.769l6-5a1.005 1.005 0 0 1 1.282 0l6 5c.423.354.481.985.128 1.41-.354.423-.983.48-1.41.128L7 2.302 2 6.469V14h10a1 1 0 0 1 1-1zM6 6a1 1 0 1 1 2 0 1 1 0 1 1-2 0zm13 3a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h6z"
});

var SvgRemoveProductMajorMonotone = function SvgRemoveProductMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7g);
};

var _ref$7h =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 15h12v4H1z"
});

var _ref2$2f =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18h10v-2H2v2zm11-5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6c0-.297.132-.578.359-.769l6-5a1.005 1.005 0 0 1 1.282 0l6 5c.423.354.481.985.128 1.41-.354.423-.983.48-1.41.128L7 2.302 2 6.469V14h10a1 1 0 0 1 1-1zM6 6a1 1 0 1 1 2 0 1 1 0 1 1-2 0zm13 3a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h6z"
});

var SvgRemoveProductMajorTwotone = function SvgRemoveProductMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7h, _ref2$2f);
};

var _ref$7i =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 10a1 1 0 0 0-1 1v1h-4c-.379 0-.725.214-.895.553L12.382 14H7.618l-.723-1.447A1.001 1.001 0 0 0 6 12H2V3h5a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM6.077 7.618a.992.992 0 0 0 0 .764.99.99 0 0 0 .217.326l3 3a.997.997 0 0 0 1.413 0 .999.999 0 0 0 0-1.415L9.414 9H15.5C17.981 9 20 6.981 20 4.5 20 2.018 17.981 0 15.5 0a1 1 0 1 0 0 2 2.5 2.5 0 0 1 0 5H9.414l1.293-1.293a.999.999 0 1 0-1.414-1.414l-2.999 3a.99.99 0 0 0-.217.325"
});

var SvgRepeatOrderMajorMonotone = function SvgRepeatOrderMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7i);
};

var _ref$7j =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13h5l1 2h6l1-2h5v6H1v-6z"
});

var _ref2$2g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 10a1 1 0 0 0-1 1v1h-4c-.379 0-.725.214-.895.553L12.382 14H7.618l-.723-1.447A1.001 1.001 0 0 0 6 12H2V3h5a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM6.077 7.618a.992.992 0 0 0 0 .764.99.99 0 0 0 .217.326l3 3a.997.997 0 0 0 1.413 0 .999.999 0 0 0 0-1.415L9.414 9H15.5C17.981 9 20 6.981 20 4.5 20 2.018 17.981 0 15.5 0a1 1 0 1 0 0 2 2.5 2.5 0 0 1 0 5H9.414l1.293-1.293a.999.999 0 1 0-1.414-1.414l-2.999 3a.99.99 0 0 0-.217.325"
});

var SvgRepeatOrderMajorTwotone = function SvgRepeatOrderMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7j, _ref2$2g);
};

var _ref$7k =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6zM1 8a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1zm1-2h4V2H2v4zm12 12h4v-4h-4v4zm3-15h-3.586l1.293-1.293A1 1 0 0 0 13.293.293l-3 3a1 1 0 0 0 0 1.414l3 3a.996.996 0 0 0 1.414 0 1 1 0 0 0 0-1.414L13.414 5H17a1 1 0 0 1 1 1v3a1 1 0 1 0 2 0V6c0-1.654-1.346-3-3-3zM6.707 12.293a1 1 0 0 0-1.414 1.414L6.586 15H3c-.55 0-1-.448-1-1v-3a1 1 0 1 0-2 0v3c0 1.654 1.346 3 3 3h3.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3z",
  fill: undefined
});

var SvgReplaceMajorMonotone = function SvgReplaceMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7k);
};

var _ref$7l =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h6v6H1V1zm12 12h6v6h-6v-6z"
});

var _ref2$2h =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 12h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zM1 8h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-2h4V2H2v4zm12 12h4v-4h-4v4zm3-15h-3.586l1.293-1.293A.999.999 0 1 0 13.293.293l-3 3a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L13.414 5H17a1 1 0 0 1 1 1v3a1 1 0 1 0 2 0V6c0-1.654-1.346-3-3-3M6.707 12.293a.999.999 0 1 0-1.414 1.414L6.586 15H3c-.551 0-1-.448-1-1v-3a1 1 0 1 0-2 0v3c0 1.654 1.346 3 3 3h3.586l-1.293 1.293a.999.999 0 1 0 1.414 1.414l3-3a.999.999 0 0 0 0-1.414l-3-3z"
});

var SvgReplaceMajorTwotone = function SvgReplaceMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7l, _ref2$2h);
};

var _ref$7m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13.635 7.657c0 .27.106.527.298.719a1.044 1.044 0 0 0 1.441 0L17.7 6.05a1.011 1.011 0 0 0 0-1.441l-2.326-2.326a1.042 1.042 0 0 0-1.44 0 1.007 1.007 0 0 0-.299.72c0 .27.106.527.3.719l.588.589H8.836C5.066 4.31 2 7.379 2 11.148a6.843 6.843 0 0 0 6.836 6.836c3.346 0 6.252-2.493 6.757-5.796.002-.01.016-.115.016-.194l.002-.352a1.02 1.02 0 0 0-2.037 0v.189c0 .319-.117.658-.139.728-.628 1.969-2.51 3.388-4.599 3.388a4.804 4.804 0 0 1-4.8-4.8c0-2.645 2.153-4.8 4.8-4.8h5.687l-.589.59a1.01 1.01 0 0 0-.299.72"
});

var SvgReplayMinor = function SvgReplayMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7m);
};

var _ref$7n =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-4 13h2V8h-2v7zm-4 0h2V5H9v10zm-4 0h2v-4H5v4z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgReportMinor = function SvgReportMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7n);
};

var _ref$7o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18H3v-2.637l3.789-4.549 1.316 2.633a1.003 1.003 0 0 0 1.664.194L13 9.763V11a1 1 0 1 0 2 0V7c0-.016-.008-.028-.009-.043-.003-.072-.023-.14-.042-.209-.015-.059-.024-.116-.049-.169-.025-.055-.066-.1-.101-.151-.041-.057-.078-.114-.13-.16-.012-.011-.017-.026-.028-.037-.037-.03-.081-.04-.12-.064-.06-.038-.117-.075-.184-.099-.066-.024-.133-.031-.201-.041C14.089 6.021 14.048 6 14 6h-4a1 1 0 1 0 0 2h1.864l-2.653 3.186-1.316-2.633a1.003 1.003 0 0 0-1.664-.194L3 12.237V2h10.586L17 5.414V18zm1.707-13.707l-4-4A.996.996 0 0 0 14 0H2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707z"
});

var SvgReportsMajorMonotone = function SvgReportsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7o);
};

var _ref$7p =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 18h14V5.333L14.5 2H3z"
});

var _ref2$2i =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 18H3v-2.637l3.789-4.549 1.316 2.633a1.003 1.003 0 0 0 1.664.194L13 9.763V11a1 1 0 1 0 2 0V7c0-.016-.008-.028-.009-.043-.003-.072-.023-.14-.042-.209-.015-.059-.024-.116-.049-.169-.025-.055-.066-.1-.101-.151-.041-.057-.078-.114-.13-.16-.012-.011-.017-.026-.028-.037-.037-.03-.081-.04-.12-.064-.06-.038-.117-.075-.184-.099-.066-.024-.133-.031-.201-.041C14.089 6.021 14.048 6 14 6h-4a1 1 0 1 0 0 2h1.864l-2.653 3.186-1.316-2.633a1.003 1.003 0 0 0-1.664-.194L3 12.237V2h10.586L17 5.414V18zm1.707-13.707l-4-4A.996.996 0 0 0 14 0H2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a.996.996 0 0 0-.293-.707z"
});

var SvgReportsMajorTwotone = function SvgReportsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7p, _ref2$2i);
};

var _ref$7q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 9a1 1 0 0 1-1-1c0-.551-.448-1-1-1H5.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.997.997 0 0 1 1.414 0 .999.999 0 0 1 0 1.414L5.414 5H15c1.654 0 3 1.346 3 3a1 1 0 0 1-1 1zM3 11a1 1 0 0 1 1 1c0 .551.448 1 1 1h9.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.999.999 0 1 1-1.414-1.414L14.586 15H5c-1.654 0-3-1.346-3-3a1 1 0 0 1 1-1z"
});

var SvgResetMinor = function SvgResetMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7q);
};

var _ref$7r =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.986 10.835l-.987-5.926A3.004 3.004 0 0 0 16 2a1 1 0 1 0 0 2c.552 0 1 .449 1 1 0 .055.005.11.014.165L17.82 10H12a1 1 0 0 0-1 1v.19a2.922 2.922 0 0 0-1-.19c-.35 0-.688.076-1 .19V11a1 1 0 0 0-1-1H2.18l.806-4.835A.92.92 0 0 0 3 5c0-.551.449-1 1-1a1 1 0 0 0 0-2 3.004 3.004 0 0 0-2.999 2.909l-.988 5.926A2.29 2.29 0 0 0 0 11v2.5C0 15.981 2.019 18 4.5 18S9 15.981 9 13.5v-.039c.311-.234.714-.461 1-.461.286 0 .689.227 1 .461v.039c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5V11c0-.029-.009-.136-.014-.165zM7 13.5C7 14.879 5.878 16 4.5 16A2.503 2.503 0 0 1 2 13.5V12h5v1.5zm11 0c0 1.379-1.121 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5V12h5v1.5z"
});

var SvgResourcesMajorMonotone = function SvgResourcesMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7r);
};

var _ref$7s =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13.5V11h7v2.5a3.5 3.5 0 1 1-7 0zM12 11h7v2.5a3.5 3.5 0 1 1-7 0V11z"
});

var _ref2$2j =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.986 10.835l-.987-5.926A3.004 3.004 0 0 0 16 2a1 1 0 1 0 0 2c.552 0 1 .449 1 1 0 .055.005.11.014.165L17.82 10H12a1 1 0 0 0-1 1v.19a2.922 2.922 0 0 0-1-.19c-.35 0-.688.076-1 .19V11a1 1 0 0 0-1-1H2.18l.806-4.835A.92.92 0 0 0 3 5c0-.551.449-1 1-1a1 1 0 0 0 0-2 3.004 3.004 0 0 0-2.999 2.909l-.988 5.926A2.29 2.29 0 0 0 0 11v2.5C0 15.981 2.019 18 4.5 18S9 15.981 9 13.5v-.039c.311-.234.714-.461 1-.461.286 0 .689.227 1 .461v.039c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5V11c0-.029-.009-.136-.014-.165zM7 13.5C7 14.879 5.878 16 4.5 16A2.503 2.503 0 0 1 2 13.5V12h5v1.5zm11 0c0 1.379-1.121 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5V12h5v1.5z"
});

var SvgResourcesMajorTwotone = function SvgResourcesMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7s, _ref2$2j);
};

var _ref$7t =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13.5 13H5.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.997.997 0 0 1 1.414 0 .999.999 0 0 1 0 1.414L5.414 11H13.5c1.379 0 2.5-1.121 2.5-2.5S14.879 6 13.5 6H3a1 1 0 1 1 0-2h10.5C15.981 4 18 6.019 18 8.5S15.981 13 13.5 13"
});

var SvgReturnMinor = function SvgReturnMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7t);
};

var _ref$7u =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.894.509c-.339-.678-1.449-.678-1.789 0l-9 18A.999.999 0 0 0 1 19.956h18a.998.998 0 0 0 .894-1.447l-9-18zM2.618 17.956L10 3.192l7.382 14.764H2.618zm6.382-7a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0v2zm-.1 4a1.1 1.1 0 1 0 2.2-.002 1.1 1.1 0 0 0-2.2.002z"
});

var SvgRiskMajorMonotone = function SvgRiskMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7u);
};

var _ref$7v =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 1l9 18H1z"
});

var _ref2$2k =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.894.509c-.339-.678-1.449-.678-1.789 0l-9 18A.999.999 0 0 0 1 19.956h18a.998.998 0 0 0 .894-1.447l-9-18zM2.618 17.956L10 3.192l7.382 14.764H2.618zm6.382-7a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0v2zm-.1 4a1.1 1.1 0 1 0 2.2-.002 1.1 1.1 0 0 0-2.2.002z"
});

var SvgRiskMajorTwotone = function SvgRiskMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7v, _ref2$2k);
};

var _ref$7w =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 12h2V8H9v4zm0 4h2v-2H9v2zm8.895.509l-7-14c-.339-.678-1.451-.678-1.79 0l-7 14A.999.999 0 0 0 3 17.956h14a1.001 1.001 0 0 0 .895-1.447z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgRiskMinor = function SvgRiskMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7w);
};

var _ref$7x =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M2 18h16v-3H2v3zm17.976-4.121c-.005-.041.004-.08-.006-.121l-2-8A1 1 0 0 0 17 5h-2.761l.556-2.294.961.242a1.001 1.001 0 0 0 .488-1.94L12.365.03a1 1 0 1 0-.488 1.94l.978.247-1.725 7.127a3.043 3.043 0 0 1-.683-.24c-2.421-1.208-4.794-.048-4.894 0a1.001 1.001 0 0 0 .894 1.79c.017-.007 1.599-.752 3.106 0a5.251 5.251 0 0 0 2.366.549c1.406 0 2.462-.516 2.528-.548a1.001 1.001 0 0 0-.894-1.79 3.218 3.218 0 0 1-.338.128L13.755 7h2.464l1.501 6H2.28l1.501-6H9a1 1 0 1 0 0-2H3a1 1 0 0 0-.97.757l-2 8c-.01.04-.001.08-.006.12C.02 13.92 0 13.957 0 14v5a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-5c0-.043-.02-.08-.024-.122z"
});

var SvgSandboxMajorMonotone = function SvgSandboxMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7x);
};

var _ref$7y =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2 15h16v3H2z"
});

var _ref2$2l =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M2 18h16v-3H2v3zm17.976-4.121c-.005-.041.004-.08-.006-.121l-2-8A1 1 0 0 0 17 5h-2.761l.556-2.294.961.242a1.001 1.001 0 0 0 .488-1.94L12.365.03a1 1 0 1 0-.488 1.94l.978.247-1.725 7.127a3.043 3.043 0 0 1-.683-.24c-2.421-1.208-4.794-.048-4.894 0a1.001 1.001 0 0 0 .894 1.79c.017-.007 1.599-.752 3.106 0a5.251 5.251 0 0 0 2.366.549c1.406 0 2.462-.516 2.528-.548a1.001 1.001 0 0 0-.894-1.79 3.218 3.218 0 0 1-.338.128L13.755 7h2.464l1.501 6H2.28l1.501-6H9a1 1 0 1 0 0-2H3a1 1 0 0 0-.97.757l-2 8c-.01.04-.001.08-.006.12C.02 13.92 0 13.957 0 14v5a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-5c0-.043-.02-.08-.024-.122z"
});

var SvgSandboxMajorTwotone = function SvgSandboxMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7y, _ref2$2l);
};

var _ref$7z =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 4h-3a1 1 0 1 0 0 2h2v10H4V4h3.586L9 5.414v5.172L7.707 9.293a1 1 0 0 0-1.414 1.414l3 3a.996.996 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 10.586V5a.997.997 0 0 0-.293-.707l-2-2A.994.994 0 0 0 8 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z",
  fill: undefined
});

var SvgSaveMinor = function SvgSaveMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7z);
};

var _ref$7A =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 8c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m17.707 10.293l-5.395-5.396A7.946 7.946 0 0 0 16 8c0-4.411-3.589-8-8-8S0 3.589 0 8s3.589 8 8 8a7.954 7.954 0 0 0 4.897-1.688l5.396 5.395a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"
});

var SvgSearchMajorMonotone = function SvgSearchMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7A);
};

var _ref$7B =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "currentColor"
});

var _ref2$2m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 8c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m17.707 10.293l-5.395-5.396A7.946 7.946 0 0 0 16 8c0-4.411-3.589-8-8-8S0 3.589 0 8s3.589 8 8 8a7.954 7.954 0 0 0 4.897-1.688l5.396 5.395a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"
});

var SvgSearchMajorTwotone = function SvgSearchMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7B, _ref2$2m);
};

var _ref$7C =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgSearchMinor = function SvgSearchMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7C);
};

var _ref$7D =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 5H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM6 2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2H6zm6 0h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2m7-2h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1M1 3a1 1 0 0 0 1-1 1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m13 15h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-6 0H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-6 0a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m17-1a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1M2 13h16V7H2v6z"
});

var SvgSectionMajorMonotone = function SvgSectionMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7D);
};

var _ref$7E =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 6h18v8H1V6z"
});

var _ref2$2n =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h18zM6 2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2H6zm6 0h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm7-2h-1a1 1 0 1 0 0 2 1 1 0 1 0 2 0V1a1 1 0 0 0-1-1zM1 3a1 1 0 0 0 1-1 1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1zm13 15h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm-6 0H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm-6 0a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2zm17-1a1 1 0 0 0-1 1 1 1 0 1 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM2 13h16V7H2v6z",
  fill: undefined
});

var SvgSectionMajorTwotone = function SvgSectionMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7E, _ref2$2n);
};

var _ref$7F =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.09 2.678A1 1 0 0 0 18.144 2c-.039 0-3.986-.022-7.692-1.893a1.007 1.007 0 0 0-.902 0C5.862 1.969 1.895 2 1.856 2a1 1 0 0 0-.947.678c-1.367 4.03-1.19 7.825.515 10.97 1.647 3.042 4.76 5.404 8.328 6.32a1.001 1.001 0 0 0 .497 0c3.567-.916 6.68-3.278 8.328-6.32 1.703-3.145 1.881-6.94.514-10.97m-6.797 4.615L9 10.585 7.706 9.293a1 1 0 1 0-1.415 1.415l2.001 2a.998.998 0 0 0 1.415 0l4.002-4a1 1 0 1 0-1.415-1.414m4.523 5.404c-1.349 2.49-3.884 4.444-6.816 5.268-2.934-.824-5.469-2.778-6.818-5.268-1.343-2.48-1.541-5.485-.585-8.727 1.36-.088 4.383-.444 7.403-1.858 3.018 1.414 6.04 1.77 7.401 1.858.958 3.242.758 6.248-.585 8.727"
});

var SvgSecureMajorMonotone = function SvgSecureMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7F);
};

var _ref$7G =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 19c5.563-1.429 11.192-7 8.14-16 0 0-4.181 0-8.14-2-3.959 2-8.14 2-8.14 2-3.052 9 2.577 14.571 8.14 16"
});

var _ref2$2o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.09 2.678A1 1 0 0 0 18.144 2c-.039 0-3.986-.022-7.692-1.893a1.007 1.007 0 0 0-.902 0C5.862 1.969 1.895 2 1.856 2a1 1 0 0 0-.947.678c-1.367 4.03-1.19 7.825.515 10.97 1.647 3.042 4.76 5.404 8.328 6.32a1.001 1.001 0 0 0 .497 0c3.567-.916 6.68-3.278 8.328-6.32 1.703-3.145 1.881-6.94.514-10.97m-6.797 4.615L9 10.585 7.706 9.293a1 1 0 1 0-1.415 1.415l2.001 2a.998.998 0 0 0 1.415 0l4.002-4a1 1 0 1 0-1.415-1.414m4.523 5.404c-1.349 2.49-3.884 4.444-6.816 5.268-2.934-.824-5.469-2.778-6.818-5.268-1.343-2.48-1.541-5.485-.585-8.727 1.36-.088 4.383-.444 7.403-1.858 3.018 1.414 6.04 1.77 7.401 1.858.958 3.242.758 6.248-.585 8.727"
});

var SvgSecureMajorTwotone = function SvgSecureMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7G, _ref2$2o);
};

var _ref$7H =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 8l-3-3-3 3h6zm-.1 4L10 14.9 7.1 12h5.8z",
  fill: undefined,
  fillRule: "evenodd"
});

var SvgSelectMinor = function SvgSelectMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7H);
};

var _ref$7I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.594.196a1.001 1.001 0 0 0-1.041-.09l-18 9a1 1 0 0 0-.068 1.752L7 14.767V19a1.001 1.001 0 0 0 1.447.895l3.873-1.938 3.165 1.9a1.01 1.01 0 0 0 .934.05.996.996 0 0 0 .567-.744l3-18a.997.997 0 0 0-.392-.968zm-4.34 17.19l-5.843-3.505 8.005-9.461-2.161 12.967zM9 17.382v-1.415l1.287.772L9 17.381zm6.09-13.309l-7.416 8.765-4.598-2.758L15.09 4.072z"
});

var SvgSendMajorMonotone = function SvgSendMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7I);
};

var _ref$7J =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 10l18-9-3 18z"
});

var _ref2$2p =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.594.196a1.001 1.001 0 0 0-1.041-.09l-18 9a1 1 0 0 0-.068 1.752L7 14.767V19a1.001 1.001 0 0 0 1.447.895l3.873-1.938 3.165 1.9a1.01 1.01 0 0 0 .934.05.996.996 0 0 0 .567-.744l3-18a.997.997 0 0 0-.392-.968zm-4.34 17.19l-5.843-3.505 8.005-9.461-2.161 12.967zM9 17.382v-1.415l1.287.772L9 17.381zm6.09-13.309l-7.416 8.765-4.598-2.758L15.09 4.072z"
});

var SvgSendMajorTwotone = function SvgSendMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7J, _ref2$2p);
};

var _ref$7K =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.492 11.897l-1.56-.88a7.8 7.8 0 0 0 0-2.035l1.56-.879a1.001 1.001 0 0 0 .37-1.38L17.815 3.26a1.001 1.001 0 0 0-1.353-.362l-1.491.841A8.078 8.078 0 0 0 13 2.586V1a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1.586a8.053 8.053 0 0 0-1.97 1.152l-1.492-.84a1 1 0 0 0-1.352.361L.139 6.723a1.001 1.001 0 0 0 .37 1.38l1.559.88A7.829 7.829 0 0 0 2 10c0 .335.023.675.068 1.017l-1.56.88a.998.998 0 0 0-.37 1.38l2.048 3.464a.999.999 0 0 0 1.352.362l1.492-.842A7.99 7.99 0 0 0 7 17.413V19a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.587a8.014 8.014 0 0 0 1.97-1.152l1.492.842a1 1 0 0 0 1.353-.362l2.047-3.464a1.002 1.002 0 0 0-.37-1.38m-3.643-3.219c.1.448.15.893.15 1.322a6.1 6.1 0 0 1-.15 1.322 1 1 0 0 0 .484 1.09l1.287.725-1.03 1.742-1.252-.707a1 1 0 0 0-1.183.15 6.023 6.023 0 0 1-2.44 1.425 1 1 0 0 0-.715.96V18H9v-1.294a1 1 0 0 0-.714-.959 6.01 6.01 0 0 1-2.44-1.425 1.001 1.001 0 0 0-1.184-.15l-1.252.707-1.03-1.742 1.287-.726a.999.999 0 0 0 .485-1.089A6.043 6.043 0 0 1 4 10c0-.429.05-.874.152-1.322a1 1 0 0 0-.485-1.09L2.38 6.862 3.41 5.12l1.252.707a1 1 0 0 0 1.184-.149 6.012 6.012 0 0 1 2.44-1.426A1 1 0 0 0 9 3.294V2h2v1.294a1 1 0 0 0 .715.958c.905.27 1.749.762 2.44 1.426a1 1 0 0 0 1.183.15l1.253-.708 1.029 1.742-1.287.726a1 1 0 0 0-.484 1.09M9.999 6c-2.205 0-4 1.794-4 4s1.795 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4m0 6c-1.102 0-2-.897-2-2s.898-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2"
});

var SvgSettingsMajorMonotone = function SvgSettingsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7K);
};

var _ref$7L =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm7-3c0-.53-.064-1.044-.176-1.54L19 7.23l-2.047-3.464-2.106 1.188A6.978 6.978 0 0 0 12 3.292V1H8v2.294a6.99 6.99 0 0 0-2.847 1.662L3.047 3.768 1 7.232 3.176 8.46C3.064 8.955 3 9.47 3 10s.064 1.044.176 1.54L1 12.77l2.047 3.464 2.106-1.188A6.99 6.99 0 0 0 8 16.708V19h4v-2.294a6.99 6.99 0 0 0 2.847-1.662l2.106 1.188L19 12.768l-2.176-1.227c.112-.49.176-1.01.176-1.54z"
});

var _ref2$2q =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.492 11.897l-1.56-.88a7.63 7.63 0 0 0 .001-2.035l1.56-.88a1 1 0 0 0 .369-1.38L17.815 3.26a1 1 0 0 0-1.353-.363l-1.49.84A8.077 8.077 0 0 0 13 2.587V1a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1.586a8.072 8.072 0 0 0-1.97 1.152l-1.492-.84a1 1 0 0 0-1.352.36L.14 6.724a1.004 1.004 0 0 0 .369 1.381l1.55.88C2.02 9.325 2 9.665 2 10s.023.675.068 1.017l-1.56.88a1 1 0 0 0-.369 1.372l2.04 3.46c.27.47.87.63 1.35.36l1.49-.844c.6.48 1.26.87 1.97 1.154V19c0 .552.443 1 1 1h4c.55 0 1-.448 1-1v-1.587c.7-.286 1.37-.675 1.97-1.152l1.49.85a.992.992 0 0 0 1.35-.36l2.047-3.46a1.006 1.006 0 0 0-.369-1.38zm-3.643-3.22c.1.45.15.894.15 1.323s-.05.873-.15 1.322c-.1.43.1.873.48 1.09l1.28.725-1.03 1.742-1.257-.71a.988.988 0 0 0-1.183.15 6.044 6.044 0 0 1-2.44 1.42.99.99 0 0 0-.714.96V18H9v-1.294c0-.443-.29-.833-.714-.96a5.985 5.985 0 0 1-2.44-1.424 1 1 0 0 0-1.184-.15l-1.252.707-1.03-1.75 1.287-.73c.385-.22.58-.66.485-1.09A5.907 5.907 0 0 1 4 10c0-.43.05-.874.152-1.322a1 1 0 0 0-.485-1.09L2.38 6.862 3.41 5.12l1.252.707a.998.998 0 0 0 1.184-.15 6.02 6.02 0 0 1 2.44-1.425A1 1 0 0 0 9 3.294V2h2v1.294c0 .442.29.832.715.958.905.27 1.75.762 2.44 1.426.317.306.8.365 1.183.15l1.253-.708 1.03 1.742-1.28.726a.999.999 0 0 0-.48 1.09zM10 6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z",
  fill: undefined
});

var SvgSettingsMajorTwotone = function SvgSettingsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7L, _ref2$2q);
};

var _ref$7M =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6m7.476-1.246c-1.394-.754-1.394-2.754 0-3.508a1 1 0 0 0 .376-1.404l-1.067-1.733a1 1 0 0 0-1.327-.355l-.447.243c-1.329.719-2.945-.244-2.945-1.755V3a1 1 0 0 0-1-1H8.934a1 1 0 0 0-1 1v.242c0 1.511-1.616 2.474-2.945 1.755l-.447-.243a1 1 0 0 0-1.327.355L2.148 6.842a1 1 0 0 0 .376 1.404c1.394.754 1.394 2.754 0 3.508a1 1 0 0 0-.376 1.404l1.067 1.733a1 1 0 0 0 1.327.355l.447-.243c1.329-.719 2.945.244 2.945 1.755V17a1 1 0 0 0 1 1h2.132a1 1 0 0 0 1-1v-.242c0-1.511 1.616-2.474 2.945-1.755l.447.243a1 1 0 0 0 1.327-.355l1.067-1.733a1 1 0 0 0-.376-1.404"
});

var SvgSettingsMinor = function SvgSettingsMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7M);
};

var _ref$7N =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 12c-.807 0-1.537.324-2.077.844l-4.96-2.481c.015-.12.037-.238.037-.363s-.022-.243-.037-.363l4.96-2.481c.54.52 1.27.844 2.077.844 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .125.022.243.037.363l-4.96 2.481A2.986 2.986 0 0 0 5 7c-1.654 0-3 1.346-3 3s1.346 3 3 3c.807 0 1.537-.324 2.077-.844l4.96 2.481c-.015.12-.037.238-.037.363 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3"
});

var SvgShareMinor = function SvgShareMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7N);
};

var _ref$7O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7 6.994a.999.999 0 0 1-.707-1.707l3-3c.009-.01.021-.012.03-.021a.982.982 0 0 1 .294-.196l.004-.001c.008-.003.017-.003.025-.006A.937.937 0 0 1 9.966 2c.032-.001.061.003.092.005a.944.944 0 0 1 .257.05c.032.01.063.019.094.033a.994.994 0 0 1 .298.198l3 3A.999.999 0 1 1 12.293 6.7L11 5.408v6.586a1 1 0 1 1-2 0V5.408L7.707 6.7A.997.997 0 0 1 7 6.994zm10 2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H4v5h12v-5h-2a1 1 0 1 1 0-2h3z"
});

var SvgShareIosMinor = function SvgShareIosMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7O);
};

var _ref$7P =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.816 14c-.415-1.162-1.514-2-2.816-2s-2.4.838-2.816 2H12v-4h6v4h-.184zM15 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM2 4h8v10H7.816C7.4 12.838 6.302 12 5 12s-2.4.838-2.816 2H2V4zm13.434 1l1.8 3H12V5h3.434zm4.424 3.485l-3-5C16.678 3.185 16.35 3 16 3h-4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1.185C2.6 17.162 3.698 18 5 18s2.4-.838 2.816-2h4.37c.413 1.162 1.512 2 2.814 2s2.4-.838 2.816-2H19a1 1 0 0 0 1-1V9c0-.18-.05-.36-.142-.515z",
  fill: undefined
});

var SvgShipmentMajorMonotone = function SvgShipmentMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7P);
};

var _ref$7Q =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11 4h5l3 5h-8z"
});

var _ref2$2r =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17.816 14A2.996 2.996 0 0 0 15 12a2.996 2.996 0 0 0-2.816 2H12v-4h6v4h-.184zM15 16c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .55 0 1 .449 1 1 0 .551-.45 1-1 1zM5 16c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .55 0 1 .449 1 1 0 .551-.45 1-1 1zM2 4h8v10H7.816A2.996 2.996 0 0 0 5 12a2.996 2.996 0 0 0-2.816 2H2V4zm13.434 1l1.8 3H12V5h3.434zm4.424 3.485l-3-5A1.001 1.001 0 0 0 16 3h-4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1.185A2.993 2.993 0 0 0 5 18a2.996 2.996 0 0 0 2.816-2h4.369A2.993 2.993 0 0 0 15 18a2.996 2.996 0 0 0 2.816-2H19a1 1 0 0 0 1-1V9c0-.181-.05-.359-.142-.515z"
});

var SvgShipmentMajorTwotone = function SvgShipmentMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7Q, _ref2$2r);
};

var _ref$7R =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M1 11a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2H1zm1 7h3v-3H2v3zm4-5H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zM2 5h3V2H2v3zM1 7h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm14-2h3V2h-3v3zm4-5h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-8 18v-1a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2M10 3a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m5 10a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m-5-6a.994.994 0 0 0 1-1c0-.13-.03-.26-.08-.38-.05-.13-.12-.23-.21-.33-.38-.37-1.04-.37-1.42 0-.09.1-.16.2-.21.33a.995.995 0 0 0 .21 1.09c.19.189.44.29.71.29m8.29 11.29c-.18.189-.29.45-.29.71a.993.993 0 0 0 1 1c.27 0 .52-.101.71-.29.09-.101.16-.21.21-.33.06-.12.08-.25.08-.38 0-.26-.11-.521-.29-.71-.38-.37-1.05-.37-1.42 0M19 13a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1m0-4h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2M9 13a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1H7a1 1 0 1 0 0 2h2v2z"
});

var SvgShopcodesMajorMonotone = function SvgShopcodesMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7R);
};

var _ref$7S =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h5v5H1V1zm13 0h5v5h-5V1zM1 14h5v5H1v-5z"
});

var _ref2$2s =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M1 11a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2H1zm1 7h3v-3H2v3zm4-5H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zM2 5h3V2H2v3zM1 7h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm14-2h3V2h-3v3zm4-5h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-8 18v-1a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2M10 3a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m5 10a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m-5-6a.994.994 0 0 0 1-1c0-.13-.03-.26-.08-.38-.05-.13-.12-.23-.21-.33-.38-.37-1.04-.37-1.42 0-.09.1-.16.2-.21.33a.995.995 0 0 0 .21 1.09c.19.189.44.29.71.29m8.29 11.29c-.18.189-.29.45-.29.71a.993.993 0 0 0 1 1c.27 0 .52-.101.71-.29.09-.101.16-.21.21-.33.06-.12.08-.25.08-.38 0-.26-.11-.521-.29-.71-.38-.37-1.05-.37-1.42 0M19 13a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1m0-4h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2M9 13a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1H7a1 1 0 1 0 0 2h2v2z"
});

var SvgShopcodesMajorTwotone = function SvgShopcodesMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7S, _ref2$2s);
};

var _ref$7T =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M0 19V1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zM18 8V6a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm0 6v-2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm-1 5a1 1 0 0 1 1-1 1 1 0 1 1 2 0v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm1-17a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0zm-3-1a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1zm-4 18a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1zm-4-1V2H2v16h5z"
});

var SvgSidebarLeftMajorMonotone = function SvgSidebarLeftMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7T);
};

var _ref$7U =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h7v18H1z"
});

var _ref2$2t =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M0 19V1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zM18 8V6a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm0 6v-2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm-1 5a1 1 0 0 1 1-1 1 1 0 1 1 2 0v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm1-17a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0zm-3-1a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1zm-4 18a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1zm-4-1V2H2v16h5z"
});

var SvgSidebarLeftMajorTwotone = function SvgSidebarLeftMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7U, _ref2$2t);
};

var _ref$7V =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M20 19V1a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1zM2 8a1 1 0 1 1-2 0V6a1 1 0 1 1 2 0v2zm0 6v-2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0m1 5a1 1 0 0 0-1-1 1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1M2 2a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0m3-1a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1m4 18a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1m4-1h5V2h-5v16z"
});

var SvgSidebarRightMajorMonotone = function SvgSidebarRightMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7V);
};

var _ref$7W =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M12 1h7v18h-7z"
});

var _ref2$2u =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M20 19V1a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1zM2 8a1 1 0 1 1-2 0V6a1 1 0 1 1 2 0v2zm0 6v-2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0m1 5a1 1 0 0 0-1-1 1 1 0 1 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1M2 2a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0m3-1a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1m4 18a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1m4-1h5V2h-5v16z"
});

var SvgSidebarRightMajorTwotone = function SvgSidebarRightMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7W, _ref2$2u);
};

var _ref$7X =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-1 2v4.92l-3.375-2.7a.998.998 0 0 0-1.332.073l-4.42 4.42-2.318-1.545a.996.996 0 0 0-1.07-.025L2 9.233V2h16zM2 14v-2.434l3.972-2.383 2.473 1.65c.396.263.924.212 1.262-.126l4.367-4.367L18 9.48V14H2zm4 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
  fill: undefined
});

var SvgSlideshowMajorMonotone = function SvgSlideshowMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7X);
};

var _ref$7Y =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M14 5L9.001 9.999 6.001 8 1 11v4h18V9z"
});

var _ref2$2v =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-1 2v4.919l-3.375-2.7a1 1 0 0 0-1.332.074l-4.42 4.42-2.318-1.545a.996.996 0 0 0-1.07-.025L2 9.234V2h16zM2 14v-2.434l3.972-2.383 2.473 1.649a1 1 0 0 0 1.262-.125l4.367-4.367L18 9.48V14H2zm4 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
});

var SvgSlideshowMajorTwotone = function SvgSlideshowMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7Y, _ref2$2v);
};

var _ref$7Z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.696 4.281c-.03.03-.786.72-2.304.72-1.497 0-2.252-.67-2.303-.718a1 1 0 0 0-1.404 1.424C6.425 12.84 7.653 14 10 14c2.346 0 3.575-1.16 3.707-1.293a.993.993 0 0 0 .005-1.397 1.006 1.006 0 0 0-1.408-.029"
});

var SvgSmileyHappyMajorMonotone = function SvgSmileyHappyMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7Z);
};

var _ref$7_ =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$2w =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.696 4.281c-.03.03-.786.72-2.304.72-1.497 0-2.252-.67-2.303-.718a1 1 0 0 0-1.404 1.424C6.425 12.84 7.653 14 10 14c2.346 0 3.575-1.16 3.707-1.293a.993.993 0 0 0 .005-1.397 1.006 1.006 0 0 0-1.408-.029"
});

var SvgSmileyHappyMajorTwotone = function SvgSmileyHappyMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7_, _ref2$2w);
};

var _ref$7$ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-3 6a3.006 3.006 0 0 1-2.829-2h5.658A3.006 3.006 0 0 1 10 13m4-4H6a1 1 0 0 0-1 1c0 2.757 2.243 5 5 5s5-2.243 5-5a1 1 0 0 0-1-1"
});

var SvgSmileyJoyMajorMonotone = function SvgSmileyJoyMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$7$);
};

var _ref$80 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 14a4 4 0 0 1-4-4h8a4 4 0 0 1-4 4m0-13a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9"
});

var _ref2$2x =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-3 6a3.006 3.006 0 0 1-2.829-2h5.658A3.006 3.006 0 0 1 10 13m4-4H6a1 1 0 0 0-1 1c0 2.757 2.243 5 5 5s5-2.243 5-5a1 1 0 0 0-1-1"
});

var SvgSmileyJoyMajorTwotone = function SvgSmileyJoyMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$80, _ref2$2x);
};

var _ref$81 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 5H7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"
});

var SvgSmileyNeutralMajorMonotone = function SvgSmileyNeutralMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$81);
};

var _ref$82 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$2y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 5H7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"
});

var SvgSmileyNeutralMajorTwotone = function SvgSmileyNeutralMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$82, _ref2$2y);
};

var _ref$83 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m-3-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 4c-.247 0-2.451.036-3.707 1.293a.999.999 0 1 0 1.414 1.414c.57-.57 1.881-.705 2.29-.707.415.002 1.726.137 2.296.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414C12.451 12.036 10.247 12 10 12"
});

var SvgSmileySadMajorMonotone = function SvgSmileySadMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$83);
};

var _ref$84 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "currentColor"
});

var _ref2$2z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m-3-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 4c-.247 0-2.451.036-3.707 1.293a.999.999 0 1 0 1.414 1.414c.57-.57 1.881-.705 2.29-.707.415.002 1.726.137 2.296.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414C12.451 12.036 10.247 12 10 12"
});

var SvgSmileySadMajorTwotone = function SvgSmileySadMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$84, _ref2$2z);
};

var _ref$85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 4a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm3 1a.997.997 0 0 0 .707-.293l2-2a.999.999 0 1 0-1.414-1.414l-2 2A.999.999 0 0 0 16 5zm3 1h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM4 7v4a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm2 1h5v2H6V8z",
  fill: undefined
});

var _ref2$2A =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 10a1 1 0 0 0-1 1v7H2V4h7a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1z",
  fill: undefined
});

var _ref3$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 14H5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z",
  fill: undefined
});

var SvgSocialAdMajorMonotone = function SvgSocialAdMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$85, _ref2$2A, _ref3$1);
};

var _ref$86 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 20H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2v14h13v-7a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1zm0-15a.999.999 0 0 1-.707-1.707l2-2a.999.999 0 1 1 1.414 1.414l-2 2A.997.997 0 0 1 16 5zm3 3h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm-6-4a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zm-1 8H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-6-2h5V8H6v2zm6 6H5a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2z"
});

var SvgSocialAdMajorTwotone = function SvgSocialAdMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$86);
};

var _ref$87 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 10a1 1 0 0 1 1 1v4.889a1 1 0 0 1-1 1H7.636l-2.818 2.818A.999.999 0 0 1 3.111 19v-2.111H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2v9.889h2.111a1 1 0 0 1 1 1v.697l1.404-1.404a1 1 0 0 1 .707-.293H15V11a1 1 0 0 1 1-1zm0-5a.999.999 0 0 1-.707-1.707l2-2a.999.999 0 1 1 1.414 1.414l-2 2A.997.997 0 0 1 16 5zm3 1a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2h2zm-6-2a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zM4 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm8 3a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h7z"
});

var SvgSocialPostMajorMonotone = function SvgSocialPostMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$87);
};

var _ref$88 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16 10a1 1 0 0 1 1 1v4.889a1 1 0 0 1-1 1H7.636l-2.818 2.818A.999.999 0 0 1 3.111 19v-2.111H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2v9.889h2.111a1 1 0 0 1 1 1v.697l1.404-1.404a1 1 0 0 1 .707-.293H15V11a1 1 0 0 1 1-1zm0-5a.999.999 0 0 1-.707-1.707l2-2a.999.999 0 1 1 1.414 1.414l-2 2A.997.997 0 0 1 16 5zm3 1a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2h2zm-6-2a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zM4 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm8 3a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h7z"
});

var SvgSocialPostMajorTwotone = function SvgSocialPostMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$88);
};

var _ref$89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-1 18H4V6h1a1 1 0 1 0 0-2H4V2h12v2h-1a1 1 0 1 0 0 2h1v12zm-5-4H7a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-4-2h2a1 1 0 1 0 0-2H7a1 1 0 1 0 0 2zm4-8H9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
  fill: undefined
});

var SvgSoftPackMajorMonotone = function SvgSoftPackMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$89);
};

var _ref$8a =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 1h14v18H3z"
});

var _ref2$2B =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-1 18H4V6h1a1 1 0 1 0 0-2H4V2h12v2h-1a1 1 0 1 0 0 2h1v12zm-5-4H7a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2m-4-2h2a1 1 0 1 0 0-2H7a1 1 0 1 0 0 2m4-8H9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
});

var SvgSoftPackMajorTwotone = function SvgSoftPackMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8a, _ref2$2B);
};

var _ref$8b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M5.293 2.293a.997.997 0 0 1 1.414 0l3 3a1 1 0 1 1-1.414 1.414L7 5.414V13a1 1 0 0 1-2 0V5.414L3.707 6.707a1 1 0 0 1-1.414-1.414l3-3zM13 7a1 1 0 0 1 2 0v7.585l1.293-1.292a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a.997.997 0 0 1 0-1.414.999.999 0 0 1 1.414 0L13 14.585V7z"
});

var SvgSortMinor = function SvgSortMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8b);
};

var _ref$8c =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4.707 2.293l3 3a.999.999 0 1 1-1.414 1.414L5 5.414V17a1 1 0 1 1-2 0V5.414L1.707 6.707A.999.999 0 1 1 .293 5.293l3-3a.999.999 0 0 1 1.414 0zM11 6a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2h-8zm8 3a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8zm0 5a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8z"
});

var SvgSortAscendingMajorMonotone = function SvgSortAscendingMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8c);
};

var _ref$8d =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4.707 2.293l3 3a.999.999 0 1 1-1.414 1.414L5 5.414V17a1 1 0 1 1-2 0V5.414L1.707 6.707A.999.999 0 1 1 .293 5.293l3-3a.999.999 0 0 1 1.414 0zM11 6a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2h-8zm8 3a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8zm0 5a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8z"
});

var SvgSortAscendingMajorTwotone = function SvgSortAscendingMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8d);
};

var _ref$8e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6.293 13.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a.999.999 0 1 1 1.414-1.414L3 14.586V3a1 1 0 1 1 2 0v11.586l1.293-1.293zM11 6a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2h-8zm8 3a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8zm0 5a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8z"
});

var SvgSortDescendingMajorMonotone = function SvgSortDescendingMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8e);
};

var _ref$8f =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M6.293 13.293a.999.999 0 1 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a.999.999 0 1 1 1.414-1.414L3 14.586V3a1 1 0 1 1 2 0v11.586l1.293-1.293zM11 6a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2h-8zm8 3a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8zm0 5a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h8z"
});

var SvgSortDescendingMajorTwotone = function SvgSortDescendingMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8f);
};

var _ref$8g =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13.548 2.892a1 1 0 1 1 .904-1.784C17.755 2.782 19.83 6.158 19.83 10c0 3.832-2.08 7.212-5.376 8.891a1 1 0 1 1-.908-1.782c2.628-1.338 4.284-4.03 4.284-7.109 0-3.087-1.651-5.774-4.282-7.108zm-1.214 4.154a1 1 0 0 1 1.332-1.492C14.95 6.7 15.673 8.268 15.673 10c0 1.733-.723 3.3-2.007 4.446a1 1 0 0 1-1.332-1.492c.865-.771 1.339-1.8 1.339-2.954 0-1.154-.474-2.182-1.339-2.954zM2 14c-1.096 0-2-.904-2-2V8c0-1.096.904-2 2-2h1.65l4.725-3.78A1 1 0 0 1 10 3v14a1 1 0 0 1-1.625.781l-4.726-3.78H2zm2.625-6.219a1 1 0 0 1-.625.22H2v4h2a1 1 0 0 1 .625.218L8 14.92V5.082l-3.375 2.7z"
});

var SvgSoundMajorMonotone = function SvgSoundMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8g);
};

var _ref$8h =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 11.982C1 12.544 1.456 13 2.018 13H4l5 4V3L4 7H2.018C1.456 7 1 7.456 1 8.018v3.964z"
});

var _ref2$2C =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13.548 2.892a1 1 0 1 1 .904-1.784C17.755 2.782 19.83 6.158 19.83 10c0 3.832-2.08 7.212-5.376 8.891a1 1 0 1 1-.908-1.782c2.628-1.338 4.284-4.03 4.284-7.109 0-3.087-1.651-5.774-4.282-7.108zm-1.214 4.154a1 1 0 0 1 1.332-1.492C14.95 6.7 15.673 8.268 15.673 10c0 1.733-.723 3.3-2.007 4.446a1 1 0 0 1-1.332-1.492c.865-.771 1.339-1.8 1.339-2.954 0-1.154-.474-2.182-1.339-2.954zM2 14c-1.096 0-2-.904-2-2V8c0-1.096.904-2 2-2h1.65l4.725-3.78A1 1 0 0 1 10 3v14a1 1 0 0 1-1.625.781l-4.726-3.78H2zm2.625-6.219a1 1 0 0 1-.625.22H2v4h2a1 1 0 0 1 .625.218L8 14.92V5.082l-3.375 2.7z"
});

var SvgSoundMajorTwotone = function SvgSoundMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8h, _ref2$2C);
};

var _ref$8i =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.2 17a.8.8 0 0 1-.47-.152.8.8 0 0 1-.322-.762l.743-5.203-2.917-2.917a.8.8 0 0 1-.196-.81.798.798 0 0 1 .63-.545l4.398-.733 2.218-4.435A.808.808 0 0 1 9.004 1a.8.8 0 0 1 .715.45l2.123 4.362 4.498.801a.8.8 0 0 1 .623.547.798.798 0 0 1-.198.806l-2.917 2.917.744 5.203a.8.8 0 0 1-.327.764.799.799 0 0 1-.827.063l-4.382-2.219-4.502 2.223A.792.792 0 0 1 4.2 17z",
  fill: undefined
});

var SvgStarFilledMinor = function SvgStarFilledMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8i);
};

var _ref$8j =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.2 17a.8.8 0 0 1-.47-.152.8.8 0 0 1-.322-.762l.743-5.203-2.917-2.917a.8.8 0 0 1-.196-.81.798.798 0 0 1 .63-.545l4.398-.733 2.218-4.435A.808.808 0 0 1 9.004 1a.8.8 0 0 1 .715.45l2.123 4.362 4.498.801a.8.8 0 0 1 .623.547.798.798 0 0 1-.198.806l-2.917 2.917.744 5.203a.8.8 0 0 1-.327.764.799.799 0 0 1-.827.063l-4.382-2.219-4.502 2.223A.792.792 0 0 1 4.2 17zm1.51-2.884l3.357-1.658.892.452 2.327 1.178-.56-3.912.708-.707 1.29-1.29-3.235-.576-.445-.915-1.06-2.176L7.4 7.683l-1.005.168-2.098.35 1.975 1.975-.141.99-.422 2.95z",
  fill: undefined
});

var SvgStarOutlineMinor = function SvgStarOutlineMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8j);
};

var _ref$8k =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 20a1 1 0 0 0 1-1V9.443C19.19 8.75 20 7.475 20 6V5a.99.99 0 0 0-.099-.42L17.895.553A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553L.099 4.58A.99.99 0 0 0 0 5v1c0 1.475.81 2.75 2 3.443V19a1 1 0 0 0 1 1h14zM16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm0 10h-2v-5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5H4v-8a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v8zm-8 0h4v-4H8v4zM2 6h4c0 1.103-.897 2-2 2s-2-.897-2-2zm10 0c0 1.103-.897 2-2 2s-2-.897-2-2h4zM3.618 2h12.764l1 2H2.618l1-2z"
});

var SvgStoreMajorMonotone = function SvgStoreMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8k);
};

var _ref$8l =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M19 6a3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 1 1-6 0V5l2-4h14l2 4v1z"
});

var _ref2$2D =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 20a1 1 0 0 0 1-1V9.443C19.19 8.75 20 7.475 20 6V5a.99.99 0 0 0-.099-.42L17.895.553A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553L.099 4.58A.99.99 0 0 0 0 5v1c0 1.475.81 2.75 2 3.443V19a1 1 0 0 0 1 1h14zM16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm0 10h-2v-5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5H4v-8a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v8zm-8 0h4v-4H8v4zM2 6h4c0 1.103-.897 2-2 2s-2-.897-2-2zm10 0c0 1.103-.897 2-2 2s-2-.897-2-2h4zM3.618 2h12.764l1 2H2.618l1-2z"
});

var SvgStoreMajorTwotone = function SvgStoreMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8l, _ref2$2D);
};

var _ref$8m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.895 4.553l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4A1.002 1.002 0 0 0 0 5v1c0 1.475.81 2.75 2 3.443V12a1 1 0 1 0 2 0v-2a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v2a1 1 0 1 0 2 0V9.443C19.19 8.75 20 7.475 20 6V5c0-.155-.036-.309-.105-.447zM16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm-6 0c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zM4 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm-.382-6h12.764l1 2H2.618l1-2zM19 15h-4a.997.997 0 0 0-.707.293l-2.138 2.138-3.323-4.986a1 1 0 0 0-1.539-.152L4.586 15H1a1 1 0 1 0 0 2h4c.265 0 .52-.105.707-.293l2.138-2.138 3.323 4.986a1 1 0 0 0 1.539.152L15.414 17H19a1 1 0 1 0 0-2"
});

var SvgStoreStatusMajorMonotone = function SvgStoreStatusMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8m);
};

var _ref$8n =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M19 6a3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 1 1-6 0V5l2-4h14l2 4v1z"
});

var _ref2$2E =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.895 4.553l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4A1.002 1.002 0 0 0 0 5v1c0 1.475.81 2.75 2 3.443V12a1 1 0 1 0 2 0v-2a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 10 10a3.99 3.99 0 0 0 3-1.357A3.99 3.99 0 0 0 16 10v2a1 1 0 1 0 2 0V9.443C19.19 8.75 20 7.475 20 6V5c0-.155-.036-.309-.105-.447zM16 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm-6 0c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zM4 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm-.382-6h12.764l1 2H2.618l1-2zM19 15h-4a.997.997 0 0 0-.707.293l-2.138 2.138-3.323-4.986a1 1 0 0 0-1.539-.152L4.586 15H1a1 1 0 1 0 0 2h4c.265 0 .52-.105.707-.293l2.138-2.138 3.323 4.986a1 1 0 0 0 1.539.152L15.414 17H19a1 1 0 1 0 0-2"
});

var SvgStoreStatusMajorTwotone = function SvgStoreStatusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8n, _ref2$2E);
};

var _ref$8o =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM4 18h12v-6H4v6zm0-8h12V2H4v8zm6 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
});

var SvgTabletMajorMonotone = function SvgTabletMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8o);
};

var _ref$8p =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 1h14v10H3z"
});

var _ref2$2F =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM4 18h12v-6H4v6zm0-8h12V2H4v8zm6 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
});

var SvgTabletMajorTwotone = function SvgTabletMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8p, _ref2$2F);
};

var _ref$8q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M6 10h12V2H6v8zm6 5v-3H5a1 1 0 0 1-1-1V4c-1.103 0-2 .897-2 2v9h10zM2 18h10v-1H2v1zM19 0a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-5v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6c0-2.206 1.794-4 4-4V1a1 1 0 0 1 1-1h14zM9 7a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2H9z"
});

var SvgTapChipMajorMonotone = function SvgTapChipMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8q);
};

var _ref$8r =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  fillRule: "evenodd",
  d: "M6 10h12V2H6v8zm6 5v-3H5a1 1 0 0 1-1-1V4c-1.103 0-2 .897-2 2v9h10zM2 18h10v-1H2v1zM19 0a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-5v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6c0-2.206 1.794-4 4-4V1a1 1 0 0 1 1-1h14zM9 7a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2H9z"
});

var SvgTapChipMajorTwotone = function SvgTapChipMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8r);
};

var _ref$8s =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1.555.832l2.318-1.545 1.42 1.42a.999.999 0 0 0 1.414 0L10 18.414l1.293 1.293A.993.993 0 0 0 12 20a.993.993 0 0 0 .707-.293l1.42-1.42 2.318 1.545A1 1 0 0 0 18 19V1a1 1 0 0 0-1-1zm-1 17.132l-1.445-.964a.999.999 0 0 0-1.262.125L12 17.586l-1.293-1.293a.997.997 0 0 0-1.414 0L8 17.586l-1.293-1.293a.997.997 0 0 0-1.262-.125L4 17.132V2h12v15.132zm-9-4.094a.997.997 0 0 0 .707-.293l6-6a.999.999 0 1 0-1.414-1.414l-6 6A.999.999 0 0 0 7 13.038m.5-5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 7.5 8.038m5 2a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3"
});

var SvgTaxMajorMonotone = function SvgTaxMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8s);
};

var _ref$8t =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M3 1h14v18l-3-2-2 2-2-2-2 2-2-2-3 2z"
});

var _ref2$2G =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 0H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1.555.832l2.318-1.545 1.42 1.42a.999.999 0 0 0 1.414 0L10 18.414l1.293 1.293A.993.993 0 0 0 12 20a.993.993 0 0 0 .707-.293l1.42-1.42 2.318 1.545A1 1 0 0 0 18 19V1a1 1 0 0 0-1-1zm-1 17.132l-1.445-.964a.999.999 0 0 0-1.262.125L12 17.586l-1.293-1.293a.997.997 0 0 0-1.414 0L8 17.586l-1.293-1.293a.997.997 0 0 0-1.262-.125L4 17.132V2h12v15.132zm-9-4.094a.997.997 0 0 0 .707-.293l6-6a.999.999 0 1 0-1.414-1.414l-6 6A.999.999 0 0 0 7 13.038m.5-5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 7.5 8.038m5 2a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3"
});

var SvgTaxMajorTwotone = function SvgTaxMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8t, _ref2$2G);
};

var _ref$8u =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 4a2.988 2.988 0 0 0-2.61 1.551l-4.409-.735C9.883 2.146 7.694 0 5 0 2.243 0 0 2.243 0 5s2.243 5 5 5c.384 0 .754-.053 1.113-.135l1.382 3.041C6.591 13.641 6 14.747 6 16c0 2.206 1.794 4 4 4s4-1.794 4-4c0-.918-.322-1.754-.844-2.429l2.906-3.736c.296.099.608.165.938.165 1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-7 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM7.931 9.031A5 5 0 0 0 9.654 6.79l4.399.732c.07.397.217.765.426 1.091l-2.893 3.718A3.974 3.974 0 0 0 10 12c-.236 0-.464.03-.688.069L7.931 9.031zM2 5c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3z"
});

var SvgTeamMajorMonotone = function SvgTeamMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8u);
};

var _ref$8v =
/*#__PURE__*/
React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 4,
  fill: "currentColor"
});

var _ref2$2H =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 4a2.988 2.988 0 0 0-2.61 1.551l-4.409-.735C9.883 2.146 7.694 0 5 0 2.243 0 0 2.243 0 5s2.243 5 5 5c.384 0 .754-.053 1.113-.135l1.382 3.041C6.591 13.641 6 14.747 6 16c0 2.206 1.794 4 4 4s4-1.794 4-4c0-.918-.322-1.754-.844-2.429l2.906-3.736c.296.099.608.165.938.165 1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-7 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM7.931 9.031A5 5 0 0 0 9.654 6.79l4.399.732c.07.397.217.765.426 1.091l-2.893 3.718A3.974 3.974 0 0 0 10 12c-.236 0-.464.03-.688.069L7.931 9.031zM2 5c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3z"
});

var SvgTeamMajorTwotone = function SvgTeamMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8v, _ref2$2H);
};

var _ref$8w =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 15.99H2a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm-4 4H2a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2zm-9.61-13h3.22L6 2.15 4.39 6.99zm6.56 3.68c.17.53-.11 1.09-.63 1.27-.11.03-.22.05-.32.05a.997.997 0 0 1-.95-.68l-.77-2.32H3.72l-.77 2.32c-.18.52-.74.8-1.27.63-.52-.18-.8-.74-.63-1.27l3.12-9.35C4.44.52 5.16 0 6 0c.84 0 1.56.52 1.83 1.32l3.12 9.35zm4.51-.68c.82 0 1.5-.67 1.5-1.5s-.68-1.5-1.5-1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5zm2.5-5c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1-.35 0-.65-.17-.82-.43-.5.27-1.07.43-1.68.43-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5c.61 0 1.18.16 1.68.43.17-.26.47-.43.82-.43z"
});

var SvgTextMajorMonotone = function SvgTextMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8w);
};

var _ref$8x =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 15.99H2a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm-4 4H2a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2zm-9.61-13h3.22L6 2.15 4.39 6.99zm6.56 3.68c.17.53-.11 1.09-.63 1.27-.11.03-.22.05-.32.05a.997.997 0 0 1-.95-.68l-.77-2.32H3.72l-.77 2.32c-.18.52-.74.8-1.27.63-.52-.18-.8-.74-.63-1.27l3.12-9.35C4.44.52 5.16 0 6 0c.84 0 1.56.52 1.83 1.32l3.12 9.35zm4.51-.68c.82 0 1.5-.67 1.5-1.5s-.68-1.5-1.5-1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5zm2.5-5c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1-.35 0-.65-.17-.82-.43-.5.27-1.07.43-1.68.43-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5c.61 0 1.18.16 1.68.43.17-.26.47-.43.82-.43z"
});

var SvgTextMajorTwotone = function SvgTextMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8x);
};

var _ref$8y =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 18h16V2H2v16zm3-7h10a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2m0-4h10a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2m5 6H5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2"
});

var SvgTextBlockMajorMonotone = function SvgTextBlockMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8y);
};

var _ref$8z =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 1h18v18H1V1z"
});

var _ref2$2I =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18zM2 18h16V2H2v16zm3-7h10a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2zm0-4h10a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2zm5 6H5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z",
  fill: undefined
});

var SvgTextBlockMajorTwotone = function SvgTextBlockMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8z, _ref2$2I);
};

var _ref$8A =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.09 4.91a3.145 3.145 0 0 1 0 4.42l-6.38 6.38c-.19.18-.44.29-.71.29H9c-.55 0-1-.45-1-1v-3c0-.27.11-.52.29-.71L14 5.58V5H8v1c0 .55-.45 1-1 1H4v1c0 .55-.45 1-1 1s-1-.45-1-1V7H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2h7c.55 0 1 .45 1 1v.13c1.06-.31 2.25-.05 3.09.78zm-1.42 3c.44-.43.44-1.14 0-1.58a1.11 1.11 0 0 0-1.58 0L12.42 10 14 11.58l3.67-3.67zM11.59 14l.99-1L11 11.42l-1 .99V14h1.59zM2 5h4V2H2v3zm8 15H8a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm5 0h-1a1 1 0 1 1 0-2 1 1 0 1 1 2 0v1a1 1 0 0 1-1 1zM4 20H3a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0 1 1 0 1 1 0 2zm-1-5a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1z"
});

var SvgThemeEditMajorMonotone = function SvgThemeEditMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8A);
};

var _ref$8B =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M17.67 7.91L14 11.58 12.42 10l3.67-3.67a1.11 1.11 0 0 1 1.58 0c.44.44.44 1.15 0 1.58zM11.59 14H10v-1.59l1-.99L12.58 13l-.99 1zM2 5V2h4v3H2z"
});

var _ref2$2J =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.09 4.91a3.145 3.145 0 0 1 0 4.42l-6.38 6.38c-.19.18-.44.29-.71.29H9c-.55 0-1-.45-1-1v-3c0-.27.11-.52.29-.71L14 5.58V5H8v1c0 .55-.45 1-1 1H4v1c0 .55-.45 1-1 1s-1-.45-1-1V7H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2h7c.55 0 1 .45 1 1v.13c1.06-.31 2.25-.05 3.09.78zm-1.42 3c.44-.43.44-1.14 0-1.58a1.11 1.11 0 0 0-1.58 0L12.42 10 14 11.58l3.67-3.67zM11.59 14l.99-1L11 11.42l-1 .99V14h1.59zM2 5h4V2H2v3zm8 15H8a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm5 0h-1a1 1 0 1 1 0-2 1 1 0 1 1 2 0v1a1 1 0 0 1-1 1zM4 20H3a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0 1 1 0 1 1 0 2zm-1-5a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1z"
});

var SvgThemeEditMajorTwotone = function SvgThemeEditMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8B, _ref2$2J);
};

var _ref$8C =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 18H4V7h3c.55 0 1-.45 1-1V5h6v1c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1H8V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1h1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zM2 5V2h4v3H2zm17.707 8.293l-5-5A.997.997 0 0 0 14 8H9a1 1 0 0 0-1 1v5c0 .265.105.52.293.707l5 5a.997.997 0 0 0 1.414 0l5-5a1 1 0 0 0 0-1.414zM14 17.586l-4-4V10h3.586l4 4L14 17.586zM12 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2z",
  fill: undefined
});

var SvgThemeStoreMajorMonotone = function SvgThemeStoreMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8C);
};

var _ref$8D =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2 5V2h4v3H2zm8 8.586V10h3.586l4 4L14 17.586l-4-4z"
});

var _ref2$2K =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 5h4V2H2v3zm13-2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V5H8v1c0 .55-.45 1-1 1H4v11h5c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1V7H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2h7zm-1 17a.997.997 0 0 1-.707-.293l-5-5A.996.996 0 0 1 8 14V9a1 1 0 0 1 1-1h5a1 1 0 0 1 .707.293l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 14 20zm-4-6.414l4 4L17.586 14l-4-4H10v3.586zM13 12a1 1 0 1 1-2 0 1 1 0 1 1 2 0z"
});

var SvgThemeStoreMajorTwotone = function SvgThemeStoreMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8D, _ref2$2K);
};

var _ref$8E =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 8h-3V4c0-.55-.45-1-1-1H8V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1h1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 5V2h4v3H2zm12 13H4V7h3c.55 0 1-.45 1-1V5h6v3H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h5v2zm4-4h-8v-4h8v4z",
  fill: undefined
});

var SvgThemesMajorMonotone = function SvgThemesMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8E);
};

var _ref$8F =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 14v-4h8v4h-8zM2 5V2h4v3H2z"
});

var _ref2$2L =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M10 14h8v-4h-8v4zm4 4H4V7h3c.55 0 1-.45 1-1V5h6v3H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h5v2zM2 5h4V2H2v3zm17 3h-3V4c0-.55-.45-1-1-1H8V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1h1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
});

var SvgThemesMajorTwotone = function SvgThemesMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8F, _ref2$2L);
};

var _ref$8G =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M2.18 12H9a1 1 0 1 1 0 2H8v2.962c0 .551.449 1 1 1l.394.015 2.712-5.424A.998.998 0 0 1 13 12h1V3.677L9.808 2h-5.96L2.18 12zM18 12V4h-2v8h2zm-17.986.835l2-12A1 1 0 0 1 3 0h7c.128 0 .254.024.372.071L15.194 2H19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-5.381l-2.724 5.447a.986.986 0 0 1-.933.553l-1-.039H8.96c-1.614 0-2.96-1.345-2.96-2.999V14H1a.998.998 0 0 1-.986-1.165z"
});

var SvgThumbsDownMajorMonotone = function SvgThumbsDownMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8G);
};

var _ref$8H =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M15 3h4v10h-4z"
});

var _ref2$2M =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M2.18 12H9a1 1 0 1 1 0 2H8v2.962c0 .551.449 1 1 1l.394.015 2.712-5.424A.998.998 0 0 1 13 12h1V3.677L9.808 2h-5.96L2.18 12zM18 12V4h-2v8h2zm-17.986.835l2-12A1 1 0 0 1 3 0h7c.128 0 .254.024.372.071L15.194 2H19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-5.381l-2.724 5.447a.986.986 0 0 1-.933.553l-1-.039H8.96c-1.614 0-2.96-1.345-2.96-2.999V14H1a.998.998 0 0 1-.986-1.165z"
});

var SvgThumbsDownMajorTwotone = function SvgThumbsDownMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8H, _ref2$2M);
};

var _ref$8I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9.437 15.996A.502.502 0 0 1 9 15.5V12a1 1 0 0 0-1-1H4.248l1.554-7h3.896L12 5.535v6.188l-2.563 4.273zM17 4h-3.697l-2.748-1.832A.995.995 0 0 0 10 2H5c-.468 0-.874.326-.976.783l-2 9A1 1 0 0 0 3 13h4v2.5C7 16.878 8.122 18 9.5 18h.5a1 1 0 0 0 .858-.485L13.567 13H17a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
});

var SvgThumbsDownMinor = function SvgThumbsDownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8I);
};

var _ref$8J =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.153 18.002h-5.96L6 16.325V8.002h1a1 1 0 0 0 .895-.553l2.712-5.425.393.015c.55 0 1 .45 1 1v2.962h-1a1 1 0 0 0 0 2h6.82l-1.667 10zM2 16.002v-8h2v8H2zm17.763-9.646A1 1 0 0 0 19 6.002h-5V3.04c0-1.654-1.345-3-2.96-3h-.002l-1-.038a.985.985 0 0 0-.932.553L6.382 6.002H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3.807l4.822 1.93c.117.046.243.07.37.07h7c.49 0 .906-.354.986-.835l2-12a.99.99 0 0 0-.223-.81z",
  fill: undefined
});

var SvgThumbsUpMajorMonotone = function SvgThumbsUpMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8J);
};

var _ref$8K =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 7h4v10H1z"
});

var _ref2$2N =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M16.153 18.002h-5.96L6 16.325V8.002h1c.379 0 .725-.214.895-.553l2.712-5.424.393.015c.551 0 1 .449 1 1v2.962h-1a1 1 0 0 0 0 2h6.82l-1.667 10zM2 16.002h2v-8H2v8zm17.763-9.646A.998.998 0 0 0 19 6.002h-5V3.04c0-1.654-1.345-3-2.96-3h-.002l-1-.038a.985.985 0 0 0-.932.553L6.382 6.002H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3.807l4.822 1.929c.118.047.244.07.371.07h7a1 1 0 0 0 .986-.834l2-12a.998.998 0 0 0-.223-.811z"
});

var SvgThumbsUpMajorTwotone = function SvgThumbsUpMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8K, _ref2$2N);
};

var _ref$8L =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14.198 16h-3.896L8 14.465V8.277l2.563-4.273A.502.502 0 0 1 11 4.5V8a1 1 0 0 0 1 1h3.753l-1.555 7zm3.582-8.625A1 1 0 0 0 17 7h-4V4.5C13 3.122 11.88 2 10.5 2H10a1 1 0 0 0-.858.485L6.433 7H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h3.697l2.748 1.832c.164.109.357.168.555.168h5a1 1 0 0 0 .976-.783l2-9a1 1 0 0 0-.196-.842z"
});

var SvgThumbsUpMinor = function SvgThumbsUpMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8L);
};

var _ref$8M =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M7.293 14.707l-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z"
});

var SvgTickMinor = function SvgTickMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8M);
};

var _ref$8N =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.437.437 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0",
  fill: undefined
});

var SvgTickSmallMinor = function SvgTickSmallMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8N);
};

var _ref$8O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4v16h12V5a1 1 0 0 1 1-1zm-9 7V5a1 1 0 1 1 2 0v6c.012.45.195 1 1 1 .805 0 .988-.55 1-1.012V3c-.012-.45-.195-1-1-1a1 1 0 1 1 0-2c2.201 0 3 1.794 3 3v8c0 1.206-.799 3-3 3s-3-1.794-3-3z"
});

var SvgTimelineAttachmentMajorMonotone = function SvgTimelineAttachmentMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8O);
};

var _ref$8P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M17 4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4v16h12V5a1 1 0 0 1 1-1zm-9 7V5a1 1 0 1 1 2 0v6c.012.45.195 1 1 1 .805 0 .988-.55 1-1.012V3c-.012-.45-.195-1-1-1a1 1 0 1 1 0-2c2.201 0 3 1.794 3 3v8c0 1.206-.799 3-3 3s-3-1.794-3-3z"
});

var SvgTimelineAttachmentMajorTwotone = function SvgTimelineAttachmentMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8P);
};

var _ref$8Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 20.001c-.117 0-.234-.02-.348-.062l-2.269-.84-1.397.776a.996.996 0 0 1-.857.055l-2.083-.833-1.599.8c-.28.14-.613.14-.894 0l-1.63-.816-2.607.868A.999.999 0 0 1 4 19.001v-3a1 1 0 1 1 2 0v1.612l1.684-.56a.99.99 0 0 1 .763.053l1.553.777 1.553-.777c.257-.127.554-.139.818-.034l2.06.824 1.381-.769a.999.999 0 0 1 .834-.064l1.354.501V2.39l-1.684.56a.987.987 0 0 1-.763-.053L14 2.12l-1.553.777c-.28.14-.613.14-.894 0L10 2.12l-1.553.777a.991.991 0 0 1-.763.053L6 2.39v1.612a1 1 0 1 1-2 0v-3c0-.32.154-.623.415-.812a.99.99 0 0 1 .901-.136l2.607.868 1.63-.815c.281-.14.613-.14.894 0L12 .883l1.553-.777c.281-.14.613-.14.894 0l1.63.815 2.607-.868a.991.991 0 0 1 .901.136c.261.19.415.491.415.812v18a.997.997 0 0 1-1 1zm-17-6a.999.999 0 0 1-.707-1.707l6-6a.999.999 0 1 1 1.414 1.414l-6 6a.997.997 0 0 1-.707.293zm2-6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6-5.5h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2zm0 4h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2zm0 4h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2z"
});

var SvgTipsMajorMonotone = function SvgTipsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8Q);
};

var _ref$8R =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 20.001c-.117 0-.234-.02-.348-.062l-2.269-.84-1.397.776a.996.996 0 0 1-.857.055l-2.083-.833-1.599.8c-.28.14-.613.14-.894 0l-1.63-.816-2.607.868A.999.999 0 0 1 4 19.001v-3a1 1 0 1 1 2 0v1.612l1.684-.56a.99.99 0 0 1 .763.053l1.553.777 1.553-.777c.257-.127.554-.139.818-.034l2.06.824 1.381-.769a.999.999 0 0 1 .834-.064l1.354.501V2.39l-1.684.56a.987.987 0 0 1-.763-.053L14 2.12l-1.553.777c-.28.14-.613.14-.894 0L10 2.12l-1.553.777a.991.991 0 0 1-.763.053L6 2.39v1.612a1 1 0 1 1-2 0v-3c0-.32.154-.623.415-.812a.99.99 0 0 1 .901-.136l2.607.868 1.63-.815c.281-.14.613-.14.894 0L12 .883l1.553-.777c.281-.14.613-.14.894 0l1.63.815 2.607-.868a.991.991 0 0 1 .901.136c.261.19.415.491.415.812v18a.997.997 0 0 1-1 1zm-17-6a.999.999 0 0 1-.707-1.707l6-6a.999.999 0 1 1 1.414 1.414l-6 6a.997.997 0 0 1-.707.293zm2-6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6-5.5h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2zm0 4h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2zm0 4h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2z"
});

var SvgTipsMajorTwotone = function SvgTipsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8R);
};

var _ref$8S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 17.586L13.914 16.5l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793L11.414 14 14 11.414 17.586 15 15 17.586zM3.437 14.852l1.711 1.711-2.567.856.856-2.567zM4.914 7.5l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793L2.414 5 5 2.414 8.586 6 6 8.586 4.914 7.5zm12.551-4.965a1.83 1.83 0 0 1 0 2.586L17 5.586 14.414 3l.465-.465a1.83 1.83 0 0 1 2.586 0zM4.415 13L13 4.414 15.586 7 7 15.586 4.414 13zm15.292 1.293L15.414 10l3.465-3.465a3.832 3.832 0 0 0 0-5.414 3.834 3.834 0 0 0-5.414 0L10 4.586 5.707.293a.999.999 0 0 0-1.414 0l-4 4a.999.999 0 0 0 0 1.414L4.586 10l-2.293 2.293a.996.996 0 0 0-.24.391l-2 6a.998.998 0 0 0 1.263 1.264l6-2a.996.996 0 0 0 .391-.24L10 15.413l4.293 4.293a.997.997 0 0 0 1.414 0l4-4a.999.999 0 0 0 0-1.414z"
});

var SvgToolsMajorMonotone = function SvgToolsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8S);
};

var _ref$8T =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M13 3L3 13.001 7 17l10.001-9.999z"
});

var _ref2$2O =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M15 17.586L13.914 16.5l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793L11.414 14 14 11.414 17.586 15 15 17.586zM3.437 14.852l1.711 1.711-2.567.856.856-2.567zM4.914 7.5l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793L2.414 5 5 2.414 8.586 6 6 8.586 4.914 7.5zm12.551-4.965a1.83 1.83 0 0 1 0 2.586L17 5.586 14.414 3l.465-.465a1.83 1.83 0 0 1 2.586 0zM4.415 13L13 4.414 15.586 7 7 15.586 4.414 13zm15.292 1.293L15.414 10l3.465-3.465a3.832 3.832 0 0 0 0-5.414 3.834 3.834 0 0 0-5.414 0L10 4.586 5.707.293a.999.999 0 0 0-1.414 0l-4 4a.999.999 0 0 0 0 1.414L4.586 10l-2.293 2.293a.996.996 0 0 0-.24.391l-2 6a.998.998 0 0 0 1.263 1.264l6-2a.996.996 0 0 0 .391-.24L10 15.413l4.293 4.293a.997.997 0 0 0 1.414 0l4-4a.999.999 0 0 0 0-1.414z"
});

var SvgToolsMajorTwotone = function SvgToolsMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8T, _ref2$2O);
};

var _ref$8U =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11.293 8.293L12.586 7H2v11a1 1 0 1 1-2 0V2a1 1 0 1 1 2 0v3h10.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l2.999 2.999a1 1 0 0 1 0 1.416l-2.999 2.999a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414zM19 1a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0v-3H7.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-2.999-2.999a1 1 0 0 1 0-1.416l2.999-2.999a.999.999 0 1 1 1.414 1.414L7.414 13H18V2a1 1 0 0 1 1-1z"
});

var SvgTransactionMajorMonotone = function SvgTransactionMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8U);
};

var _ref$8V =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11.293 8.293L12.586 7H2v11a1 1 0 1 1-2 0V2a1 1 0 1 1 2 0v3h10.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l2.999 2.999a1 1 0 0 1 0 1.416l-2.999 2.999a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414zM19 1a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0v-3H7.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-2.999-2.999a1 1 0 0 1 0-1.416l2.999-2.999a.999.999 0 1 1 1.414 1.414L7.414 13H18V2a1 1 0 0 1 1-1z"
});

var SvgTransactionMajorTwotone = function SvgTransactionMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8V);
};

var _ref$8W =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13c-1.103 0-2-.897-2-2V4h5.185A2.995 2.995 0 0 0 17 6c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 0 0-2.816 2H5.816A2.997 2.997 0 0 0 3 0C1.346 0 0 1.346 0 3s1.346 3 3 3a2.997 2.997 0 0 0 2.816-2H7v7c0 2.206 1.794 4 4 4a1 1 0 1 0 0-2m5.977-2c.026.001.649.04 1.316.707a.999.999 0 1 0 1.414-1.414A4.491 4.491 0 0 0 18 9.2V9a1 1 0 1 0-2 0v.185A2.995 2.995 0 0 0 14 12c0 2.281 1.727 2.712 2.758 2.97C17.873 15.249 18 15.354 18 16c0 .552-.448 1-.976 1-.026-.001-.65-.04-1.317-.707a.999.999 0 1 0-1.414 1.414A4.506 4.506 0 0 0 16 18.8v.2a1 1 0 1 0 2 0v-.185A2.993 2.993 0 0 0 20 16c0-2.281-1.726-2.712-2.757-2.97C16.128 12.751 16 12.646 16 12c0-.552.449-1 .977-1M3 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m14-2a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2"
});

var SvgTransactionFeeDollarMajorMonotone = function SvgTransactionFeeDollarMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8W);
};

var _ref$8X =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13c-1.103 0-2-.897-2-2V4h5.185A2.995 2.995 0 0 0 17 6c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 0 0-2.816 2H5.816A2.997 2.997 0 0 0 3 0C1.346 0 0 1.346 0 3s1.346 3 3 3a2.997 2.997 0 0 0 2.816-2H7v7c0 2.206 1.794 4 4 4a1 1 0 1 0 0-2m5.977-2c.026.001.649.04 1.316.707a.999.999 0 1 0 1.414-1.414A4.491 4.491 0 0 0 18 9.2V9a1 1 0 1 0-2 0v.185A2.995 2.995 0 0 0 14 12c0 2.281 1.727 2.712 2.758 2.97C17.873 15.249 18 15.354 18 16c0 .552-.448 1-.976 1-.026-.001-.65-.04-1.317-.707a.999.999 0 1 0-1.414 1.414A4.506 4.506 0 0 0 16 18.8v.2a1 1 0 1 0 2 0v-.185A2.993 2.993 0 0 0 20 16c0-2.281-1.726-2.712-2.757-2.97C16.128 12.751 16 12.646 16 12c0-.552.449-1 .977-1M3 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m14-2a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2"
});

var SvgTransactionFeeDollarMajorTwotone = function SvgTransactionFeeDollarMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8X);
};

var _ref$8Y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm-2.986 11.992a10.617 10.617 0 0 1 .014-1h-.278a.75.75 0 1 1 0-1.5h.49C14.696 9.468 15.807 8 17.326 8c1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5h-1.232a8.248 8.248 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5h-1.042c.272 1.102.749 1.812 1.119 1.812h.053c.514 0 .507.003.626-.213a.992.992 0 1 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796h-.426a.75.75 0 1 1 0-1.5h.264z"
});

var SvgTransactionFeeEuroMajorMonotone = function SvgTransactionFeeEuroMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8Y);
};

var _ref$8Z =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm-2.986 11.992a10.617 10.617 0 0 1 .014-1h-.278a.75.75 0 1 1 0-1.5h.49C14.696 9.468 15.807 8 17.326 8c1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5h-1.232a8.248 8.248 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5h-1.042c.272 1.102.749 1.812 1.119 1.812h.053c.514 0 .507.003.626-.213a.992.992 0 1 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796h-.426a.75.75 0 1 1 0-1.5h.264z"
});

var SvgTransactionFeeEuroMajorTwotone = function SvgTransactionFeeEuroMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8Z);
};

var _ref$8_ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm-2.756 14H14a1 1 0 0 1 0-2h.472c.019-.34.028-.682.028-1.027 0-1.894 1.057-3.246 2.555-3.483 1.504-.239 2.867.785 2.867 2.4a1 1 0 1 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027H18a1 1 0 0 1 0 2h-1.73a18.695 18.695 0 0 1-.422 2H18.5a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1 .998.998 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
});

var SvgTransactionFeePoundMajorMonotone = function SvgTransactionFeePoundMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8_);
};

var _ref$8$ =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm-2.756 14H14a1 1 0 0 1 0-2h.472c.019-.34.028-.682.028-1.027 0-1.894 1.057-3.246 2.555-3.483 1.504-.239 2.867.785 2.867 2.4a1 1 0 1 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027H18a1 1 0 0 1 0 2h-1.73a18.695 18.695 0 0 1-.422 2H18.5a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1 .998.998 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
});

var SvgTransactionFeePoundMajorTwotone = function SvgTransactionFeePoundMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$8$);
};

var _ref$90 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm-1.152 13.562l2.08 2.761a1 1 0 1 1-1.596 1.204l-3.01-3.993a1 1 0 0 1 1.259-1.49c.233.037.492.056.776.056.702 0 1.242-.478 1.494-1.235H13.75a.75.75 0 1 1 0-1.5h3.23c-.091-.72-.395-1.283-.844-1.58H14a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2h-.944c.232.467.38 1.004.431 1.58h.763a.75.75 0 1 1 0 1.5h-.849c-.298 1.407-1.21 2.486-2.553 2.697z"
});

var SvgTransactionFeeRupeeMajorMonotone = function SvgTransactionFeeRupeeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$90);
};

var _ref$91 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm-1.152 13.562l2.08 2.761a1 1 0 1 1-1.596 1.204l-3.01-3.993a1 1 0 0 1 1.259-1.49c.233.037.492.056.776.056.702 0 1.242-.478 1.494-1.235H13.75a.75.75 0 1 1 0-1.5h3.23c-.091-.72-.395-1.283-.844-1.58H14a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2h-.944c.232.467.38 1.004.431 1.58h.763a.75.75 0 1 1 0 1.5h-.849c-.298 1.407-1.21 2.486-2.553 2.697z"
});

var SvgTransactionFeeRupeeMajorTwotone = function SvgTransactionFeeRupeeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$91);
};

var _ref$92 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm.475 14.454h1.25a.75.75 0 0 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859L13.234 11a1 1 0 0 1 1.732-1l1.515 2.624L17.996 10a1 1 0 1 1 1.732 1l-1.85 3.204h.847a.75.75 0 0 1 0 1.5h-1.25v.75z"
});

var SvgTransactionFeeYenMajorMonotone = function SvgTransactionFeeYenMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$92);
};

var _ref$93 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11 13a1 1 0 1 1 0 2c-2.206 0-4-1.794-4-4V4H5.816A2.997 2.997 0 0 1 3 6C1.346 6 0 4.654 0 3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368A2.997 2.997 0 0 1 17 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2H9v7c0 1.103.897 2 2 2zM3 4a1.001 1.001 0 0 0 0-2 1.001 1.001 0 0 0 0 2zm14-2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zm.475 14.454h1.25a.75.75 0 0 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859L13.234 11a1 1 0 0 1 1.732-1l1.515 2.624L17.996 10a1 1 0 1 1 1.732 1l-1.85 3.204h.847a.75.75 0 0 1 0 1.5h-1.25v.75z"
});

var SvgTransactionFeeYenMajorTwotone = function SvgTransactionFeeYenMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$93);
};

var _ref$94 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13 8.414l-4 4V19a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h6.586l4-4H10a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8.414zM19 15h-7a1 1 0 1 1 0-2h6V2H7v6a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1zM2 18h5v-5H2v5z"
});

var SvgTransferMajorMonotone = function SvgTransferMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$94);
};

var _ref$95 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2 18h5v-5H2z"
});

var _ref2$2P =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M13 8.414l-4 4V19a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h6.586l4-4H10a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8.414zM19 15h-7a1 1 0 1 1 0-2h6V2H7v6a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1zM2 18h5v-5H2v5z"
});

var SvgTransferMajorTwotone = function SvgTransferMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$95, _ref2$2P);
};

var _ref$96 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M8.586 13H2a1 1 0 1 1 0-2h6.586L7.293 9.707a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L8.586 13zM18 20H2a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14V5.618l-7-3.5-7 3.5V7a1 1 0 1 1-2 0V5c0-.379.214-.725.553-.895l8-4c.281-.14.613-.14.894 0l8 4c.339.17.553.516.553.895v14a1 1 0 0 1-1 1z"
});

var SvgTransferInMajorMonotone = function SvgTransferInMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$96);
};

var _ref$97 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M8.586 13H2a1 1 0 1 1 0-2h6.586L7.293 9.707a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L8.586 13zM18 20H2a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14V5.618l-7-3.5-7 3.5V7a1 1 0 1 1-2 0V5c0-.379.214-.725.553-.895l8-4c.281-.14.613-.14.894 0l8 4c.339.17.553.516.553.895v14a1 1 0 0 1-1 1z"
});

var SvgTransferInMajorTwotone = function SvgTransferInMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$97);
};

var _ref$98 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4.414 13l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L4.414 11H11a1 1 0 1 1 0 2H4.414zM18 20H2a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14V5.618l-7-3.5-7 3.5V7a1 1 0 1 1-2 0V5c0-.379.214-.725.553-.895l8-4c.281-.14.613-.14.894 0l8 4c.339.17.553.516.553.895v14a1 1 0 0 1-1 1z"
});

var SvgTransferOutMajorMonotone = function SvgTransferOutMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$98);
};

var _ref$99 =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4.414 13l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L4.414 11H11a1 1 0 1 1 0 2H4.414zM18 20H2a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14V5.618l-7-3.5-7 3.5V7a1 1 0 1 1-2 0V5c0-.379.214-.725.553-.895l8-4c.281-.14.613-.14.894 0l8 4c.339.17.553.516.553.895v14a1 1 0 0 1-1 1z"
});

var SvgTransferOutMajorTwotone = function SvgTransferOutMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$99);
};

var _ref$9a =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9.801 4.07L7 2.202 2 5.535V16.75a1 1 0 1 1-2 0V5c0-.334.167-.646.445-.832l6-4a1 1 0 0 1 1.11 0l4.108 2.739.807-.505a1.003 1.003 0 0 1 1.06 0l6 3.75A1 1 0 0 1 20 7v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h10V7.554l-5-3.125-5 3.125V8a1 1 0 1 1-2 0V7a1 1 0 0 1 .47-.848L9.801 4.07zM11.586 13H5a1 1 0 1 1 0-2h6.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L11.586 13z"
});

var SvgTransferWithinShopifyMajorMonotone = function SvgTransferWithinShopifyMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9a);
};

var _ref$9b =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M9.801 4.07L7 2.202 2 5.535V16.75a1 1 0 1 1-2 0V5c0-.334.167-.646.445-.832l6-4a1 1 0 0 1 1.11 0l4.108 2.739.807-.505a1.003 1.003 0 0 1 1.06 0l6 3.75A1 1 0 0 1 20 7v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h10V7.554l-5-3.125-5 3.125V8a1 1 0 1 1-2 0V7a1 1 0 0 1 .47-.848L9.801 4.07zM11.586 13H5a1 1 0 1 1 0-2h6.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L11.586 13z"
});

var SvgTransferWithinShopifyMajorTwotone = function SvgTransferWithinShopifyMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9b);
};

var _ref$9c =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.923 11.075a1 1 0 0 1 .914.594l2.595 5.84 1.475-.985-1.464-8.79a.998.998 0 0 1 .28-.872l2.95-2.95a1.121 1.121 0 1 0-1.587-1.586L13.17 5.243a.988.988 0 0 1-.886.276L4.337 4.075l-1.6 1.601 5.592 2.485a1 1 0 0 1 .301 1.621l-1.923 1.923a1 1 0 0 1-.707.293H3.414l-.725.725 2.758 1.38c.194.097.351.254.448.448l1.38 2.758.725-.725v-2.586a1 1 0 0 1 .293-.707l1.923-1.923a1 1 0 0 1 .707-.293M7 19.998a1.001 1.001 0 0 1-.894-.553l-1.85-3.702-3.703-1.85a1.001 1.001 0 0 1-.26-1.602l2-2A1 1 0 0 1 3 9.998h2.586l.601-.6L.594 6.911a1 1 0 0 1-.3-1.62l3-3a.985.985 0 0 1 .885-.278l7.946 1.445L14.672.912a3.126 3.126 0 0 1 4.414 0 3.125 3.125 0 0 1 0 4.414L16.5 7.912l1.486 8.922a1 1 0 0 1-.43.996l-3 2a1 1 0 0 1-1.47-.426l-2.485-5.593-.6.601v2.586a1 1 0 0 1-.294.707l-2 2a.998.998 0 0 1-.707.293"
});

var SvgTransportMajorMonotone = function SvgTransportMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9c);
};

var _ref$9d =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13l2-2h3l1.923-1.923L1 6l3-3 8.462 1.538 2.917-2.917a2.122 2.122 0 0 1 3 3l-2.95 2.95L17 17l-3 2-3.077-6.923L9 14v3l-2 2-2-4-4-2z"
});

var _ref2$2Q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.923 11.075a1 1 0 0 1 .914.594l2.595 5.84 1.475-.985-1.464-8.79a.998.998 0 0 1 .28-.872l2.95-2.95a1.121 1.121 0 1 0-1.587-1.586L13.17 5.243a.988.988 0 0 1-.886.276L4.337 4.075l-1.6 1.601 5.592 2.485a1 1 0 0 1 .301 1.621l-1.923 1.923a1 1 0 0 1-.707.293H3.414l-.725.725 2.758 1.38c.194.097.351.254.448.448l1.38 2.758.725-.725v-2.586a1 1 0 0 1 .293-.707l1.923-1.923a1 1 0 0 1 .707-.293M7 19.998a1.001 1.001 0 0 1-.894-.553l-1.85-3.702-3.703-1.85a1.001 1.001 0 0 1-.26-1.602l2-2A1 1 0 0 1 3 9.998h2.586l.601-.6L.594 6.911a1 1 0 0 1-.3-1.62l3-3a.985.985 0 0 1 .885-.278l7.946 1.445L14.672.912a3.126 3.126 0 0 1 4.414 0 3.125 3.125 0 0 1 0 4.414L16.5 7.912l1.486 8.922a1 1 0 0 1-.43.996l-3 2a1 1 0 0 1-1.47-.426l-2.485-5.593-.6.601v2.586a1 1 0 0 1-.294.707l-2 2a.998.998 0 0 1-.707.293"
});

var SvgTransportMajorTwotone = function SvgTransportMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9d, _ref2$2Q);
};

var _ref$9e =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12 14c-3.309 0-6-2.691-6-6a6.006 6.006 0 0 1 7.416-5.831l-3.123 3.124a.999.999 0 0 0 0 1.414l3 3a1.03 1.03 0 0 0 1.414 0l3.124-3.124A6.006 6.006 0 0 1 12 14m7.102-9.675a1.002 1.002 0 0 0-1.595-.246L14 7.586 12.414 6l3.507-3.507a1.001 1.001 0 0 0-.247-1.595A7.91 7.91 0 0 0 12 0C7.589 0 4 3.589 4 8c0 1.846.634 3.543 1.688 4.897L.293 18.293a.999.999 0 1 0 1.414 1.414l5.396-5.395A7.954 7.954 0 0 0 12 16c4.411 0 8-3.589 8-8 0-1.29-.303-2.526-.898-3.675"
});

var SvgTroubleshootMajorMonotone = function SvgTroubleshootMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9e);
};

var _ref$9f =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M12 1c1.16 0 2.251.287 3.214.786L11 6l3 3 4.214-4.214C18.714 5.749 19 6.84 19 8a7 7 0 1 1-7-7"
});

var _ref2$2R =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M12 14c-3.309 0-6-2.691-6-6a6.006 6.006 0 0 1 7.416-5.831l-3.123 3.124a.999.999 0 0 0 0 1.414l3 3a1.03 1.03 0 0 0 1.414 0l3.124-3.124A6.006 6.006 0 0 1 12 14m7.102-9.675a1.002 1.002 0 0 0-1.595-.246L14 7.586 12.414 6l3.507-3.507a1.001 1.001 0 0 0-.247-1.595A7.91 7.91 0 0 0 12 0C7.589 0 4 3.589 4 8c0 1.846.634 3.543 1.688 4.897L.293 18.293a.999.999 0 1 0 1.414 1.414l5.396-5.395A7.954 7.954 0 0 0 12 16c4.411 0 8-3.589 8-8 0-1.29-.303-2.526-.898-3.675"
});

var SvgTroubleshootMajorTwotone = function SvgTroubleshootMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9f, _ref2$2R);
};

var _ref$9g =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.458 12A626.512 626.512 0 0 0 8.19 6.19 591.222 591.222 0 0 1 6.055 12h4.404zm3.49 3.684c.3.9.37 1.664.263 2.316h2.2a8.444 8.444 0 0 1-.303-.553c-.9-1.8-4.79-12.608-5.81-15.447h-.59L9.22 3.354c.89 2.236 3.88 9.778 4.73 12.33h-.002zM1 20a1 1 0 0 1-.094-1.996c.082-.028.598-.248 1.2-1.45.77-1.54 4.23-11.068 5.952-15.89C8.2.266 8.578 0 9 0h2a1 1 0 0 1 .942.664c1.722 4.822 5.183 14.35 5.953 15.89.6 1.202 1.117 1.422 1.2 1.45A1 1 0 0 1 19 20h-7a.982.982 0 0 1-.978-.964c-.02-.537.41-.996.948-1.036.006 0 .156-.012.224-.115.042-.063.235-.437-.143-1.57a70.868 70.868 0 0 0-.85-2.356c-.065.013-.13.04-.2.04H5.3c-.2.525-.392 1.02-.566 1.46-.088 1.687.922 2.775.98 2.836a.999.999 0 0 1-.003 1.41A1.007 1.007 0 0 1 5 20H1z",
  fill: undefined
});

var SvgTypeMajorMonotone = function SvgTypeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9g);
};

var _ref$9h =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M18.852 19s-1 0-2-2-6-16-6-16h-2L8 3.371c.732 1.836 3.967 9.974 4.852 12.629 1 3-1 3-1 3h7z"
});

var _ref2$2S =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.458 12a627.928 627.928 0 0 0-2.267-5.81A681.39 681.39 0 0 1 6.053 12h4.405zm3.491 3.684c.3.899.37 1.664.262 2.316h2.197a8.192 8.192 0 0 1-.303-.553C15.206 15.648 11.314 4.839 10.296 2h-.592l-.486 1.354c.89 2.236 3.881 9.778 4.731 12.33zM1 20a1 1 0 0 1-.094-1.996c.082-.028.598-.248 1.199-1.451.77-1.539 4.231-11.067 5.953-15.889A1 1 0 0 1 9 0h2a1 1 0 0 1 .942.664c1.722 4.822 5.183 14.35 5.953 15.889.601 1.203 1.117 1.423 1.199 1.451A1 1 0 0 1 19 20h-7a.982.982 0 0 1-.978-.964c-.02-.537.411-.995.947-1.036.007 0 .157-.012.225-.115.042-.063.235-.437-.143-1.569a74.753 74.753 0 0 0-.85-2.357c-.067.015-.13.041-.201.041H5.297c-.201.526-.392 1.019-.566 1.459-.089 1.689.921 2.777.98 2.838A1 1 0 0 1 5 20H1z"
});

var SvgTypeMajorTwotone = function SvgTypeMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9h, _ref2$2S);
};

var _ref$9i =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5 3H3.414l1.293-1.293A.999.999 0 1 0 3.293.293l-3 3a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L3.414 5H11.5c3.584 0 6.5 2.916 6.5 6.5S15.084 18 11.5 18A6.508 6.508 0 0 1 5 11.5V11a1 1 0 0 0-2 0v.5c0 4.687 3.813 8.5 8.5 8.5 4.687 0 8.5-3.813 8.5-8.5C20 6.813 16.187 3 11.5 3",
  fill: undefined
});

var SvgUndoMajorMonotone = function SvgUndoMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9i);
};

var _ref$9j =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M11.5 3H3.414l1.293-1.293A.999.999 0 1 0 3.293.293l-3 3a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L3.414 5H11.5c3.584 0 6.5 2.916 6.5 6.5S15.084 18 11.5 18A6.508 6.508 0 0 1 5 11.5V11a1 1 0 0 0-2 0v.5c0 4.687 3.813 8.5 8.5 8.5 4.687 0 8.5-3.813 8.5-8.5C20 6.813 16.187 3 11.5 3"
});

var SvgUndoMajorTwotone = function SvgUndoMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9j);
};

var _ref$9k =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM18 2v10h-4c-.379 0-.725.214-.895.553L12.382 14H7.618l-.723-1.447A1.001 1.001 0 0 0 6 12H2V2h16zm1-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"
});

var SvgUnfulfilledMajorMonotone = function SvgUnfulfilledMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9k);
};

var _ref$9l =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1 13h5l1 2h6l1-2h5v6H1z"
});

var _ref2$2T =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M2 18v-4h3.382l.723 1.447c.17.339.516.553.895.553h6c.379 0 .725-.214.895-.553L14.618 14H18v4H2zM18 2v10h-4c-.379 0-.725.214-.895.553L12.382 14H7.618l-.723-1.447A1.001 1.001 0 0 0 6 12H2V2h16zm1-2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"
});

var SvgUnfulfilledMajorTwotone = function SvgUnfulfilledMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9l, _ref2$2T);
};

var _ref$9m =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4 0a1 1 0 1 1 0 2 1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h1zm13 0a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0 1 1 0 1 1 0-2h1zm0 17a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2 1 1 0 0 1 1-1zM4 18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0zm-1-3a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zm0-6a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zm14 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0-6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1zm-7 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm0-10c1.654 0 3 1.346 3 3 0 .951-.459 1.856-1.227 2.42-.289.213-.773.664-.773 1.317V11a1 1 0 1 1-2 0v-.263c0-1.121.58-2.189 1.591-2.929A1 1 0 0 0 10 6c-.392 0-1.005.424-1.296.71a1.002 1.002 0 0 1-1.412-.007.997.997 0 0 1 .001-1.41C7.425 5.16 8.625 4 10 4z"
});

var SvgUnknownDeviceMajorMonotone = function SvgUnknownDeviceMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9m);
};

var _ref$9n =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M4 0a1 1 0 1 1 0 2 1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h1zm13 0a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0 1 1 0 1 1 0-2h1zm0 17a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2 1 1 0 0 1 1-1zM4 18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0zm-1-3a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zm0-6a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1zm14 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0-6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1zm-7 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm0-10c1.654 0 3 1.346 3 3 0 .951-.459 1.856-1.227 2.42-.289.213-.773.664-.773 1.317V11a1 1 0 1 1-2 0v-.263c0-1.121.58-2.189 1.591-2.929A1 1 0 0 0 10 6c-.392 0-1.005.424-1.296.71a1.002 1.002 0 0 1-1.412-.007.997.997 0 0 1 .001-1.41C7.425 5.16 8.625 4 10 4z"
});

var SvgUnknownDeviceMajorTwotone = function SvgUnknownDeviceMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9n);
};

var _ref$9o =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 20a1 1 0 0 1-1-1V5.65l-8-3.555L2 5.65V19a1 1 0 1 1-2 0V5c0-.396.232-.753.594-.913l9-4a.999.999 0 0 1 .812 0l9 4A.999.999 0 0 1 20 5v14a1 1 0 0 1-1 1zM9 15a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414L9 12.586l3.293-3.293a.999.999 0 1 1 1.414 1.415l-4 4A.997.997 0 0 1 9 15z"
});

var SvgUpdateInventoryMajorMonotone = function SvgUpdateInventoryMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9o);
};

var _ref$9p =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 20a1 1 0 0 1-1-1V5.65l-8-3.555L2 5.65V19a1 1 0 1 1-2 0V5c0-.396.232-.753.594-.913l9-4a.999.999 0 0 1 .812 0l9 4A.999.999 0 0 1 20 5v14a1 1 0 0 1-1 1zM9 15a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414L9 12.586l3.293-3.293a.999.999 0 1 1 1.414 1.415l-4 4A.997.997 0 0 1 9 15z"
});

var SvgUpdateInventoryMajorTwotone = function SvgUpdateInventoryMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9p);
};

var _ref$9q =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 12.86h-5.59L18 7.269v5.591zM12.86 18H2V7.139h3.14v6.721c0 .55.45 1 1 1h6.72V18zM7.14 2h5.59L7.14 7.589V2zM18 4.44l-8.42 8.42H7.14v-2.44L15.56 2H18v2.44zM19 0H6.14c-.55 0-1 .45-1 1v4.139H1c-.55 0-1 .45-1 1V19c0 .549.45 1 1 1h12.86c.55 0 1-.451 1-1v-4.14H19c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
});

var SvgVariantMajorMonotone = function SvgVariantMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9q);
};

var _ref$9r =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M12.86 18H2V7.139h3.14v6.721c0 .55.45 1 1 1h6.72V18z"
});

var _ref2$2U =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M18 12.86h-5.59L18 7.269v5.591zM12.86 18H2V7.139h3.14v6.721c0 .55.45 1 1 1h6.72V18zM7.14 2h5.59L7.14 7.589V2zM18 4.44l-8.42 8.42H7.14v-2.44L15.56 2H18v2.44zM19 0H6.14c-.55 0-1 .45-1 1v4.139H1c-.55 0-1 .45-1 1V19c0 .549.45 1 1 1h12.86c.55 0 1-.451 1-1v-4.14H19c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"
});

var SvgVariantMajorTwotone = function SvgVariantMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9r, _ref2$2U);
};

var _ref$9s =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.962 9.725C19.94 9.648 17.666 2 10 2S.06 9.648.038 9.725c-.05.18-.05.37 0 .55C.06 10.352 2.334 18 10 18s9.94-7.648 9.962-7.725c.05-.18.05-.37 0-.55zM10 16c-5.467 0-7.512-4.772-7.948-6C2.488 8.772 4.532 4 10 4c5.47 0 7.514 4.776 7.948 6-.435 1.228-2.48 6-7.948 6zm0-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
  fill: undefined
});

var SvgViewMajorMonotone = function SvgViewMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9s);
};

var _ref$9t =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 13c-1.655 0-3-1.345-3-3s1.345-3 3-3 3 1.345 3 3-1.345 3-3 3"
});

var _ref2$2V =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.962 9.725C19.94 9.648 17.666 2 10 2S.06 9.648.038 9.725c-.05.18-.05.37 0 .55C.06 10.352 2.334 18 10 18s9.94-7.648 9.962-7.725c.05-.18.05-.37 0-.55zM10 16c-5.467 0-7.512-4.772-7.948-6C2.488 8.772 4.532 4 10 4c5.47 0 7.514 4.776 7.948 6-.435 1.228-2.48 6-7.948 6zm0-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
  fill: undefined
});

var SvgViewMajorTwotone = function SvgViewMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9t, _ref2$2V);
};

var _ref$9u =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.928 9.628C17.836 9.399 15.611 4 9.999 4S2.162 9.399 2.07 9.628a1.017 1.017 0 0 0 0 .744C2.162 10.601 4.387 16 9.999 16s7.837-5.399 7.929-5.628a1.017 1.017 0 0 0 0-.744zM9.999 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-6A2 2 0 1 0 10 12.001 2 2 0 0 0 10 8z",
  fill: undefined
});

var SvgViewMinor = function SvgViewMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9u);
};

var _ref$9v =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14.414 9H19a1 1 0 1 1 0 2h-4.586l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L14.414 9zM5.707 6.293l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L5.586 11H1a1 1 0 1 1 0-2h4.586L4.293 7.707a.999.999 0 1 1 1.414-1.414zM8 4a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V2H8v2zm4 12a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h4v-2z"
});

var SvgViewportNarrowMajorMonotone = function SvgViewportNarrowMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9v);
};

var _ref$9w =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M14.414 9H19a1 1 0 1 1 0 2h-4.586l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L14.414 9zM5.707 6.293l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L5.586 11H1a1 1 0 1 1 0-2h4.586L4.293 7.707a.999.999 0 1 1 1.414-1.414zM8 4a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V2H8v2zm4 12a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h4v-2z"
});

var SvgViewportNarrowMajorTwotone = function SvgViewportNarrowMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9w);
};

var _ref$9x =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.707 6.293l3 3a1 1 0 0 1 0 1.414l-3 3a.996.996 0 0 1-1.414 0 1 1 0 0 1 0-1.414L16.586 11H12a1 1 0 1 1 0-2h4.586l-1.293-1.293a1 1 0 0 1 1.414-1.414zm-12 0a1 1 0 0 1 0 1.414L3.414 9H8a1 1 0 1 1 0 2H3.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0zM19 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2H2v2a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h18zm0 15a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h16v-2a1 1 0 0 1 1-1z",
  fill: undefined
});

var SvgViewportWideMajorMonotone = function SvgViewportWideMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9x);
};

var _ref$9y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M16.707 6.293l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 11H12a1 1 0 1 1 0-2h4.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414zm-13.414 0a.999.999 0 1 1 1.414 1.414L3.414 9H8a1 1 0 1 1 0 2H3.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3zM1 0h18a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V2H2v2a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1zm17 16a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h16v-2z"
});

var SvgViewportWideMajorTwotone = function SvgViewportWideMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9y);
};

var _ref$9z =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 8H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm8 2h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2zM6 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 8H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2z",
  fill: undefined
});

var _ref2$2W =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 0h-7c-.768 0-1.469.29-2 .766A2.987 2.987 0 0 0 8 0H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h7a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1h7a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM9 16.179A2.959 2.959 0 0 0 8 16H2V2h6a1 1 0 0 1 1 1v13.179zM18 16h-6c-.352 0-.687.067-1 .179V3a1 1 0 0 1 1-1h6v14z",
  fill: undefined
});

var _ref3$2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 6h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2z",
  fill: undefined
});

var SvgVocabularyMajorMonotone = function SvgVocabularyMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9z, _ref2$2W, _ref3$2);
};

var _ref$9A =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 19a2 2 0 0 1 2-2h7V1h-7a2 2 0 0 0-2 2 2 2 0 0 0-2-2H1v16h7a2 2 0 0 1 2 2"
});

var _ref2$2X =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19 0h-7c-.768 0-1.469.29-2 .766A2.987 2.987 0 0 0 8 0H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h7a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1h7a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-1 16h-6c-.352 0-.687.067-1 .179V3a1 1 0 0 1 1-1h6v14zM8 16H2V2h6a1 1 0 0 1 1 1v13.179A2.959 2.959 0 0 0 8 16zM6 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m0 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m8-2h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2m0 4h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2m-8 2H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2"
});

var SvgVocabularyMajorTwotone = function SvgVocabularyMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9A, _ref2$2X);
};

var _ref$9B =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.707 3.293l-3-3a.999.999 0 0 0-1.414 0l-15 15a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0l15-15a.999.999 0 0 0 0-1.414zM16 5.586L14.414 4 16 2.414 17.586 4 16 5.586zm-12 12L2.414 16 13 5.414 14.586 7 4 17.586zM5 4c.551 0 1 .448 1 1a1 1 0 1 0 2 0c0-.552.449-1 1-1a1 1 0 1 0 0-2c-.551 0-1-.448-1-1a1 1 0 1 0-2 0c0 .552-.449 1-1 1a1 1 0 1 0 0 2m14 8c-.551 0-1-.448-1-1a1 1 0 1 0-2 0c0 .552-.449 1-1 1a1 1 0 1 0 0 2c.551 0 1 .448 1 1a1 1 0 1 0 2 0c0-.552.449-1 1-1a1 1 0 1 0 0-2"
});

var SvgWandMajorMonotone = function SvgWandMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9B);
};

var _ref$9C =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16 7l3-3-3-3-3 3z"
});

var _ref2$2Y =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M19.707 3.293l-3-3a.999.999 0 0 0-1.414 0l-15 15a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0l15-15a.999.999 0 0 0 0-1.414zM16 5.586L14.414 4 16 2.414 17.586 4 16 5.586zm-12 12L2.414 16 13 5.414 14.586 7 4 17.586zM5 4c.551 0 1 .448 1 1a1 1 0 1 0 2 0c0-.552.449-1 1-1a1 1 0 1 0 0-2c-.551 0-1-.448-1-1a1 1 0 1 0-2 0c0 .552-.449 1-1 1a1 1 0 1 0 0 2m14 8c-.551 0-1-.448-1-1a1 1 0 1 0-2 0c0 .552-.449 1-1 1a1 1 0 1 0 0 2c.551 0 1 .448 1 1a1 1 0 1 0 2 0c0-.552.449-1 1-1a1 1 0 1 0 0-2"
});

var SvgWandMajorTwotone = function SvgWandMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9C, _ref2$2Y);
};

var _ref$9D =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M16 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6zm-8 5h4v-2H8v2zM8 4h4V2H8v2zm7 0h-1V1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3H5C3.346 4 2 5.346 2 7v6c0 1.654 1.346 3 3 3h1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3h1c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z"
});

var SvgWearableMajorMonotone = function SvgWearableMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9D);
};

var _ref$9E =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M15 15H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2"
});

var _ref2$2Z =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M16 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6zm-8 5h4v-2H8v2zM8 4h4V2H8v2zm7 0h-1V1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3H5C3.346 4 2 5.346 2 7v6c0 1.654 1.346 3 3 3h1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3h1c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z"
});

var SvgWearableMajorTwotone = function SvgWearableMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9E, _ref2$2Z);
};

var _ref$9F =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: undefined,
  d: "M12 16c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm-9 0c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm0-8h2V6H3v2zm7.382-4l2 4H7V4h3.382zM9.184 14H5.816A2.996 2.996 0 0 0 3 12c-.353 0-.686.072-1 .184V10h11v2.184A2.962 2.962 0 0 0 12 12a2.996 2.996 0 0 0-2.816 2zM19 12h-2V3a1 1 0 0 0-2 0v6c0-.011-.006-.02-.006-.03-.002-.067-.024-.131-.04-.198-.016-.064-.024-.13-.051-.189-.005-.01-.004-.02-.008-.03l-3-6A1.001 1.001 0 0 0 11 2H6a1 1 0 0 0-1 1v1H2a1 1 0 0 0-1 1v3a1 1 0 0 0-1 1v6c0 1.654 1.346 3 3 3a2.996 2.996 0 0 0 2.816-2h3.369A2.993 2.993 0 0 0 12 18c1.654 0 3-1.346 3-3v-2a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2z"
});

var SvgWholesaleMajorMonotone = function SvgWholesaleMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9F);
};

var _ref$9G =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M6 9V3h5l3 6z"
});

var _ref2$2_ =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-9 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-8V6h2v2H3zm7.382-4l2 4H7V4h3.382zM9.184 14H5.816A2.997 2.997 0 0 0 3 12c-.353 0-.686.072-1 .184V10h11v2.184A2.962 2.962 0 0 0 12 12c-1.302 0-2.4.838-2.816 2zM19 12h-2V3a1 1 0 0 0-2 0v6c0-.01-.006-.02-.006-.03-.002-.067-.024-.13-.04-.198-.016-.064-.024-.13-.05-.19-.006-.01-.005-.02-.01-.03l-3-6A1 1 0 0 0 11 2H6a1 1 0 0 0-1 1v1H2a1 1 0 0 0-1 1v3a1 1 0 0 0-1 1v6c0 1.654 1.346 3 3 3 1.302 0 2.4-.838 2.816-2h3.37A2.991 2.991 0 0 0 12 18c1.654 0 3-1.346 3-3v-2a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2z",
  fill: undefined
});

var SvgWholesaleMajorTwotone = function SvgWholesaleMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9G, _ref2$2_);
};

var _ref$9H =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.004 18c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM1 8a.998.998 0 0 1-.607-1.795C3.104 4.138 6.517 3 10.004 3c3.486 0 6.898 1.137 9.606 3.202a1 1 0 1 1-1.213 1.59C16.036 5.991 13.055 5 10.004 5c-3.052 0-6.034.992-8.398 2.795A.989.989 0 0 1 1 8zm3 3a.998.998 0 0 1-.606-1.795C5.255 7.783 7.604 7 10.004 7c2.399 0 4.746.782 6.607 2.203a1 1 0 1 1-1.214 1.59C13.882 9.637 11.967 9 10.004 9c-1.964 0-3.88.638-5.396 1.795a.99.99 0 0 1-.606.205zm9.002 3a.995.995 0 0 1-.595-.197 4.058 4.058 0 0 0-4.808 0 1 1 0 0 1-1.193-1.606c2.11-1.565 5.083-1.566 7.193 0A1 1 0 0 1 13.003 14z"
});

var SvgWifiMajorMonotone = function SvgWifiMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9H);
};

var _ref$9I =
/*#__PURE__*/
React.createElement("path", {
  fill: undefined,
  d: "M10.004 18c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM1 8a.998.998 0 0 1-.607-1.795C3.104 4.138 6.517 3 10.004 3c3.486 0 6.898 1.137 9.606 3.202a1 1 0 1 1-1.213 1.59C16.036 5.991 13.055 5 10.004 5c-3.052 0-6.034.992-8.398 2.795A.989.989 0 0 1 1 8zm3 3a.998.998 0 0 1-.606-1.795C5.255 7.783 7.604 7 10.004 7c2.399 0 4.746.782 6.607 2.203a1 1 0 1 1-1.214 1.59C13.882 9.637 11.967 9 10.004 9c-1.964 0-3.88.638-5.396 1.795a.99.99 0 0 1-.606.205zm9.002 3a.995.995 0 0 1-.595-.197 4.058 4.058 0 0 0-4.808 0 1 1 0 0 1-1.193-1.606c2.11-1.565 5.083-1.566 7.193 0A1 1 0 0 1 13.003 14z"
});

var SvgWifiMajorTwotone = function SvgWifiMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref$9I);
}; // DO NOT MANUALLY EDIT THIS FILE


export { SvgAbandonedCartMajorMonotone as AbandonedCartMajorMonotone, SvgAbandonedCartMajorTwotone as AbandonedCartMajorTwotone, SvgAccessibilityMajorMonotone as AccessibilityMajorMonotone, SvgAccessibilityMajorTwotone as AccessibilityMajorTwotone, SvgActivitiesMajorMonotone as ActivitiesMajorMonotone, SvgActivitiesMajorTwotone as ActivitiesMajorTwotone, SvgAddMajorMonotone as AddMajorMonotone, SvgAddMajorTwotone as AddMajorTwotone, SvgAddCodeMajorMonotone as AddCodeMajorMonotone, SvgAddCodeMajorTwotone as AddCodeMajorTwotone, SvgAddImageMajorMonotone as AddImageMajorMonotone, SvgAddImageMajorTwotone as AddImageMajorTwotone, SvgAddNoteMajorMonotone as AddNoteMajorMonotone, SvgAddNoteMajorTwotone as AddNoteMajorTwotone, SvgAddProductMajorMonotone as AddProductMajorMonotone, SvgAddProductMajorTwotone as AddProductMajorTwotone, SvgAffiliateMajorMonotone as AffiliateMajorMonotone, SvgAffiliateMajorTwotone as AffiliateMajorTwotone, SvgAlertMinor as AlertMinor, SvgAnalyticsMajorMonotone as AnalyticsMajorMonotone, SvgAnalyticsMajorTwotone as AnalyticsMajorTwotone, SvgAppExtensionMinor as AppExtensionMinor, SvgAppsMajorMonotone as AppsMajorMonotone, SvgAppsMajorTwotone as AppsMajorTwotone, SvgArchiveMajorMonotone as ArchiveMajorMonotone, SvgArchiveMajorTwotone as ArchiveMajorTwotone, SvgArchiveMinor as ArchiveMinor, SvgArrowDownMinor as ArrowDownMinor, SvgArrowLeftMinor as ArrowLeftMinor, SvgArrowRightMinor as ArrowRightMinor, SvgArrowUpMinor as ArrowUpMinor, SvgAttachmentMajorMonotone as AttachmentMajorMonotone, SvgAttachmentMajorTwotone as AttachmentMajorTwotone, SvgBackspaceMajorMonotone as BackspaceMajorMonotone, SvgBackspaceMajorTwotone as BackspaceMajorTwotone, SvgBalanceMajorMonotone as BalanceMajorMonotone, SvgBalanceMajorTwotone as BalanceMajorTwotone, SvgBankMajorMonotone as BankMajorMonotone, SvgBankMajorTwotone as BankMajorTwotone, SvgBarcodeMajorMonotone as BarcodeMajorMonotone, SvgBarcodeMajorTwotone as BarcodeMajorTwotone, SvgBehaviorMajorMonotone as BehaviorMajorMonotone, SvgBehaviorMajorTwotone as BehaviorMajorTwotone, SvgBillingStatementDollarMajorMonotone as BillingStatementDollarMajorMonotone, SvgBillingStatementDollarMajorTwotone as BillingStatementDollarMajorTwotone, SvgBillingStatementEuroMajorMonotone as BillingStatementEuroMajorMonotone, SvgBillingStatementEuroMajorTwotone as BillingStatementEuroMajorTwotone, SvgBillingStatementPoundMajorMonotone as BillingStatementPoundMajorMonotone, SvgBillingStatementPoundMajorTwotone as BillingStatementPoundMajorTwotone, SvgBillingStatementRupeeMajorMonotone as BillingStatementRupeeMajorMonotone, SvgBillingStatementRupeeMajorTwotone as BillingStatementRupeeMajorTwotone, SvgBillingStatementYenMajorMonotone as BillingStatementYenMajorMonotone, SvgBillingStatementYenMajorTwotone as BillingStatementYenMajorTwotone, SvgBlockquoteMajorMonotone as BlockquoteMajorMonotone, SvgBlockquoteMajorTwotone as BlockquoteMajorTwotone, SvgBlogMajorMonotone as BlogMajorMonotone, SvgBlogMajorTwotone as BlogMajorTwotone, SvgBugMajorMonotone as BugMajorMonotone, SvgBugMajorTwotone as BugMajorTwotone, SvgBuyButtonMajorMonotone as BuyButtonMajorMonotone, SvgBuyButtonMajorTwotone as BuyButtonMajorTwotone, SvgBuyButtonButtonLayoutMajorMonotone as BuyButtonButtonLayoutMajorMonotone, SvgBuyButtonButtonLayoutMajorTwotone as BuyButtonButtonLayoutMajorTwotone, SvgBuyButtonHorizontalLayoutMajorMonotone as BuyButtonHorizontalLayoutMajorMonotone, SvgBuyButtonHorizontalLayoutMajorTwotone as BuyButtonHorizontalLayoutMajorTwotone, SvgBuyButtonVerticalLayoutMajorMonotone as BuyButtonVerticalLayoutMajorMonotone, SvgBuyButtonVerticalLayoutMajorTwotone as BuyButtonVerticalLayoutMajorTwotone, SvgCalendarMajorMonotone as CalendarMajorMonotone, SvgCalendarMajorTwotone as CalendarMajorTwotone, SvgCalendarMinor as CalendarMinor, SvgCalendarTickMajorMonotone as CalendarTickMajorMonotone, SvgCalendarTickMajorTwotone as CalendarTickMajorTwotone, SvgCameraMajorMonotone as CameraMajorMonotone, SvgCameraMajorTwotone as CameraMajorTwotone, SvgCancelSmallMinor as CancelSmallMinor, SvgCapturePaymentMinor as CapturePaymentMinor, SvgCardReaderMajorMonotone as CardReaderMajorMonotone, SvgCardReaderMajorTwotone as CardReaderMajorTwotone, SvgCardReaderChipMajorMonotone as CardReaderChipMajorMonotone, SvgCardReaderChipMajorTwotone as CardReaderChipMajorTwotone, SvgCardReaderTapMajorMonotone as CardReaderTapMajorMonotone, SvgCardReaderTapMajorTwotone as CardReaderTapMajorTwotone, SvgCaretDownMinor as CaretDownMinor, SvgCaretUpMinor as CaretUpMinor, SvgCartMajorMonotone as CartMajorMonotone, SvgCartMajorTwotone as CartMajorTwotone, SvgCartDownMajorMonotone as CartDownMajorMonotone, SvgCartDownMajorTwotone as CartDownMajorTwotone, SvgCartUpMajorMonotone as CartUpMajorMonotone, SvgCartUpMajorTwotone as CartUpMajorTwotone, SvgCashDollarMajorMonotone as CashDollarMajorMonotone, SvgCashDollarMajorTwotone as CashDollarMajorTwotone, SvgCashEuroMajorMonotone as CashEuroMajorMonotone, SvgCashEuroMajorTwotone as CashEuroMajorTwotone, SvgCashPoundMajorMonotone as CashPoundMajorMonotone, SvgCashPoundMajorTwotone as CashPoundMajorTwotone, SvgCashRupeeMajorMonotone as CashRupeeMajorMonotone, SvgCashRupeeMajorTwotone as CashRupeeMajorTwotone, SvgCashYenMajorMonotone as CashYenMajorMonotone, SvgCashYenMajorTwotone as CashYenMajorTwotone, SvgCategoriesMajorMonotone as CategoriesMajorMonotone, SvgCategoriesMajorTwotone as CategoriesMajorTwotone, SvgChannelsMajorMonotone as ChannelsMajorMonotone, SvgChannelsMajorTwotone as ChannelsMajorTwotone, SvgChatMajorMonotone as ChatMajorMonotone, SvgChatMajorTwotone as ChatMajorTwotone, SvgChecklistMajorMonotone as ChecklistMajorMonotone, SvgChecklistMajorTwotone as ChecklistMajorTwotone, SvgChecklistAlternateMajorMonotone as ChecklistAlternateMajorMonotone, SvgChecklistAlternateMajorTwotone as ChecklistAlternateMajorTwotone, SvgCheckoutMajorMonotone as CheckoutMajorMonotone, SvgCheckoutMajorTwotone as CheckoutMajorTwotone, SvgChevronDownMinor as ChevronDownMinor, SvgChevronLeftMinor as ChevronLeftMinor, SvgChevronRightMinor as ChevronRightMinor, SvgChevronUpMinor as ChevronUpMinor, SvgCircleAlertMajorMonotone as CircleAlertMajorMonotone, SvgCircleAlertMajorTwotone as CircleAlertMajorTwotone, SvgCircleCancelMajorMonotone as CircleCancelMajorMonotone, SvgCircleCancelMajorTwotone as CircleCancelMajorTwotone, SvgCircleCancelMinor as CircleCancelMinor, SvgCircleChevronDownMinor as CircleChevronDownMinor, SvgCircleChevronLeftMinor as CircleChevronLeftMinor, SvgCircleChevronRightMinor as CircleChevronRightMinor, SvgCircleChevronUpMinor as CircleChevronUpMinor, SvgCircleDisableMinor as CircleDisableMinor, SvgCircleDisabledMajorMonotone as CircleDisabledMajorMonotone, SvgCircleDisabledMajorTwotone as CircleDisabledMajorTwotone, SvgCircleDotsMajorMonotone as CircleDotsMajorMonotone, SvgCircleDotsMajorTwotone as CircleDotsMajorTwotone, SvgCircleDownMajorMonotone as CircleDownMajorMonotone, SvgCircleDownMajorTwotone as CircleDownMajorTwotone, SvgCircleInformationMajorMonotone as CircleInformationMajorMonotone, SvgCircleInformationMajorTwotone as CircleInformationMajorTwotone, SvgCircleLeftMajorMonotone as CircleLeftMajorMonotone, SvgCircleLeftMajorTwotone as CircleLeftMajorTwotone, SvgCircleMinusMajorMonotone as CircleMinusMajorMonotone, SvgCircleMinusMajorTwotone as CircleMinusMajorTwotone, SvgCircleMinusMinor as CircleMinusMinor, SvgCircleMinusOutlineMinor as CircleMinusOutlineMinor, SvgCirclePlusMajorMonotone as CirclePlusMajorMonotone, SvgCirclePlusMajorTwotone as CirclePlusMajorTwotone, SvgCirclePlusMinor as CirclePlusMinor, SvgCirclePlusOutlineMinor as CirclePlusOutlineMinor, SvgCircleRightMajorMonotone as CircleRightMajorMonotone, SvgCircleRightMajorTwotone as CircleRightMajorTwotone, SvgCircleTickMajorMonotone as CircleTickMajorMonotone, SvgCircleTickMajorTwotone as CircleTickMajorTwotone, SvgCircleTickOutlineMinor as CircleTickOutlineMinor, SvgCircleUpMajorMonotone as CircleUpMajorMonotone, SvgCircleUpMajorTwotone as CircleUpMajorTwotone, SvgClipboardMinor as ClipboardMinor, SvgClockMajorMonotone as ClockMajorMonotone, SvgClockMajorTwotone as ClockMajorTwotone, SvgClockMinor as ClockMinor, SvgCodeMajorMonotone as CodeMajorMonotone, SvgCodeMajorTwotone as CodeMajorTwotone, SvgCollectionsMajorMonotone as CollectionsMajorMonotone, SvgCollectionsMajorTwotone as CollectionsMajorTwotone, SvgColorNoneMinor as ColorNoneMinor, SvgColorsMajorMonotone as ColorsMajorMonotone, SvgColorsMajorMonotone as ColorMajorMonotone, SvgColorsMajorTwotone as ColorsMajorTwotone, SvgColumnWithTextMajorMonotone as ColumnWithTextMajorMonotone, SvgColumnWithTextMajorTwotone as ColumnWithTextMajorTwotone, SvgConfettiMajorMonotone as ConfettiMajorMonotone, SvgConfettiMajorTwotone as ConfettiMajorTwotone, SvgConnectMinor as ConnectMinor, SvgConversationMinor as ConversationMinor, SvgCreditCardMajorMonotone as CreditCardMajorMonotone, SvgCreditCardMajorTwotone as CreditCardMajorTwotone, SvgCreditCardPercentMajorMonotone as CreditCardPercentMajorMonotone, SvgCreditCardPercentMajorTwotone as CreditCardPercentMajorTwotone, SvgCreditCardSecureMajorMonotone as CreditCardSecureMajorMonotone, SvgCreditCardSecureMajorTwotone as CreditCardSecureMajorTwotone, SvgCurrencyConvertMinor as CurrencyConvertMinor, SvgCustomerMinusMajorMonotone as CustomerMinusMajorMonotone, SvgCustomerMinusMajorTwotone as CustomerMinusMajorTwotone, SvgCustomerPlusMajorMonotone as CustomerPlusMajorMonotone, SvgCustomerPlusMajorTwotone as CustomerPlusMajorTwotone, SvgCustomersMajorMonotone as CustomersMajorMonotone, SvgCustomersMajorTwotone as CustomersMajorTwotone, SvgDataVisualizationMajorMonotone as DataVisualizationMajorMonotone, SvgDataVisualizationMajorTwotone as DataVisualizationMajorTwotone, SvgDeleteMajorMonotone as DeleteMajorMonotone, SvgDeleteMajorTwotone as DeleteMajorTwotone, SvgDeleteMinor as DeleteMinor, SvgDesktopMajorMonotone as DesktopMajorMonotone, SvgDesktopMajorTwotone as DesktopMajorTwotone, SvgDigitalMediaReceiverMajorMonotone as DigitalMediaReceiverMajorMonotone, SvgDigitalMediaReceiverMajorTwotone as DigitalMediaReceiverMajorTwotone, SvgDiscountAutomaticMajorMonotone as DiscountAutomaticMajorMonotone, SvgDiscountAutomaticMajorTwotone as DiscountAutomaticMajorTwotone, SvgDiscountCodeMajorMonotone as DiscountCodeMajorMonotone, SvgDiscountCodeMajorTwotone as DiscountCodeMajorTwotone, SvgDiscountsMajorMonotone as DiscountsMajorMonotone, SvgDiscountsMajorTwotone as DiscountsMajorTwotone, SvgDisputeMinor as DisputeMinor, SvgDnsSettingsMajorMonotone as DnsSettingsMajorMonotone, SvgDnsSettingsMajorTwotone as DnsSettingsMajorTwotone, SvgDomainNewMajorMonotone as DomainNewMajorMonotone, SvgDomainNewMajorTwotone as DomainNewMajorTwotone, SvgDomainsMajorMonotone as DomainsMajorMonotone, SvgDomainsMajorTwotone as DomainsMajorTwotone, SvgDraftOrdersMajorMonotone as DraftOrdersMajorMonotone, SvgDraftOrdersMajorTwotone as DraftOrdersMajorTwotone, SvgDragDropMajorMonotone as DragDropMajorMonotone, SvgDragDropMajorTwotone as DragDropMajorTwotone, SvgDragHandleMinor as DragHandleMinor, SvgDropdownMinor as DropdownMinor, SvgDuplicateMinor as DuplicateMinor, SvgEditMajorMonotone as EditMajorMonotone, SvgEditMajorTwotone as EditMajorTwotone, SvgEditMinor as EditMinor, SvgEmailMajorMonotone as EmailMajorMonotone, SvgEmailMajorTwotone as EmailMajorTwotone, SvgEmailNewsletterMajorMonotone as EmailNewsletterMajorMonotone, SvgEmailNewsletterMajorTwotone as EmailNewsletterMajorTwotone, SvgEmbedMinor as EmbedMinor, SvgEnableSelectionMinor as EnableSelectionMinor, SvgEnvelopeMajorMonotone as EnvelopeMajorMonotone, SvgEnvelopeMajorTwotone as EnvelopeMajorTwotone, SvgExchangeMajorMonotone as ExchangeMajorMonotone, SvgExchangeMajorTwotone as ExchangeMajorTwotone, SvgExistingInventoryMajorMonotone as ExistingInventoryMajorMonotone, SvgExistingInventoryMajorTwotone as ExistingInventoryMajorTwotone, SvgExportMinor as ExportMinor, SvgExternalMinor as ExternalMinor, SvgExternalSmallMinor as ExternalSmallMinor, SvgFaviconMajorMonotone as FaviconMajorMonotone, SvgFaviconMajorTwotone as FaviconMajorTwotone, SvgFavouriteMajorMonotone as FavouriteMajorMonotone, SvgFavouriteMajorTwotone as FavouriteMajorTwotone, SvgFeaturedCollectionMajorMonotone as FeaturedCollectionMajorMonotone, SvgFeaturedCollectionMajorTwotone as FeaturedCollectionMajorTwotone, SvgFeaturedContentMajorMonotone as FeaturedContentMajorMonotone, SvgFeaturedContentMajorTwotone as FeaturedContentMajorTwotone, SvgFilterMajorMonotone as FilterMajorMonotone, SvgFilterMajorTwotone as FilterMajorTwotone, SvgFirstOrderMajorMonotone as FirstOrderMajorMonotone, SvgFirstOrderMajorTwotone as FirstOrderMajorTwotone, SvgFirstVisitMajorMonotone as FirstVisitMajorMonotone, SvgFirstVisitMajorTwotone as FirstVisitMajorTwotone, SvgFlagMajorMonotone as FlagMajorMonotone, SvgFlagMajorTwotone as FlagMajorTwotone, SvgFlipCameraMajorMonotone as FlipCameraMajorMonotone, SvgFlipCameraMajorTwotone as FlipCameraMajorTwotone, SvgFolderMajorMonotone as FolderMajorMonotone, SvgFolderMajorTwotone as FolderMajorTwotone, SvgFolderDownMajorMonotone as FolderDownMajorMonotone, SvgFolderDownMajorTwotone as FolderDownMajorTwotone, SvgFolderMinusMajorMonotone as FolderMinusMajorMonotone, SvgFolderMinusMajorTwotone as FolderMinusMajorTwotone, SvgFolderPlusMajorMonotone as FolderPlusMajorMonotone, SvgFolderPlusMajorTwotone as FolderPlusMajorTwotone, SvgFolderUpMajorMonotone as FolderUpMajorMonotone, SvgFolderUpMajorTwotone as FolderUpMajorTwotone, SvgFollowUpEmailMajorMonotone as FollowUpEmailMajorMonotone, SvgFollowUpEmailMajorTwotone as FollowUpEmailMajorTwotone, SvgFoodMajorMonotone as FoodMajorMonotone, SvgFoodMajorTwotone as FoodMajorTwotone, SvgFooterMajorMonotone as FooterMajorMonotone, SvgFooterMajorTwotone as FooterMajorTwotone, SvgFormsMajorMonotone as FormsMajorMonotone, SvgFormsMajorTwotone as FormsMajorTwotone, SvgGamesConsoleMajorMonotone as GamesConsoleMajorMonotone, SvgGamesConsoleMajorTwotone as GamesConsoleMajorTwotone, SvgGiftCardMajorMonotone as GiftCardMajorMonotone, SvgGiftCardMajorTwotone as GiftCardMajorTwotone, SvgGiftCardMinor as GiftCardMinor, SvgGlobeMajorMonotone as GlobeMajorMonotone, SvgGlobeMajorTwotone as GlobeMajorTwotone, SvgGlobeMinor as GlobeMinor, SvgGrammarMajorMonotone as GrammarMajorMonotone, SvgGrammarMajorTwotone as GrammarMajorTwotone, SvgHashtagMajorMonotone as HashtagMajorMonotone, SvgHashtagMajorTwotone as HashtagMajorTwotone, SvgHeaderMajorMonotone as HeaderMajorMonotone, SvgHeaderMajorTwotone as HeaderMajorTwotone, SvgHeartMajorMonotone as HeartMajorMonotone, SvgHeartMajorTwotone as HeartMajorTwotone, SvgHideMinor as HideMinor, SvgHideKeyboardMajorMonotone as HideKeyboardMajorMonotone, SvgHideKeyboardMajorTwotone as HideKeyboardMajorTwotone, SvgHintMajorMonotone as HintMajorMonotone, SvgHintMajorTwotone as HintMajorTwotone, SvgHomeMajorMonotone as HomeMajorMonotone, SvgHomeMajorTwotone as HomeMajorTwotone, SvgHorizontalDotsMinor as HorizontalDotsMinor, SvgIconsMajorMonotone as IconsMajorMonotone, SvgIconsMajorTwotone as IconsMajorTwotone, SvgIllustrationMajorMonotone as IllustrationMajorMonotone, SvgIllustrationMajorTwotone as IllustrationMajorTwotone, SvgImageMajorMonotone as ImageMajorMonotone, SvgImageMajorTwotone as ImageMajorTwotone, SvgImageAltMajorMonotone as ImageAltMajorMonotone, SvgImageAltMajorTwotone as ImageAltMajorTwotone, SvgImageAltMinor as ImageAltMinor, SvgImageWithTextMajorMonotone as ImageWithTextMajorMonotone, SvgImageWithTextMajorTwotone as ImageWithTextMajorTwotone, SvgImageWithTextOverlayMajorMonotone as ImageWithTextOverlayMajorMonotone, SvgImageWithTextOverlayMajorTwotone as ImageWithTextOverlayMajorTwotone, SvgImagesMajorMonotone as ImagesMajorMonotone, SvgImagesMajorTwotone as ImagesMajorTwotone, SvgImportMinor as ImportMinor, SvgImportStoreMajorMonotone as ImportStoreMajorMonotone, SvgImportStoreMajorTwotone as ImportStoreMajorTwotone, SvgIncomingMajorMonotone as IncomingMajorMonotone, SvgIncomingMajorTwotone as IncomingMajorTwotone, SvgInfoMinor as InfoMinor, SvgInstallMinor as InstallMinor, SvgInventoryMajorMonotone as InventoryMajorMonotone, SvgInventoryMajorTwotone as InventoryMajorTwotone, SvgInviteMinor as InviteMinor, SvgIqMajorMonotone as IqMajorMonotone, SvgIqMajorTwotone as IqMajorTwotone, SvgJobsMajorMonotone as JobsMajorMonotone, SvgJobsMajorTwotone as JobsMajorTwotone, SvgKeyMajorMonotone as KeyMajorMonotone, SvgKeyMajorTwotone as KeyMajorTwotone, SvgLabelPrinterMajorMonotone as LabelPrinterMajorMonotone, SvgLabelPrinterMajorTwotone as LabelPrinterMajorTwotone, SvgLandingPageMajorMonotone as LandingPageMajorMonotone, SvgLandingPageMajorTwotone as LandingPageMajorTwotone, SvgLanguageMinor as LanguageMinor, SvgLegalMajorMonotone as LegalMajorMonotone, SvgLegalMajorTwotone as LegalMajorTwotone, SvgLinkMinor as LinkMinor, SvgListMajorMonotone as ListMajorMonotone, SvgListMajorTwotone as ListMajorTwotone, SvgLiveViewMajorMonotone as LiveViewMajorMonotone, SvgLiveViewMajorTwotone as LiveViewMajorTwotone, SvgLocationMajorMonotone as LocationMajorMonotone, SvgLocationMajorTwotone as LocationMajorTwotone, SvgLocationsMinor as LocationsMinor, SvgLockMajorMonotone as LockMajorMonotone, SvgLockMajorTwotone as LockMajorTwotone, SvgLockMinor as LockMinor, SvgLogOutMinor as LogOutMinor, SvgLogoBlockMajorMonotone as LogoBlockMajorMonotone, SvgLogoBlockMajorTwotone as LogoBlockMajorTwotone, SvgManagedStoreMajorMonotone as ManagedStoreMajorMonotone, SvgManagedStoreMajorTwotone as ManagedStoreMajorTwotone, SvgMarkFulfilledMinor as MarkFulfilledMinor, SvgMarkPaidMinor as MarkPaidMinor, SvgMarketingMajorMonotone as MarketingMajorMonotone, SvgMarketingMajorTwotone as MarketingMajorTwotone, SvgMaximizeMajorMonotone as MaximizeMajorMonotone, SvgMaximizeMajorTwotone as MaximizeMajorTwotone, SvgMaximizeMinor as MaximizeMinor, SvgMentionMajorMonotone as MentionMajorMonotone, SvgMentionMajorTwotone as MentionMajorTwotone, SvgMicrophoneMajorMonotone as MicrophoneMajorMonotone, SvgMicrophoneMajorTwotone as MicrophoneMajorTwotone, SvgMinimizeMajorMonotone as MinimizeMajorMonotone, SvgMinimizeMajorTwotone as MinimizeMajorTwotone, SvgMinimizeMinor as MinimizeMinor, SvgMinusMinor as MinusMinor, SvgMobileMajorMonotone as MobileMajorMonotone, SvgMobileMajorTwotone as MobileMajorTwotone, SvgMobileAcceptMajorMonotone as MobileAcceptMajorMonotone, SvgMobileAcceptMajorTwotone as MobileAcceptMajorTwotone, SvgMobileBackArrowMajorMonotone as MobileBackArrowMajorMonotone, SvgMobileBackArrowMajorTwotone as MobileBackArrowMajorTwotone, SvgMobileCancelMajorMonotone as MobileCancelMajorMonotone, SvgMobileCancelMajorTwotone as MobileCancelMajorTwotone, SvgMobileChevronMajorMonotone as MobileChevronMajorMonotone, SvgMobileChevronMajorTwotone as MobileChevronMajorTwotone, SvgMobileHamburgerMajorMonotone as MobileHamburgerMajorMonotone, SvgMobileHamburgerMajorTwotone as MobileHamburgerMajorTwotone, SvgMobileHorizontalDotsMajorMonotone as MobileHorizontalDotsMajorMonotone, SvgMobileHorizontalDotsMajorTwotone as MobileHorizontalDotsMajorTwotone, SvgMobilePlusMajorMonotone as MobilePlusMajorMonotone, SvgMobilePlusMajorTwotone as MobilePlusMajorTwotone, SvgMobileVerticalDotsMajorMonotone as MobileVerticalDotsMajorMonotone, SvgMobileVerticalDotsMajorTwotone as MobileVerticalDotsMajorTwotone, SvgMonerisMajorMonotone as MonerisMajorMonotone, SvgMonerisMajorTwotone as MonerisMajorTwotone, SvgNatureMajorMonotone as NatureMajorMonotone, SvgNatureMajorTwotone as NatureMajorTwotone, SvgNavigationMajorMonotone as NavigationMajorMonotone, SvgNavigationMajorTwotone as NavigationMajorTwotone, SvgNoteMajorMonotone as NoteMajorMonotone, SvgNoteMajorTwotone as NoteMajorTwotone, SvgNoteMinor as NoteMinor, SvgNotesMinor as NotesMinor, SvgNotificationMajorMonotone as NotificationMajorMonotone, SvgNotificationMajorTwotone as NotificationMajorTwotone, SvgOnlineStoreMajorMonotone as OnlineStoreMajorMonotone, SvgOnlineStoreMajorTwotone as OnlineStoreMajorTwotone, SvgOrderStatusMinor as OrderStatusMinor, SvgOrdersMajorMonotone as OrdersMajorMonotone, SvgOrdersMajorTwotone as OrdersMajorTwotone, SvgOutgoingMajorMonotone as OutgoingMajorMonotone, SvgOutgoingMajorTwotone as OutgoingMajorTwotone, SvgPackageMajorMonotone as PackageMajorMonotone, SvgPackageMajorTwotone as PackageMajorTwotone, SvgPageMajorMonotone as PageMajorMonotone, SvgPageMajorTwotone as PageMajorTwotone, SvgPageDownMajorMonotone as PageDownMajorMonotone, SvgPageDownMajorTwotone as PageDownMajorTwotone, SvgPageMinusMajorMonotone as PageMinusMajorMonotone, SvgPageMinusMajorTwotone as PageMinusMajorTwotone, SvgPagePlusMajorMonotone as PagePlusMajorMonotone, SvgPagePlusMajorTwotone as PagePlusMajorTwotone, SvgPageUpMajorMonotone as PageUpMajorMonotone, SvgPageUpMajorTwotone as PageUpMajorTwotone, SvgPaginationEndMinor as PaginationEndMinor, SvgPaginationStartMinor as PaginationStartMinor, SvgPaintBrushMajorMonotone as PaintBrushMajorMonotone, SvgPaintBrushMajorTwotone as PaintBrushMajorTwotone, SvgPauseMajorMonotone as PauseMajorMonotone, SvgPauseMajorTwotone as PauseMajorTwotone, SvgPauseMinor as PauseMinor, SvgPauseCircleMajorMonotone as PauseCircleMajorMonotone, SvgPauseCircleMajorTwotone as PauseCircleMajorTwotone, SvgPaymentsMajorMonotone as PaymentsMajorMonotone, SvgPaymentsMajorTwotone as PaymentsMajorTwotone, SvgPhoneMajorMonotone as PhoneMajorMonotone, SvgPhoneMajorTwotone as PhoneMajorTwotone, SvgPhoneInMajorMonotone as PhoneInMajorMonotone, SvgPhoneInMajorTwotone as PhoneInMajorTwotone, SvgPhoneOutMajorMonotone as PhoneOutMajorMonotone, SvgPhoneOutMajorTwotone as PhoneOutMajorTwotone, SvgPinMajorMonotone as PinMajorMonotone, SvgPinMajorTwotone as PinMajorTwotone, SvgPinMinor as PinMinor, SvgPlayMajorMonotone as PlayMajorMonotone, SvgPlayMajorTwotone as PlayMajorTwotone, SvgPlayMinor as PlayMinor, SvgPlayCircleMajorMonotone as PlayCircleMajorMonotone, SvgPlayCircleMajorTwotone as PlayCircleMajorTwotone, SvgPlusMinor as PlusMinor, SvgPointOfSaleMajorMonotone as PointOfSaleMajorMonotone, SvgPointOfSaleMajorTwotone as PointOfSaleMajorTwotone, SvgPopularMajorMonotone as PopularMajorMonotone, SvgPopularMajorTwotone as PopularMajorTwotone, SvgPriceLookupMinor as PriceLookupMinor, SvgPrintMajorMonotone as PrintMajorMonotone, SvgPrintMajorTwotone as PrintMajorTwotone, SvgPrintMinor as PrintMinor, SvgProductsMajorMonotone as ProductsMajorMonotone, SvgProductsMajorTwotone as ProductsMajorTwotone, SvgProfileMajorMonotone as ProfileMajorMonotone, SvgProfileMajorTwotone as ProfileMajorTwotone, SvgProfileMinor as ProfileMinor, SvgPromoteMinor as PromoteMinor, SvgQuestionMarkMajorMonotone as QuestionMarkMajorMonotone, SvgQuestionMarkMajorTwotone as QuestionMarkMajorTwotone, SvgQuestionMarkMinor as QuestionMarkMinor, SvgQuickSaleMajorMonotone as QuickSaleMajorMonotone, SvgQuickSaleMajorTwotone as QuickSaleMajorTwotone, SvgReadTimeMinor as ReadTimeMinor, SvgReceiptMajorMonotone as ReceiptMajorMonotone, SvgReceiptMajorTwotone as ReceiptMajorTwotone, SvgRecentSearchesMajorMonotone as RecentSearchesMajorMonotone, SvgRecentSearchesMajorTwotone as RecentSearchesMajorTwotone, SvgRedoMajorMonotone as RedoMajorMonotone, SvgRedoMajorTwotone as RedoMajorTwotone, SvgRefreshMajorMonotone as RefreshMajorMonotone, SvgRefreshMajorTwotone as RefreshMajorTwotone, SvgRefreshMinor as RefreshMinor, SvgRefundMajorMonotone as RefundMajorMonotone, SvgRefundMajorTwotone as RefundMajorTwotone, SvgRefundMinor as RefundMinor, SvgRemoveProductMajorMonotone as RemoveProductMajorMonotone, SvgRemoveProductMajorTwotone as RemoveProductMajorTwotone, SvgRepeatOrderMajorMonotone as RepeatOrderMajorMonotone, SvgRepeatOrderMajorTwotone as RepeatOrderMajorTwotone, SvgReplaceMajorMonotone as ReplaceMajorMonotone, SvgReplaceMajorTwotone as ReplaceMajorTwotone, SvgReplayMinor as ReplayMinor, SvgReportMinor as ReportMinor, SvgReportsMajorMonotone as ReportsMajorMonotone, SvgReportsMajorTwotone as ReportsMajorTwotone, SvgResetMinor as ResetMinor, SvgResourcesMajorMonotone as ResourcesMajorMonotone, SvgResourcesMajorTwotone as ResourcesMajorTwotone, SvgReturnMinor as ReturnMinor, SvgRiskMajorMonotone as RiskMajorMonotone, SvgRiskMajorTwotone as RiskMajorTwotone, SvgRiskMinor as RiskMinor, SvgSandboxMajorMonotone as SandboxMajorMonotone, SvgSandboxMajorTwotone as SandboxMajorTwotone, SvgSaveMinor as SaveMinor, SvgSearchMajorMonotone as SearchMajorMonotone, SvgSearchMajorTwotone as SearchMajorTwotone, SvgSearchMinor as SearchMinor, SvgSectionMajorMonotone as SectionMajorMonotone, SvgSectionMajorTwotone as SectionMajorTwotone, SvgSecureMajorMonotone as SecureMajorMonotone, SvgSecureMajorTwotone as SecureMajorTwotone, SvgSelectMinor as SelectMinor, SvgSelectMinor as ArrowUpDownMinor, SvgSendMajorMonotone as SendMajorMonotone, SvgSendMajorTwotone as SendMajorTwotone, SvgSettingsMajorMonotone as SettingsMajorMonotone, SvgSettingsMajorTwotone as SettingsMajorTwotone, SvgSettingsMinor as SettingsMinor, SvgShareMinor as ShareMinor, SvgShareIosMinor as ShareIosMinor, SvgShipmentMajorMonotone as ShipmentMajorMonotone, SvgShipmentMajorTwotone as ShipmentMajorTwotone, SvgShopcodesMajorMonotone as ShopcodesMajorMonotone, SvgShopcodesMajorTwotone as ShopcodesMajorTwotone, SvgSidebarLeftMajorMonotone as SidebarLeftMajorMonotone, SvgSidebarLeftMajorMonotone as SidebarMajorMonotone, SvgSidebarLeftMajorTwotone as SidebarLeftMajorTwotone, SvgSidebarRightMajorMonotone as SidebarRightMajorMonotone, SvgSidebarRightMajorTwotone as SidebarRightMajorTwotone, SvgSlideshowMajorMonotone as SlideshowMajorMonotone, SvgSlideshowMajorTwotone as SlideshowMajorTwotone, SvgSmileyHappyMajorMonotone as SmileyHappyMajorMonotone, SvgSmileyHappyMajorTwotone as SmileyHappyMajorTwotone, SvgSmileyJoyMajorMonotone as SmileyJoyMajorMonotone, SvgSmileyJoyMajorTwotone as SmileyJoyMajorTwotone, SvgSmileyNeutralMajorMonotone as SmileyNeutralMajorMonotone, SvgSmileyNeutralMajorTwotone as SmileyNeutralMajorTwotone, SvgSmileySadMajorMonotone as SmileySadMajorMonotone, SvgSmileySadMajorTwotone as SmileySadMajorTwotone, SvgSocialAdMajorMonotone as SocialAdMajorMonotone, SvgSocialAdMajorTwotone as SocialAdMajorTwotone, SvgSocialPostMajorMonotone as SocialPostMajorMonotone, SvgSocialPostMajorTwotone as SocialPostMajorTwotone, SvgSoftPackMajorMonotone as SoftPackMajorMonotone, SvgSoftPackMajorTwotone as SoftPackMajorTwotone, SvgSortMinor as SortMinor, SvgSortAscendingMajorMonotone as SortAscendingMajorMonotone, SvgSortAscendingMajorTwotone as SortAscendingMajorTwotone, SvgSortDescendingMajorMonotone as SortDescendingMajorMonotone, SvgSortDescendingMajorTwotone as SortDescendingMajorTwotone, SvgSoundMajorMonotone as SoundMajorMonotone, SvgSoundMajorTwotone as SoundMajorTwotone, SvgStarFilledMinor as StarFilledMinor, SvgStarOutlineMinor as StarOutlineMinor, SvgStoreMajorMonotone as StoreMajorMonotone, SvgStoreMajorTwotone as StoreMajorTwotone, SvgStoreStatusMajorMonotone as StoreStatusMajorMonotone, SvgStoreStatusMajorTwotone as StoreStatusMajorTwotone, SvgTabletMajorMonotone as TabletMajorMonotone, SvgTabletMajorTwotone as TabletMajorTwotone, SvgTapChipMajorMonotone as TapChipMajorMonotone, SvgTapChipMajorTwotone as TapChipMajorTwotone, SvgTaxMajorMonotone as TaxMajorMonotone, SvgTaxMajorTwotone as TaxMajorTwotone, SvgTeamMajorMonotone as TeamMajorMonotone, SvgTeamMajorTwotone as TeamMajorTwotone, SvgTextMajorMonotone as TextMajorMonotone, SvgTextMajorTwotone as TextMajorTwotone, SvgTextBlockMajorMonotone as TextBlockMajorMonotone, SvgTextBlockMajorTwotone as TextBlockMajorTwotone, SvgThemeEditMajorMonotone as ThemeEditMajorMonotone, SvgThemeEditMajorTwotone as ThemeEditMajorTwotone, SvgThemeStoreMajorMonotone as ThemeStoreMajorMonotone, SvgThemeStoreMajorTwotone as ThemeStoreMajorTwotone, SvgThemesMajorMonotone as ThemesMajorMonotone, SvgThemesMajorTwotone as ThemesMajorTwotone, SvgThumbsDownMajorMonotone as ThumbsDownMajorMonotone, SvgThumbsDownMajorTwotone as ThumbsDownMajorTwotone, SvgThumbsDownMinor as ThumbsDownMinor, SvgThumbsUpMajorMonotone as ThumbsUpMajorMonotone, SvgThumbsUpMajorTwotone as ThumbsUpMajorTwotone, SvgThumbsUpMinor as ThumbsUpMinor, SvgTickMinor as TickMinor, SvgTickSmallMinor as TickSmallMinor, SvgTimelineAttachmentMajorMonotone as TimelineAttachmentMajorMonotone, SvgTimelineAttachmentMajorTwotone as TimelineAttachmentMajorTwotone, SvgTipsMajorMonotone as TipsMajorMonotone, SvgTipsMajorTwotone as TipsMajorTwotone, SvgToolsMajorMonotone as ToolsMajorMonotone, SvgToolsMajorTwotone as ToolsMajorTwotone, SvgTransactionMajorMonotone as TransactionMajorMonotone, SvgTransactionMajorTwotone as TransactionMajorTwotone, SvgTransactionFeeDollarMajorMonotone as TransactionFeeDollarMajorMonotone, SvgTransactionFeeDollarMajorTwotone as TransactionFeeDollarMajorTwotone, SvgTransactionFeeEuroMajorMonotone as TransactionFeeEuroMajorMonotone, SvgTransactionFeeEuroMajorTwotone as TransactionFeeEuroMajorTwotone, SvgTransactionFeePoundMajorMonotone as TransactionFeePoundMajorMonotone, SvgTransactionFeePoundMajorTwotone as TransactionFeePoundMajorTwotone, SvgTransactionFeeRupeeMajorMonotone as TransactionFeeRupeeMajorMonotone, SvgTransactionFeeRupeeMajorTwotone as TransactionFeeRupeeMajorTwotone, SvgTransactionFeeYenMajorMonotone as TransactionFeeYenMajorMonotone, SvgTransactionFeeYenMajorTwotone as TransactionFeeYenMajorTwotone, SvgTransferMajorMonotone as TransferMajorMonotone, SvgTransferMajorTwotone as TransferMajorTwotone, SvgTransferInMajorMonotone as TransferInMajorMonotone, SvgTransferInMajorTwotone as TransferInMajorTwotone, SvgTransferOutMajorMonotone as TransferOutMajorMonotone, SvgTransferOutMajorTwotone as TransferOutMajorTwotone, SvgTransferWithinShopifyMajorMonotone as TransferWithinShopifyMajorMonotone, SvgTransferWithinShopifyMajorTwotone as TransferWithinShopifyMajorTwotone, SvgTransportMajorMonotone as TransportMajorMonotone, SvgTransportMajorTwotone as TransportMajorTwotone, SvgTroubleshootMajorMonotone as TroubleshootMajorMonotone, SvgTroubleshootMajorTwotone as TroubleshootMajorTwotone, SvgTypeMajorMonotone as TypeMajorMonotone, SvgTypeMajorTwotone as TypeMajorTwotone, SvgUndoMajorMonotone as UndoMajorMonotone, SvgUndoMajorTwotone as UndoMajorTwotone, SvgUnfulfilledMajorMonotone as UnfulfilledMajorMonotone, SvgUnfulfilledMajorTwotone as UnfulfilledMajorTwotone, SvgUnknownDeviceMajorMonotone as UnknownDeviceMajorMonotone, SvgUnknownDeviceMajorTwotone as UnknownDeviceMajorTwotone, SvgUpdateInventoryMajorMonotone as UpdateInventoryMajorMonotone, SvgUpdateInventoryMajorTwotone as UpdateInventoryMajorTwotone, SvgVariantMajorMonotone as VariantMajorMonotone, SvgVariantMajorTwotone as VariantMajorTwotone, SvgViewMajorMonotone as ViewMajorMonotone, SvgViewMajorTwotone as ViewMajorTwotone, SvgViewMinor as ViewMinor, SvgViewportNarrowMajorMonotone as ViewportNarrowMajorMonotone, SvgViewportNarrowMajorTwotone as ViewportNarrowMajorTwotone, SvgViewportWideMajorMonotone as ViewportWideMajorMonotone, SvgViewportWideMajorTwotone as ViewportWideMajorTwotone, SvgVocabularyMajorMonotone as VocabularyMajorMonotone, SvgVocabularyMajorTwotone as VocabularyMajorTwotone, SvgWandMajorMonotone as WandMajorMonotone, SvgWandMajorTwotone as WandMajorTwotone, SvgWearableMajorMonotone as WearableMajorMonotone, SvgWearableMajorTwotone as WearableMajorTwotone, SvgWholesaleMajorMonotone as WholesaleMajorMonotone, SvgWholesaleMajorTwotone as WholesaleMajorTwotone, SvgWifiMajorMonotone as WifiMajorMonotone, SvgWifiMajorTwotone as WifiMajorTwotone };